import React, { useState, useRef, useEffect, useCallback,Component } from 'react';
import ReactDOM from 'react-dom'
import { CheckboxPopup, RadioButtons, Checkbox, FileChooser, SimpleButton, SimpleIcon, DeleteButton } from './Buttons.js'
import { SearchField } from './SearchField.js'
import { bindCallback, of, concat, from, Subject, merge as mergeN } from 'rxjs'
import { ReactSVG } from 'react-svg'
import { makeTextPlain, walkDOM, InputField, parseCode, renderCode, KeyboardAutocomplete, Document, InputControl, KeyboardButton, KeyboardButton1, KeyboardTitle } from '../InputField'
import { UComponent, BnPage, BnSubpage } from '../Page'
import { UIButton, UIOKCancel } from '../Button/legacy'
import { isSafari, isChrome, isMobile, isDesktop } from '../../classes/Platform.js'
import { FadeComponents, FadeSpan } from '../FadeSpan'
import AICheck from '../../assets/Icons/AICheck.svg'
import Spin from '../../assets/Icons/Spin.svg'
import Cross from '../../assets/Icons/Cross.svg'
import Visible from '../../assets/Icons/Visible.svg'
import Trash from '../../assets/Icons/Trash.svg'
import Empty from '../../assets/Icons/Empty.svg'
import MenuUp from '../../assets/Icons/MenuUp.svg'
import MenuDown from '../../assets/Icons/MenuDown.svg'
import Down from '../../assets/Icons/Down.svg'
import Up from '../../assets/Icons/Up.svg'
import Category from '../../assets/Icons/UserSaid.svg'
import OpenFile from '../../assets/Icons/OpenFile.svg'
import File from '../../assets/Icons/File.svg'
import Folder from '../../assets/Icons/Folder.svg'
import Image from '../../assets/Icons/Image.svg'
import Save from '../../assets/Icons/SaveCommand.svg'
import Undo from '../../assets/Icons/Redo.svg'
import Redo from '../../assets/Icons/Undo.svg'
import Stop from '../../assets/Icons/Stop.svg'
import Send from '../../assets/Icons/Send.svg'
import Cut from '../../assets/Icons/Share.svg'
import Copy from '../../assets/Icons/Copy.svg'
import Share from '../../assets/Icons/Share.svg'
import UserSaid from '../../assets/Icons/UserSaid.svg'
import AISaid from '../../assets/Icons/AISaid.svg'
import CheckMark from '../../assets/Icons/Tick.svg'
import EditIcon from '../../assets/Icons/Edit.svg'
import Plus from '../../assets/Icons/Plus.svg'
import Left from '../../assets/Icons/Back.svg'
import Right from '../../assets/Icons/Forward.svg'
import Alert from '../../assets/Icons/Alert.svg'
import Hashtag from '../../assets/Icons/Hashtag.svg'
import Chat from '../../assets/Icons/Chat.svg'
import SearchIcon from '../../assets/Icons/Search.svg'
import Question from '../../assets/Icons/Question.svg'
import Filter from '../../assets/Icons/Filter.svg'
import Marker from '../../assets/Icons/Marker.svg'
import Gear from '../../assets/Icons/Settings.svg'
import ToolServer from '../../assets/Icons/ToolServer.svg'
import { EditMenu } from '../Home/EditMenu.js'
import moment from 'moment'
import { langs } from '../../classes/Lang.js'
import {SpectrumAnalyzer} from '../SpectrumAnalyzer'
import ClickAwayListener from 'react-click-away-listener'
import { MarkdownNew, Markdown, containsLatex, containsMarkdown, mdToHtml } from './Markdown.js'
import { getPortal } from '../Client'
import { useSwipeable } from 'react-swipeable'
import { parseTable, renderTable, renderTableMarkdown } from '../InputField/Table.js'
import {Prism as SyntaxHighlighter} from 'react-syntax-highlighter'
import {materialLight as CodeStyle} from 'react-syntax-highlighter/dist/esm/styles/prism'
import { markdownToTxt } from './MarkdownToTxt.js'
import { jsonrepair } from 'jsonrepair'
import Popup from 'reactjs-popup';
import TurndownService from 'turndown'
import Settings from '../../assets/Icons/Settings.svg'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Pagination, Scrollbar, Mousewheel } from 'swiper/modules';
import { Calendar, getPricingContext } from '../Home/Usage.js'
import { ActionMenu } from '../Home/ActionMenu.js'
import { formatPrice, getSubscriptionRouteIndicator, ModelLabel, Model, ModelVendor, ModelsMenu, ModelsView } from './ModelsMenu.js'
import { formatInt, ellipsizePath, setCaretPositionFromEvent, capitalize, formatName, delay, countTokens, scrollIntoView, scrollOnKeyDown, startOfDay, startOfWeek, endOfWeek, startOfMonth, endOfDay} from '../../classes/Util.js'
import { InMemorySearch } from '../../classes/InMemorySearch.js'
import { InfiniteScroll } from '../Scrolling'
import { scrollIntoViewIfNeeded } from '../Scrolling/ScrollIntoView'
import FollowPane from '../Scrolling/FollowPane.jsx'
import { GoogleSearchResults } from '../Home/GoogleSearchResults.js'
import { AnalogClock } from './AnalogClock.js'
import { CalendarDate } from './CalendarDate.js'
import { catchError, tap, scan, filter, map, mergeMap, flatMap, take, merge, distinctUntilChanged  } from 'rxjs/operators'
import { CanvasInterpreter, MultiFileCanvasEditor } from '../CanvasEditor';
import { marked } from "marked";
import { XcodeDiffViewer } from './EditTextFile.js'
import { XcodeVCS } from './xcode_vcs.jsx'
import { SafariBrowser } from './safari_browser.jsx'
import { AgentBrowserScreencast } from './AgentBrowser.js'
import { MacErrorPanel } from './mac_error_dialog.jsx'
import yaml from 'js-yaml'
import { tallyUsage, add, sub, tallyTranscriptUsage } from './TallyUsage.js'
import { Timeline } from './Timeline.jsx'
import { applyDiff } from './PatchTool.js'
import usageBilling from '@attunewise/shared/usage-billing'
import {
  ConversationToolResultView,
  ConversationSearchResults,
  ConversationBrowseResult,
  ConversationOpenLinkResult,
  ConversationSummarySpine
} from './ConversationSearchResult.js'
const { cleanConversationResult } = require('@attunewise/shared/conversation-tool-result')
const { assistantReplyTargetFor } = require('@attunewise/shared/assistant-message-mutations')
const {
  assistantTranscriptRenderUnits,
  firstToolCallForRendering,
  toolResultRenderUnit,
  toolCallForRendering,
  transcriptEntriesWithInferenceProgress
} = require('./TranscriptVirtualization.js')
const { appendStreamingDelta, uncommittedStreamingTail } = require('./StreamingText.js')
const { isDetachedStreamStatus } = require('../../classes/StreamLifecycle.js')
const { selectReplyContextUsage } = require('./ContextUsage.js')
const {
  hasTranscriptArchives,
  hydrateTranscriptArchives,
  replaceCachedArchiveEntries
} = require('./TranscriptArchiveCache.js')
const { modelId: resolveModelId, normalizeModelIds } = require('./ModelIds.js')
const {
  MODEL_REQUEST_CONFIG_VERSION,
  pickModelRouteConfig,
  mergeModelRequestConfigs,
  selectedModelRouteConfigsFromOptions,
  mergeSelectedModelRouteConfigs
} = require('./ModelRequestConfig.js')
const { shouldCancelActiveRun } = require('./ChatRunLifecycle.js')

import 'swiper/css'; // basic Swiper styles
import 'swiper/css/navigation'; // if you need navigation buttons
import './index.css'
import './text.css'
import './ReadOnly.css'

const shorten = prompt => {
  const comps = prompt.split(/[.]|\n/).filter(x=>x.trim())
  return comps.length > 1 ? comps[0] + "..." : prompt
}

const Timestamp = props => {
  const { start, end, ts } = props
  let text
  if (start && end) {
    if (end - start === 0) return null
    text = durationBetween(start, end)
  } else {
    if (!ts) return null
    text = fromNow(ts)
  }
  return <div className='timestamp'>{text}</div>
}

const usageCostBreakdown = (usage, context) => usageBilling.usageCostBreakdown(
  usage,
  context && context.price,
  1000000
)

const resolveUsagePricingModel = (billingModelId, modelsById) => {
  const direct = modelsById[billingModelId]
  if (direct) {
    return direct
  }
  const route = usageBilling.splitBillingModelId(billingModelId)
  if (!route) {
    return null
  }
  const { inferenceProviderId, modelId } = route
  const model = modelsById[modelId]
  if (!model) {
    return null
  }
  if (usageBilling.isVirtualInferenceProvider(inferenceProviderId)) {
    return {
      ...model,
      billingModelId,
      inferenceProviderId,
      contexts: model.contexts
    }
  }
  const provider = (model.inferenceProviders || []).find(item => item && (
    item.id === inferenceProviderId || item.providerId === inferenceProviderId
  ))
  if (!provider) {
    return null
  }
  return {
    ...model,
    billingModelId,
    inferenceProviderId,
    contexts: provider.contexts || model.contexts
  }
}

const Figma = props => {
  const { children } = props
  return <div className='figma'>
           {children}
           </div>
}

const removeSignatures = text => {
  const result = text.replace(
    /<signed\b[^>]*>[\s\S]*?<\\?\/signed>|<signature\b[^>]*>[\s\S]*?<\\?\/signature>|<gemini-sig\b[^>]*>[\s\S]*?<\\?\/gemini-sig>|<openai-sig\b[^>]*>[\s\S]*?<\\?\/openai-sig>/g,
    ''
  )
  return result
}

const CONTENT_PREVIEW_CHARS = 8192

const visibleStoredContent = content => removeSignatures(String(content || ''))

const getStoredContentDisplayState = (message, fallbackContent = '', limit = CONTENT_PREVIEW_CHARS) => {
  const rawContent = String((message && message.content) || fallbackContent || '')
  const visibleContent = visibleStoredContent(rawContent)
  const contentLength = Number(message && message.contentLength)
  const hasStoredLength = Number.isFinite(contentLength) && contentLength > 0
  const partial = Boolean(message && message.storage && hasStoredLength && rawContent.length < contentLength)
  const fullVisibleLength = partial ? Math.max(contentLength, visibleContent.length) : visibleContent.length
  const previewContent = visibleContent.substring(0, limit)
  const remaining = Math.max(0, fullVisibleLength - previewContent.length)
  const truncated = partial || visibleContent.length > limit
  return {
    rawContent,
    visibleContent,
    previewContent,
    remaining,
    partial,
    truncated,
  }
}

const storedContentMoreLabel = (displayState, downloading) => {
  if (displayState.partial) {
    return downloading ? 'Loading...' : 'Load full message ...'
  }
  return `${displayState.remaining.toLocaleString()} more characters ...`
}

const Home = Left
const End = Right

marked.setOptions({ gfm: true, breaks: false });

export const mdToHtmlBad = (markdown) => {
  return marked.parse(markdown)
}


// Scroll to a custom highlight on the page
function scrollToHighlight(id, index,  opts = {}) {
  const behavior = opts.behavior ?? 'smooth';
  const block = opts.block ?? 'center';
  const container = document.getElementById(id)
  const name = 'searchHighlight'
  // Use the CSS Custom Highlight API if supported
  if (CSS && CSS.highlights) {
    const h = CSS.highlights.get(name);
    if (!h || h.size === 0) return false;

    // Collect visible ranges, optionally filtered to a container
    const sorted = [...h.values()]
      .filter(r => {
        if (!container) return true;
        const node = r.startContainer.nodeType === Node.ELEMENT_NODE
          ? r.startContainer
          : r.startContainer.parentElement;
        return node && container.contains(node);
      })
      .map(r => ({ r, rect: r.getBoundingClientRect() }))
      .filter(o => o.rect && (o.rect.width || o.rect.height))
      .sort((a, b) => a.rect.top - b.rect.top || a.rect.left - b.rect.left);

    const target = sorted[index]?.r;
    if (!target) return false;

    // Prefer element-based scroll (handles nested scroll containers)
    const anchor =
      target.startContainer.nodeType === Node.ELEMENT_NODE
        ? target.startContainer
        : target.startContainer.parentElement;

    if (anchor?.scrollIntoView) {
      anchor.scrollIntoView({ behavior, block });
    } else {
      // Fallback: scroll the window to the range's bounding rect
      const rect = target.getBoundingClientRect();
      const y = rect.top + window.scrollY - window.innerHeight * 0.33;
      window.scrollTo({ top: y, behavior });
    }
    return true;
  }

  // Fallback if you used <mark> or a .highlight class instead of the API
  const selector = 'mark, .highlight';
  const els = container
    ? container.querySelectorAll(selector)
    : document.querySelectorAll(selector);
  const el = els[index];
  if (el?.scrollIntoView) {
    el.scrollIntoView({ behavior, block });
    return true;
  }

  return false;
}



// Scroll to the first custom highlight on the page
function scrollToFirstHighlight(name = 'searchHighlight', opts = {}) {
  const behavior = opts.behavior ?? 'smooth';
  const block = opts.block ?? 'center';

  // Use the CSS Custom Highlight API if supported
  if (CSS && CSS.highlights) {
    const h = CSS.highlights.get(name);
    if (!h || h.size === 0) return false;

    // Pick the top-most range in document/viewport space
    const first = [...h.values()]
      .map(r => ({ r, rect: r.getBoundingClientRect() }))
      .filter(o => o.rect && (o.rect.width || o.rect.height))
      .sort((a, b) => a.rect.top - b.rect.top || a.rect.left - b.rect.left)[0]?.r;

    if (!first) return false;

    // Prefer element-based scroll (handles nested scroll containers)
    const anchor =
      first.startContainer.nodeType === Node.ELEMENT_NODE
        ? first.startContainer
        : first.startContainer.parentElement;

    if (anchor?.scrollIntoView) {
      anchor.scrollIntoView({ behavior, block });
    } else {
      // Fallback: scroll the window to the range’s bounding rect
      const rect = first.getBoundingClientRect();
      const y = rect.top + window.scrollY - window.innerHeight * 0.33;
      window.scrollTo({ top: y, behavior });
    }
    return true;
  }

  // Fallback if you used <mark> or a .highlight class instead of the API
  const el = document.querySelector('mark, .highlight');
  if (el?.scrollIntoView) {
    el.scrollIntoView({ behavior, block });
    return true;
  }

  return false;
}


function highlightIn(roots, query, selectedMessageId, index) {
  if (!roots || !window.CSS || !CSS.highlights) return; // no-op if unsupported
  if (!query) return;
  clearHighlight()
  const set = new Highlight();
  const selectedSet = new Highlight();
  const needle = String(query).toLowerCase();
  let j = 0
  let searchResults = []
  const MSG = {}
  let selectedElement
  for (const x of roots) {
    const { container, root, attribute } = x
    const it = document.createNodeIterator(container, NodeFilter.SHOW_TEXT);
    for (let n; (n = it.nextNode()); ) {
      const text = n.nodeValue || "";
      const lowered = text.toLowerCase()
      let i = lowered.indexOf(needle);
      if (i < 0) {
        //if (j > 0) //console.log("no match", lowered, needle)
      }
      const getElementParent = n => {
        if (!n) return null
        if (n.nodeType === Node.ELEMENT_NODE) {
          return n
        }
        return getElementParent(n.parentNode)
      }
      const getMessageId = el => {
        if (!el) return null
        if (el.getAttribute) {
          const id = el.getAttribute(attribute)
          if (id) {
            return id
          }
        }
        return getMessageId(el.parentNode)
      }
      const messageId = getMessageId(n)
      let k = 0
      while (i !== -1) {
        const r = new Range();
        r.setStart(n, i);
        r.setEnd(n, i + needle.length);
        let N = MSG[messageId]
        if (N === undefined) {
          MSG[messageId] = 0
        } else {
          MSG[messageId]++
        }
        if (messageId === selectedMessageId && MSG[messageId] === index) {
          selectedSet.add(r)
          selectedElement = getElementParent(n)
        } else {
          set.add(r);
        }
        i = lowered.indexOf(needle, i + needle.length);
        k++
      }
    }
    j++
  }
  CSS.highlights.set("searchHighlight", set);
  CSS.highlights.set("searchHighlightSelected", selectedSet);
  if (selectedElement) selectedElement.scrollIntoViewIfNeeded()
}

// optional cleanup
function clearHighlight() {
  if (window.CSS?.highlights) {
    CSS.highlights.delete("searchHighlight");
    CSS.highlights.delete("searchHighlightSelected");
  }
}

const VisibleToolUseContent = ({ item }) => {
  useEffect(() => {
    if (item && item.hydrateVisible) {
      item.hydrateVisible()
    }
  }, [item && item.id, item && item.cacheVersion])
  return item ? item.content : null
}

class ToolUsePanel extends Component {

  toolUseIds = ''
  // The user swiping off the latest slide pauses auto-advance until they
  // return to the latest slide or the chat's bottom lock re-engages.
  userPaused = false
  programmaticSlide = false

  constructor (props) {
    super(props)
  }

  updateAutoHeight = () => {
    const swiper = this.swiper
    if (swiper) {
      try {
        swiper.update()
      } catch (err) {
      }
      if (this.autoHeightFrame) {
        cancelAnimationFrame(this.autoHeightFrame)
      }
      this.autoHeightFrame = requestAnimationFrame(() => {
        try {
          swiper.updateAutoHeight()
        } catch (err) {
        }
        this.autoHeightFrame = null
      })
    }
  }

  setRef = ref => {
    if (this.ref === ref) return
    if (this.resizeObserver && this.ref) {
      this.resizeObserver.unobserve(this.ref)
    }
    this.ref = ref
    if (ref && typeof ResizeObserver !== 'undefined') {
      if (!this.resizeObserver) {
        this.resizeObserver = new ResizeObserver(this.onResize)
      }
      this.resizeObserver.observe(ref)
    }
  }

  onResize = () => {
    if (this.resizeFrame) {
      cancelAnimationFrame(this.resizeFrame)
    }
    this.resizeFrame = requestAnimationFrame(() => {
      this.resizeFrame = null
      this.updateAutoHeight()
    })
  }

  onSwiper = swiper => {
    this.swiper = swiper
    swiper.slideTo(this.pos, 0)
    this.updateAutoHeight();
  }

  slideToLatest = (speed = 300) => {
    if (this.userPaused) {
      return
    }

    const toolUse = this.props.toolUse || []
    const pos = toolUse.length - 1
    const swiper = this.swiper

    if (pos < 0) {
      return
    }

    this.props.setPos(pos)
    if (toolUse.length < 2) {
      this.updateAutoHeight()
      return
    }

    if (swiper) {
      this.programmaticSlide = true
      swiper.update()
      requestAnimationFrame(() => {
        if (this.swiper === swiper && swiper.activeIndex !== pos) {
          swiper.slideTo(pos, speed)
        }

        this.programmaticSlide = false
        this.updateAutoHeight()
      })
      return
    }

    this.updateAutoHeight()
  }

  componentDidMount() {
    this.toolUseIds = (this.props.toolUse || []).map(x => x.id).join('|')
    this.updateAutoHeight()
    if (this.props.autoAdvance) {
      this.slideToLatest()
    } else {
      this.swiper.slideTo(this.props.pos, 0)
    }
    this.hydrateToolUseAt(this.props.autoAdvance ? (this.props.toolUse || []).length - 1 : this.props.pos)
  }

  componentWillUnmount() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect()
      this.resizeObserver = null
    }
    if (this.resizeFrame) {
      cancelAnimationFrame(this.resizeFrame)
      this.resizeFrame = null
    }
    if (this.autoHeightFrame) {
      cancelAnimationFrame(this.autoHeightFrame)
      this.autoHeightFrame = null
    }
  }

  componentDidUpdate(prevProps) {
    const nextToolUseIds = (this.props.toolUse || []).map(x => x.id).join('|')
    const toolUseChanged = nextToolUseIds !== this.toolUseIds
    const autoAdvanceStarted = this.props.autoAdvance && !prevProps.autoAdvance

    this.toolUseIds = nextToolUseIds

    if (autoAdvanceStarted) {
      this.userPaused = false
    }

    if (this.props.autoAdvance && (toolUseChanged || autoAdvanceStarted)) {
      this.slideToLatest()
    }

    this.hydrateToolUseAt(this.swiper ? this.swiper.activeIndex : this.props.pos)
    this.updateAutoHeight()
  }

  hydrateToolUseAt = pos => {
    const toolUse = this.props.toolUse || []
    const item = toolUse[pos]
    if (item && item.hydrateVisible) {
      item.hydrateVisible()
    }
  }

  render() {
    const ids = this.props.ids
    const toolUse = this.props.toolUse
    const { byToolCallId, totalUsage } = this.props.usages
    const setPos = pos => {
      this.props.setPos(pos)
      const swiper = this.swiper
      if (swiper.activeIndex !== pos) {
        this.swiper.slideTo(pos)
        this.swiper.updateAutoHeight()
      }
      this.hydrateToolUseAt(pos)
      this.forceUpdate()
    }
    const getPos = () => {
      const swiper = this.swiper
      return swiper ? swiper.activeIndex : this.props.pos
    }
    const onSlideChange = e => {
      const swiper = this.swiper
      if (!this.programmaticSlide) {
        const latest = (this.props.toolUse || []).length - 1
        this.userPaused = swiper.activeIndex < latest
      }
      this.props.setPos(swiper.activeIndex)
      this.hydrateToolUseAt(swiper.activeIndex)
      this.updateAutoHeight()
      this.forceUpdate(this.updateAutoHeight)
    }
    return <div className='toolUsesContent' key={'tool-use-'+ids} ref={this.setRef}>
            <Swiper
              autoHeight={true}
              onSwiper={this.onSwiper}
              preventClicks={false}
              nested={true}
              onSlideChange={onSlideChange}
              modules={[Mousewheel]}
              allowTouchMove={!isDesktop()}
              mousewheel={isDesktop() ? { forceToAxis: true, releaseOnEdges: true  } : undefined}
            >
              {
                toolUse.map((x, j) => {
                  let messagePrice
                  const { model, id, ts } = x
                  let tally = byToolCallId[id]
                  if (tally) {
                    const { inTokens, outTokens, cachedTokens, cacheWriteTokens, inDollars, outDollars, cacheReadDollars, cacheWriteDollars } = tally
                    //console.log({tally})
                    let ci = 0
                    let co = 0
                    if (cacheReadDollars) {
                      ci = cacheReadDollars[model]
                      co = cacheWriteDollars[model]
                    }
                    const i = inDollars[model]
                    const o = outDollars[model]
                    if (i > 0 || o > 0) {
                      messagePrice = ''
                      if (ci > 0 || co > 0) {
                        messagePrice += formatPrice(ci) + "/" + formatPrice(co) +"|"
                      }
                      messagePrice += +formatPrice(i) + "/" + formatPrice(o)
                    }
                  } else {
                    ////debugger
                  }
                  const content = <div className='toolUseContentN'>
                                    <div className='toolUseContentHeader'>
                                      <div className='toolUseContentNFunctionName'>
                                        {j+1}. Use the {formatName(x.name)} tool.
                                      </div>
                                      <div className='toolUseRight'>
                                        <div className='messagePrice'>
                                          {messagePrice}
                                        </div>
                                      </div>
                                    </div>
                                    <div className='toolUseContentNContent'>
                                                    {x.content}
                                    </div>
                                  </div>
                  return <SwiperSlide>{content}</SwiperSlide>
                })
              }
            </Swiper>
             {toolUse.length > 1 && <Navigation
              length={toolUse.length}
              pos={getPos()}
              setPos={setPos}
                                    />}
          </div>

  }
}



const ScalingDiv = ({ width, children, height, shrink }) => {
  height = height || width * .67
  const containerRef = useRef(null);
  const contentRef = useRef(null);
  const [layout, setLayout] = useState({ scale: 1, contentHeight: height });
  const observerRef = useRef(null);

  const updateLayout = useCallback(() => {
    if (containerRef.current) {
      const currentWidth = containerRef.current.offsetWidth;
      const nextScale = Math.min(currentWidth / width, 1);
      const measuredHeight =
        contentRef.current &&
        Math.max(contentRef.current.scrollHeight, contentRef.current.offsetHeight);
      const nextContentHeight = measuredHeight || height;
      setLayout(prev => {
        if (prev.scale === nextScale && prev.contentHeight === nextContentHeight) {
          return prev
        }
        return {
          scale: nextScale,
          contentHeight: nextContentHeight
        }
      });
    }
  }, [height, width]);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    updateLayout();

    if ('ResizeObserver' in window) {
      if (observerRef.current) {
        observerRef.current.disconnect();
      }

      const resizeObserver = new ResizeObserver(() => {
        updateLayout();
      });
      resizeObserver.observe(container);
      if (contentRef.current) {
        resizeObserver.observe(contentRef.current);
      }
      observerRef.current = resizeObserver;

      return () => {
        resizeObserver.disconnect();
      };
    } else {
      window.addEventListener('resize', updateLayout);
      return () => window.removeEventListener('resize', updateLayout);
    }
  }, [updateLayout]);

  useEffect(() => {
    updateLayout()
  });

  const { scale, contentHeight } = layout
  let maxHeight
  let h = '400px'
  let mh
  let outerHeight = contentHeight * scale
  if (shrink) {
    maxHeight = scale * height
    h = undefined
    mh = '400px'
  }
  return (
    <div ref={containerRef} className='scalingDiv' style={{width: '100%', maxHeight, height: outerHeight}}>
      <div style={{ transform: `scale(${scale})`, transformOrigin: 'top left' }}>
        <div ref={contentRef} className='container1' style={{'width': width, minHeight: 0, height: h, maxHeight: mh}}>
          {children}
        </div>
      </div>
    </div>
  );
};


const windowElemExtern = (id, div, shrink, width="100%") => {
  return <ScalingDiv key={id} width={width} shrink={shrink}>
           {div}
         </ScalingDiv>
}

class CanvasComponent extends Component {
  constructor(props) {
    super(props);

    // Create interpreter

    // Ref for editor component
  }

  componentDidMount() {
    // Connect interpreter to transcript
    // Subscribe to editor edits
    this.transcriptSubscription = this.interpreter.processTranscript(this.props.transcript)
    if (this.props.onCreate) {
      this.props.onCreate(this)
      const { availableFiles } = this.getObservables()
      availableFiles.subscribe(file => {
        this.props.onFileAvailable(file)
      })
    }
  }

  getObservables = () => {
    if (!this.commands$) {
      this.interpreter = new CanvasInterpreter({
        hydrateToolResult: this.props.hydrateToolResult
      });
      // Store references to observables
      this.commands$ = this.interpreter.observeCommands();
      this.availableFiles$ = this.interpreter.observeAvailableFiles();
    }
    return { commands: this.commands$, availableFiles: this.availableFiles$, desktopFiles: this.props.desktopFiles}
  }

  componentWillUnmount() {
    // Clean up subscriptions
    if (this.transcriptSubscription) {
      this.transcriptSubscription.unsubscribe();
    }

    if (this.editsSubscription) {
      this.editsSubscription.unsubscribe();
    }

    // Dispose interpreter
    this.interpreter.dispose();
    if (this.sub) {
      this.sub.unsubscribe()
      this.sub = null
    }
  }

  setEditorRef = editorRef => {
    this.editorRef = editorRef
  }

  reset = () => {
    this.interpreter.reset()
  }

  resolveFile = path => {
    if (this.interpreter) {
      return this.interpreter.getFileContents(path)
    }
  }

  render() {
    const { commands, availableFiles, desktopFiles } = this.getObservables()
    return (
      <MultiFileCanvasEditor
        messages={this.props.messages}
        getFileContents={this.props.getFileContents}
        ref={this.setEditorRef}
        onUserEdit={this.props.onUserEdit}
        commands$={commands}
        desktopFiles={desktopFiles}
        availableFiles$={availableFiles}
        onFileVisible={path => {
          this.interpreter.hydrateFile(path).catch(err => console.error(err))
        }}
      />
    );
  }
}

let chatGptId = 0

function buildTree(paths) {
  // Handle edge cases
  if (!paths || paths.length === 0) {
    return {
      name: '/',
      path: '/',
      children: []
    }
  }
  // 1) Split each path into arrays of segments
  const splitPaths = paths.map(path => path.split('/'));

  // 2) Determine the greatest common prefix (GCP) among all paths
  let commonParts = splitPaths[0];
  for (let i = 1; i < splitPaths.length; i++) {
    const parts = splitPaths[i];
    let j = 0;
    while (j < commonParts.length && j < parts.length && commonParts[j] === parts[j]) {
      j++;
    }
    commonParts = commonParts.slice(0, j);
    if (!commonParts.length) {
      break; // no common prefix
    }
  }

  // 3) Build the root node using the GCP
  const rootPath = commonParts.join('/');
  const rootName = commonParts.length ? commonParts[commonParts.length - 1] : '';
  const root = {
    name: rootName, // just the last segment of the GCP
    path: rootPath, // the full common prefix
    type: 'directory',
    children: []
  };

  // 4) Remove the GCP from each path, leaving remainder segments
  const remainderPaths = splitPaths.map(parts => parts.slice(commonParts.length));

  // 5) Helper to add a remainder path to the tree
  function addPathToTree(parent, segments) {
    let currentNode = parent;
    let currentPath = parent.path;

    segments.forEach((seg, index) => {
      // Build up the path
      const newPath = currentPath ? `${currentPath}/${seg}` : seg;
      let child = currentNode.children.find(c => c.name === seg);

      if (!child) {
        child = {
          name: seg, // the final segment only
          path: newPath, // the full path from root
          type: index === segments.length - 1 ? 'file' : 'directory',
          children: []
        };
        currentNode.children.push(child);
      }

      currentNode = child;
      currentPath = newPath;
    });
  }

  // 6) Add each path remainder to the tree
  remainderPaths.forEach(segments => {
    if (segments.length) {
      addPathToTree(root, segments);
    }
  });

  // 7) Collapse single-child directories so we skip intermediate folders
  function collapseSingleChildDirectories(node) {
    while (
      node.type === 'directory' &&
      node.children.length === 1 &&
      node.children[0].type === 'directory'
    ) {
      const child = node.children[0];
      // Replace this node's info with its child's
      node.name = child.name;
      node.path = child.path;
      node.children = child.children;
      node.type = child.type; // stays 'directory'
    }
    node.children.forEach(c => collapseSingleChildDirectories(c));
  }

  collapseSingleChildDirectories(root);

  // 8) If the root has no name and only one child directory, the child might become a better root
  // But typically, we keep the GCP as the root. If there's no GCP, root name/path is '' anyway.

  return root;
}

const formatConversationNumber = value => {
  const n = Number(value)
  if (!Number.isFinite(n)) return ''
  return formatInt(Math.round(n))
}

const cvxFirstLine = content => {
  const text = String(content || '').trim()
  const newline = text.indexOf('\n')
  const line = newline >= 0 ? text.slice(0, newline) : text
  return line.length > 120 ? line.slice(0, 119) + '…' : line
}

class InteractiveConversationToolResult extends Component {
  state = { opened: null, openedRequest: null, paged: null, loading: false, error: null }

  conversationIdFor = link => {
    if (this.props.result && this.props.result.conversation_id) return this.props.result.conversation_id
    try {
      return new URL(String(link)).searchParams.get('conversation_id') || undefined
    } catch (err) {
      return undefined
    }
  }

  open = async (link, node = {}) => {
    const me = this.props.me
    if (!me || !link) return
    if (String(link).startsWith('conversation://') && this.props.openConversationLink) {
      this.props.openConversationLink(link, node)
      return
    }
    const requestId = (this.requestId || 0) + 1
    this.requestId = requestId
    this.setState({ loading: true, error: null })
    try {
      const browse = Number(node.zoom) > 0 || Number(node.child_count) > 0 || node.kind === 'conversation'
      const toolResult = String(link).startsWith('tool-result://')
      let result
      let openedRequest = null
      if (toolResult && browse) {
        result = await me.toolResultBrowse({ link })
      } else if (toolResult) {
        result = await me.toolResultOpenLink({ link, budget_tokens: 1200 })
      } else if (browse) {
        openedRequest = {
          kind: 'browse',
          conversationId: this.conversationIdFor(link),
          link
        }
        result = await me.conversationBrowse({
          ...openedRequest,
          start_at: 0,
          limit: 10,
          full_summary: true
        })
      } else {
        openedRequest = {
          kind: 'open',
          conversationId: this.conversationIdFor(link),
          link
        }
        result = await me.conversationOpenLink({
          ...openedRequest,
          start_at: 0,
          budget_tokens: 1200
        })
      }
      if (this.requestId !== requestId) return
      this.setState({ opened: cleanConversationResult(result), openedRequest, loading: false })
    } catch (err) {
      if (this.requestId !== requestId) return
      this.setState({ loading: false, error: err && err.message || String(err) })
    }
  }

  loadMore = async (baseResult, stateKey, nextStartAt) => {
    const me = this.props.me
    if (!me || !baseResult) return
    const requestId = (this.requestId || 0) + 1
    this.requestId = requestId
    this.setState({ loading: true, error: null })
    try {
      const search = Array.isArray(baseResult.hits)
      const args = this.props.args || {}
      const link = baseResult.link || baseResult.node && baseResult.node.link
      const toolResult = String(this.props.toolName || '').startsWith('tool_result_') ||
        String(link || '').startsWith('tool-result://') || Boolean(baseResult.storage_path)
      let response
      if (search && toolResult) {
        response = await me.toolResultSearch({
          conversationId: baseResult.conversation_id,
          messageId: baseResult.message_id || args.message_id,
          toolCallId: baseResult.tool_call_id || args.tool_call_id,
          storagePath: baseResult.storage_path || args.storage_path,
          toolName: baseResult.tool_name || args.tool_name,
          query: baseResult.query ?? args.query,
          within: baseResult.within ?? args.within,
          filter: baseResult.filter || args.filter,
          start_at: nextStartAt,
          limit: 10,
          budget_tokens: 1200
        })
      } else if (search) {
        response = await me.conversationIndexSearch({
          conversationId: baseResult.conversation_id,
          query: baseResult.query ?? args.query,
          within: baseResult.within ?? args.within,
          filter: baseResult.filter || args.filter,
          start_at: nextStartAt,
          limit: 10,
          budget_tokens: 1200
        })
      } else if (!toolResult) {
        const toolName = String(this.props.toolName || '')
        const request = stateKey === 'opened'
          ? this.state.openedRequest
          : toolName.endsWith('browse')
            ? {
                kind: 'browse',
                conversationId: baseResult.conversation_id || args.conversation_id,
                handle: args.handle,
                link: args.link,
                filter: args.filter
              }
            : toolName.endsWith('open_link')
              ? {
                  kind: 'open',
                  conversationId: baseResult.conversation_id || args.conversation_id,
                  link: args.link || link
                }
              : null
        if (!request) throw new Error('This result has no pageable Conversation request')
        if (request.kind === 'browse') {
          response = await me.conversationBrowse({
            conversationId: request.conversationId,
            handle: request.handle,
            link: request.link,
            filter: request.filter,
            start_at: nextStartAt,
            limit: args.limit || 10,
            full_summary: true
          })
        } else {
          response = await me.conversationOpenLink({
            conversationId: request.conversationId,
            link: request.link,
            start_at: nextStartAt,
            budget_tokens: args.budget_tokens || 1200
          })
        }
      } else {
        throw new Error('This tool-result response is not paged')
      }
      const page = cleanConversationResult(response)
      if (this.requestId !== requestId) return
      let merged
      if (search) {
        merged = {
          ...baseResult,
          ...page,
          hits: (baseResult.hits || []).concat(page.hits || [])
        }
      } else if (this.state.openedRequest && stateKey === 'opened' && this.state.openedRequest.kind === 'open' ||
                 String(this.props.toolName || '').endsWith('open_link') && stateKey !== 'opened') {
        merged = {
          ...baseResult,
          ...page,
          node: {
            ...(baseResult.node || {}),
            ...(page.node || {}),
            content: String(baseResult.node && baseResult.node.content || '') +
              String(page.node && page.node.content || '')
          }
        }
      } else {
        const rootRequest = stateKey !== 'opened' && !args.link && !args.handle
        const pageRelations = rootRequest
          ? [page.node].concat(page.siblings || []).filter(Boolean)
          : page.children || []
        merged = {
          ...baseResult,
          ...page,
          node: baseResult.node || page.node,
          siblings: rootRequest
            ? (baseResult.siblings || []).concat(pageRelations)
            : baseResult.siblings || [],
          children: rootRequest
            ? baseResult.children || []
            : (baseResult.children || []).concat(pageRelations)
        }
      }
      this.setState({
        [stateKey]: merged,
        loading: false
      })
    } catch (err) {
      if (this.requestId !== requestId) return
      this.setState({ loading: false, error: err && err.message || String(err) })
    }
  }

  componentWillUnmount() {
    this.requestId = (this.requestId || 0) + 1
  }

  render() {
    const { toolName, args, result, components, renderLeaf } = this.props
    const displayed = this.state.paged || result
    return <div className='convInteractiveResult'>
             <ConversationToolResultView
               toolName={toolName}
               args={args}
               result={displayed}
               components={components}
               renderLeaf={renderLeaf}
               onOpen={this.open}
               onMore={nextStartAt => this.loadMore(displayed, 'paged', nextStartAt)}/>
             {this.state.loading && <div className='convSearchEmpty'>Loading link…</div>}
             {this.state.error && <div className='convIndexStatusError'>{this.state.error}</div>}
             {this.state.opened &&
               <div className='convInteractiveOpened'>
                 <ConversationToolResultView
                   result={this.state.opened}
                   components={components}
                   renderLeaf={renderLeaf}
                   onOpen={this.open}
                   onMore={nextStartAt => this.loadMore(this.state.opened, 'opened', nextStartAt)}/>
               </div>}
           </div>
  }
}

// The Conversation tab: browse, search, and summary-spine views over the
// conversation index. Every result is passed through cleanConversationResult
// and rendered with the same components as the conversation_* tool calls, so
// this tab shows exactly what the model sees — its reason for being is QA of
// browse results, search results, and the spines in compaction records.
class ConversationIndexBrowser extends Component {
  constructor(props) {
    super(props)
    this.state = {
      status: null,
      loading: false,
      error: null,
      mode: 'browse',
      // browse: a drill-down path; each level is one cleaned browse result
      path: [],
      preview: null,
      searchTerm: '',
      searching: false,
      searchResults: [],
      searchQuery: '',
      searchNextStartAt: null,
      filterZoom: '',
      filterRole: '',
      filterKind: '',
      filterMessageId: '',
      filterInReplyTo: '',
      filterToolCallId: '',
      searchWithinSelected: false,
      selectedCompactionId: null,
      compactionRefresh: null,
      refreshingCompactions: false,
      history: [],
      historyIndex: -1
    }
  }

  componentDidMount() {
    this.loadConversation()
    if (this.props.hydrateCompactionRecords) {
      void this.props.hydrateCompactionRecords()
    }
  }

  componentDidUpdate(prevProps) {
    if (this.getConversationId(prevProps) !== this.getConversationId()) {
      this.loadConversation()
    } else if (this.getConversationIndexVersion() !== this.loadedConversationIndexVersion) {
      void this.refreshConversation()
    }
  }

  componentWillUnmount() {
    this.unmounted = true
    this.requestId = (this.requestId || 0) + 1
    if (this.compactionRefreshTimer) clearTimeout(this.compactionRefreshTimer)
  }

  getConversationId = (props = this.props) => {
    const task = props.task
    return task && task.id
  }

  getConversationIndexVersion = (props = this.props) => {
    const index = props.task && props.task.conversationIndex || {}
    return [
      props.task && props.task.id,
      index.updatedAt || index.conversationIndexUpdatedAt || '',
      Array.isArray(index.summaryLevelCounts) ? index.summaryLevelCounts.join(',') : '',
      index.throughMessageId || ''
    ].join(':')
  }

  openExternalLink = (link, node = {}) => {
    this.navigateToNode(link, node)
  }

  isSummaryLink = (link, node = {}) => {
    return Number(node.zoom) > 0 || Number(node.child_count) > 0 ||
      node.kind === 'summary_span' ||
      String(link).includes('%2Fmip%2F') || String(link).includes('/mip/')
  }

  rememberLocation = location => {
    this.setState(state => {
      const current = state.history[state.historyIndex]
      const locationKey = item => JSON.stringify({
        type: item && item.type,
        link: item && item.link || null,
        filter: item && item.filter || null,
        selectedCompactionId: item && item.selectedCompactionId || null,
        search: item && item.searchState
          ? {
              searchTerm: item.searchState.searchTerm,
              searchQuery: item.searchState.searchQuery,
              filterZoom: item.searchState.filterZoom,
              filterRole: item.searchState.filterRole,
              filterKind: item.searchState.filterKind,
              filterMessageId: item.searchState.filterMessageId,
              filterInReplyTo: item.searchState.filterInReplyTo,
              filterToolCallId: item.searchState.filterToolCallId,
              searchWithinSelected: item.searchState.searchWithinSelected
            }
          : null
      })
      if (current && locationKey(current) === locationKey(location)) return null
      const history = state.history.slice(0, state.historyIndex + 1).concat([location])
      return { history, historyIndex: history.length - 1 }
    }, () => this.showLocation(location))
  }

  showLocation = location => {
    if (!location) return
    if (location.type === 'open') {
      this.setState({ mode: 'browse' }, () => {
        void this.openPreview(location.link, location.node || { link: location.link, zoom: 0 })
      })
      return
    }
    if (location.type === 'search') {
      this.setState({
        mode: 'search',
        preview: null,
        ...(location.searchState || {})
      })
      return
    }
    if (location.type === 'spine') {
      const items = this.compactionTimeline()
      const selected = items.find(item => item.id === location.selectedCompactionId) || items[items.length - 1]
      this.setState({ mode: 'spine', preview: null }, () => {
        if (selected) this.selectCompaction(selected)
      })
      return
    }
    this.setState({ mode: 'browse', path: [], preview: null }, () => {
      void this.openBrowseLevel(0, location.link || null, location.filter)
    })
  }

  navigateToLocation = location => {
    if (!location) return
    this.rememberLocation(location)
  }

  navigateToNode = (link, node = {}) => {
    if (!link) return
    const location = this.isSummaryLink(link, node)
      ? { type: 'browse', link, node }
      : { type: 'open', link, node }
    this.navigateToLocation(location)
  }

  navigateToRoot = filter => {
    this.navigateToLocation({ type: 'browse', link: null, filter: filter || undefined })
  }

  searchHistoryLocation = () => ({
    type: 'search',
    searchState: {
      searchTerm: this.state.searchTerm,
      searchQuery: this.state.searchQuery,
      searchResults: this.state.searchResults,
      searchNextStartAt: this.state.searchNextStartAt,
      filterZoom: this.state.filterZoom,
      filterRole: this.state.filterRole,
      filterKind: this.state.filterKind,
      filterMessageId: this.state.filterMessageId,
      filterInReplyTo: this.state.filterInReplyTo,
      filterToolCallId: this.state.filterToolCallId,
      searchWithinSelected: this.state.searchWithinSelected
    }
  })

  moveHistory = delta => {
    const nextIndex = this.state.historyIndex + delta
    if (nextIndex < 0 || nextIndex >= this.state.history.length) return
    const location = this.state.history[nextIndex]
    this.setState({ historyIndex: nextIndex }, () => this.showLocation(location))
  }

  canMoveHistory = delta => {
    const nextIndex = this.state.historyIndex + delta
    return nextIndex >= 0 && nextIndex < this.state.history.length
  }

  loadBrowseLink = async link => {
    return cleanConversationResult(await this.props.me.conversationBrowse({
      conversationId: this.getConversationId(),
      link,
      start_at: 0,
      limit: 10,
      full_summary: true
    }))
  }

  deepestSelectedLink = () => {
    const { path } = this.state
    const current = path[path.length - 1]
    return current && current.node && current.node.link || null
  }

  loadConversation = async () => {
    const conversationId = this.getConversationId()
    if (!conversationId || !this.props.me) return
    this.loadedConversationIndexVersion = this.getConversationIndexVersion()
    const requestId = (this.requestId || 0) + 1
    this.requestId = requestId
    this.setState({
      status: null,
      path: [],
      preview: null,
      searchResults: [],
      searchQuery: '',
      searchNextStartAt: null,
      history: [{ type: 'browse', link: null }],
      historyIndex: 0,
      loading: true,
      error: null
    })
    // Browse is the primary read. Status is informational and runs alongside
    // it; neither result gates the other or starts background work.
    void this.openBrowseLevel(0, null)
    try {
      const status = cleanConversationResult(await this.props.me.conversationIndexStatus({ conversationId }))
      if (this.requestId !== requestId) return
      this.setState({ status, loading: false, error: null })
    } catch (err) {
      if (this.requestId !== requestId) return
      this.setState({
        status: { state: 'error', error_message: err.message },
        loading: false,
        error: null
      })
    }
  }

  refreshConversation = async () => {
    const conversationId = this.getConversationId()
    if (!conversationId || !this.props.me) return
    this.loadedConversationIndexVersion = this.getConversationIndexVersion()
    const requestId = (this.requestId || 0) + 1
    this.requestId = requestId
    const location = this.state.history[this.state.historyIndex] || { type: 'browse', link: null }
    this.setState({ loading: true, error: null }, () => this.showLocation(location))
    try {
      const status = cleanConversationResult(await this.props.me.conversationIndexStatus({ conversationId }))
      if (this.requestId !== requestId) return
      this.setState({ status, loading: false, error: null })
    } catch (err) {
      if (this.requestId !== requestId) return
      this.setState({
        status: { state: 'error', error_message: err.message },
        loading: false,
        error: null
      })
    }
  }

  retryConversation = () => this.refreshConversation()

  completeCompactionRefresh = async result => {
    if (this.unmounted) return
    if (this.props.hydrateCompactionRecords) {
      await this.props.hydrateCompactionRecords()
    }
    if (this.props.invalidateSummaryRecords) {
      this.props.invalidateSummaryRecords()
    }
    this.setState({
      refreshingCompactions: false,
      compactionRefresh: {
        ...(result || {}),
        status: 'completed',
        phase: 'completed'
      }
    })
  }

  pollCompactionRefresh = async () => {
    if (this.unmounted || !this.state.refreshingCompactions) return
    const conversationId = this.getConversationId()
    try {
      const job = await this.props.me.conversationIndexJobStatus({ conversationId })
      if (this.unmounted) return
      const progress = job && job.progress || {}
      this.setState({
        compactionRefresh: {
          ...job,
          phase: progress.phase || job.status
        }
      })
      if (job.status === 'completed') {
        await this.completeCompactionRefresh(job)
        return
      }
      if (job.status === 'failed') {
        this.setState({
          refreshingCompactions: false,
          error: job.lastError && job.lastError.message || 'Compaction refresh failed'
        })
        return
      }
    } catch (err) {
      if (this.unmounted) return
      this.setState({
        refreshingCompactions: false,
        error: err.message
      })
      return
    }
    this.compactionRefreshTimer = setTimeout(this.pollCompactionRefresh, 1500)
  }

  refreshCompactionRecords = async () => {
    const conversationId = this.getConversationId()
    if (!conversationId || !this.props.me || this.state.refreshingCompactions) return
    this.setState({
      refreshingCompactions: true,
      compactionRefresh: { status: 'auditing', phase: 'auditing-compaction-records' },
      error: null
    })
    try {
      const result = await this.props.me.conversationCompactionRefresh({ conversationId })
      if (this.unmounted) return
      if (result.status === 'completed' && !result.jobId) {
        await this.completeCompactionRefresh(result)
        return
      }
      this.setState({
        compactionRefresh: {
          ...result,
          phase: result.status || 'queued'
        }
      }, this.pollCompactionRefresh)
    } catch (err) {
      if (this.unmounted) return
      this.setState({
        refreshingCompactions: false,
        error: err.message
      })
    }
  }

  browseSelectedZoom = () => {
    const zoomValue = String(this.state.filterZoom)
    const filter = zoomValue === '' ? undefined : { zoom: Number(zoomValue) }
    this.navigateToRoot(filter)
  }

  // Fetch one browse level — the identical call and cleaned shape the model
  // gets from conversation_browse — and place it at `depth` in the path.
  openBrowseLevel = async (depth, link, filter) => {
    const conversationId = this.getConversationId()
    const requestId = this.requestId
    const requestedFilter = filter || undefined
    this.browseRequestIds = this.browseRequestIds || {}
    const browseRequestId = (this.browseRequestIds[depth] || 0) + 1
    this.browseRequestIds[depth] = browseRequestId
    this.setState(state => {
      const path = state.path.slice(0, depth + 1)
      path[depth] = {
        link,
        requestLink: link || null,
        requestFilter: depth === 0 ? requestedFilter : undefined,
        node: null,
        parent: null,
        siblings: [],
        children: [],
        loading: true,
        error: null
      }
      return { path }
    })
    try {
      const browse = cleanConversationResult(await this.props.me.conversationBrowse({
        conversationId,
        link: link || undefined,
        filter: depth === 0 ? requestedFilter : undefined,
        start_at: 0,
        limit: 10,
        full_summary: true
      }))
      if (this.requestId !== requestId || this.browseRequestIds[depth] !== browseRequestId) return
      this.setState(state => {
        const path = state.path.slice(0, depth + 1)
        const level = path[depth] || { link }
        path[depth] = {
          ...level,
          link: browse.link || link || level.link,
          requestLink: link || null,
          requestFilter: depth === 0 ? requestedFilter : undefined,
          node: browse.node || level.node || null,
          parent: browse.parent || null,
          siblings: browse.siblings || [],
          children: browse.children || [],
          result: browse,
          loading: false,
          error: null
        }
        return { path }
      })
    } catch (err) {
      if (this.requestId !== requestId || this.browseRequestIds[depth] !== browseRequestId) return
      this.setState(state => {
        const path = state.path.slice()
        if (path[depth]) path[depth] = { ...path[depth], loading: false, error: err.message }
        return { path }
      })
    }
  }

  loadMoreBrowseLevel = async (depth, nextStartAt) => {
    const level = this.state.path[depth]
    if (!level || level.loading || nextStartAt === undefined || nextStartAt === null) return
    const conversationId = this.getConversationId()
    const requestId = this.requestId
    this.browseRequestIds = this.browseRequestIds || {}
    const browseRequestId = (this.browseRequestIds[depth] || 0) + 1
    this.browseRequestIds[depth] = browseRequestId
    this.setState(state => {
      const path = state.path.slice()
      if (path[depth]) path[depth] = { ...path[depth], loading: true, error: null }
      return { path }
    })
    try {
      const page = cleanConversationResult(await this.props.me.conversationBrowse({
        conversationId,
        link: level.requestLink || undefined,
        filter: level.requestFilter,
        start_at: nextStartAt,
        limit: 10,
        full_summary: true
      }))
      if (this.requestId !== requestId || this.browseRequestIds[depth] !== browseRequestId) return
      this.setState(state => {
        const path = state.path.slice()
        const current = path[depth]
        if (!current) return null
        const rootRequest = !current.requestLink
        const pageRelations = rootRequest
          ? [page.node].concat(page.siblings || []).filter(Boolean)
          : page.children || []
        const result = {
          ...(current.result || {}),
          ...page,
          node: current.node || page.node,
          parent: current.parent || page.parent || null,
          siblings: rootRequest
            ? (current.siblings || []).concat(pageRelations)
            : current.siblings || [],
          children: rootRequest
            ? current.children || []
            : (current.children || []).concat(pageRelations)
        }
        path[depth] = {
          ...current,
          node: result.node,
          parent: result.parent,
          siblings: result.siblings,
          children: result.children,
          result,
          loading: false,
          error: null
        }
        return { path }
      })
    } catch (err) {
      if (this.requestId !== requestId || this.browseRequestIds[depth] !== browseRequestId) return
      this.setState(state => {
        const path = state.path.slice()
        if (path[depth]) path[depth] = { ...path[depth], loading: false, error: err.message }
        return { path }
      })
    }
  }

  // Clicking a node: drill into summaries, preview source leaves. Summary
  // nodes always have children — stored child_count on older index documents
  // is unreliable, so zoom decides.
  enterNode = node => {
    if (!node || !node.link) return
    this.navigateToNode(node.link, node)
  }

  popToDepth = depth => {
    this.setState(state => ({ path: state.path.slice(0, depth + 1), preview: null }))
  }

  // Resolve one source link with the identical conversation_open_link call
  // and cleaned shape used by the model tool.
  openPreview = async (link, summary) => {
    const conversationId = this.getConversationId()
    const requestId = this.requestId
    const previewRequestId = (this.previewRequestId || 0) + 1
    this.previewRequestId = previewRequestId
    this.setState({ preview: { link, summary: summary || null, result: null, loading: true, error: null } })
    try {
      const opened = cleanConversationResult(await this.props.me.conversationOpenLink({
        conversationId,
        link,
        start_at: 0,
        budget_tokens: 1200
      }))
      if (this.requestId !== requestId || this.previewRequestId !== previewRequestId) return
      this.setState(state => (
        state.preview && state.preview.link === link
          ? { preview: { ...state.preview, result: opened || null, loading: false } }
          : null
      ))
    } catch (err) {
      if (this.requestId !== requestId || this.previewRequestId !== previewRequestId) return
      this.setState(state => (
        state.preview && state.preview.link === link
          ? { preview: { ...state.preview, loading: false, error: err.message } }
          : null
      ))
    }
  }

  loadMorePreview = async nextStartAt => {
    const preview = this.state.preview
    if (!preview || preview.loading || nextStartAt === undefined || nextStartAt === null) return
    const conversationId = this.getConversationId()
    const requestId = this.requestId
    const previewRequestId = (this.previewRequestId || 0) + 1
    this.previewRequestId = previewRequestId
    this.setState({ preview: { ...preview, loading: true, error: null } })
    try {
      const page = cleanConversationResult(await this.props.me.conversationOpenLink({
        conversationId,
        link: preview.link,
        start_at: nextStartAt,
        budget_tokens: 1200
      }))
      if (this.requestId !== requestId || this.previewRequestId !== previewRequestId) return
      this.setState(state => {
        if (!state.preview || state.preview.link !== preview.link) return null
        const previous = state.preview.result || {}
        return {
          preview: {
            ...state.preview,
            result: {
              ...previous,
              ...page,
              node: {
                ...(previous.node || {}),
                ...(page.node || {}),
                content: String(previous.node && previous.node.content || '') +
                  String(page.node && page.node.content || '')
              }
            },
            loading: false,
            error: null
          }
        }
      })
    } catch (err) {
      if (this.requestId !== requestId || this.previewRequestId !== previewRequestId) return
      this.setState(state => (
        state.preview && state.preview.link === preview.link
          ? { preview: { ...state.preview, loading: false, error: err.message } }
          : null
      ))
    }
  }

  // --- summary spine over compaction events ---

  compactionTimeline = () => {
    const messages = this.props.getMessages ? this.props.getMessages() : []
    const messageIndexById = messageIndexMap(messages)
    const items = []
    const seen = new Set()
    messages.forEach((message, index) => {
      for (const entry of getMessageCompactionEntries(message)) {
        const compactionId = getCompactionEntryId(entry)
        if (!compactionId) continue
        const holderDocId = getCompactionEntryHolderId(entry)
        const compaction = entry && entry.compaction || {}
        const id = [compactionId, compaction.model || '', holderDocId || '', compaction.createdAt || ''].join(':')
        if (seen.has(id)) continue
        seen.add(id)
        const displayIndex = holderDocId && messageIndexById.has(holderDocId)
          ? messageIndexById.get(holderDocId)
          : index
        items.push({
          entry,
          id,
          index: displayIndex,
          createdAt: Number(entry && entry.compaction && entry.compaction.createdAt) ||
            Number(message && (message.lastUpdated || message.ts)) || 0
        })
      }
    })
    items.sort((left, right) => (left.index - right.index) || (left.createdAt - right.createdAt))
    return items
  }

  selectCompaction = item => {
    this.setState({ selectedCompactionId: item.id })
    if (this.props.hydrateCompactionRecords) {
      void this.props.hydrateCompactionRecords()
    }
    const index = item && item.entry && item.entry.compaction && item.entry.compaction.index || {}
    const needsSummaryRecords = compactionSpineItems(index).some(spineItem => (
      !String(spineItem.text || '').trim()
    ))
    if (needsSummaryRecords && this.props.loadSummaryRecords) {
      void this.props.loadSummaryRecords(item.entry)
    }
  }

  spineFallbackTextForHandle = handle => {
    const messageId = messageIdForCompactionHandle(handle)
    const message = messageId && this.props.getMessageById && this.props.getMessageById(messageId)
    if (!message) return ''
    const replies = message.models || []
    for (const reply of replies.length ? replies : [null]) {
      const text = getClientMessageCompactionText({ handle, message, reply })
      if (text) return text
    }
    return ''
  }

  searchFilter = () => {
    const filter = {}
    const zoom = String(this.state.filterZoom)
    if (zoom !== '') filter.zoom = Number(zoom)
    if (this.state.filterKind.trim()) filter.kind = this.state.filterKind.trim()
    if (this.state.filterRole.trim()) filter.role = this.state.filterRole.trim()
    if (this.state.filterMessageId.trim()) filter.messageId = this.state.filterMessageId.trim()
    if (this.state.filterInReplyTo.trim()) filter.inReplyTo = this.state.filterInReplyTo.trim()
    if (this.state.filterToolCallId.trim()) filter.toolCallId = this.state.filterToolCallId.trim()
    return filter
  }

  searchConversation = async (startAt = 0) => {
    startAt = Number.isFinite(Number(startAt)) ? Math.max(0, Number(startAt)) : 0
    const conversationId = this.getConversationId()
    const query = this.state.searchTerm.trim()
    if (!conversationId) return
    const filter = this.searchFilter()
    const within = this.state.searchWithinSelected ? this.deepestSelectedLink() : undefined
    if (!query && !Object.keys(filter).length && !within) {
      this.clearSearch()
      return
    }
    const requestId = this.requestId
    const searchRequestId = (this.searchRequestId || 0) + 1
    this.searchRequestId = searchRequestId
    this.setState({ mode: 'search', searching: true, error: null })
    try {
      // The identical call and cleaned shape the model gets from
      // conversation_search.
      const searchResponse = cleanConversationResult(await this.props.me.conversationIndexSearch({
        conversationId,
        query,
        filter: Object.keys(filter).length ? filter : undefined,
        within: within || undefined,
        start_at: startAt,
        limit: 10,
        budget_tokens: 1200
      }))
      if (this.requestId !== requestId || this.searchRequestId !== searchRequestId) return
      this.setState({
        searchResults: startAt > 0
          ? this.state.searchResults.concat(searchResponse.hits || [])
          : (searchResponse.hits || []),
        searchQuery: searchResponse.query || query,
        searchNextStartAt: searchResponse.next_start_at ?? null,
        searching: false
      }, () => this.navigateToLocation(this.searchHistoryLocation()))
    } catch (err) {
      if (this.requestId !== requestId || this.searchRequestId !== searchRequestId) return
      this.setState({ searching: false, error: err.message })
    }
  }

  clearSearch = () => this.setState({
    searchTerm: '',
    searchResults: [],
    searchQuery: '',
    searchNextStartAt: null
  }, () => {
    if (this.conversationSearchField) this.conversationSearchField.clear()
    this.setMode('browse')
  })

  onSearchTermChange = event => this.setState({ searchTerm: event.target.value })
  onConversationSearchChange = searchTerm => this.setState({ searchTerm })
  setConversationSearchField = field => { this.conversationSearchField = field }

  onSearchKeyDown = event => {
    if (event.key === 'Enter') {
      event.preventDefault()
      this.searchConversation(0)
    }
    if (event.key === 'Escape' && this.state.mode === 'search') {
      event.preventDefault()
      this.clearSearch()
    }
  }

  renderFilters = () => {
    const { filterZoom, filterKind, filterRole, filterMessageId, filterInReplyTo, filterToolCallId, searchWithinSelected, status, mode } = this.state
    const rootZoom = Number(status && status.root && status.root.zoom)
    const maxSummaryZoom = Number.isFinite(rootZoom) ? Math.max(0, rootZoom - 1) : 3
    const zoomOptions = [{ value: '', label: mode === 'browse' ? 'coarsest zoom' : 'zoom: any' }, { value: '0', label: 'zoom 0 (source)' }]
    for (let level = 1; level <= maxSummaryZoom; level += 1) {
      zoomOptions.push({ value: String(level), label: `zoom ${level}` })
    }
    const set = key => event => this.setState({ [key]: event.target.value })
    const text = (key, value, placeholder) => (
      <input className='cvxChipInput'
             key={key}
             value={value}
             onChange={set(key)}
             onKeyDown={this.onSearchKeyDown}
             placeholder={placeholder}/>
    )
    return <div className='cvxFilters'>
             <select className='cvxChipSelect' value={filterZoom} onChange={set('filterZoom')}>
               {zoomOptions.map(option => <option key={option.value} value={option.value}>{option.label}</option>)}
             </select>
             {mode === 'browse' &&
               <SimpleButton label='Browse zoom' action={this.browseSelectedZoom}/>}
             {mode === 'search' && <React.Fragment>
             <select className='cvxChipSelect' value={filterRole} onChange={set('filterRole')}>
               <option value=''>role: any</option>
               <option value='user'>user</option>
               <option value='assistant'>assistant</option>
               <option value='tool'>tool</option>
             </select>
             {text('filterKind', filterKind, 'kind')}
             {text('filterMessageId', filterMessageId, 'messageId')}
             {text('filterInReplyTo', filterInReplyTo, 'inReplyTo')}
             {text('filterToolCallId', filterToolCallId, 'toolCallId')}
             <label className='cvxChipToggle'>
               <input type='checkbox'
                      checked={searchWithinSelected}
                      disabled={!this.deepestSelectedLink()}
                      onChange={event => this.setState({ searchWithinSelected: event.target.checked })}/>
               within selected
             </label>
             </React.Fragment>}
           </div>
  }

  renderPreview = () => {
    const { preview } = this.state
    if (!preview) return null
    return <React.Fragment>
             {preview.loading && <div className='cvxEmpty'>Loading…</div>}
             {preview.error && <div className='cvxPreviewError'>{preview.error}</div>}
             {!preview.loading && !preview.error && preview.result &&
               <ConversationOpenLinkResult
                 result={preview.result}
                 components={this.getComponents()}
                 renderLeaf={this.props.renderLeaf}
                 onOpen={(link, node) => this.enterNode(node || { link })}
                 onMore={this.loadMorePreview}/>}
           </React.Fragment>
  }

  getComponents = () => {
    if (!this.components) {
      this.components = this.props.components || getComponents({
        openLink: url => {
          if (String(url).startsWith('conversation://')) {
            this.navigateToNode(url, {
              link: url,
              zoom: String(url).includes('%2Fmip%2F') || String(url).includes('/mip/') ? 1 : 0
            })
            return
          }
          if (this.props.me && this.props.me.openWindow) this.props.me.openWindow(url)
        }
      })
    }
    return this.components
  }

  renderBrowse = () => {
    const { path, loading, status } = this.state
    if (loading && !path.length) {
      return <div className='cvxBody'><div className='cvxEmpty'>Loading index…</div></div>
    }
    const current = path[path.length - 1]
    const components = this.getComponents()
    const preview = this.renderPreview()
    return <div className='cvxBody'>
             <div className='cvxBrowsePane'>
               {!preview && path.length > 1 &&
                 <div className='cvxBreadcrumbs'>
                   {path.map((level, depth) => (
                     <button key={depth}
                             type='button'
                             className='cvxCrumb'
                             onClick={() => this.popToDepth(depth)}>
                       {depth === 0
                         ? 'conversation'
                         : cvxFirstLine(level.node && level.node.content) || `level ${depth}`}
                       {depth < path.length - 1 ? ' ›' : ''}
                     </button>
                   ))}
                 </div>}
               {preview}
               {!preview && current && current.node && <ConversationBrowseResult
                 result={current.result || {
                   node: current.node,
                   parent: current.parent || null,
                   siblings: current.siblings || [],
                   children: current.children || []
                 }}
                 components={components}
                 renderLeaf={this.props.renderLeaf}
                 onOpen={(link, child) => this.enterNode(child || { link })}
                 onMore={nextStartAt => this.loadMoreBrowseLevel(path.length - 1, nextStartAt)}/>}
               {!preview && current && current.loading && <div className='cvxColumnLoading'>Loading…</div>}
               {!preview && current && current.error && <div className='cvxColumnError'>{current.error}</div>}
             </div>
           </div>
  }

  renderSearch = () => {
    const { searchResults, searching, searchQuery, searchNextStartAt } = this.state
    return <div className='cvxBody'>
             <div className='cvxBrowsePane'>
               {searching
                 ? <div className='cvxEmpty'>Searching…</div>
                 : <div className='cvxSearchResultsScroller'>
                     <InfiniteScroll
                       items={searchResults}
                       pageSize={10}
                       getId={(hit, index) => hit && hit.link || `search-hit-${index}`}
                       getSelector={id => `[data-conversation-search-link="${String(id).replace(/"/g, '\\"')}"]`}
                       onLoadMore={this.loadMoreSearchResults}
                       renderItems={hits => <div className='cvxSearchResultWindow'>
                         {hits.map(hit => <div key={hit.link} data-conversation-search-link={hit.link}>
                           <ConversationSearchResults
                             results={[hit]}
                             query={searchQuery}
                             conversationId={this.getConversationId()}
                             onOpen={(link, openedHit) => this.enterNode(openedHit || { link })}/>
                         </div>)}
                       </div>}/>
                   </div>}
             </div>
           </div>
  }

  loadMoreSearchResults = async direction => {
    const startAt = this.state.searchNextStartAt
    if (direction !== 'after' || startAt === undefined || startAt === null || this.state.searching) {
      return { count: 0, update: () => {} }
    }
    const filter = this.searchFilter()
    const within = this.state.searchWithinSelected ? this.deepestSelectedLink() : undefined
    const response = cleanConversationResult(await this.props.me.conversationIndexSearch({
      conversationId: this.getConversationId(),
      query: this.state.searchQuery || this.state.searchTerm.trim(),
      filter: Object.keys(filter).length ? filter : undefined,
      within: within || undefined,
      start_at: startAt,
      limit: 10,
      budget_tokens: 1200
    }))
    const hits = response.hits || []
    return {
      count: hits.length,
      update: () => new Promise(resolve => this.setState(state => ({
        searchResults: state.searchResults.concat(hits),
        searchNextStartAt: response.next_start_at ?? null
      }), resolve))
    }
  }

  renderSpine = () => {
    const items = this.compactionTimeline()
    if (!items.length) {
      return <div className='cvxBody'><div className='cvxEmpty'>No compaction events yet</div></div>
    }
    const selected = items.find(item => item.id === this.state.selectedCompactionId) || items[items.length - 1]
    const compacted = selected.entry
    const compaction = compacted && compacted.compaction || {}
    const index = compaction.index || {}
    const handles = compactionSpineHandles(index)
    const storedMessage = compacted && compacted.message || {}
    const storedContentLength = Number(storedMessage.contentLength)
    const hasStoredContent = Boolean(storedMessage.content) && (
      Number.isFinite(storedContentLength)
        ? storedMessage.content.length === storedContentLength
        : !storedMessage.storage
    )
    const storedContentPending = Boolean(storedMessage.storage) &&
      !hasStoredContent &&
      !storedMessage.storageHydrationError
    const recordsByHandle = {}
    const records = this.props.getSummaryRecords ? this.props.getSummaryRecords(compacted) : []
    for (const record of normalizeConversationSummaryRecords(records)) {
      if (record && record.handle) {
        recordsByHandle[record.handle] = { ...record, head: cleanCompactionSummaryText(record.head) }
      }
    }
    mergeCompactionSpineMetadata(recordsByHandle, index)
    const recordsState = this.props.getSummaryRecordsState ? this.props.getSummaryRecordsState(compacted) : {}
    const pendingText = recordsState.error
      ? `Could not load summary records: ${recordsState.error}`
      : (recordsState.loading || !recordsState.loaded ? 'Loading summary records…' : 'Summary record unavailable')
    return <div className='cvxBody'>
             <div className='cvxTimeline'>
               {items.map((item, position) => {
                 const itemIndex = item.entry && item.entry.compaction && item.entry.compaction.index || {}
                 const itemHandles = compactionSpineHandles(itemIndex)
                 return <button key={item.id}
                                type='button'
                                className={item.id === selected.id ? 'cvxRow cvxRowSelected' : 'cvxRow'}
                                onClick={() => this.navigateToLocation({
                                  type: 'spine',
                                  selectedCompactionId: item.id
                                })}>
                          <span className='cvxRowText'>
                            <span className='cvxRowTitle'>
                              {`Compaction ${position + 1}`}
                              {item.createdAt ? ` · ${new Date(item.createdAt).toLocaleString()}` : ''}
                            </span>
                            <span className='cvxRowMeta'>
                              {[
                                itemHandles.length ? `${itemHandles.length} spine item${itemHandles.length === 1 ? '' : 's'}` : '',
                                item.entry && item.entry.compaction && item.entry.compaction.model || ''
                              ].filter(Boolean).join(' · ')}
                            </span>
                          </span>
                        </button>
               })}
             </div>
             <div className='cvxSpinePane'>
               <ConversationSummarySpine
                 handles={handles}
                 recordsByHandle={recordsByHandle}
                 pendingText={pendingText}
                 components={this.getComponents()}
                 loadBrowse={this.loadBrowseLink}
                 storedContent={hasStoredContent ? cleanCompactionSummaryText(storedMessage.content) : ''}
                 storedContentPending={storedContentPending}
                 exactContentUnavailable={!hasStoredContent && !storedContentPending}
                 onOpen={(link, node) => this.enterNode(node || { link })}/>
             </div>
           </div>
  }

  setMode = mode => {
    if (mode === this.state.mode) return
    if (mode === 'search') {
      this.navigateToLocation(this.searchHistoryLocation())
      return
    }
    if (mode === 'spine') {
      const items = this.compactionTimeline()
      const selected = items.find(item => item.id === this.state.selectedCompactionId) || items[items.length - 1]
      this.navigateToLocation({ type: 'spine', selectedCompactionId: selected && selected.id })
      return
    }
    const current = this.state.path[this.state.path.length - 1]
    this.navigateToLocation({
      type: 'browse',
      link: current && (current.link || current.node && current.node.link) || null,
      node: current && current.node || undefined
    })
  }

  render() {
    const { status, error, loading, mode, compactionRefresh, refreshingCompactions } = this.state
    const messageCount = status && formatConversationNumber(status.message_count)
    const statusLabel = status && status.phase
      ? String(status.phase).replace(/-/g, ' ')
      : (status && status.state) || (loading ? 'loading' : (error ? 'error' : 'ready'))
    const conciseStatus = [messageCount && `${messageCount} events`, statusLabel].filter(Boolean).join(' · ')
    return <div className='conversationBrowser'>
             <div className='cvxHeader'>
               <div className='cvxHistoryControls' aria-label='Conversation navigation history'>
                 <SimpleButton icon={Left}
                               label='Back'
                               action={this.canMoveHistory(-1) ? () => this.moveHistory(-1) : null}/>
                 <SimpleButton icon={Right}
                               label='Forward'
                               action={this.canMoveHistory(1) ? () => this.moveHistory(1) : null}/>
               </div>
               <div className='cvxModes'>
                 <RadioButtons small buttons={['browse', 'search', 'spine'].map(value => ({
                   selected: mode === value,
                   label: value === 'spine' ? 'Compactions' : value.charAt(0).toUpperCase() + value.slice(1),
                   select: () => this.setMode(value)
                 }))}/>
               </div>
               {mode === 'spine' &&
                 <SimpleButton icon={Redo}
                               action={refreshingCompactions ? null : this.refreshCompactionRecords}
                               label={refreshingCompactions ? 'Refreshing compactions…' : 'Refresh compactions'}/>}
               <SimpleButton icon={Redo} action={this.retryConversation} label='Refresh view'/>
             </div>
             <div className='cvxStatus cvxStatusBelowToolbar'>{conciseStatus}</div>
             {mode === 'spine' && compactionRefresh &&
               <div className='cvxStatus cvxStatusBelowToolbar'>
                 {[
                   String(compactionRefresh.phase || compactionRefresh.status || '').replace(/-/g, ' '),
                   compactionRefresh.progress && compactionRefresh.progress.summaryCount !== undefined
                     ? `${compactionRefresh.progress.summaryCount} summaries`
                     : '',
                   compactionRefresh.initialRepair && compactionRefresh.initialRepair.unresolvedSummaryCount
                     ? `${compactionRefresh.initialRepair.unresolvedSummaryCount} missing; regenerating`
                     : ''
                 ].filter(Boolean).join(' · ')}
               </div>}
             {mode !== 'spine' &&
               <div className='cvxSearchBar'>
                 <SearchField me={this.props.me}
                              onCreate={this.setConversationSearchField}
                              onSearch={this.onConversationSearchChange}
                              onKeyDown={this.onSearchKeyDown}
                              placeholder='Search this conversation'/>
                 <SimpleButton icon={SearchIcon} action={this.searchConversation} label='Search'/>
                 {mode === 'search' &&
                   <SimpleButton label='Browse' action={this.clearSearch}/>}
               </div>}
             {mode !== 'spine' && this.renderFilters()}
             {error && <div className='cvxError'>{error}</div>}
             {mode === 'search' ? this.renderSearch() : mode === 'spine' ? this.renderSpine() : this.renderBrowse()}
           </div>
  }
}


class SystemMessage extends Component {

  constructor(props) {
    super(props)
    this.state = {}
  }

  getUiState = () => {
    if (!this.localUiState) {
      this.localUiState = {}
    }
    const uiState = this.props.uiState || this.localUiState
    if (!uiState.open) {
      uiState.open = {}
    }
    if (uiState.editing === undefined) {
      uiState.editing = false
    }
    if (uiState.isThisOpen === undefined) {
      uiState.isThisOpen = this.props.readOnly
    }
    return uiState
  }

  setUiState = (updates, cb) => {
    const uiState = this.getUiState()
    Object.assign(uiState, updates)
    this.forceUpdate(cb)
  }

  setRef = (ref, content) => {
    const self = this
    this.contentEditable = ref
    if (ref) {
      ref.innerText = content
    }
  }

  handleKeyDown = event => {
    if (!isDesktop()) {
      return
    }
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault()
      this.commitEdit()
    } else if (event.key === 'Escape') {
      event.preventDefault()
      this.cancelEdit()
    }
  }

  cancelEdit = () => {
    this.setUiState({
      editing: false
    })
  }

  commitEdit = async () => {
    const newContent = this.contentEditable.innerText
    await this.props.saveContent(newContent)
    this.setUiState({
      editing: false
    })
  }

  componentDidMount() {
    ////////debugger
  }

  getSystemPromptText = () => {
    let {  content, systemPrompts, systemPromptsExpanded, deleteSystemPrompt, components, openSystemPrompts, editSystemPrompt, systemPromptMask, maskSystemPrompt } = this.props
    return systemPromptsExpanded.filter(x => !x.isFolder && systemPromptMask[x.id]).map(systemPrompt => {
      let { id, content, heading, title, name, isFolder } = systemPrompt
      return content
    }).join('\n\n')
  }

  render() {
    const uiState = this.getUiState()
    let delSysPrompt
    let {  content, systemPrompts, systemPromptsExpanded, deleteSystemPrompt, components, openSystemPrompts, editSystemPrompt, systemPromptMask, maskSystemPrompt } = this.props
    systemPrompts = systemPrompts || (systemPrompt && [systemPrompt]) || []
    systemPromptsExpanded = systemPromptsExpanded || []
    const TopLevel = {}
    const folders = []
    for (const top of systemPrompts) {
      TopLevel[top.id] = true
      if (top.isFolder) {
        folders.push(top)
      }
    }
    const getHeading = systemPrompt => {
      let { id, content, heading, title, name } = systemPrompt
      return heading || name
    }
    const sort = (x, y) => {
      const h1 = getHeading(x)
      const h2 = getHeading(y)
      if (!h1 || !h2) {
        //////debugger
      }
      return h1.localeCompare(h2)
    }
    systemPrompts.sort(sort)
    systemPromptsExpanded.sort(sort)
    if (systemPrompts.length > 0) {
      delSysPrompt = deleteSystemPrompt
    }
    const openThis = async () => {
      this.setUiState({
        isThisOpen: !uiState.isThisOpen
      })
    }
    const title = "System"
    const hostName = ""
    let rendered = {}
    const renderPrompt = systemPrompt => {
      let { id, content, heading, title, name, isFolder } = systemPrompt
      if (rendered[name]) {
        return null
      }
      rendered[name] = systemPrompt
      let contentDiv
      const del = async () => {
        deleteSystemPrompt(systemPrompt)
      }
      const isOpen = uiState.open[id]
      if (!isFolder) {
        contentDiv = <Markdown components={components}>{content}</Markdown>
      } else {
        const prompts = systemPromptsExpanded.filter(x => x.parents && x.parents.includes(id))
        contentDiv = prompts.map(renderPrompt)
      }
      const open = async () => {
        uiState.open[id] = !isOpen
        this.forceUpdate()
      }
      let toggle = () => {
        maskSystemPrompt(id)
      }
      if (this.props.readOnly) {
        toggle = () => {}
      }
      const selected = systemPromptMask[id] !== false
      const isTopLevel = TopLevel[id]
      const visibleClassName = selected ? 'systemPromptVisible' : 'systemPromptInvisible'
      return <div key={id} className='systemPromptContainer'>
               <div className='systemPromptHeader'>
                 <div className='systemPromptHeaderLeft'>
                   <div className='systemPromptHeaderIcon'>
                     <SimpleIcon src={isFolder ? Folder : isTopLevel ? File : AISaid}/>
                   </div>
                   <div className='systemPromptHeaderTitle'>
                     {name || title || heading}
                   </div>
                 </div>
                 <div className='systemPromptHeaderDisclosure'>
                   <SimpleButton key='disclosure' icon={isOpen ? Up: Down} action={open}/>
                   {!isFolder &&<div className={visibleClassName}>
                                  <SimpleButton icon={Visible} action={toggle}/>
                                </div>
                   }
                   {
                     !this.props.readOnly && isTopLevel && <SimpleButton icon={Cross} action={del}/>
                   }
                 </div>
               </div>
               <div className='systemPromptBody' style={isOpen ? null: { display: 'none'}}>
                 {contentDiv}
               </div>
             </div>
    }
    let addSystemPrompt = () => {
      ////debugger
      openSystemPrompts(systemPrompt => {
        this.setUiState({
          isThisOpen: true
        })
      })
    }
    let onClick = () => {
      this.setUiState({
        editing: true
      }, () => {
        this.contentEditable.focus()
      })
    }
    if (this.props.readOnly) {
      onClick = addSystemPrompt = null
    }
    let contentDiv = <ClickAwayListener mouseEvent={'mousedown'} onClickAway={this.cancelEdit}>
                       <div key='editable' className='editableContentContainer' onDoubleClick={onClick}>
                         <div ref={ref =>this.setRef(ref, content || '')}
                              className='editableContent'
                              onPaste={pasteText}
                              contentEditable={uiState.editing}
                              onKeyDown={this.handleKeyDown}
                              onBlur={this.commitEdit}/>

                       </div>
                     </ClickAwayListener>

    const sysMessage = <div key='sysMessage'
                            data-message-id='system'
                            className='systemInstructionMessage'>
                           <div className='systemInstructionMessageLeft'>
                             <div className='systemInstructionMessageLeftTop'>
                               <div className='systemInstructionTitle'>
                                 <SimpleIcon src={AISaid}/>
                                 <div className='systemInstructionTitle'>{title}</div>
                               </div>
                               <div className='systemInstructionControls'>
                                 {systemPrompts.length > 0 && <SimpleButton key='disclosure' icon={uiState.isThisOpen ? Up: Down} action={openThis}/> }
                                 {addSystemPrompt && <SimpleButton key='right' icon={Plus} action={addSystemPrompt}/>}
                                 {onClick && <SimpleButton key='edit' icon={EditIcon} action={onClick}/>}
                               </div>
                             </div>
                             <div className='systemInstructionHost'>{hostName}</div>
                             <div className='systemPrompts' style={uiState.isThisOpen ? null : {display: 'none'}}>
                               {
                                 systemPrompts.map(prompt => {
                                   return renderPrompt(prompt)
                                 })
                               }
                             </div>
                             {contentDiv}
                           </div>
                       </div>
    return sysMessage
  }
}

class IMessageDisplay extends React.Component {
  formatPhoneNumber(phoneNumber) {
    if (!phoneNumber) return '';
    const cleaned = phoneNumber.replace(/\D/g, '');
    const match = cleaned.match(/^1?(\d{3})(\d{3})(\d{4})$/);
    if (match) return `(${match[1]}) ${match[2]}-${match[3]}`;
    return phoneNumber;
  }

  getSenderName(sender) {
    if (sender.isMe) return 'Me';
    if (sender.contactName) return sender.contactName;
    if (sender.phoneNumber) return this.formatPhoneNumber(sender.phoneNumber);
    return '';
  }

  formatDate(dateStr) {
    const today = new Date();
    const date = new Date(dateStr.replace(' PST', ''));

    // If invalid date, return original
    if (isNaN(date)) return dateStr;

    // Check if message is from current week
    const weekAgo = new Date();
    weekAgo.setDate(weekAgo.getDate() - 7);

    // Within current week, just show day and time
    if (date > weekAgo) {
      return date.toLocaleString('en-US', {
        weekday: 'short',
        hour: 'numeric',
        minute: '2-digit'
      });
    }

    // Before current week, show full date
    return date.toLocaleString('en-US', {
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: '2-digit'
    });
  }

  render() {
    const { messages = [] } = this.props;

    const styles = {
      container: {
        fontFamily: '-apple-system, BlinkMacSystemFont, sans-serif',
        backgroundColor: '#fff',
        borderRadius: '8px',
        overflow: 'hidden',
        maxWidth: '800px',
        border: '1px solid #ddd',
        boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)'
      },
      header: {
        backgroundColor: '#f6f6f6',
        borderBottom: '1px solid #ddd',
        padding: '12px 16px',
        display: 'flex',
        alignItems: 'center',
        gap: '16px'
      },
      windowButtons: {
        display: 'flex',
        gap: '8px'
      },
      button: {
        width: '12px',
        height: '12px',
        borderRadius: '50%',
        border: 'none'
      },
      title: {
        flex: 1,
        fontSize: '13px',
        color: '#333',
        textAlign: 'center'
      },
      chat: {
        backgroundColor: '#fff',
        padding: '20px',
        display: 'flex',
        flexDirection: 'column',
        gap: '2px',
        minHeight: '300px'
      },
      messageGroup: {
        display: 'flex',
        flexDirection: 'column',
        gap: '2px',
        marginBottom: '16px'
      },
      message: {
        maxWidth: '70%',
        padding: '8px 12px',
        borderRadius: '18px',
        fontSize: '15px',
        lineHeight: '1.4'
      },
      sent: {
        alignSelf: 'flex-end',
        backgroundColor: '#007AFF',
        color: 'white',
        marginLeft: '32px',
        borderBottomRightRadius: '4px'
      },
      received: {
        alignSelf: 'flex-start',
        backgroundColor: '#E9E9EB',
        color: 'black',
        marginRight: '32px',
        borderBottomLeftRadius: '4px'
      },
      sender: {
        fontSize: '12px',
        color: '#666',
        marginBottom: '4px',
        marginLeft: '12px'
      },
      timestamp: {
        fontSize: '11px',
        color: '#8e8e93',
        marginTop: '4px',
        alignSelf: 'center'
      }
    };

    return (
      <div style={styles.container}>
        <div style={styles.header}>
          <div className='windowButtons'>
            <button style={{...styles.button, backgroundColor: '#ff5f57'}} />
            <button style={{...styles.button, backgroundColor: '#febc2e'}} />
            <button style={{...styles.button, backgroundColor: '#28c840'}} />
          </div>
          <div style={styles.title}>Messages</div>
        </div>
        <div style={styles.chat}>
          {messages.filter(message => message.text || message.attachment).map((message, index) => {
            const showSender = !message.isFromMe &&
              (index === 0 || messages[index - 1].sender?.phoneNumber !== message.sender?.phoneNumber);

            let text = message.text
            if (text === '￼' && message.attachment) {
              const { mimeType } = message.attachment
              let shared = 'Shared'
              if (message.isFromMe) {
                shared = "You shared"
              }
              if (mimeType.startsWith("image")) {
                text = shared + ' an image.'
              } else if (mimeType.startsWith("video")) {
                text = shared + ' a movie.'
              } else {
                text = shared + ' a file.'
              }
            }
            return (
              <div key={message.id} style={styles.messageGroup}>
                {showSender && message.sender && (
                  <div style={styles.sender}>
                    {this.getSenderName(message.sender)}
                  </div>
                )}
                <div style={styles.timestamp}>
                  {this.formatDate(message.date)}
                </div>
                {text && (
                  <div style={{
                    ...styles.message,
                    ...(message.isFromMe ? styles.sent : styles.received)
                  }}>
                    {text}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    );
  }
}
class BrowserTab extends React.Component {
  render() {
    const { url = '', content = '' } = this.props;

    const styles = {
      container: {
        fontFamily: '-apple-system, BlinkMacSystemFont, sans-serif',
        backgroundColor: '#fff',
        borderRadius: '8px',
        overflow: 'hidden',
        width: '100%',
        boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
        border: '1px solid #ddd'
      },
      header: {
        backgroundColor: '#f6f6f6',
        borderBottom: '1px solid #ddd',
        padding: '12px 16px',
        display: 'flex',
        gap: '16px'
      },
      windowButtons: {
        display: 'flex',
        gap: '8px'
      },
      button: {
        width: '12px',
        height: '12px',
        borderRadius: '50%',
        border: 'none',
        padding: 0
      },
      closeButton: {
        backgroundColor: '#ff5f57'
      },
      minimizeButton: {
        backgroundColor: '#febc2e'
      },
      maximizeButton: {
        backgroundColor: '#28c840'
      },
      urlBar: {
        flex: 1,
        backgroundColor: '#fff',
        borderRadius: '4px',
        padding: '6px 12px',
        fontSize: '13px',
        color: '#666',
        border: '1px solid #ddd'
      },
      content: {
        padding: '20px',
        minHeight: '200px',
        color: '#333',
        lineHeight: '1.5',
        backgroundColor: '#fff',
        maxHeight: '600px',
        overflowY: 'auto'
      }
    };

    return (
      <div style={styles.container}>
        <div style={styles.header}>
          <div className='windowButtons'>
            <button style={{...styles.button, ...styles.closeButton}} />
            <button style={{...styles.button, ...styles.minimizeButton}} />
            <button style={{...styles.button, ...styles.maximizeButton}} />
          </div>
          <div style={styles.urlBar}>
            {url}
          </div>
        </div>
        <div style={styles.content}>
          {content}
        </div>
      </div>
    );
  }
}

class CodeDisplay extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      copied: false
    };
  }

  handleCopy = () => {
    navigator.clipboard.writeText(this.props.code);
    this.setState({ copied: true });
    setTimeout(() => this.setState({ copied: false }), 2000);
  }

  render() {
    const { code, language = 'javascript', output, title } = this.props;
    const { copied } = this.state;

    const styles = {
      container: {
        fontFamily: 'monospace',
        backgroundColor: '#1a1a1a',
        borderRadius: '4px',
        overflow: 'hidden',
        color: '#fff',
        fontSize: '14px',
        maxHeight: '400px',
        width: '100%',
        display: 'flex',
        flexDirection: 'column'
      },
      header: {
        backgroundColor: '#2a2a2a',
        padding: '8px 16px',
        borderBottom: '1px solid #333',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
      },
      windowButtons: {
        display: 'flex',
        gap: '8px'
      },
      button: {
        width: '12px',
        height: '12px',
        borderRadius: '50%',
        border: 'none'
      },
      copyButton: {
        backgroundColor: 'transparent',
        border: '1px solid #666',
        color: '#fff',
        padding: '4px 8px',
        borderRadius: '4px',
        cursor: 'pointer',
        fontSize: '12px',
        whiteSpace: 'noWrap'
      },
      codeContainer: {
        display: 'flex'
      },
      lineNumbers: {
        padding: '16px 8px',
        borderRight: '1px solid #333',
        textAlign: 'right',
        color: '#666',
        userSelect: 'none',
        minWidth: 24
      },
      code: {
        padding: '16px',
        margin: 0,
        overflowX: 'auto',
        flex: 1
      }
    };

    return (
      <div style={styles.container}>
        <div style={styles.header}>
          <div className='windowButtons'>
            <button style={{ ...styles.button, backgroundColor: '#ff5f56' }} />
            <button style={{ ...styles.button, backgroundColor: '#ffbd2e' }} />
            <button style={{ ...styles.button, backgroundColor: '#27c93f' }} />
          </div>
          <div className='codeDisplayTitle'>{title}</div>
          <button
            onClick={this.handleCopy}
            style={styles.copyButton}
          >
            {copied ? 'Copied!' : 'Copy'}
          </button>
        </div>
        <FollowPane follow={this.props.follow} style={{ flex: 1, minHeight: 0 }}>
          <div className='codeContainer' style={styles.codeContainer}>
            <div style={styles.lineNumbers}>
              {Array.from({ length: (code).split('\n').length }).map((_, i) => (
                <div key={i + 1}>{i + 1}</div>
              ))}
            </div>
            <div className='codeContent'>
              <pre style={styles.code}>
                <code>{code}</code>
                <div class="codeOutput">
                  <code>{output}</code>
                </div>
              </pre>
            </div>
          </div>
        </FollowPane>
      </div>
    );
  }
}


const DEFAULT_TREE = {
  name: "christopheroliver",
  type: "directory",
  path: "/Users/UserName",
  children: [
    {
      name: "Applications",
      type: "directory",
      children: []
    },
    {
      name: "Desktop",
      type: "directory",
      children: []
    },
    {
      name: "Documents",
      type: "directory",
      children: [
        {
          name: "Toolset.js.txt",
          type: "file",
          kind: "Plain Text",
          dateModified: "Today at 2:51 PM"
        }
      ]
    },
    {
      name: "Downloads",
      type: "directory",
      children: []
    },
    {
      name: "Pictures",
      type: "directory",
      children: []
    },
    {
      name: "Music",
      type: "directory",
      children: []
    },
    {
      name: "Movies",
      type: "directory",
      children: []
    }
  ]
};

const FinderWindow = ({ directoryTree = DEFAULT_TREE }) => {
  const [selectedPath, setSelectedPath] = useState('');

  const styles = {
    container: {
      fontFamily: '-apple-system, BlinkMacSystemFont, sans-serif',
      backgroundColor: '#fff',
      width: '100%',
      borderRadius: '8px',
      minHeight: '400px',
      maxHeight: '100%',
      overflowY: "auto",
      display: 'flex',
      flexDirection: 'column',
      color: 'black'
    },
    toolbar: {
      background: 'linear-gradient(to bottom, #f8f8f8, #e8e8e8)',
      borderBottom: '1px solid #c8c8c8',
      padding: '12px',
      display: 'flex',
      flexDirection: 'column',
      gap: '8px'
    },
    mainSection: {
      display: 'flex',
      flex: 1
    },
    sidebar: {
      width: '200px',
      background: 'linear-gradient(to right, #f3f3f3, #ebebeb)',
      borderRight: '1px solid #d8d8d8',
      overflow: 'auto',
      display: 'none'
    },
    mainArea: {
      flex: 1,
      background: '#ffffff',
    },
    headerButtons: {
      display: 'flex',
      gap: '8px',
      alignItems: 'center'
    },
    circle: {
      width: '12px',
      height: '12px',
      borderRadius: '50%',
      border: '1px solid rgba(0, 0, 0, 0.1)',
      boxShadow: 'inset 0 1px 1px rgba(255, 255, 255, 0.5)'
    },
    closeButton: {
      background: 'linear-gradient(to bottom, #ff6058, #ff1a1a)',
    },
    minimizeButton: {
      background: 'linear-gradient(to bottom, #ffbe2f, #ffad33)'
    },
    maximizeButton: {
      background: 'linear-gradient(to bottom, #29c941, #17a92b)'
    },
    title: {
      flex: 1,
      textAlign: 'center',
      fontSize: '13px',
      color: '#4d4d4d',
      textShadow: '0 1px 0 rgba(255, 255, 255, 0.5)'
    },
    navigationBar: {
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      display: 'none'
    },
    navButton: {
      background: 'linear-gradient(to bottom, #fbfbfb, #e8e8e8)',
      border: '1px solid #c8c8c8',
      borderRadius: '4px',
      padding: '4px 8px',
      color: '#4d4d4d',
      fontSize: '14px'
    },
    sectionTitle: {
      fontSize: '12px',
      fontWeight: '500',
      color: '#737373',
      padding: '8px 10px 4px',
      textTransform: 'uppercase'
    },
    sidebarItem: {
      padding: '4px 10px',
      fontSize: '13px',
      display: 'flex',
      alignItems: 'center',
      gap: '6px',
      color: '#333',
      cursor: 'default'
    },
    tableHeader: {
      display: 'flex',
      padding: '6px 12px',
      background: 'linear-gradient(to bottom, #f6f6f6, #efefef)',
      borderBottom: '1px solid #d8d8d8'
    },
    headerCell: {
      fontSize: '12px',
      color: '#666',
      fontWeight: '500'
    },
    nameCell: {
      flex: 1
    },
    kindCell: {
      width: '120px'
    },
    dateCell: {
      width: '150px'
    },
    fileItem: {
      display: 'flex',
      padding: '0px 12px',
      fontSize: '13px',
      alignItems: 'center',
      cursor: 'default'
    },
    selectedFile: {
      background: 'linear-gradient(to bottom, #116cd6, #0851a6)',
      color: '#fff'
    },
    footer: {
      padding: '4px 8px',
      height: '28px',
      fontSize: '11px',
      color: '#666',
      background: 'linear-gradient(to bottom, #f6f6f6, #efefef)',
      borderTop: '1px solid #d8d8d8',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center'
    }
  };

  const renderSidebarSections = () => {
    const sections = [
      {
        title: "Favorites",
        items: [
          { name: "AirDrop", icon: "📡" },
          { name: "Recents", icon: "🕒" },
          { name: "Applications", icon: "📱" },
          { name: "Desktop", icon: "🖥️" },
          { name: "Documents", icon: "📄" },
          { name: "Downloads", icon: "⬇️" },
        ]
      },
      {
        title: "iCloud",
        items: [
          { name: "iCloud Drive", icon: "☁️" },
          { name: "Shared", icon: "🔄" }
        ]
      }
    ];

    return sections.map(section => (
      <div key={section.title}>
        <div style={styles.sectionTitle}>{section.title}</div>
        {section.items.map(item => (
          <div key={item.name} style={styles.sidebarItem}>
            <span>{item.icon}</span>
            <span>{item.name}</span>
          </div>
        ))}
      </div>
    ));
  };

  const renderFiles = () => {
    const files = directoryTree.children || [];
    return files.map(file => (
      <div
        key={file.name}
        style={{
          ...styles.fileItem,
          ...(selectedPath === file.name ? styles.selectedFile : {})
        }}

      >
        <div style={styles.nameCell}>
          <div className='finderNameCell'><SimpleIcon src={file.type === 'directory' ? Folder: File}/><span>{file.name}</span></div>
        </div>
        <div style={styles.kindCell}>{file.kind || (file.type === 'directory' ? 'Folder' : 'File')}</div>
        <div style={styles.dateCell}>{file.dateModified || '--'}</div>
      </div>
    ));
  };
  let name = directoryTree.name
  if (!name) {
    let comps = directoryTree.path.split('/').filter(x=>x)
    name = comps[comps.length-1]
  }
  return (
    <div style={styles.container}>
      <div style={styles.toolbar}>
        <div style={styles.headerButtons}>
          <div className='windowButtons'>
            <div style={{...styles.circle, ...styles.closeButton}} />
            <div style={{...styles.circle, ...styles.minimizeButton}} />
            <div style={{...styles.circle, ...styles.maximizeButton}} />
            </div>
          <div style={styles.title}>{name}</div>
        </div>
        <div style={styles.navigationBar}>
          <button style={styles.navButton}>←</button>
          <button style={styles.navButton}>→</button>
          <button style={styles.navButton}>↑</button>
          <div style={{ flex: 1 }} />
          <button style={styles.navButton}>☰</button>
          <button style={styles.navButton}>⊞</button>
        </div>
      </div>
      <div style={styles.mainSection}>
        <div style={styles.sidebar}>
          {renderSidebarSections()}
        </div>
        <div style={styles.mainArea}>
          <div style={styles.tableHeader}>
            <div style={{...styles.headerCell, ...styles.nameCell}}>Name</div>
            <div style={{...styles.headerCell, ...styles.kindCell}}>Kind</div>
            <div style={{...styles.headerCell, ...styles.dateCell}}>Date Modified</div>
          </div>
          <div className='finderFiles'>
            {renderFiles()}
          </div>
        </div>
      </div>
      <div style={styles.footer}>
        <div>{directoryTree.path || directoryTree.name}</div>
        <div>{directoryTree.children ? `${directoryTree.children.length } items`: ''}</div>
      </div>
    </div>
  );
};



const stringifyTerminalText = value => {
  if (value === undefined || value === null) return ''
  if (typeof value === 'string') return value
  try {
    return JSON.stringify(value, null, 2)
  } catch (err) {
    return String(value)
  }
}

const normalizeTerminalEntries = ({ input = '', output = '', entries, io, exitCode, errorMessage }) => {
  const transcript = Array.isArray(entries) ? entries : io
  if (Array.isArray(transcript)) {
    return transcript.filter(Boolean).map(entry => {
      if (typeof entry === 'string') {
        return { type: 'output', text: entry }
      }
      let type = entry.type || entry.kind
      if (!type) {
        if ('input' in entry) type = 'input'
        else if ('stderr' in entry) type = 'stderr'
        else if ('error' in entry) type = 'error'
        else if ('exit_code' in entry || 'exitCode' in entry) type = 'status'
        else type = 'output'
      }
      return {
        ...entry,
        type,
        text: stringifyTerminalText(entry.text ?? entry.content ?? entry.output ?? entry.input ?? entry.stderr ?? entry.error ?? '')
      }
    })
  }

  const normalized = []
  if (input) {
    normalized.push({ type: 'input', text: stringifyTerminalText(input) })
  }
  if (output) {
    normalized.push({ type: 'output', text: stringifyTerminalText(output) })
  }
  if (errorMessage) {
    normalized.push({ type: 'error', text: stringifyTerminalText(errorMessage) })
  }
  if (exitCode !== undefined && exitCode !== null) {
    normalized.push({ type: 'status', exit_code: exitCode })
  }
  return normalized
}

const TerminalWindow = ({ input = '', output = '', entries, io, exitCode, errorMessage, follow }) => {
  const styles = {
    container: {
      fontFamily: '-apple-system, BlinkMacSystemFont, sans-serif',
      backgroundColor: '#1E1E1E',
      borderRadius: '8px',
      width: '100%',
      boxShadow: '0 2px 10px rgba(0, 0, 0, 0.2)',
      border: '1px solid #2A2A2A',
      height: 'calc(100% - 60px)',
    },
    header: {
      backgroundColor: '#2A2A2A',
      padding: '12px 16px',
      display: 'flex',
      alignItems: 'center',
      gap: '16px'
    },
    windowButtons: {
      display: 'flex',
      gap: '8px'
    },
    button: {
      width: '12px',
      height: '12px',
      borderRadius: '50%',
      border: 'none',
      padding: 0
    },
    closeButton: {
      backgroundColor: '#ff5f57'
    },
    minimizeButton: {
      backgroundColor: '#febc2e'
    },
    maximizeButton: {
      backgroundColor: '#28c840'
    },
    title: {
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
      fontSize: '16px',
      color: '#9A9A9A',
      fontWeight: '500',
      transform: 'translate(-40px, 0)'
    },
    content: {
      padding: '20px',
      width: 'calc(100% - 40px)',
      height: 'calc(100% - 40px)',
      overflowY: 'auto',
      color: '#F0F0F0',
      lineHeight: '1.5',
      fontFamily: 'Menlo, Monaco, "Courier New", monospace',
      fontSize: '13px',
      backgroundColor: '#1E1E1E',
      whiteSpace: 'pre-wrap'
    },
    prompt: {
      color: '#50FA7B',
      userSelect: 'none'
    },
    input: {
      color: '#F0F0F0'
    },
    output: {
      color: '#BBBBBB',
      display: 'block',
      paddingLeft: '0px'  // Aligns with text after prompt
    },
    stderr: {
      color: '#FFB86C',
      display: 'block',
      paddingLeft: '0px'
    },
    error: {
      color: '#FF6E6E',
      display: 'block',
      paddingLeft: '0px'
    },
    status: {
      color: '#8BE9FD',
      display: 'block',
      paddingLeft: '0px'
    }
  };

  const terminalEntries = normalizeTerminalEntries({ input, output, entries, io, exitCode, errorMessage })

  const renderTextLines = (entry, style, keyPrefix, trimLeft = false) => {
    const text = stringifyTerminalText(entry.text)
    if (!text) return null
    const lines = text.split('\n')
    return lines.map((line, index) => {
      const renderedLine = trimLeft ? line.trimLeft() : line
      return <React.Fragment key={`${keyPrefix}-${index}`}>
               <span style={style}>{renderedLine}</span>
               {index < lines.length - 1 && '\n'}
             </React.Fragment>
    })
  }

  const renderInput = (entry, index) => {
    const lines = stringifyTerminalText(entry.text).split('\n')
    return lines.map((line, lineIndex) => (
      <React.Fragment key={`input-${index}-${lineIndex}`}>
        <span style={styles.prompt}>$ </span>
        <span style={styles.input}>{line}</span>
        {lineIndex < lines.length - 1 && '\n'}
      </React.Fragment>
    ))
  }

  const renderStatus = (entry, index) => {
    const exitCode = entry.exit_code ?? entry.exitCode
    if (exitCode === undefined || exitCode === null) return null
    return <span key={`status-${index}`} style={exitCode === 0 ? styles.status : styles.error}>
             {`[exit ${exitCode}]`}
           </span>
  }

  const renderContent = () => {
    return (
      <>
        {terminalEntries.map((entry, index) => {
          const type = entry.type || (entry.exit_code !== undefined || entry.exitCode !== undefined ? 'status' : 'output')
          const newline = index < terminalEntries.length - 1 ? '\n' : null
          let rendered
          switch (type) {
            case 'input':
            case 'stdin':
            case 'command':
              rendered = renderInput(entry, index)
              break
            case 'stderr':
              rendered = renderTextLines(entry, styles.stderr, `stderr-${index}`, true)
              break
            case 'error':
              rendered = renderTextLines(entry, styles.error, `error-${index}`, true)
              break
            case 'status':
            case 'exit':
              rendered = renderStatus(entry, index)
              break
            case 'output':
            case 'stdout':
            default:
              rendered = renderTextLines(entry, styles.output, `output-${index}`, true)
              break
          }
          return <React.Fragment key={`terminal-entry-${index}`}>{rendered}{newline}</React.Fragment>
        })}
      </>
    );
  };

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <div className='windowButtons'>
          <button style={{...styles.button, ...styles.closeButton}} />
          <button style={{...styles.button, ...styles.minimizeButton}} />
          <button style={{...styles.button, ...styles.maximizeButton}} />
        </div>
        <div style={styles.title}>
          Terminal
        </div>
      </div>
      <FollowPane follow={follow} style={styles.content}>
        {renderContent()}
      </FollowPane>
    </div>
  );
};



const TextEditViewer = ({ filePath = '', content = '', follow }) => {
  if (typeof content !== 'string') {
    content = JSON.stringify(content, null, ' ')
  }
  const copyAction = async () => {
    await delay(0.3)
    navigator.clipboard.writeText(content)
  }
  const styles = {
    container: {
      fontFamily: '-apple-system, BlinkMacSystemFont, sans-serif',
      backgroundColor: '#fff',
      borderRadius: '8px',
      overflow: 'hidden',
      width: '100%',
      maxWidth: '800px',
      boxSizing: 'border-box',
      boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
      border: '1px solid #ddd'
    },
    header: {
      backgroundColor: '#f6f6f6',
      borderBottom: '1px solid #ddd',
      paddingLeft: '12px',
      paddingTop: '4px',
      paddingBottom: '4px',
      display: 'flex',
      flexDirection: 'column',
      gap: '8px'
    },
    titleBar: {
      display: 'flex',
      alignItems: 'center',
      gap: '16px'
    },
    windowButtons: {
      display: 'flex',
      gap: '8px'
    },
    button: {
      width: '12px',
      height: '12px',
      borderRadius: '50%',
      border: 'none',
      padding: 0
    },
    closeButton: {
      backgroundColor: '#ff5f57'
    },
    minimizeButton: {
      backgroundColor: '#febc2e'
    },
    maximizeButton: {
      backgroundColor: '#28c840'
    },
    title: {
      flex: 1,
      textAlign: 'center',
      fontSize: '13px',
      color: '#666'
    },
    pathBar: {
      fontSize: '11px',
      color: '#666',
      textAlign: 'center',
      paddingTop: '4px',
      fontWeight: '500'
    },
    content: {
      padding: '20px',
      minHeight: '400px',
      maxHeight: '400px',
      overflow: 'auto',
      boxSizing: 'border-box',
      color: '#333',
      lineHeight: '1.5',
      fontFamily: 'Menlo, Monaco, "Courier New", monospace',
      fontSize: '13px',
      backgroundColor: '#fff',
      whiteSpace: 'pre-wrap'
    }
  };

  return (
    <div className='textEditViewer'>
      <div className='textEditViewerFullPath'>
        {ellipsizePath(filePath, 80)}
      </div>
      <div style={styles.container}>
        <div style={styles.header}>
          <div style={styles.titleBar}>
            <div className='windowButtons'style={styles.windowButtons}>
            <button style={{...styles.button, ...styles.closeButton}} />
              <button style={{...styles.button, ...styles.minimizeButton}} />
              <button style={{...styles.button, ...styles.maximizeButton}} />
            </div>
            <div style={styles.title}>
              {filePath.split('/').pop() || 'Untitled'}
            </div>
            <div className='fileCopyButton'>
              <SimpleButton icon={Copy} action={copyAction}/>
            </div>
          </div>
        </div>
        <FollowPane follow={follow} style={styles.content}>
          {content}
        </FollowPane>
      </div>
    </div>
  );
};







/**
 * Convert JSON to Markdown
 * @param {Object} json - JSON object to convert
 * @param {number} level - Current nesting level (for indentation)
 * @returns {string} - Markdown string
 */
function jsonToMarkdown(json, level = 0) {
    const indent = '  '.repeat(level);
    let markdown = '';

    if (Array.isArray(json)) {
        json.forEach(item => {
            markdown += `${indent}- ${typeof item === 'object' ? '' : item}\n`;
            if (typeof item === 'object') {
                markdown += jsonToMarkdown(item, level + 1);
            }
        });
    } else if (typeof json === 'object') {
        Object.keys(json).forEach(key => {
            const value = json[key];
            if (typeof value === 'object' && value !== null) {
                markdown += `${indent}- **${key}**:\n`;
                markdown += jsonToMarkdown(value, level + 1);
            } else {
                markdown += `${indent}- **${key}**: ${value}\n`;
            }
        });
    } else {
        markdown += `${indent}${json}\n`;
    }

    return markdown;
}


class Autoheight extends Component {
  setRef = (ref) => {
    if (this.resizeObserver) {
      this.resizeObserver.unobserve(this.ref)
      if (ref) {
        this.resizeObserve.observe(ref)
      }
    }
    this.ref = ref
  }
  resizeLater = () => {
    clearTimeout(this.resizeTimeout)
    this.resizeTimeout = setTimeout(() => {
      if (this.props.swiper) {
        if (this.props.swiper.activeIndex === this.props.index) {
          requestAnimationFrame(() => {
            try {
              this.props.swiper.update()
              this.props.swiper.updateAutoHeight()
            } catch (err) {
              console.warn(err)
            }
          })
        }
      }
    }, 16)
  }
  componentDidMount() {
    this.resizeObserver = new ResizeObserver(entries => {
      this.resizeLater()
    })
    this.resizeObserver.observe(this.ref)
  }

  componentWillUnmount() {
    this.resizeObserver.disconnect()
  }
  render() {
    return <div className='autoheight' ref={this.setRef}>
             {this.props.children}
             </div>
  }

}

export class ImageComp extends Component {
  constructor(props) {
    super(props)
    this.state = {
    }
  }

  onError = async () => {
    let replacement = []
    try {
      this.setState({
        replacement
      })
      // Perform HEAD request to determine Content-Type
      const response = await fetch(url, { method: 'HEAD' });
      const contentType = response.headers.get('Content-Type');
      if (contentType && contentType.startsWith('video')) {
        replacement = <div className='aiLink'><video className='aiLinkImg' src={src} onError={this.onError}/></div>
      } else {
      }
    } catch (err) {
      console.error('Error fetching Content-Type:', err);
    }
    this.setState({
      replacement
    })
  }

  render() {
    if (this.state.replacement) {
      return this.state.replacement
    }
    const { src } = this.props
    return <div className='aiLink'><img className='aiLinkImg' src={src} onError={this.onError}/></div>
  }
}


class FadeSpanOld extends React.Component {

  setRef=ref => {
    this.ref = ref
  }

  componentWillUnmount() {
    //////console.log("FadeSpan unmounted", this.props.debugKey)
  }

  componentDidMount() {
    //////console.log("FadeSpan mounted", this.props.debugKey)
    requestAnimationFrame(() => {
      const el = this.ref
      if (el) {
        el.style.transition = 'opacity 0.4s cubic-bezier(0.25, 0.1, 0.25, 1.0)'
        const delay = (this.props.index * 1) + 'ms'
        el.style.transitionDelay = delay
        ////console.log("animation delay", this.props.debugKey, this.props.index, delay)
        requestAnimationFrame(() => {
          if (this.ref) {
            this.ref.style.opacity = 1
          }
        });
      }
    });
  }

  render() {
    return (
      <span
        id={this.props.id}
        ref={this.setRef}
        style={{
          opacity: 0,
        }}
      >
        {this.props.children}
      </span>
    );
  }
}


export const getComponents = ({openLink} = {}) => {
  const components = {
    antthinking: opts => {
      const { node, ...props } = opts
      return <div className={'thinking'} {...props}/>
    },
    think: opts => {
      const { node, ...props } = opts
      return <div className={'thinking'} {...props}/>
    },
    reasoning: opts => {
      const { node, ...props } = opts
      return <div className={'thinking'} {...props}/>
    },
    signed: opts => {
      const { node, ...props } = opts
      return <div className={'signed'} {...props}/>
    },
    'gemini-sig': opts => {
      const { node, ...props } = opts
      return <div className={'signed'} {...props}/>
    },
    'openai-sig': opts => {
      const { node, ...props } = opts
      return <div className={'signed'} {...props}/>
    },
    p: opts => {
        const { node, ...props } = opts
        return <p {...props}/>
    },
    table: opts => {
      const { node, ...props} = opts
      return <div className='tableContainer'><table {...props} /></div>
    },
    td: opts => {
      const { node, ...props} = opts
      return <td {...props} />
    },
    th: opts => {
      const { node, ...props} = opts
      return <th {...props} />
    },
    pre: PreBlock,
    code: CodeBlock,
    check: CheckMarkComp,
    ol: opts => {
      const { node, ...props } = opts
      let className
      if (props.children.filter(x => x.props && x.props.node.tagName === 'li').length === 1) {
        className = 'olSingle'
      }
      return <ol className={className} {...props}/>
    },
    ul: opts => {
      const { node, ...props } = opts
      let className
      if (props.children && props.children.filter(x => x.props && x.props.node && x.props.node.tagName === 'li').length === 1) {
        className = 'olSingle'
      }
      return <ul className={className} {...props}/>
    },
    li: opts => {
      let { node, children } = opts
      if (Array.isArray(children)) {
        children = children.filter((x, i) => i > 0 || x[i] !== '\n')
      }
      if (children && (children[0] === '\n' || children.length > 1)) {
        return <li className='liFun'><div className='liContent'>{children}</div></li>
      } else {
        const { node, ...props } = opts
        return <li {...props}/>
      }
    },
    img: ({src, alt}) => {
      return <ImageComp src={src}/>
    },
    a: props => {
      const { node, children } = props
      const { href, name } = node.properties
      if (!href || !href.startsWith) {
        return null
      }
      const title = ''
      const prefix = "ai://?q="
      let onClick
      let tooltip
      if (href.startsWith(prefix)) {
        let q = (href + ' ' + (title || '')).substring(prefix.length)
      } else {
        tooltip = href
        onClick = e => {
          openLink(href)
        }
      }
      const nop = () => {
      }
      let enter
      let leave
      return <a id={name} onPointerEnter={enter} onPointerLeave={leave}
                className='aiLink' onMouseDown={onClick}>{children}</a>
    }
  }
  return components
}

const insertImage = (img) => {
  const sel = window.getSelection();
  if (sel.rangeCount > 0) {
    const range = sel.getRangeAt(0);
    range.insertNode(img);
    const space = document.createTextNode('\u200B');
    range.insertNode(space);
    // Move the range after the inserted image
    range.setStartAfter(img);
    range.setEndAfter(img);

    // Update the selection
    sel.removeAllRanges();
    sel.addRange(range);
  } else {
    // If the rangeCount is 0, append the image at the end
    const space = document.createTextNode('\u200B');
    range.insertNode(space);
    range.insertNode(img);
    const range = document.createRange();
    range.setStartAfter(img);
    range.setEndAfter(img);
    sel.removeAllRanges();
    sel.addRange(range);
  }
}

const getEditedContent = (editable) => {
  let content  = []
  let result = ''
  const flush = () => {
    if (result) {
      result = result.replace(/\n•[ ]+/g, "\n•  ");
      content.push({
        type: "text",
        text: result
      })
      result = ''
    }
  }
  const apply = node => {
    walkDOM(node, n => {
      if (n instanceof HTMLVideoElement) {
      }
      else if (n instanceof HTMLImageElement) {
        const url = n.src
        flush()
        content.push({
          type: "image_url",
          image_url: {
            url
          }
        })
      } else if (n.nodeName == "WBR") {
      } else if (n.nodeName == "BR") {
        result += "\n";
      } else if (n.nodeType == 3 && !(n.parentElement instanceof HTMLSpanElement)) {
        let textContent = n.textContent.replace(nbsp, " ");
        result += textContent;
        if (n.parentElement !== node && n.parentElement instanceof HTMLDivElement) {
          result += '\n'
        }
      }
    })
    flush()
  }
  apply(editable)
  return content
}


const hasTranscriptCompactionEntry = addedToTranscript => {
  return (addedToTranscript || []).some(entry => entry && entry.compaction)
}

const hasTopLevelAssistantReply = message => {
  return Boolean(message && (
    hasTranscriptCompactionEntry(message.addedToTranscript) ||
    message.content ||
    message.model ||
    message.usage ||
    message.storage ||
    message.addedToTranscript ||
    message.tool_calls ||
    message.contentLength ||
    message.phase ||
    message.inferenceProgress ||
    message.pendingToolCalls
  ))
}

export const getReplies = message => {
  if (message && message.role === 'assistant') {
    const modelReplies = (message.models || []).filter(Boolean)
    if (hasTopLevelAssistantReply(message)) {
      return [message].concat(modelReplies)
    }
    return modelReplies
  }
  return []
}

const normalizeToolFunctionName = name => {
  const value = String(name || '')
  const slash = value.split('/').filter(Boolean).pop() || value
  return slash.split('.').filter(Boolean).pop() || slash
}

// Tool-result messages are stable objects for the lifetime of a rendered
// transcript entry. Keep the parsed value until streaming or storage
// hydration replaces its content instead of JSON.parse-ing the same (often
// very large) payload for every renderer and every React pass.
const parsedToolResultContentCache = new WeakMap()
const transcriptToolLookupCache = new WeakMap()

const transcriptToolLookup = entries => {
  const transcript = Array.isArray(entries) ? entries : []
  const firstEntry = transcript[0]
  const lastEntry = transcript[transcript.length - 1]
  const lastMessage = lastEntry && lastEntry.message
  const cached = transcriptToolLookupCache.get(transcript)
  if (cached &&
      cached.length === transcript.length &&
      cached.firstEntry === firstEntry &&
      cached.lastEntry === lastEntry &&
      cached.lastContent === (lastMessage && lastMessage.content)) {
    return cached
  }
  const toolCallsById = new Map()
  const directToolResultsById = new Map()
  const orderedToolResults = []
  for (const entry of transcript) {
    const message = entry && entry.message
    if (!message) continue
    const messageToolCalls = Array.isArray(message.tool_calls) ? message.tool_calls : []
    for (const toolCall of messageToolCalls) {
      const renderable = toolCallForRendering(toolCall)
      if (renderable) toolCallsById.set(renderable.id, renderable)
    }
    if (message.tool_call_id && message.content) {
      if (!directToolResultsById.has(message.tool_call_id)) {
        directToolResultsById.set(message.tool_call_id, message)
      }
      orderedToolResults.push(message)
    }
  }
  const lookup = {
    length: transcript.length,
    firstEntry,
    lastEntry,
    lastContent: lastMessage && lastMessage.content,
    toolCallsById,
    directToolResultsById,
    orderedToolResults,
    latestSessionResultCache: new Map(),
    sessionOriginCache: new Map(),
    terminalSessionEntriesCache: new Map()
  }
  transcriptToolLookupCache.set(transcript, lookup)
  return lookup
}

const formatContextUsageTokens = (value, options = {}) => {
  const n = Number(value)
  if (!Number.isFinite(n)) return null
  if (!options.allowZero && n <= 0) return null
  const abs = Math.abs(n)
  if (abs >= 1000000) {
    return `${(n / 1000000).toFixed(abs >= 10000000 ? 1 : 2)}M`
  }
  if (abs >= 1000) {
    return `${(n / 1000).toFixed(abs >= 100000 ? 0 : 1)}k`
  }
  return formatInt(Math.round(n))
}

const findCompactionEntry = addedToTranscript => {
  return (addedToTranscript || []).find(entry => entry && entry.compaction)
}

const findCompactionEntries = addedToTranscript => {
  return (addedToTranscript || []).filter(entry => entry && entry.compaction)
}

const activeTranscriptEntries = addedToTranscript => {
  const entries = (addedToTranscript || []).filter(Boolean)
  let lastCompactionIndex = -1
  for (let i = 0; i < entries.length; i += 1) {
    if (entries[i] && entries[i].compaction) {
      lastCompactionIndex = i
    }
  }
  return lastCompactionIndex >= 0 ? entries.slice(lastCompactionIndex + 1) : entries
}

const transcriptArchiveEventCount = entry => {
  const archive = entry && entry.transcriptArchive
  if (!archive || archive.schema !== 'attunewise.added_to_transcript_archive.v1') return null
  const value = archive.eventCount
  const fallback = archive.count
  const count = Number(value === undefined ? fallback : value)
  return Number.isSafeInteger(count) && count >= 0 ? count : 0
}

const transcriptEntryEventCount = entry => {
  const archived = transcriptArchiveEventCount(entry)
  if (archived !== null) return archived
  if (!entry || entry.compaction) return 0
  const message = entry.message || entry
  const toolCalls = Array.isArray(message && message.tool_calls) ? message.tool_calls : []
  return toolCalls.length || (message && (
    message.content || message.tool_call_id || message.toolCallId
  ) ? 1 : 0)
}

const transcriptArrayCount = (entries, counter) => (
  (entries || []).reduce((total, entry) => total + counter(entry), 0)
)

const directTranscriptEventCount = message => {
  if (!message) return 0
  const toolCalls = Array.isArray(message.tool_calls) ? message.tool_calls : []
  return toolCalls.length || ((
    message.content || message.storage || message.tool_call_id || message.toolCallId
  ) ? 1 : 0)
}

const replyEventCount = reply => {
  if (!reply) return 0
  const entries = transcriptEntriesWithInferenceProgress(reply)
  const count = transcriptArrayCount(entries, transcriptEntryEventCount)
  if (count > 0) return count
  return directTranscriptEventCount(reply)
}

const holderEventCount = message => {
  if (!message) return 0
  if (message.role === 'assistant' && Array.isArray(message.models) && message.models.length) {
    return message.models.reduce((total, reply) => total + replyEventCount(reply), 0)
  }
  const entries = transcriptArrayCount(message.addedToTranscript, transcriptEntryEventCount)
  if (message.role === 'assistant' && entries > 0) return entries
  return directTranscriptEventCount(message) + entries
}

const modelReplyForCount = (message, selectedModelId, resolveModel) => {
  const replies = getReplies(message)
  if (!replies.length) return null
  if (selectedModelId) {
    const selectedModel = resolveModel && resolveModel(selectedModelId)
    const exact = replies.find(reply => reply && (
      reply.model === selectedModelId ||
      selectedModel && selectedModel.isModel && selectedModel.isModel(reply.model)
    ))
    if (exact) return exact
  }
  return replies.find(reply => reply && (
    reply.content || reply.storage || reply.tool_calls ||
    Array.isArray(reply.addedToTranscript) && reply.addedToTranscript.length
  )) || replies[0]
}

const holderVisibleEventCount = (message, selectedModelId, resolveModel) => {
  if (!message) return 0
  if (message.role === 'user') return directTranscriptEventCount(message)
  if (message.role !== 'assistant') return 0
  const reply = modelReplyForCount(message, selectedModelId, resolveModel)
  if (!reply) return directTranscriptEventCount(message)
  return replyEventCount(reply)
}

const conversationHeaderMessageCounts = ({ messages, task, selectedModelId, resolveModel }) => {
  const transcript = (messages || []).filter(message => (
    message && (message.role === 'user' || message.role === 'assistant')
  ))
  const index = task && task.conversationIndex || {}
  const indexedCount = Number(index.messageCount || index.message_count)
  const indexedThroughId = index.throughMessageId || index.through_message_id
  const indexedThrough = indexedThroughId
    ? transcript.findIndex(message => message.id === indexedThroughId)
    : -1
  const total = Number.isSafeInteger(indexedCount) && indexedCount >= 0 && indexedThrough >= 0
    ? indexedCount + transcript.slice(indexedThrough + 1).reduce((sum, message) => sum + holderEventCount(message), 0)
    : transcript.reduce((sum, message) => sum + holderEventCount(message), 0)

  const lastCompaction = task && task.lastCompaction || {}
  const globalCompaction = lastCompaction.virtual === true ||
    lastCompaction.strategy === 'attunewise-conversation-index-reset-v1'
  const compactionApplies = globalCompaction || !lastCompaction.model || !selectedModelId || (() => {
    const selectedModel = resolveModel && resolveModel(selectedModelId)
    return lastCompaction.model === selectedModelId ||
      Boolean(selectedModel && selectedModel.isModel && selectedModel.isModel(lastCompaction.model))
  })()
  const compactionThrough = compactionApplies && lastCompaction.holderDocId
    ? transcript.findIndex(message => message.id === lastCompaction.holderDocId)
    : -1
  const visible = compactionThrough >= 0
    ? 1 + transcript.slice(compactionThrough + 1).reduce((sum, message) => (
        sum + holderVisibleEventCount(message, selectedModelId, resolveModel)
      ), 0)
    : transcript.reduce((sum, message) => (
        sum + holderVisibleEventCount(message, selectedModelId, resolveModel)
      ), 0)

  return { visible, total }
}

const getCompactionEntryId = entry => entry && entry.compaction && entry.compaction.id

const getCompactionEntryHolderId = entry => {
  const source = entry && entry.compaction && entry.compaction.source || {}
  return source.holderDocId || source.endDocId || null
}

const compactionSpineItems = index => Array.isArray(index && index.spine)
  ? index.spine.filter(item => item && item.handle)
  : []

const compactionSpineHandles = index => {
  if (Array.isArray(index && index.frontierHandles) && index.frontierHandles.length) {
    return index.frontierHandles
  }
  const recorded = compactionSpineItems(index).map(item => item.handle)
  if (recorded.length) return recorded
  if (Array.isArray(index && index.summaryHandles) && index.summaryHandles.length) {
    return index.summaryHandles
  }
  return index && index.summaryHandle ? [index.summaryHandle] : []
}

const mergeCompactionSpineMetadata = (recordsByHandle, index) => {
  for (const item of compactionSpineItems(index)) {
    const current = recordsByHandle[item.handle] || {}
    recordsByHandle[item.handle] = {
      ...item,
      ...current,
      head: current.head || String(item.text || '').trim(),
      link: item.browseLink || item.link || current.link
    }
  }
  return recordsByHandle
}

const isCompactionEntryOnMessage = (entry, message) => {
  const holderDocId = getCompactionEntryHolderId(entry)
  return !holderDocId || holderDocId === (message && message.id)
}

const getMessageCompactionEntries = message => {
  const entries = findCompactionEntries(message && message.conversationCompactions)
  entries.push(...findCompactionEntries(message && message.addedToTranscript))
  for (const reply of message && message.models || []) {
    entries.push(...findCompactionEntries(reply && reply.addedToTranscript))
  }
  return entries
}

const messageIndexMap = messages => {
  const messageIndexById = new Map()
  ;(messages || []).forEach((message, index) => {
    if (message && message.id) messageIndexById.set(message.id, index)
  })
  return messageIndexById
}

const latestCompactionInMessages = (messages, messageIndexById = messageIndexMap(messages)) => {
  let latest = null
  ;(messages || []).forEach((message, index) => {
    for (const entry of getMessageCompactionEntries(message)) {
      const holderDocId = getCompactionEntryHolderId(entry)
      const displayIndex = holderDocId && messageIndexById.has(holderDocId)
        ? messageIndexById.get(holderDocId)
        : index
      const createdAt = Number(entry && entry.compaction && entry.compaction.createdAt) ||
        Number(message && (message.lastUpdated || message.ts)) ||
        0
      if (!latest || displayIndex > latest.index || (displayIndex === latest.index && createdAt >= latest.createdAt)) {
        latest = {
          entry,
          id: getCompactionEntryId(entry),
          index: displayIndex,
          createdAt
        }
      }
    }
  })
  return latest
}

const conversationCompactionRenderState = messages => {
  const messageIndexById = messageIndexMap(messages)
  const latestCompaction = latestCompactionInMessages(messages, messageIndexById)
  return {
    messageIndexById,
    latestCompaction,
    lastCompactionIndex: latestCompaction ? latestCompaction.index : -1,
    activeCompactionId: latestCompaction && latestCompaction.id
  }
}

const normalizeConversationSummaryRecords = records => {
  if (!records) return []
  if (Array.isArray(records)) return records.filter(Boolean)
  if (typeof records === 'object') return Object.values(records).filter(Boolean)
  return []
}

const previewCompactionText = (value, max = 240) => {
  let text = ''
  if (typeof value === 'string') {
    text = value
  } else if (value !== undefined && value !== null) {
    try {
      text = JSON.stringify(value)
    } catch (_err) {
      text = String(value)
    }
  }
  text = text.replace(/\s+/g, ' ').trim()
  if (text.length <= max) return text
  return `${text.slice(0, max - 1)}...`
}

const cleanCompactionSummaryText = value => {
  return String(value || '')
    .replace(/<\s*(signature|openai-sig|gemini-sig|signed)\b[^>]*>[\s\S]*?<\s*\/\s*\1\s*>/gi, '')
    .replace(/\n{3,}/g, '\n\n')
    .trim()
}

const decodeCompactionHandlePart = value => {
  try {
    return decodeURIComponent(value)
  } catch (_err) {
    return value
  }
}

const messageIdForCompactionHandle = handle => {
  const parts = String(handle || '').split('/').map(decodeCompactionHandlePart)
  const messageIndex = parts.indexOf('message')
  if (messageIndex >= 0) return parts[messageIndex + 1] || null
  const transcriptIndex = parts.indexOf('transcript')
  return transcriptIndex >= 0 ? parts[transcriptIndex + 1] || null : null
}

const sameCompactionMessage = (message, handle) => {
  const messageId = messageIdForCompactionHandle(handle)
  return Boolean(message && messageId && message.id === messageId)
}

const compactedEntryContent = entry => {
  if (!entry || entry.compaction) return ''
  const message = entry.message || entry
  if (!message) return ''
  if (message.tool_calls && message.tool_calls.length) {
    return `${message.tool_calls.length} tool call${message.tool_calls.length === 1 ? '' : 's'}`
  }
  if (message.content) {
    const role = message.role ? `${message.role}: ` : ''
    return `${role}${previewCompactionText(message.content)}`
  }
  return ''
}

const getClientMessageCompactionText = ({ handle, message, reply }) => {
  if (!sameCompactionMessage(message, handle)) return ''
  const parts = []
  if (message.content) {
    parts.push(previewCompactionText(message.content))
  }
  if (reply && reply.content) {
    const prefix = reply.model ? `${reply.model}: ` : ''
    parts.push(`${prefix}${previewCompactionText(reply.content)}`)
  }
  for (const entry of reply && reply.addedToTranscript || []) {
    const text = compactedEntryContent(entry)
    if (text) parts.push(text)
  }
  for (const entry of message.addedToTranscript || []) {
    const text = compactedEntryContent(entry)
    if (text) parts.push(text)
  }
  return parts.filter(Boolean).join('\n')
}

const renderConversationCompactionSummary = ({ compacted, task, message, reply, summaryRecords, summaryState, loadSummaryRecords, uiState, components, me, onOpen, forceUpdate }) => {
  if (!compacted || !compacted.compaction) return null
  const { compaction } = compacted
  const index = compaction.index || {}
  const providerPayload = compaction.providerPayload || {}
  const isPending = Boolean(index.pending || index.status === 'building' || providerPayload.status === 'building')
  const handles = compactionSpineHandles(index)
  const hasSummaryHandles = handles.length > 0
  const storedMessage = compacted.message || {}
  const storedContentLength = Number(storedMessage.contentLength)
  const hasStoredContent = Boolean(storedMessage.content) && (
    Number.isFinite(storedContentLength)
      ? storedMessage.content.length === storedContentLength
      : !storedMessage.storage
  )
  const storedContentPending = Boolean(storedMessage.storage) && !hasStoredContent && !storedMessage.storageHydrationError
  const exactContentUnavailable = !hasStoredContent && !storedContentPending
  const isOpen = uiState.compactionOpen && uiState.compactionOpen[compaction.id]
  if (!isPending && !hasSummaryHandles && !hasStoredContent && !storedContentPending) return null
  const error = summaryState && summaryState.error
  const pendingText = error
    ? `Could not load summary records: ${error}`
    : (isPending ? 'Building conversation summary...' : 'Loading summary records...')
  const toggleCompaction = () => {
    if (!uiState.compactionOpen) {
      uiState.compactionOpen = {}
    }
    const opening = !uiState.compactionOpen[compaction.id]
    uiState.compactionOpen[compaction.id] = opening
    forceUpdate()
    const needsSummaryRecords = compactionSpineItems(index).some(item => (
      !String(item.text || '').trim()
    ))
    if (opening && needsSummaryRecords && loadSummaryRecords) {
      loadSummaryRecords()
    }
  }
  const openStyle = (isOpen || isPending) ? null : { display: 'none' }
  // The spine renders through the same components as the Conversation tab
  // and the conversation_* tool calls, so this record is QA-able against
  // exactly what the model sees.
  const recordsByHandle = {}
  for (const record of normalizeConversationSummaryRecords(summaryRecords)) {
    if (record && record.handle) {
      recordsByHandle[record.handle] = { ...record, head: cleanCompactionSummaryText(record.head) }
    }
  }
  mergeCompactionSpineMetadata(recordsByHandle, index)
  const loadBrowse = me && task && task.id
    ? async link => cleanConversationResult(await me.conversationBrowse({
        conversationId: task.id,
        link,
        full_summary: true
      }))
    : null
  const contentDiv = <div className='aiSaidCompaction'>
                       <ConversationSummarySpine
                         storedContent={hasStoredContent ? cleanCompactionSummaryText(storedMessage.content) : ''}
                         storedContentPending={storedContentPending}
                         exactContentUnavailable={exactContentUnavailable}
                         handles={handles}
                         recordsByHandle={recordsByHandle}
                         fallbackTextForHandle={handle => getClientMessageCompactionText({ handle, message, reply })}
                         pendingText={pendingText}
                         components={components}
                         loadBrowse={loadBrowse}
                         onOpen={onOpen}/>
                     </div>
  return <div className={`toolUseDiv aiSaidCompaction${isPending ? ' aiSaidCompactionPending' : ''}`}>
           <div className='toolUseHeader'>
             <div className='toolUseHeaderLeft'>
               <div className='toolUserHeaderIcon'><SimpleIcon src={Gear}/></div>
               <div className='toolUseHeaderTitle'>{isPending ? 'Building summary' : 'Summary'}</div>
             </div>
             <div className='toolUseHeaderRight'>
               {isPending && <div className='compactionSpinner'/>}
               <div className='toolUseDisclosure'>
                 <SimpleButton icon={isOpen ? Up : Down} action={toggleCompaction}/>
               </div>
             </div>
           </div>
           <div key='toolUseContent' className='toolUseContent' style={openStyle}>
             {contentDiv}
             <div className='aiSaidCompactionFooter'>
               <SimpleButton label="Close" icon={Cross} action={toggleCompaction}/>
             </div>
           </div>
         </div>
}

const renderConversationIndexProgress = progress => {
  if (!progress || (
    progress.status !== 'planning' &&
    progress.status !== 'queued' &&
    progress.status !== 'running' &&
    progress.status !== 'error'
  )) {
    return null
  }
  const failed = progress.status === 'error'
  const title = failed ? 'Conversation summary unavailable' : 'Building conversation summary'
  const detail = failed
    ? 'The conversation summary could not be completed. Replay the message to try again.'
    : (progress.status === 'planning'
        ? 'Loading new conversation turns...'
        : progress.status === 'queued'
        ? 'Waiting to start summarization...'
        : 'Summarizing conversation history...')
  return <div className={`conversationIndexProgress${failed ? ' conversationIndexProgressError' : ''}`}>
           <div className='conversationIndexProgressTitle'>
             {!failed && <div className='compactionSpinner'/>}
             <span>{title}</span>
           </div>
           <div className='conversationIndexProgressDetail'>{detail}</div>
         </div>
}

const getTranscriptEntrySourceMessageId = entry => {
  return entry && entry.attributes && entry.attributes.sourceMessageId
}

const getTranscriptEntryCompactionId = entry => {
  return entry && entry.compaction && entry.compaction.id
}

const transcriptMessageIdentity = message => JSON.stringify({
  role: message && message.role,
  content: message && message.content || '',
  phase: message && message.phase || '',
  name: message && message.name || '',
  tool_call_id: message && message.tool_call_id || '',
  tool_calls: message && message.tool_calls || []
})

const isSameTranscriptEntry = (left, right) => {
  const leftCompaction = getTranscriptEntryCompactionId(left)
  const rightCompaction = getTranscriptEntryCompactionId(right)
  if (leftCompaction && rightCompaction) {
    return leftCompaction === rightCompaction
  }
  const leftSource = getTranscriptEntrySourceMessageId(left)
  const rightSource = getTranscriptEntrySourceMessageId(right)
  if (leftSource && rightSource && leftSource === rightSource) {
    return true
  }
  return !!(left && right && left.message && right.message &&
            transcriptMessageIdentity(left.message) === transcriptMessageIdentity(right.message))
}

const hasTranscriptEntry = (entries, entry) => {
  return (entries || []).some(existing => isSameTranscriptEntry(existing, entry))
}

const appendTranscriptEntriesToReply = (reply, entries) => {
  if (!reply || !entries || entries.length === 0) return false
  if (!reply.addedToTranscript) {
    reply.addedToTranscript = []
  }
  if (reply.stream) {
    const streamEntry = {
      message: {
        role: 'assistant',
        content: reply.stream
      }
    }
    if (!hasTranscriptEntry(reply.addedToTranscript, streamEntry)) {
      reply.addedToTranscript.push(streamEntry)
    }
    reply.stream = ''
  }
  let appended = false
  for (const entry of entries) {
    if (!entry || (!entry.message && !entry.compaction) || hasTranscriptEntry(reply.addedToTranscript, entry)) continue
    reply.addedToTranscript.push(entry)
    appended = true
  }
  return appended
}

const makeSteeredTranscriptEntry = (message, ts = Date.now()) => {
  const transcriptMessage = {
    role: 'user',
    content: message.content
  }
  if (message.name) {
    transcriptMessage.name = message.name
  }
  return {
    message: transcriptMessage,
    attributes: {
      steered: true,
      sourceMessageId: message.id,
      status: 'steered'
    },
    ts
  }
}

export const visitToolCalls = (messages, f) => {
  for (const message of messages) {
    if (message.role === 'assistant') {
      for (const reply of getReplies(message)) {
        const { model, tool_calls, addedToTranscript } = reply
        const check = tool_calls => {
          for (const x of tool_calls) {
            f(x)
          }
        }
        if (addedToTranscript) {
          for (const entry of addedToTranscript) {
            const message = entry && entry.message
            if (!message) continue
            const { tool_calls } = message
            if (tool_calls) {
              check(tool_calls)
            }
          }
        } else if (tool_calls) {
          check(tool_calls)
        }
      }
    }
  }
}

export const EPOCH = n => {
  return {
    title: "Epoch "+n,
    name: "Train "+n,
    id: 'epoch-'+n,
    getIcon: () => CheckMark,
    vendor: '',
    vendorId: '',
    isModel:id =>  id === 'epoch-'+n
  }
}

const EPOCHS = {}

export const TRAIN = {
  title: "Assistant",
  name: "Assistant",
  id: 'train',
  getIcon: () => AISaid,
  vendor: '',
  vendorId: '',
  isModel:id =>  id === 'train'
}

export const REJECT = {
  title: "Reject",
  name: "Reject",
  id: 'reject',
  getIcon: () => Cross,
  vendor: '',
  vendorId: '',
  isModel:id =>  id === 'reject'
}

export const pasteText = e => {
  e.preventDefault();
  let plainText = e.clipboardData.getData('text/plain')
  if (!plainText) {
    const text = e.clipboardData.getData('text/html')
    plainText = makeTextPlain(text)
  }
  document.execCommand("insertText", false, plainText);
}

const sortModels = (x, y) => {
  if (x.id === 'train') return -1
  if (y.id === 'train') return 1
  const cmp = x.title.localeCompare(y.title)
  if (cmp) return cmp
  if (x.isFinetune && !y.isFinetune) {
    return 1
  }
  if (y.isFinetune && !x.isFinetune) {
    return -1
  }
  return y.ts - x.ts
}

const defaultPricingModeForModel = model => {
  const modes = model && Array.isArray(model.supportedPricingModes) ? model.supportedPricingModes : []
  if (modes.includes('flex')) {
    return 'flex'
  }
  if (model && model.defaultPricingMode && (!modes.length || modes.includes(model.defaultPricingMode))) {
    return model.defaultPricingMode
  }
  return modes[0] || 'fast'
}

const defaultReasoningEffortForModel = model => {
  const efforts = model && Array.isArray(model.supportedReasoningEfforts) ? model.supportedReasoningEfforts : []
  if (efforts.includes('xhigh')) {
    return 'xhigh'
  }
  if (efforts.includes('max')) {
    return 'max'
  }
  if (efforts.includes('high')) {
    return 'high'
  }
  if (efforts.includes('medium')) {
    return 'medium'
  }
  if (efforts.includes('low')) {
    return 'low'
  }
  if (efforts.includes('none')) {
    return 'none'
  }
  if (model && model.defaultReasoningEffort && model.defaultReasoningEffort !== 'auto' && (!efforts.length || efforts.includes(model.defaultReasoningEffort))) {
    return model.defaultReasoningEffort
  }
  return efforts[0] || 'auto'
}

const DEFAULT_MODEL_TEMPERATURE = 0.7
const DEFAULT_MODEL_TOP_P = 0.9
const DEFAULT_MODEL_TOP_K = 50


export class ModelConfig extends Component {

  constructor(props) {
    super(props)
    this.state = {
      temperature: DEFAULT_MODEL_TEMPERATURE,
      top_p: DEFAULT_MODEL_TOP_P,
      top_k: DEFAULT_MODEL_TOP_K / 100,
      reasoningEffort: defaultReasoningEffortForModel(props.model),
      pricingMode: 'flex',
      textVerbosity: 'medium'
    }
  }

  componentDidMount() {
    this.props.onCreate(this)
    const { model } = this.props
    const updates = {}
    if (model) {
      if (model.supportedReasoningEfforts) {
        updates.reasoningEffort = defaultReasoningEffortForModel(model)
      }
      if (model.supportedPricingModes) {
        updates.pricingMode = defaultPricingModeForModel(model)
      }
      if (model.defaultVerbosityLevel) {
        updates.textVerbosity = model.defaultVerbosityLevel
      }
    }
    if (this.props.value) {
      const { top_p, top_k, temperature, reasoning_effort, reasoning, pricingMode, textVerbosity, text } = this.props.value
      if (top_p !== undefined) updates.top_p = top_p
      if (temperature !== undefined) updates.temperature = temperature
      if (top_k !== undefined) updates.top_k = top_k / 100
      updates.reasoningEffort = reasoning_effort || reasoning && reasoning.effort || updates.reasoningEffort
      updates.pricingMode = pricingMode || updates.pricingMode
      updates.textVerbosity = textVerbosity || text && text.verbosity || updates.textVerbosity
    }
    this.setState(updates)
  }

  fireChange = () => {
    if (this.props.onChange) {
      this.props.onChange(this.getOpts())
    }
  }

  getOpts = () => {
    const { temperature, top_p, top_k, reasoningEffort, pricingMode, textVerbosity } = this.state
    const { model } = this.props
    const opts = {
      temperature,
      top_p,
      top_k: Math.round(top_k * 100)
    }
    if (model && model.supportedReasoningEfforts && reasoningEffort) {
      opts.reasoning_effort = reasoningEffort
      if (reasoningEffort !== 'auto') {
        opts.reasoning = {
          effort: reasoningEffort,
          summary: 'auto'
        }
      }
    }
    if (model && model.supportedPricingModes && pricingMode) {
      opts.pricingMode = pricingMode
    }
    if (model && model.supportedVerbosityLevels && textVerbosity) {
      opts.textVerbosity = textVerbosity
      opts.text = {
        verbosity: textVerbosity
      }
    }
    return opts
  }

  setTemperature = (temperature) => {
    this.setState({temperature}, this.fireChange)
  }

  getTemperature = () => {
    return this.state.temperature
  }

  setTop_p = (top_p) => {
    this.setState({
      top_p
    }, this.fireChange)
  }

  getTop_p = () => {
    return this.state.top_p
  }

  setTop_k = (top_k) => {
    this.setState({
      top_k
    }, this.fireChange)
  }

  getTop_k = () => this.state.top_k

  setOption = (key, value) => {
    this.setState({
      [key]: value
    }, this.fireChange)
  }

  renderOptionGroup = (label, key, values) => {
    if (!values || !values.length) {
      return null
    }
    return <div className='modelConfigOptionGroup'>
             <div className='modelConfigOptionLabel'>{label}</div>
             <div className='modelConfigOptionButtons'>
               {
                 values.map(value => {
                   let className = 'modelConfigOptionButton'
                   if (this.state[key] === value) {
                     className += ' modelConfigOptionButtonSelected'
                   }
                   return <div key={value} className={className} onClick={() => this.setOption(key, value)}>
                            {value}
                          </div>
                 })
               }
             </div>
           </div>
  }

  renderModelConfig() {
    const model = this.props.model || {}
    return <div className='modelConfig'>
             {this.renderOptionGroup('Reasoning', 'reasoningEffort', model.supportedReasoningEfforts)}
             {this.renderOptionGroup('Price', 'pricingMode', model.supportedPricingModes)}
             {this.renderOptionGroup('Verbosity', 'textVerbosity', model.supportedVerbosityLevels)}
           </div>
  }

  render() {
    return this.renderModelConfig()
  }
}


class ChatPage extends BnSubpage {

  openSubpage = f => {
    this.setState({
      subpage: f
    })
  }


  componentDidMount() {
    this.props.chatGPT.chatPage = this
    //////////////debugger
  }

  renderContent() {
    return <div className='chatPageContent'>
             {this.props.chatGPT.renderChat()}
           </div>
  }

}

class MovablePortal extends Component {
  constructor(props) {
    super(props)
    this.el = document.createElement('div')
    this.el.className = 'chatPortalMount'
  }

  componentDidMount() {
    this.attach()
  }

  componentDidUpdate() {
    this.attach()
  }

  componentWillUnmount() {
    if (this.restoreFrame) {
      window.cancelAnimationFrame(this.restoreFrame)
      this.restoreFrame = null
    }
    if (this.el.parentNode) {
      this.el.parentNode.removeChild(this.el)
    }
  }

  attach = () => {
    const { target, beforeMove, afterMove } = this.props
    if (target && this.el.parentNode !== target) {
      const snapshot = beforeMove ? beforeMove() : null
      target.appendChild(this.el)
      if (afterMove) {
        afterMove(snapshot)
        if (this.restoreFrame) {
          window.cancelAnimationFrame(this.restoreFrame)
        }
        this.restoreFrame = window.requestAnimationFrame(() => {
          afterMove(snapshot)
          this.restoreFrame = null
        })
      }
    }
  }

  render() {
    return ReactDOM.createPortal(this.props.children, this.el)
  }
}


class MessageContainer extends Component {
  constructor(props) {
    super(props)
  }

  setRef = ref => {
    this.ref = ref
  }

  componentDidUpdate() {
    this.checkCreateObserver()
  }


  componentDidMount() {
    this.checkCreateObserver()
  }

  checkCreateObserver = () => {
    if (!this.ref || !this.props.scrollRef) return
    if (this.observer) return
    const cb = (entries) => {
      entries.forEach(entry => {
        let visible = entry.isIntersecting
        if (entry.isIntersecting) {
          entry.target.classList.remove('message-fade-out')
        } else {
          entry.target.classList.add('message-fade-out')
        }
      })
    }
    this.observer = new IntersectionObserver(cb, {
      root: this.props.scrollRef,
      rootMargin: '100px 0px',
      threshold: 0
    });
    this.observer.observe(this.ref)
  }

  componentWillUnmount() {
    if (this.observer) this.observer.disconnect()
  }

  render() {
    return <div ref={this.setRef} className='chatGptChatMessageBody'>
             {this.props.children}
             </div>
  }
}

export class PlayButton extends Component {

  constructor (props) {
    super(props)
    this.state = {
      playing: false
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.playing !== this.props.playing) {
      this.setState({
        playing: this.props.playing
      })
    }
  }

  componentDidMount() {

  }

  play = async () => {
    if (this.state.playing) {
      await this.props.stop()
      this.state.playing = false
      this.forceUpdate()
    } else {
      this.state.playing = true
      this.props.play()
      this.forceUpdate()
    }
  }

  render() {
    let icon = Send
    if (this.state.playing && !this.props.playing) {
      icon = Spin
    } else if (this.props.playing) {
      icon = Stop
    }
    return <div className='playButton'>
             <SimpleButton icon={icon} action={this.play}/>
           </div>
  }
}


// Function to select all content of the contenteditable div
function divSelectAll(div) {
  if (div && div.isContentEditable) {
    // Create a range object
    const range = document.createRange();

    // Select the entire content of the div
    range.selectNodeContents(div);

    // Clear any existing selection
    const selection = window.getSelection();
    selection.removeAllRanges();

    // Add the new range (i.e., select the div's content)
    selection.addRange(range);
  }
}



export const GearButton = props => {
  return <SimpleButton legacyIconSize icon={Gear} {...props}/>
}

export const GearIcon = props => {
  return <SimpleIcon legacyIconSize src={Gear} {...props}/>
}

export const LegacyButton = props => {
  return <SimpleButton legacyIconSize {...props}/>
}

class AssistantFooter extends Component {
  render() {
    let { ts, copy, replays, selectedReplay, setReplay, replay, copyThread, edit, replaying, stopReplay } = this.props
    let leftStyle1
    let rightStyle1
    let replayStyle = selectedReplay < 0 ? {display: 'none'} : null
    let right1
    let left1
    //console.log("selectedReplay render", selectedReplay)
    if (selectedReplay > 0) {
      left1 = () => {
        return setReplay(selectedReplay-1)
      }
    }
    if (selectedReplay + 1 < replays) {
      right1 = () => {
        return setReplay(selectedReplay + 1)
      }
    }
    return <div className='assistantFooterNav'>
             <div className='assistantFooterButtons'>
               {copy && <div className='copyAssistantFooter'>
                          <SimpleButton icon={Copy} action={copy}/>
                        </div>}
               {edit && <div className='copyAssistantFooter'>
                          <SimpleButton icon={EditIcon} action={edit}/>
                        </div>}
               {replay && <div className='copyAssistantFooter'>
                            <SimpleButton icon={replaying ? Stop: Send} action={replaying ? stopReplay: replay}/>
                          </div>}
               {copyThread && <div className='copyAssistantFooter'>
                                <SimpleButton icon={Chat} action={copyThread}/>
                              </div>}
               <Timestamp ts={ts}/>
             </div>
            <div className='replayNav' style={replayStyle}>
               <div className='swiperNavButton' style={leftStyle1} onClick={left1}>
                 <ReactSVG src={Left}/>
               </div>
               <div className='selectedReplay'>
                 {selectedReplay+1} of {replays}
               </div>
               <div className='swiperNavButton' style={rightStyle1} onClick={right1}>
                 <ReactSVG src={Right}/>
               </div>
            </div>
           </div>
  }
}

export class Navigation extends Component {
  constructor(props) {
    super(props)
  }

  render() {
    const { length, pos, setPos, replays, selectedReplay, setReplay, copy } = this.props
    ////////console.log("Navigation", this.props)
    let leftStyle
    let rightStyle
    const left = () => setPos(pos-1)
    const right = () => setPos(pos+1)
    const hidden = {
      visibility: 'hidden'
    }
    if (pos === 0) {
      leftStyle = hidden
    }
    if (pos === length-1) {
      rightStyle = hidden
    }
    const left1 = () => {
      setReplay(replay -1)
    }
    const right1 = () => {
      setReplay(replay +1)
    }
    let replayStyle = null//(replays || 0) > 1 ? null :  { display: 'none' }
    let leftStyle1
    let rightStyle1
    const counterWidth = Math.max(2, String(length).length)
    const counter = `${String(pos + 1).padStart(counterWidth, '0')} / ${String(length).padStart(counterWidth, '0')}`
    return <div className='swiperNav'>
             <div className='swiperNavButton' style={leftStyle} onClick={left}>
               <ReactSVG src={Left}/>
             </div>
             <div className='swiperNavCounter'>{counter}</div>
             <div className='swiperNavButton' style={rightStyle} onClick={right}>
               <ReactSVG src={Right}/>
             </div>
           </div>
  }
}


class JudgementComp extends Component {
  constructor (props) {
    super(props)
  }

  componentDidUpdate(prevProps, prevState) {
    if (super.componentDidUpdate) super.componentDidUpdate(prevProps, prevState)
    this.updateSwiper()
  }

  onSelectionChange = e => {
    if (!this.swiper) return
    const selection = document.getSelection();
    if (selection.toString().length > 0) {
      this.swiper.disable()
    } else {
      this.swiper.enable()
    }
  }

  componentDidMount() {
    if (this.props.onCreate) {
      this.props.onCreate(this)
    }
    if (isMobile()) {
      document.addEventListener('selectionchange', this.onSelectionChange)
    }
  }

  componentWillUnmount() {
    if (this.props.onCreate) {
      this.props.onCreate(null)
    }
    if (isMobile()) {
      document.removeEventListener('selectionchange', this.onSelectionChange)
    }
  }

  swiper = null
  onSwiper = x => {
    this.swiper = x
  }

  updateSwiper = () => {
    if (this.swiper) {
      try {
        this.swiper.update()
        this.swiper.updateAutoHeight();
      } catch (err) {
        console.warn(err)
      }
    }
  }

  selectJudge = model => {
    ////////console.log("selectJudge", model)
    const judgements = this.getJudgements()
    for (let i = 0; i< judgements.length; i++) {
      if (judgements[i].judge === model.id) {
        this.swiper.slideTo(i)
        ////////console.log("selectJudge", i, model.name)
        this.forceUpdate()
        return
      }
    }

  }

  onSlideChange = (e) => {
    ////////console.log("judge onSlideChange", e)
    this.props.onSlideChange()
  }

  getPos = () => this.swiper ? this.swiper.activeIndex : 0
  setPos = pos => this.swiper && this.swiper.slideTo(pos)


  getJudgements = () => {
    //////console.log("getJudgements", this.props.message.judgement)
    let { judge, ratings, judgements } = this.props.message.judgement
    if (!judgements) {
      judgements = [{
        judge,
        ratings
      }]
    }
    const sortedJudgements = [].concat(judgements)
    sortedJudgements.sort((x, y) => {
      const a = this.props.resolveModel(x.judge)
      const b = this.props.resolveModel(y.judge)
      return a.name.localeCompare(b.name)
    })
    //////////////////debugger
    return sortedJudgements
  }

  render() {
    let judgeViews = []
    const judgements = this.getJudgements()
    //////console.log({judgements})
    const { model } = this.props
    for (const j of judgements) {
      const { judge, ratings } = j
      const judgement = ratings.find(x => x.model === model)
      if (!judgement) {
        console.error("rating not found", judge, model)
        continue
      } else {
        const { rating, review, reward, claims, susClaims } = judgement
        let score
        if (reward) {
          score = reward.score
        }
        const judgeModel = this.props.resolveModel(judge)
        const icon = (judgeModel.getModelIcon && judgeModel.getModelIcon()) || judgeModel.getIcon()
        const judgeView = <div className='modelJudgementInline'>
                            <div className='modelJudgementHeader'>
                              <div className='modelJudgementHeaderLeft'>
                                <SimpleIcon src={icon}/>
                                <div className='modelTitle'>{judgeModel.name}</div>
                              </div>
                              <div className='modelJudgementHeaderRight'>
                                {`Rating: ${rating}/10`}
                              </div>
                            </div>
                            <div className='modelJudgementText'>
                              {review}
                              {susClaims && susClaims.length > 0 && <div className='claims'>
                                                                      Corrections:<br/>
                                                                      {
                                                                        susClaims.map((x, i) => {
                                                                          const { claim, sus } = x
                                                                          return <div className='claim'>
                                                                                 <div className='claimClaim'>{i+1}. {claim}<br/>{sus}</div></div>
                                                                        })
                                                                      }
                                                                    </div>
                              }
                            </div>
                          </div>
        judgeViews.push({judge, judgeView})
      }
    }
    const handleTouchStart = e => {
      if (this.props.onTouchStart) this.props.onTouchStart(e)
    }
    const handleTouchEnd = e => {
      if (this.props.onTouchEnd) this.props.onTouchEnd(e)
    }
    if (judgeViews.length === 0) {
      return null
    }
    if (judgeViews.length === 1) {
      return judgeViews[0].judgeView
    }
    return <div className='judgementSwiper'>
             <Swiper
               preventClicks={false}
               onSwiper={this.onSwiper}
               nested={true}
               modules={[Mousewheel]}
               allowTouchMove={!isDesktop()}
               onSlideChange={this.onSlideChange}
               onTouchStart={handleTouchStart}
               onTouchEnd={handleTouchEnd}
               mousewheel={isDesktop() ? { forceToAxis: true, releaseOnEdges: true  } : undefined}
             >
               {
                 judgeViews.map(v => {
                   return <SwiperSlide key={v.judge}>{v.judgeView}</SwiperSlide>
                 })
               }
             </Swiper>
             <Navigation
             length={judgeViews.length}
             pos={this.getPos()}
             setPos={this.setPos}
             />
           </div>
  }
}


export class ModelSelection extends Component {
  constructor (props) {
    super(props)
    this.state = {
      showOptions: false
    }
  }

  configs = {}
  configValues = {}

  getDefaultConfig = id => {
    const item = (this.props.models || []).find(x => x.model && x.model.id === id)
    const model = item && item.model
    if (!model) {
      return {}
    }
    const opts = {
      temperature: DEFAULT_MODEL_TEMPERATURE,
      top_p: DEFAULT_MODEL_TOP_P,
      top_k: DEFAULT_MODEL_TOP_K
    }
    const reasoningEffort = defaultReasoningEffortForModel(model)
    if (model.supportedReasoningEfforts && reasoningEffort && reasoningEffort !== 'auto') {
      opts.reasoning_effort = reasoningEffort
      opts.reasoning = {
        effort: reasoningEffort,
        summary: 'auto'
      }
    }
    if (model.supportedPricingModes) {
      opts.pricingMode = defaultPricingModeForModel(model)
    }
    if (model.supportedVerbosityLevels && model.defaultVerbosityLevel) {
      opts.textVerbosity = model.defaultVerbosityLevel
      opts.text = {
        verbosity: model.defaultVerbosityLevel
      }
    }
    return opts
  }

  getConfig = selectedModelIds => {
    const result = {}
    for (const id of selectedModelIds) {
      const defaults = this.getDefaultConfig(id)
      if (this.configs[id]) {
        result[id] = {
          ...defaults,
          ...this.configs[id].getOpts()
        }
      } else {
        result[id] = defaults
      }
    }
    //////debugger
    return result
  }

  onCreateConfig = (model, config) => {
    this.configs[model.id] = config
  }

  componentDidMount() {
    this.props.onCreate(this)
  }

  render() {
    let  {actions} = this.props
    actions = actions || []
    return <div className='modelSelection'>
             {
               this.props.models.map(x => {
                 let { model, selected, active, menu, configure } = x
                 let modelActions= actions.map(x => {
                   const { icon, label, action } = x
                   return {
                     icon,
                     label,
                     action: () => action(model.id)
                   }
                 })
                 let fractionUsed
                 const isTrain = model.id === 'train'
                 const isReject = model.id === 'reject'
                 const isTrainOrReject = isTrain || isReject
                 if (isTrainOrReject) {
                   active = false
                 } else {
                   const usage = this.props.currentUsage && this.props.currentUsage[model.id] || {
                     inputTokens: 0,
                     outputTokens: 0
                   }
                   const { inputTokens, outputTokens, reasoningTokens, cacheReadTokens, cacheWriteTokens } = usage
                   const context = model.contexts ?
                         model.contexts[model.contexts.length-1] : getPricingContext(model, inputTokens, cacheReadTokens)
                   if (!model || !context) {
                     // hugging face/custom models don't have contexts
                   } else {
                     fractionUsed = (inputTokens + outputTokens - (reasoningTokens || 0)) / (context.input * 1000)
                   }
                 }
                 const icon = (model.getModelIcon && model.getModelIcon()) || model.getIcon()
                 let action
                 if (this.props.action) {
                   action = async () => {
                     await this.props.action(model)
                     await delay(0.3)
                   }
                 }
                 let className = 'modelSelectionModel'
                 if (selected) {
                   if (active) {
                     className += ' modelSelectionModelActiveSelected'
                   } else {
                     className += ' modelSelectionModelSelected'
                   }
                 } else {
                   className += ' modelSelectionModelActive'
                 }
                 const routeIndicator = this.props.getModelRouteIndicator && this.props.getModelRouteIndicator(model)
                 if (routeIndicator && routeIndicator.className) {
                   className += ' ' + routeIndicator.className
                 }
                 let trash
                 let trashLabel
                 let label = <ModelLabel model={model}/>
                 let toggleSelection
                 if (!isTrainOrReject) {
                   if (!active) {
                     toggleSelection = () => this.props.toggleSelection(x)
                   } else {
                     trash = () => {
                       this.props.trash(x)
                     }
                   }
                 }
                 let deleteButton
                 if (trash) {
                   const deleteAction = async close => {
                     await trash()
                     close()
                   }
                   const deleteLabel = 'Delete'
                   deleteButton = close => <DeleteButton icon={Cross} trash={() => deleteAction(close)} label={deleteLabel}/>
                 } else if (toggleSelection) {
                   const deleteAction = async close => {
                     await toggleSelection()
                     close()
                   }
                   const deleteLabel = 'Remove'
                   deleteButton = close => <SimpleButton icon={Cross} action={() => deleteAction(close)} label={deleteLabel}/>
                 }
                 if (deleteButton) {
                   modelActions.push({
                     button: deleteButton
                   })
                 }
                 if (modelActions.length > 0) {
                   menu = <ActionMenu actions={modelActions}/>
                 }
                 const showModelOptions = () => {
                   this.setState({
                     modelOptions: model
                   })
                 }
                 let config
                 let longPress
                 longPress = () => this.props.toggleSelection({model})
                 const configurable = !isTrainOrReject && (
                   model.supportedReasoningEfforts ||
                   model.supportedPricingModes ||
                   model.supportedVerbosityLevels
                 )
                 if (configurable) {
                   let className = 'modelConfigPopup'
                   if (active) {
                     if (selected) {
                       className += ' modelConfigPopupActiveSelected'
                     } else {
                       className += ' modelConfigPopupActive'
                     }
                   } else if (selected) {
                     className += ' modelConfigPopupSelected'
                   }
                   const trigger = <div id={'modelMenuTrigger'}>
                                     <SimpleButton icon={Filter} action={() => {}}/>
                                   </div>
                   let className0 = 'modelConfigPopupContainer'
                   if (isMobile()) {
                     className0 += ' modelConfigPopupMobile'
                   }
                   const setConfig = opts => {
                     this.configValues[model.id] = opts
                     //this.forceUpdate()
                   }
                   const getConfig = () => this.configValues[model.id]
                   config = <Popup closeOnDocumentClick position='bottom' trigger={trigger}>
                              {close =>
                                <div className={className0}>
                                  <div className={className}>
                                    <ModelConfig
                                      onCreate={ref => this.onCreateConfig(model, ref)}
                                      value={getConfig()}
                                      onChange={setConfig}
                                      model={model}/>
                                  </div>
                                </div>
                              }
                            </Popup>
                 }
                 const pct = Math.round((fractionUsed || 0) * 100)
                 return <div className={className} key={model.id}>
                          <SimpleButton icon={icon}
                                        label={label}
                                        longPress={longPress}
                                        action={action}/>
                          {pct >= 1 && <div className='contextSize'>
                                         {pct}%
                                       </div>}
                          <div className='modelSelectionGap'/>
                          {config}
                          <div className='modelSelectionGap'/>
                          {menu}
                          </div>
               })
             }
             <div className='selectionAddButton'>
               <SimpleButton keepFocus legacyIconSize icon={Plus} action={() => this.props.add()}/>
             </div>
           </div>
  }
}

class Popup1 extends Component {


  renderPopup = () => {
    return this.props.popup && ReactDOM.createPortal(this.props.popup, getPortal())
  }

  render() {
    return [this.props.children, this.renderPopup()]
  }

}

const turndownService = new TurndownService()

class MessageBody extends Component {

  constructor(props) {
    super(props)
    this.state = {}
  }

  getUiState = () => {
    if (!this.localUiState) {
      this.localUiState = {}
    }
    const uiState = this.props.uiState || this.localUiState
    if (uiState.transition === undefined) {
      uiState.transition = false
    }
    if (!uiState.read) {
      uiState.read = {}
    }
    return uiState
  }

  setUiState = (updates, cb) => {
    const uiState = this.getUiState()
    Object.assign(uiState, updates)
    this.forceUpdate(cb)
  }


  getRequestedReplyIndex = () => {
    const uiState = this.getUiState()
    const replies = this.getReplies()
    if (this.props.selectedModelIndex) {
      const selectedModel = this.props.resolveModel(this.props.selectedModelIndex)
      const selectedIndex = replies.findIndex(reply => reply && (
        reply.model === this.props.selectedModelIndex ||
        selectedModel && selectedModel.isModel && selectedModel.isModel(reply.model)
      ))
      if (selectedIndex >= 0) return selectedIndex
    }
    const activeIndex = Number.isInteger(uiState.activeIndex) ? uiState.activeIndex : 0
    return Math.max(0, Math.min(activeIndex, Math.max(0, replies.length - 1)))
  }

  syncSwiperSelection = () => {
    if (!this.swiper) return
    const index = this.getRequestedReplyIndex()
    this.getUiState().activeIndex = index
    if (this.swiper.activeIndex !== index) {
      this.blockNotifs = true
      this.swiper.slideTo(index, 0, false)
      this.swiper.updateAutoHeight()
      this.blockNotifs = false
    }
  }

  onSwiper = swiper => {
    this.swiper = swiper
    this.syncSwiperSelection()
  }

  selectReply = i => {
    if (this.swiper.activeIndex !== i) {
      this.swiper.slideTo(i)
    } else {
      this.onSlideChange()
    }
  }


  selectModel = (model, speed) => {
    if (!this.swiper) {
      return
    }
    if (typeof model === 'number') {
      this.getUiState().activeIndex = model
      return this.swiper.slideTo(model, speed)
    }
    const replies = this.getReplies()
    let index = 0
    for (const reply of replies) {
      if (model.isModel(reply.model)) {
        this.getUiState().activeIndex = index
        this.swiper.slideTo(index, speed)
        break
      }
      index++
    }
  }

  updateSwiper = () => {
    const { swiper } = this
    if (swiper) {
      try {
        swiper.updateAutoHeight();
      } catch (err) {
        ////////////debugger
        console.warn(err)
      }
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (super.componentDidUpdate) {
      super.componentDidUpdate(prevProps, prevState)
    }
    if (prevProps.selectedModelIndex !== this.props.selectedModelIndex) {
      this.syncSwiperSelection()
    }
    this.updateSwiper()
  }

  componentDidMount() {
    ////////////console.log("MOUNTED Message Body", this.props.msg.message.id, this.props.key1 )
    this.props.onCreate(this)
    if (isMobile()) {
      document.addEventListener('selectionchange', this.onSelectionChange)
    }
  }

  onSelectionChange = e => {
    const selection = document.getSelection();
    if (selection.toString().length > 0) {
      if (this.swiper) this.swiper.disable()
    } else {
      if (this.swiper) this.swiper.enable()
    }
  }

  componentWillUnmount() {
    if (isMobile()) {
      document.removeEventListener('selectionchange', this.onSelectionChange)
    }
  }

  onSlideChangeTransitionStart = e => {
    ////////////console.log("slide transition start")
    if (this.blockNotifs) return
    this.getUiState().transition = true
    this.props.onSlideTransitionStart()
  }

  onSlideChangeTransitionEnd = e => {
    if (this.blockNotifs) return
    this.getUiState().transition = false
    //////////console.log("****slide transition end scroll into view")
    this.props.onSlideTransitionEnd()
  }

  onSlideChange = e => {
    const uiState = this.getUiState()
    uiState.transition = false
    const activeIndex = this.swiper.activeIndex
    const replies = this.getReplies()
    const reply = replies[activeIndex]
    uiState.activeIndex = activeIndex
    this.forceUpdate()
    if (this.props.onSelectReply) this.props.onSelectReply(activeIndex, reply, uiState.read[activeIndex])
    uiState.read[activeIndex] = true
  }

  judges = {}
  setJudge = (model, x) => {
    if (x) {
      this.judges[model] = x
    } else {
      delete this.judges[model]
    }
  }

  selectJudgeIndex = judge => {
    for (const model in this.judges) {
      this.judges[model].selectJudge(judge)
    }
  }

  scrollIntoView = () => {
    //////////////debugger
    if (this.ref) {
      //this.ref.scrollIntoView({block: 'nearest', behavior: 'smooth' })
    }
  }

  setRef = ref => {
    //////////////debugger
    this.ref = ref
  }

  onJudgementStart = e => {
    this.swiper.disable()
  }

  onJudgementEnd = e => {
    if (this.swiper) this.swiper.enable()
  }

  onJudgementSlideChange = e => {
    this.forceUpdate()
  }

  getReplies = () => {
    const { message } = this.props
    let replies = getReplies(message)
    if (this.getUiState().replay === 'attunewise' && !replies.includes(message)) {
      replies = [message].concat(replies)
    }
    const { inReplyTo } = this.props
    if (inReplyTo) {
      const modelIds = inReplyTo.models
      if (modelIds) {
        replies = modelIds.map(id => {
          let reply = replies.find(x => x.model === id)
          if (!reply) {
            reply = {
              model: id,
              content: ''
            }
          }
          return reply
        })
      }
    }
    if (this.props.participants.length > 0) replies = this.props.participants.map(p => {
      if (p.id === message.model) {
        return message
      }
      if (message.models) {
        const found = getReplies(message).find(x => x.model === p.id)
        if (found) {
          return found
        } else {
          //////////////////debugger
        }
      }
      const self = this
      return { model: p.id, content: '', usage: { inputTokens: 0, outputTokens: 0 } }
    })
    if (false) replies.sort((x, y) => {
      const a = this.props.resolveModel(x.model)
      const b = this.props.resolveModel(y.model)
      if (!a) return b
      if (!b) return a
      return a.title.localeCompare(b.title)
    })
    return replies
  }

  render() {
    const replies = this.getReplies()
    //////console.log("REPLIES", replies)
    const selection = this.props.selection
    let className = 'keyboardEditDocument'
    const bodies = replies.map((message, i) => {
      let {model, content}  = message
      if (!content) {
        //content = "Model did not respond."
        content = ''
        ////////////debugger
      }
      let judgement
      if (!model) {
        model = 'train' // hack
      }
      ////////console.log('judging', this.props.judging, "judgement", this.props.message.judgement)
      if (this.props.judging && this.props.message.judgement) {
        judgement = <JudgementComp key={this.props.message.id}
                                   onSlideChange={this.onJudgementSlideChange}
                                   onTouchStart={this.onJudgementStart}
                                   onTouchEnd={this.onJudgementEnd}
                                   onCreate={(judge) => this.setJudge(model, judge)}
                                   onSelectModel={this.selectModel}
                                   model={model}
                                   resolveModel={this.props.resolveModel}
                                   message={this.props.message}
                    />
      }
      const body = this.props.renderBody(message, model, content, judgement, {
        forceUpdate: () => {
          this.props.purgeCache(this.props.message)
        },
        setEditing: isEditing => {
          if (this.swiper) {
            if (isEditing) {
              this.swiper.disable()
            } else {
              this.swiper.enable()
            }
          }
        }
      })
      return body
    })
    if (true && bodies.length === 1) {
      return <div className='singleMsgBody'>
               {bodies[0]}
             </div>
    }
    const render1Body = (body, i) => {
      const reply = replies[i]
      return <SwiperSlide key={'swiper-'+reply.model+'-'+i}>
               <Autoheight index={i} swiper={this.swiper}>
                 {body}
               </Autoheight>
             </SwiperSlide>
    }
    let replays = 1
    let selectedReplay = 0
    const setReplay = () => {
    }
    return <div key={'body-'+this.props.key1} className='messageBodySwiperContainer' ref={this.setRef}>
             <div className='messageBodyDotsContainer'>
               <Navigation
                 length={bodies.length}
                pos={this.getUiState().activeIndex || 0}
                 setPos={pos => {
                   if (this.swiper.activeIndex !== pos) {
                     this.swiper.slideTo(pos)
                   } else {
                     this.props.selectModel(pos)
                   }
                 }}
               />
             </div>
             <Swiper
               speed={600}
               preventClicks={false}
               nested={true}
               modules={[Mousewheel]}
               allowTouchMove={!isDesktop()}
               mousewheel={isDesktop() ? { forceToAxis: true, thresholdDelta: 6, releaseOnEdges: true  } : undefined}
               onSwiper={this.onSwiper}
               onSlideChange={this.onSlideChange}
               onSlideChangeTransitionStart={this.onSlideChangeTransitionStart}
               onSlideChangeTransitionEnd={this.onSlideChangeTransitionEnd}
               autoHeight={this.props.autoHeight}>
               {
                 bodies.map((body, i) => render1Body(body, i))
               }
             </Swiper>
           </div>
  }
}

class UserSaidComp extends Component {
  constructor (props) {
    super(props)
    this.state = {}
  }

  getUiState = () => {
    if (!this.localUiState) {
      this.localUiState = {}
    }
    const uiState = this.props.uiState || this.localUiState
    if (uiState.editing === undefined) {
      uiState.editing = false
    }
    if (uiState.showAll === undefined) {
      uiState.showAll = false
    }
    if (uiState.downloading === undefined) {
      uiState.downloading = false
    }
    if (!uiState.compactionOpen) {
      uiState.compactionOpen = {}
    }
    return uiState
  }

  setUiState = (updates, cb) => {
    const uiState = this.getUiState()
    Object.assign(uiState, updates)
    this.forceUpdate(cb)
  }

  componentDidUpdate(prevProps) {
    if (prevProps.selectedMessage !== this.props.selectedMessage) {
      //this.checkScrollIntoView()
    }
  }

  checkScrollIntoView = () => {
  }

  componentDidMount() {
    this.id = this.props.message.id
    if (this.props.registerComponent !== false) {
      this.props.onCreate(this, this.id)
    }
    this.checkScrollIntoView()
  }

  componentWillUnmount() {
    if (this.props.registerComponent !== false) {
      this.props.onDelete(this.id)
    }
  }

  scrollIntoView = () => {
    if (this.ref) {
      ////console.log("scroll into view")
      //this.ref.scrollIntoView({block: 'start', behavior: 'smooth'})
    } else {
      //////////debugger
    }
  }

  setRef = ref => {
    //////////////debugger
    this.ref = ref
  }

  startEdit = () => {
    this.setUiState({
      editing: true
    })
  }

  setEditable = ref => {
    if (ref && ref !== this.editable) {
      this.editable = ref
      ref.innerText = this.props.message.content
      //divSelectAll(this.editable)
      ////debugger
      if (isDesktop()) {
        this.editable.addEventListener('keydown', this.handleKeyDown)
      }
    }
    if (!ref) {
      if (isDesktop()) {
        if (this.editable) {
          this.editable.removeEventListener('keydown', this.handleKeyDown)
        }
      }
      this.editable = null
    }
  }

  handleKeyDown = event => {
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault()
      this.commitEdit()
    } else if (event.key === 'Escape') {
      event.preventDefault()
      this.cancelEdit()
    }
  }

  files = {}

  commitEdit = async () => {
    //////////////debugger
    const uiState = this.getUiState()
    if (!uiState.editing) {
      return
    }
    let contents = getEditedContent(this.editable)
    let content = ''
    //////console.log({contents})
    //////console.log({files: this.files})
    for (const element of contents) {
      if (element.type === 'image_url') {
        const { file, uploaded } = this.files[element.image_url.url]
        const downloadURL = await uploaded
        content += `![${file.name}](${downloadURL})`
      } else {
        content += element.text
      }
    }
    this.files = {}
    this.setUiState({ editing: false })
    if (this.props.message.content !== content) {
      await this.props.saveEdit(content)
      this.props.purgeCache(this.props.message)
    }
  }

  cancelEdit = async() => {
    this.getUiState().editing = false
    this.props.purgeCache(this.props.message)
    this.forceUpdate()
  }


  toggleShowAll = () => {
    const message = this.props.message
    if (message.content.length !== message.contentLength) {
      const uiState = this.getUiState()
      if (!uiState.downloading) {
        uiState.downloading = true
        this.props.me.downloadMessageContent(message.id, message.storage).then(content => {
          message.content = content
          uiState.downloading = false
          this.forceUpdate()
        }).catch(err => {
          uiState.downloading = false
          console.error(err)
        })
      }
    }
    const uiState = this.getUiState()
    this.setUiState({
      showAll: !uiState.showAll
    })
  }

  render() {
    const uiState = this.getUiState()
    const { message, components, isJudge, queueState, steerQueuedMessage } = this.props
    const trash = async () => {
      await this.props.deleteChatMessage(message.id)
      this.props.purgeCache(message)
    }
    const deleteButton = <DeleteButton trash={trash}/>
    let content = message.content
    let contentDiv
    if (!uiState.editing) {
      if (message.storage) {
        const displayState = getStoredContentDisplayState(message, content)
        if (displayState.partial || (!uiState.showAll && displayState.truncated)) {
          const label = storedContentMoreLabel(displayState, uiState.downloading)
          let button = <div className='contentSmallButton' onClick={this.toggleShowAll}>{label}<span className='showAll'>(Show All)</span></div>
          contentDiv = <div className='contentSmall'><Markdown key={message.id} components={components}>{displayState.previewContent}</Markdown>{button}
                       </div>
        } else if (uiState.showAll && displayState.truncated) {
          let button = <div className='contentSmallButton' onClick={this.toggleShowAll}>(Show Less)</div>
          contentDiv= <div className='contentLarge' onClick={this.toggleShowAll}><Markdown key={message.id} components={components}>{displayState.visibleContent}</Markdown>{button}</div>
        } else {
          contentDiv = <Markdown key={message.id} components={components}>{displayState.visibleContent}</Markdown>
        }
      } else {
        contentDiv = <Markdown key={message.id} components={components}>{content}</Markdown>
      }
      const edit = (e) => {
        this.setUiState({
          editing: true
        }, () => {
          this.editable.focus()
          setCaretPositionFromEvent(this.editable, e)
        })
      }
      contentDiv = <div className='nonEditing' onDoubleClick={edit}>
                     {contentDiv}
                   </div>
    } else {
      const stopEditing = async () => {
        if (!this.getUiState().editing) {
          return
        }
        this.getUiState().editing = false
        if (isMobile()) {
          await this.commitEdit()
        } else {
          this.cancelEdit()
        }
      }
      const cancelEdit = async () => {
        this.cancelEdit()
      }
      const onPaste = async e => {
        if (e.clipboardData.files && e.clipboardData.files.length > 0) {
          ////////debugger
          e.preventDefault()
          for (const file of e.clipboardData.files) {
            const blobUrl = URL.createObjectURL(file)
            const img = document.createElement('img')
            img.src = blobUrl
            this.files[blobUrl] = {
              file,
              uploaded: this.props.uploadFile(file)
            }
            insertImage(img)
          }
        } else {
          pasteText(e)
        }
      }
      contentDiv = <div className='editableContentContainer'>
                     <div ref={this.setEditable} className='editableContent editableContentUser'
                          onPaste={onPaste}
                          contentEditable={true}
                          onBlur={this.commitEdit}>
                     </div>
                   </div>
      contentDiv = <ClickAwayListener mouseEvent={'mousedown'} onClickAway={this.commitEdit}>
                     {contentDiv}
                   </ClickAwayListener>
    }
    let judgeIcon = this.props.judging ? Spin : Right
    let judge
    const hasReplies = message => {
      for (const id in this.received) {
        if (this.received[id].inReplyTo === message.id) return true
      }
    }
    const nop = async () => {}
    if (!isJudge) {
      if (uiState.editing) {
        judge = nop
      } else {
        judge = this.props.judge
      }
    }
    const onSwipe = e => {
      this.setUiState({
        swipeMessage: message
      })
    }
    let edit
    let trashMessage
    if (!isJudge) {
      const isTrain = false//(message.models && message.models.find(x => x === 'train'))
      if (!isTrain) {
        edit = async () => {
          this.props.purgeCache(message)
          this.setUiState({
            editing: true
          }, () => {
            this.editable.focus()
          })
        }
        trashMessage = async () => {
          await this.props.deleteChatMessage(message.id)
          this.props.purgeCache(message)
        }
      }
    }
    const isTrain = message.model === 'train'
    let toggleJson = this.props.toggleJson
    let cutMessage
    let copyMessage
    let pasteMessage
    if (this.props.pasteMessage) {
      pasteMessage = () => this.props.pasteMessage(this, uiState.selectedTask, message)
    }
    if (this.props.cutMessage) {
      cutMessage = () => this.props.cutMessage(this, uiState.selectedTask, message)
    }
    if (this.props.copyMessage) {
      copyMessage = () => this.props.copyMessage(this, uiState.selectedTask, message)
    }
    let copy = () => this.props.copy(message.content)
    let trimUp
    let trimDown
    let makeThread
    let openThread
    if (this.props.cutConversation) {
      trimUp = () => this.props.cutConversation(message, 'up')
      trimDown = () => this.props.cutConversation(message, 'down')
      makeThread = () => this.props.cutConversation(message, 'thread')
      openThread = () => {
        return this.props.openThread(message)
      }
    }
    let split  = () => {
      //////////debugger
      return this.props.cutConversation(message, 'split')
    }
    if (this.props.readOnly) {
      trashMessage = copyMessage = pasteMessage = cutMessage = edit = trimUp = trimDown = makeThread = null
    }
    let actions =  []
    if (makeThread) {
      actions.push({
        button: (close) => <DeleteButton icon={Chat} label='Thread' trash={
                                           async () => {
                                             makeThread()
                                             close()
                                           }
                                         }/>
      })
    }
    if (trimUp) {
      actions.push({
        button: (close) => <DeleteButton icon={Up} label='Cut Above' trash={
                                           async () => {
                                             await trimUp()
                                             close()
                                           }
                                         }/>
      })
    }
    if (trimUp) {
      actions.push({
        icon: Left,
        label: "Split Here",
        action: split
      })
    }
    if (trimDown) {
      actions.push({
        button: (close) => <DeleteButton icon={Down} label='Cut Below' trash={
                                           async () => {
                                             await trimDown()
                                             close()
                                           }
                                         }/>
      })
    }
    if (false) {
      actions.push({
        icon: judgeIcon,
        action: judge,
        label: "Judge"
      })
    }
    if (edit) actions.push({
      icon: EditIcon,
      action: edit,
      label: "Edit"
    })
    if (cutMessage) {
      actions.push({
        icon: Cut,
        action: cutMessage,
        label: "Cut"
      })
    }
    actions.push({
      icon: Copy,
      action: async () => {
        await copy()
        if (copyMessage) copyMessage()
      },
      label: "Copy"
    })
    if (pasteMessage) {
      actions.push({
        icon: Import,
        action: pasteMessage,
        label: "Paste"
      })
    }
    if (trashMessage) {
      actions.push({
        button: (close) => <DeleteButton label='Delete' trash={
                                           async () => {
                                             await trashMessage()
                                             close()
                                           }
                                         }/>
      })
    }
    if (this.props.subpages) {
      actions = actions.concat(this.props.subpages)
    }
    let className = 'keyboardEditInstruction aiUser'
    const compacted = findCompactionEntry(message.addedToTranscript)
    const compactionOnMessage = isCompactionEntryOnMessage(compacted, message)
    const activeCompaction = compacted && compactionOnMessage && (
      !this.props.isActiveCompactionEntry ||
      this.props.isActiveCompactionEntry(compacted)
    )
    if (this.props.compacted) {
      className += ' aiUserCompacted'
    }
    if (queueState) {
      className += ' aiUser-'+queueState
    } else {
      className += ' aiUser-idle'
    }
    let user = <div
                 data-message-id={message.id}
                 key='usermsg'
                 className={className}
                 ref={this.setRef}
               >
                 <div className='keyboardEditIconAndInstruction'>
                   <div className='keyboardEditInstructionLeftIcon'>
                     <SimpleIcon src={UserSaid}/>
                   </div>
                   <div className='keyboardEditInstructionText' key={'user-'+message.id}>
                     {contentDiv}
                     {queueState ?
                      <div className={'queuedUserMessage queuedUserMessage-' + queueState}>
                        {queueState === 'inferencing' ? 'Inferencing' : capitalize(queueState)}
                      </div> :
                      null}
                   </div>
                   <div className='rightColumn1 copyAISaid'>
                     {!this.props.readOnly && queueState === 'queued' && steerQueuedMessage ?
                      <div className='queuedUserMessageSend'>
                        <SimpleButton icon={Send} action={() => steerQueuedMessage(message)}/>
                      </div> :
                      null}
                     <ActionMenu
                       className='aiUserEditMenu'
                       actions={actions}
                     />
                   </div>
                 </div>
               </div>
    if (!activeCompaction) {
      return user
    }
    const compactedDiv = renderConversationCompactionSummary({
      compacted,
      task: this.props.task,
      message,
      summaryRecords: this.props.getConversationSummaryRecords
        ? this.props.getConversationSummaryRecords(compacted)
        : this.props.conversationSummaryRecords,
      summaryState: this.props.getConversationSummaryRecordsState
        ? this.props.getConversationSummaryRecordsState(compacted)
        : this.props.conversationSummaryState,
      loadSummaryRecords: this.props.loadConversationSummaryRecords
        ? () => this.props.loadConversationSummaryRecords(compacted)
        : null,
      uiState,
      components,
      me: this.props.me,
      onOpen: this.props.openConversationLink,
      forceUpdate: () => this.forceUpdate()
    })
    if (!compactedDiv) {
      return user
    }
    return <div className='aiUserMaybeCompacted'>
             {user}
             {compactedDiv}
           </div>
  }
}

class SystemSaidComp extends Component {
  constructor (props) {
    super(props)
    this.state = {
      editing: false
    }
  }

  setEditable = ref => {
    if (ref) {
      if (ref !== this.editable) {
        if (this.editable) {
          this.editable.removeEventListener('keydown', this.handleKeyDown)
        }
        this.editable = ref
        if (isDesktop()) {
          this.editable.addEventListener('keydown', this.handleKeyDown)
        }
      }
      this.editable.innerText = this.props.task.systemPrompt ? this.props.task.systemPrompt.content : ''
      this.editable.focus()
    } else {
      if (isDesktop()) {
        if (this.editable) {
          this.editable.removeEventListener('keydown', this.handleKeyDown)
        }
      }
      this.editable = null
    }
  }

  handleKeyDown = event => {
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault()
      this.commitEdit()
    } else if (event.key === 'Escape') {
      event.preventDefault()
      this.cancelEdit()
    }
  }

  commitEdit = async () => {
    const content = this.editable.innerText
    const model = this.state.editing
    this.state.editing = false
    this.forceUpdate()
    await this.props.saveEdit(content)
  }

  cancelEdit = async() => {
    this.state.editing = false
    this.forceUpdate()
  }


  render() {
    const { components, task, openSystemPrompt } = this.props
    const editSystemPrompt = async () => {
      this.setState({
        editing: true
      })
    }
    return <SystemMessage key='systemMessage'
                          readOnly={this.props.readOnly}
                          components={this.getComponents()}
                          systemPrompts={task.systemPrompts}
                          systemPromptsExpanded={this.state.systemPrompts || []}
                          deleteSystemPrompt={this.deleteSystemPrompt}
                          editSystemPrompt={editSystemPrompt}
                          openSystemPrompt={openSystemPrompt}
           />
  }
}

class AISaidComp extends Component {
  constructor(props) {
    super(props)
    this.state = {}
    this.toolUse = {}
  }

  setToolUsePos = (ids, pos) => {
    return this.props.setToolUsePos(ids, pos)
  }

  getToolUsePos = (ids) => {
    return this.props.getToolUsePos(ids)
  }

  getUiState = () => {
    if (!this.localUiState) {
      this.localUiState = {}
    }
    const uiState = this.props.uiState || this.localUiState
    if (!uiState.showAll) {
      uiState.showAll = {}
    }
    if (!uiState.downloading) {
      uiState.downloading = {}
    }
    if (!uiState.compactionOpen) {
      uiState.compactionOpen = {}
    }
    if (!uiState.toolProgress) {
      uiState.toolProgress = {}
    }
    if (!uiState.storageContent) {
      uiState.storageContent = {}
    }
    if (!uiState.downloadError) {
      uiState.downloadError = {}
    }
    if (!uiState.messageBodyState) {
      uiState.messageBodyState = {}
    }
    return uiState
  }

  setUiState = (updates, cb) => {
    const uiState = this.getUiState()
    Object.assign(uiState, updates)
    this.forceUpdate(cb)
  }

  onSelectReply = (index, reply)  => {
    if (this.props.transcriptPosition === 'middle' || this.props.transcriptPosition === 'last') {
      return
    }
    this.getUiState().activeIndex = index
    if (reply && reply.model) {
      const model = this.props.resolveModel(reply.model)
      if (model) {
        this.props.selectModel(model, 0)
      }
    }
    if (this.props.onSelectReply) this.props.onSelectReply(index)
    this.forceUpdate()
  }

  componentDidMount() {
    this.id = this.props.message.id
    this.props.onCreate(this, this.id)
    if (this.props.selected) {
      this.scrollIntoView()
    }
    if (this.props.isLast) {
      this.resolveStorage()
    }
    if (this.props.hydrateTranscriptArchives !== false) {
      this.hydrateTranscriptArchives()
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.isLast && !prevProps.isLast) {
      this.resolveStorage()
    }
    if (this.props.hydrateTranscriptArchives !== false) {
      this.hydrateTranscriptArchives()
    }
  }

  hydrateTranscriptArchives = async () => {
    if (this.hydratingTranscriptArchives || !this.props.hydrateTranscriptArchiveEntries) return
    const sourceMessage = this.props.sourceMessage || this.props.message
    if (!hasTranscriptArchives(sourceMessage)) return

    this.hydratingTranscriptArchives = true
    try {
      const changed = await this.props.hydrateTranscriptArchiveEntries(sourceMessage)
      if (changed && !this.unmounted) {
        if (this.props.onTranscriptChanged) this.props.onTranscriptChanged()
        this.forceUpdate()
      }
    } catch (err) {
      console.error(err)
    } finally {
      this.hydratingTranscriptArchives = false
    }
  }

  resolveStorage = () => {
    if (this.resolving) return
    this.resolving = true
    const replies = getReplies(this.props.sourceMessage || this.props.message)
    for (const reply of replies) {
      this.toggleShowAll(reply)
    }
  }

  componentWillUnmount() {
    this.unmounted = true
    if (this.props.registerComponent !== false) {
      this.props.onDelete(this.id)
    }
  }

  getLastBrowserLocation = () => this.props.getLastBrowserLocation()
  setLastBrowserLocation = url => this.props.setLastBrowserLocation(url)
  setLastBrowserStreamURL = url => this.props.setLastBrowserStreamURL(url)

  setBody = body => {
    this.messageBody = body
  }

  scrollIntoView = () => {
    ///this.messageBody.scrollIntoView()
  }

  selectModel = (index, animate) => {
    this.messageBody.selectModel(index, animate)
  }

  updateSwiper = () => {
    this.messageBody.updateSwiper()
  }

  selectJudgeIndex = index => {
    this.messageBody.selectJudgeIndex(index)
  }

  toggleShowAll = (reply) => {
    const message = this.props.sourceMessage || this.props.message
    const uiState = this.getUiState()
    const { showAll, downloading } = uiState
    //debugger
    if (reply.storage && !showAll[reply.model] && reply.content.length < reply.contentLength) {
      const when = downloading[reply.model] || 0
      if (Date.now() - when > 2000) {
        downloading[reply.model] = Date.now()
        this.props.me.downloadAssistantContent(message.id, reply.model, reply.storage).then(content => {
          reply.content = content
          this.forceUpdate()
        })
      }
    }
    showAll[reply.model] = !showAll[reply.model]
    this.forceUpdate()
  }

  setEditable = (ref, reply, init) => {
    if (ref) {
      if (ref !== this.editable) {
        if (this.editable) {
          this.editable.removeEventListener('keydown', this.handleKeyDown)
        }
        if (!this.resizeObserver) {
          this.resizeObserver = new ResizeObserver(entries => {
            clearTimeout(this.resizeTimeout)
            this.resizeTimeout = setTimeout(() => {
              if (this.messageBody && this.messageBody.swiper) this.messageBody.swiper.updateAutoHeight()
            }, 16)
          })
        } else {
          this.resizeObserver.unobserve(this.editable)
        }
        this.editable = ref
        init = init || ''
        if (init.indexOf("<think>") >= 0) {
          init = removeSignatures(init)
          init = init.replace(/<think>([\s\S]*?)<\/think>/gi, '<div class=\'thinking\' contenteditable="false">$1</div>')
          ref.innerHTML = init
        } else {
          ref.innerText = init
        }
        if (reply.storage && reply.content.length !== reply.contentLength) {
          const sourceMessage = this.props.sourceMessage || this.props.message
          this.props.me.downloadAssistantContent(sourceMessage.id, reply.model, reply.storage).then(init => {
            reply.content = init
            ref.innerText = removeSignatures(init)
            if (init.indexOf("<think>") >= 0) {
              init = removeSignatures(init)
              init = init.replace(/<think>([\s\S]*?)<\/think>/gi, '<div class=\'thinking\' contenteditable="false">$1</div>')
              ref.innerHTML = init
            } else {
              ref.innerText = init
            }
          })
        }
        this.resizeObserver.observe(this.editable)
        if (isDesktop()) {
          this.editable.addEventListener('keydown', this.handleKeyDown)
        }
      }
      this.editable.focus()
    } else {
      if (isDesktop()) {
        if (this.editable) {
          this.editable.removeEventListener('keydown', this.handleKeyDown)
        }
      }
      if (this.resizeObserver) {
        this.resizeObserver.disconnect()
        this.resizeObserver = null
      }
      this.editable = null
    }
  }

  handleKeyDown = event => {
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault()
      this.commitEdit()
    } else if (event.key === 'Escape') {
      event.preventDefault()
      this.cancelEdit()
    }
  }

  commitEdit = async () => {
    const content = this.editable.innerText
    const uiState = this.getUiState()
    const model = uiState.editing
    const reply = this.getReply(model)
    const message = this.props.sourceMessage || this.props.message
    const target = assistantReplyTargetFor(message, reply)
    await this.props.saveEdit({target, model, content})
    uiState.editing = null
    this.forceUpdate()
    this.props.purgeCache(this.props.sourceMessage || this.props.message)
    this.enableSwiper()
  }

  enableSwiper = () => {
    try {
      if (this.messageBody.swiper) {
        this.messageBody.swiper.enable()
      }
    } catch (err) {
      console.warn(error)
    }
  }

  cancelEdit = async() => {
    this.getUiState().editing = false
    this.props.purgeCache(this.props.sourceMessage || this.props.message)
    this.forceUpdate()
    this.enableSwiper()
  }

  comps = {}
  getComponents = (reply) => {
    if (typeof reply.stream !== 'string') {
      return this.props.getComponents()
    }
    if (!this.comps[reply.model]) {
      this.comps[reply.model] = new FadeComponents({
        id: this.props.message.id + '-' + reply.model,
        components: this.props.getComponents()
      })
    }
    const result = this.comps[reply.model]
    result.reset(reply.stream)
    return result
  }

  getReply = (model) => {
    const sourceMessage = this.props.sourceMessage || this.props.message
    if (sourceMessage.model === model) return sourceMessage
    const found = (this.props.message.models || []).find(reply => reply && reply.model === model)
    if (!found) throw new Error(`assistant model reply not found: ${model}`)
    return found
  }

  render() {
    const uiState = this.getUiState()
    const displayMessage = this.props.message
    const message = this.props.sourceMessage || displayMessage
    let replies = getReplies(displayMessage)
    const forceTopLevelReply = uiState.replay === 'attunewise' || message.model === 'train'
    if (forceTopLevelReply && !replies.includes(displayMessage)) {
      replies = [displayMessage].concat(replies)
    }
    let selection = uiState.activeIndex
    const opts = this.props.opts
    const { isLast, isJudge } = opts
    // Movie mode: inner tool panes follow their streaming tails only while
    // the chat itself is bottom-locked on this (latest) message.
    const followStreaming = this.props.isBottomLock && isLast
    let retry = this.props.retry
    const pause = this.props.pause
    let del
    const visibleReply = replies[selection]
    ////////////console.log("visibleReply", visibleReply && visibleReply.uid, this.props.me.self.uid)
    let action3
    let clazz3
    let { role, content, code, serverError, isStreaming, model } = message
    const isDataset = model === 'train'
    const w = 675
    const windowElem = (id, div, shrink) => windowElemExtern(id, div, shrink, w)
    const renderBody = (reply, model, text, judgement, parent) => {
      //console.log("renderBody", {message, reply})
      let copy
      const replyTarget = () => {
        if (reply === displayMessage || reply === message) return { kind: 'top-level' }
        return assistantReplyTargetFor(message, reply)
      }
      const isCompacted = this.props.isCompacted(message, model)
      if (this.props.copy) {
        copy = async () => {
          let target = reply
          //debugger
          if (!target.content) {
            target = getReplies(message).find(x => x.content)
          }
          return await this.props.copy(message, target)
        }
      }
      const components = this.getComponents(reply)
      const { addedToTranscript } = reply
      const progressTranscriptEntries = transcriptEntriesWithInferenceProgress(reply)
      const transcriptEntries = this.props.getTranscriptEntriesForReply
        ? this.props.getTranscriptEntriesForReply(reply)
        : progressTranscriptEntries
      const isTrain = model === 'train'
      const isReject = model === 'reject'
      const isTrainOrReject = isTrain || isReject
      let defaulted = isTrainOrReject || (model === 'train' && !text)
      if (uiState.editing !== model && !text && message.model === 'train') {
        //////console.log("MESSAGE", message)
        ////////////////debugger
        if (message.corrected) {
          text = message.corrected.disclaimer || message.corrected.content
        } else {
          text = message.content
          defaulted = true
        }
      }
      if (typeof reply.stream === 'string') {
        text = reply.stream
        defaulted = false
      }
      if (!text) {
        const found = replies.find(x => x.content)
        if (found) {
          text = found.content
          defaulted = true
        }
      }
      if (!text) {
        ////debugger
      }
      let icon2 = Copy
      let className = 'keyboardEditDocument'
      let icon1 = this.props.getModelIcon(model)
      if (reply.stream !== undefined || reply.inferenceProgress) {
        icon1 = Spin
      }
      let leftIconClassName = 'chatGPTLeftIcon copyAISaid'
      const modelTitle = <ModelLabel model={this.props.resolveModel(model)}/>
      let edit
      let editIcon = EditIcon
      if (!judgement) {
        edit = async (e) => {
          let editing = !uiState.editing
          uiState.editing = editing ? model : null
          parent.setEditing(editing)
          this.props.purgeCache(message)
          this.forceUpdate(() => {
            if (this.editable) {
              this.editable.focus()
              setCaretPositionFromEvent(this.editable, e)
            }
          })
          await delay(0.3)
        }
      }
      let contentEditable
      let contentDiv
      let undo
      let redo
      let save
      let cancel
      let stopEditing
      let cancelEditing
      let replay
      const replyRunning = this.props.isReplyRunning && this.props.isReplyRunning(message, reply)
      let stopReplay = async () => {
        await this.props.stop()
        this.setUiState({
          replay: null
        })
      }
      const replayRunning = !!(uiState.replay || replyRunning)
      if (!judgement && !isTrain) {
        replay = async () => {
          if (replayRunning) {
            return
          }
          this.setUiState({
            replay: reply.model
          })
          try {
            this.props.replay(reply).then(() => {
              //////////debugger
              this.setUiState({
                replay: null
              })
            })
          } catch (err) {
            console.error(err)
          }
          parent.forceUpdate()
        }
      }
      let deleteContent
      if (!isTrain) {
        if (replay || reply.corrected || reply.content || reply.addedToTranscript) {
          deleteContent = async () => {
            await this.props.deleteReply({ target: replyTarget(), model })
            this.props.purgeCache(message)
          }
        }
      }
      let corrected = reply.corrected
      let disclaimer
      let judge
      let corrector
      let crossedOut
      if (corrected) {
        if (corrected.corrected && corrected.corrected.disclaimer) {
          corrector = corrected.model
          text += "\n\n" + corrected.content
          corrected = corrected.corrected
          ////////////////debugger
        }
        disclaimer = corrected.disclaimer
        if (isTrain) {
          crossedOut = text
          text = disclaimer || corrected.content
          if (crossedOut === text) {
            crossedOut = ''
          }
          ////////////////debugger
          judge = this.props.resolveModel(corrected.judge)
          deleteContent = async () => {
            await this.props.saveEdit({target: replyTarget(), model, content: reply.content, corrected: null})
            this.props.purgeCache(message)
          }
        } else {
          if (disclaimer) {
            crossedOut = text
            text = disclaimer
          }
          judge = this.props.resolveModel(corrected.judge)
        }
      }
      if (uiState.editing !== model) {
        let cert
        if (judge) {
          cert = <div className='certifiedJudgement'>
                   <div className='certifiedJudge'>
                     <SimpleIcon src={AICheck}/>{judge && <ModelLabel model={judge}/>}
                   </div>
                   <div className='certifiedSummary'>{corrected.summary}</div>
                 </div>
        }
        if (corrected) {
          let answerType = disclaimer ? 'answerYellow' : 'answerGreen'
          contentDiv = <div className='hallucinatedAnswerContainer'>
                         {crossedOut && <div className='answerRed'>
                                          <Markdown components={components}>{crossedOut}</Markdown>
                                        </div>}
                         <div className={answerType}>
                           <Markdown components={components}>{text}</Markdown>
                           {cert}
                         </div>
                       </div>
        } else {
          //contentDiv = <MarkdownNew components={components} markdown={text || ''}/>
          if (Array.isArray(transcriptEntries) && transcriptEntries.length > 0) {
            let toolUse = []
            const {
              toolCallsById,
              directToolResultsById,
              orderedToolResults,
              latestSessionResultCache,
              sessionOriginCache,
              terminalSessionEntriesCache
            } = transcriptToolLookup(progressTranscriptEntries)
            const findToolCall = id => toolCallsById.get(id)
            const isObject = value => value && typeof value === 'object' && !Array.isArray(value)
            const hasOwn = (value, key) => Object.prototype.hasOwnProperty.call(value, key)
            const isAsyncToolResult = value => {
              return isObject(value)
                && hasOwn(value, 'output')
                && (hasOwn(value, 'completed') || hasOwn(value, 'running') || hasOwn(value, 'failed') || hasOwn(value, 'cancelled'))
                && (hasOwn(value, 'tool') || hasOwn(value, 'operation') || hasOwn(value, 'status'))
            }
            const asyncToolMetadata = value => ({
              status: value.status,
              completed: value.completed,
              running: value.running,
              failed: value.failed,
              cancelled: value.cancelled,
              tool: value.tool,
              operation: value.operation,
              session_id: value.session_id,
              message: value.message,
              events: value.events,
            })
            const getAsyncToolMetadata = value => value && value._asyncToolResult
            const normalizeToolResultContent = value => {
              if (!isAsyncToolResult(value)) return value
              const output = value.output
              const normalized = output && typeof output === 'object'
                ? Array.isArray(output) ? output.slice() : { ...output }
                : { value: output, output }
              Object.defineProperty(normalized, '_asyncToolResult', {
                value: asyncToolMetadata(value),
                enumerable: false,
              })
              return normalized
            }
            const stringifyToolResultContent = value => {
              if (value === undefined || value === null) return ''
              if (typeof value === 'string') return value
              try {
                return JSON.stringify(value, null, 2)
              } catch (err) {
                return String(value)
              }
            }
            const parseToolResultContent = message => {
              if (!message || !message.content) return null
              const cached = parsedToolResultContentCache.get(message)
              if (cached && cached.content === message.content) return cached.value
              let value
              try {
                value = normalizeToolResultContent(JSON.parse(message.content))
              } catch (err) {
                value = {
                  output: message.content
                }
              }
              parsedToolResultContentCache.set(message, { content: message.content, value })
              return value
            }
            const toolResultText = message => {
              const parsed = parseToolResultContent(message)
              if (parsed === undefined || parsed === null) return ''
              if (typeof parsed === 'string') return parsed
              if (typeof parsed.value === 'string') return parsed.value
              if (typeof parsed.content === 'string') return parsed.content
              if (typeof parsed.output === 'string') return parsed.output
              const metadata = getAsyncToolMetadata(parsed)
              if (metadata && typeof metadata.message === 'string') return metadata.message
              return stringifyToolResultContent(parsed)
            }
            const decodeJsonStringPrefix = value => {
              let result = ''
              let escaped = false
              for (let i = 0; i < value.length; i += 1) {
                const ch = value[i]
                if (escaped) {
                  if (ch === 'n') result += '\n'
                  else if (ch === 'r') result += '\r'
                  else if (ch === 't') result += '\t'
                  else if (ch === 'b') result += '\b'
                  else if (ch === 'f') result += '\f'
                  else if (ch === 'u' && i + 4 < value.length) {
                    const hex = value.slice(i + 1, i + 5)
                    const code = parseInt(hex, 16)
                    if (Number.isFinite(code)) {
                      result += String.fromCharCode(code)
                      i += 4
                    } else {
                      result += ch
                    }
                  } else {
                    result += ch
                  }
                  escaped = false
                } else if (ch === '\\') {
                  escaped = true
                } else if (ch === '"') {
                  break
                } else {
                  result += ch
                }
              }
              return result
            }
            const storedToolResultHead = value => {
              const text = String(value || '')
              const match = text.match(/\nhead \(\d+ chars\):\n([\s\S]*)$/)
              return match ? match[1] : text
            }
            const extractStoredReadFileContent = value => {
              const text = storedToolResultHead(value)
              const match = /"content"\s*:\s*"/.exec(text)
              if (!match) return null
              return decodeJsonStringPrefix(text.slice(match.index + match[0].length))
            }
            const toolResultFileText = message => {
              const parsed = parseToolResultContent(message)
              const normalizeText = value => {
                if (value === undefined || value === null) return null
                if (typeof value === 'string') {
                  const extracted = extractStoredReadFileContent(value)
                  return extracted === null ? storedToolResultHead(value) : extracted
                }
                if (Array.isArray(value)) {
                  return value.map(item => normalizeText(item) || '').join('')
                }
                if (typeof value === 'object') {
                  for (const key of ['content', 'value', 'text', 'output']) {
                    const text = normalizeText(value[key])
                    if (text !== null) return text
                  }
                }
                return null
              }
              const text = normalizeText(parsed)
              return text === null ? toolResultText(message) : text
            }
            const parseToolCallArguments = tool_call => {
              try {
                return JSON.parse(tool_call.function.arguments || "{}")
              } catch (err) {
                return {}
              }
            }
            const addTerminalResultEntries = (entries, result) => {
              if (!result) return entries
              if (result.output) {
                entries.push({ type: 'output', text: stringifyToolResultContent(result.output) })
              }
              if (result.stderr) {
                entries.push({ type: 'stderr', text: stringifyToolResultContent(result.stderr) })
              }
              if (result.error || result.message) {
                entries.push({ type: result.error ? 'error' : 'output', text: stringifyToolResultContent(result.error || result.message) })
              }
              if (result.exit_code !== undefined && result.exit_code !== null) {
                entries.push({ type: 'status', exit_code: result.exit_code })
              }
              return entries
            }
            const sessionIdFromResult = result => {
              if (!result) return null
              return result.session_id || (getAsyncToolMetadata(result) || {}).session_id || null
            }
            const sessionIdFromToolResult = toolResult => {
              const content = toolResult && toolResult.content
              if (typeof content !== 'string' || !content.includes('session_id')) return null
              return sessionIdFromResult(parseToolResultContent(toolResult))
            }
            const isAsyncContinuationToolCall = tool_call => {
              const name = normalizeToolFunctionName(tool_call && tool_call.function && tool_call.function.name)
              return name === 'poll_tool_output' || name === 'write_stdin'
            }
            const findDirectToolResult = id => directToolResultsById.get(id) || null
            const findLatestSessionResult = (sessionId, { throughToolCallId } = {}) => {
              if (!throughToolCallId && latestSessionResultCache.has(sessionId)) {
                return latestSessionResultCache.get(sessionId)
              }
              let latest = null
              for (const message of orderedToolResults) {
                if (sessionIdFromToolResult(message) === sessionId) {
                  latest = message
                }
                if (throughToolCallId && message.tool_call_id === throughToolCallId) {
                  break
                }
              }
              if (!throughToolCallId) latestSessionResultCache.set(sessionId, latest)
              return latest
            }
            const findSessionOrigin = sessionId => {
              if (sessionOriginCache.has(sessionId)) {
                const found = sessionOriginCache.get(sessionId)
                return found && { ...found, result: parseToolResultContent(found.message) }
              }
              for (const message of orderedToolResults) {
                const { tool_call_id } = message
                if (sessionIdFromToolResult(message) === sessionId) {
                  const result = parseToolResultContent(message)
                  const tool_call = findToolCall(tool_call_id)
                  if (tool_call && !isAsyncContinuationToolCall(tool_call)) {
                    const found = { message, tool_call, args: parseToolCallArguments(tool_call) }
                    sessionOriginCache.set(sessionId, found)
                    return { ...found, result }
                  }
                }
              }
              sessionOriginCache.set(sessionId, null)
              return null
            }
            const buildTerminalSessionEntries = ({ sessionId, throughToolCallId }) => {
              const cacheKey = `${sessionId || ''}\u0000${throughToolCallId || ''}`
              if (terminalSessionEntriesCache.has(cacheKey)) {
                return terminalSessionEntriesCache.get(cacheKey)
              }
              const found = findSessionOrigin(sessionId)
              if (!found) {
                terminalSessionEntriesCache.set(cacheKey, null)
                return null
              }
              const entries = []
              entries.push({ type: 'input', text: found.args.text || found.args.cmd || '' })
              addTerminalResultEntries(entries, found.result)
              for (const message of orderedToolResults) {
                const sessionToolCall = findToolCall(message.tool_call_id)
                if (!sessionToolCall) continue
                const sessionToolName = normalizeToolFunctionName(sessionToolCall.function && sessionToolCall.function.name)
                if (!['write_stdin', 'poll_tool_output'].includes(sessionToolName)) continue
                const args = parseToolCallArguments(sessionToolCall)
                if (args.session_id !== sessionId) continue
                if (sessionToolName === 'write_stdin' && args.chars) {
                  entries.push({ type: 'input', text: args.chars })
                }
                addTerminalResultEntries(entries, parseToolResultContent(message))
                if (message.tool_call_id === throughToolCallId) {
                  break
                }
              }
              terminalSessionEntriesCache.set(cacheKey, entries)
              return entries
            }
            const findToolResult = (id, options = {}) => {
              const { preferSessionResult = true } = options
              const direct = findDirectToolResult(id)
              if (!direct) return null
              if (!preferSessionResult) return direct
              const tool_call = findToolCall(id)
              if (isAsyncContinuationToolCall(tool_call)) {
                return direct
              }
              const sessionId = sessionIdFromToolResult(direct)
              return sessionId ? (findLatestSessionResult(sessionId) || direct) : direct
            }
            const storedTranscriptEntryKey = message => [
              message && message.storage || '',
              message && message.contentLength || '',
              message && (message.lastUpdated || message.updatedAt || message.ts) || ''
            ].join(':')
            const storedToolCallArgumentsKey = (toolCall, transcriptMessage) => {
              const fn = toolCall && toolCall.function
              const storage = fn && (fn.argumentsStorage || fn.argumentsStoragePath)
              if (!storage) return ''
              return [
                'tool-call-arguments',
                storage,
                fn.argumentsLength || '',
                transcriptMessage && (transcriptMessage.lastUpdated || transcriptMessage.updatedAt || transcriptMessage.ts) || '',
                reply && (reply.lastUpdated || reply.updatedAt || reply.ts) || '',
                (this.props.sourceMessage || this.props.message) &&
                  ((this.props.sourceMessage || this.props.message).lastUpdated ||
                   (this.props.sourceMessage || this.props.message).updatedAt ||
                   (this.props.sourceMessage || this.props.message).ts) || ''
              ].join(':')
            }
            const hydrateStoredToolCallArguments = (toolCall, transcriptMessage) => {
              const fn = toolCall && toolCall.function
              const storage = fn && (fn.argumentsStorage || fn.argumentsStoragePath)
              if (!storage) return

              const key = storedToolCallArgumentsKey(toolCall, transcriptMessage)
              const cached = uiState.storageContent[key]
              if (cached && typeof cached.content === 'string') {
                if (fn.arguments !== cached.content) {
                  fn.arguments = cached.content
                  this.forceUpdate()
                }
                return
              }

              const argumentsLength = Number(fn.argumentsLength)
              const inlineArguments = String(fn.arguments || '')
              if (Number.isFinite(argumentsLength) && inlineArguments.length >= argumentsLength) return

              const when = uiState.downloading[key] || uiState.downloadError[key] || 0
              if (Date.now() - when <= 2000) return
              uiState.downloading[key] = Date.now()
              uiState.downloadError[key] = 0
              const sourceMessage = this.props.sourceMessage || this.props.message
              this.props.me.downloadAssistantContent(sourceMessage.id, model || 'transcript', storage).then(content => {
                if (typeof content !== 'string') {
                  throw new Error(`Stored tool-call arguments unavailable: ${storage}`)
                }
                uiState.storageContent[key] = {
                  content,
                  contentLength: fn.argumentsLength,
                  lastUpdated: transcriptMessage &&
                    (transcriptMessage.lastUpdated || transcriptMessage.updatedAt || transcriptMessage.ts) || null
                }
                fn.arguments = content
                uiState.downloading[key] = 0
                this.forceUpdate()
              }).catch(err => {
                uiState.downloading[key] = 0
                uiState.downloadError[key] = Date.now()
                console.error(err)
                this.forceUpdate()
              })
            }
            const cachedStoredTranscriptEntry = message => {
              if (!message || !message.storage) return false
              const key = storedTranscriptEntryKey(message)
              const cached = uiState.storageContent[key]
              if (!cached || typeof cached.content !== 'string') return false
              return cached
            }
            const applyCachedStoredTranscriptEntry = message => {
              const cached = cachedStoredTranscriptEntry(message)
              if (!cached) return false
              if (message.content === cached.content) return false
              message.content = cached.content
              return true
            }
            const isStoredTranscriptEntryPartial = message => {
              applyCachedStoredTranscriptEntry(message)
              if (!message || !message.storage || !message.contentLength) return false
              const contentLength = Number(message.contentLength)
              return Number.isFinite(contentLength) && String(message.content || '').length < contentLength
            }
	            const hydrateStoredTranscriptEntry = (message, options = {}) => {
	              const { showAllOnComplete = false } = options
	              if (!message || !message.storage) return
	              const key = storedTranscriptEntryKey(message)
	              const cached = cachedStoredTranscriptEntry(message)
	              if (cached) {
	                if (message.content !== cached.content) {
	                  message.content = cached.content
	                }
	                if (showAllOnComplete && !uiState.showAll[key]) {
	                  uiState.showAll[key] = true
	                  this.forceUpdate()
	                }
	                return
	              }
              if (!isStoredTranscriptEntryPartial(message)) return
              const when = uiState.downloading[key] || uiState.downloadError[key] || 0
              if (Date.now() - when <= 2000) return
              uiState.downloading[key] = Date.now()
              uiState.downloadError[key] = 0
              this.props.me.downloadAssistantContent((this.props.sourceMessage || this.props.message).id, model || 'transcript', message.storage).then(content => {
                uiState.storageContent[key] = {
                  content,
                  contentLength: message.contentLength,
                  lastUpdated: message.lastUpdated || message.updatedAt || message.ts || null
                }
                message.content = content
                uiState.downloading[key] = 0
                if (showAllOnComplete) uiState.showAll[key] = true
                this.forceUpdate()
              }).catch(err => {
                uiState.downloading[key] = 0
                uiState.downloadError[key] = Date.now()
                console.error(err)
                this.forceUpdate()
              })
            }
            const toggleStoredTranscriptEntry = message => {
              const key = storedTranscriptEntryKey(message)
              if (isStoredTranscriptEntryPartial(message)) {
                uiState.showAll[key] = true
                hydrateStoredTranscriptEntry(message, { showAllOnComplete: true })
                this.forceUpdate()
                return
              }
              uiState.showAll[key] = !uiState.showAll[key]
              this.forceUpdate()
            }
            const renderStoredTranscriptMarkdown = (message, index, key, content) => {
              if (!message || !message.storage) {
                return <Markdown key={key} components={components}>{content}</Markdown>
              }
              applyCachedStoredTranscriptEntry(message)
              const storageKey = storedTranscriptEntryKey(message)
              const displayState = getStoredContentDisplayState(message, content)
              if (displayState.partial || (!uiState.showAll[storageKey] && displayState.truncated)) {
                const label = storedContentMoreLabel(displayState, uiState.downloading[storageKey])
                const button = <div className='contentSmallButton' onClick={() => toggleStoredTranscriptEntry(message)}>{label}<span className='showAll'>(Show All)</span></div>
                return <div className='contentSmall'><Markdown key={key} components={components}>{displayState.previewContent}</Markdown>{button}</div>
              }
              if (uiState.showAll[storageKey] && displayState.truncated) {
                const button = <div className='contentSmallButton' onClick={() => toggleStoredTranscriptEntry(message)}>(Show Less)</div>
                return <div className='contentLarge'><Markdown key={key} components={components}>{displayState.visibleContent}</Markdown>{button}</div>
              }
              return <Markdown key={key} components={components}>{displayState.visibleContent}</Markdown>
            }

            const resolvePrice = (model, usage) => {
              const resolved = this.props.resolveModel(model)
              const contextTokens = usageBilling.usageTokenBreakdown(usage).contextInputTokens
              const context = getPricingContext(resolved, contextTokens)
              if (!context) { // model not loaded yet
                return {
                  input: 0, output: 0, cached: 0, cacheWrite: 0
                }
              }
              const { input, output, cached, cacheWrite } = context.price
              //console.log(model, context)
              return {
                input: input / (1000*1000),
                output: output / (1000*1000),
                cached: (cached || 0) / (1000*1000),
                cacheWrite: (cacheWrite || 0) / (1000*1000),
              }
            }

            const usages = tallyUsage({resolvePrice, addedToTranscript: (addedToTranscript || []).filter(Boolean)})
            const { byToolCallId, totalUsage } = usages

            const findToolUsage = id => {
              return byToolCallId[id][model]
            }
            // Tool-result UI-only metadata lives as a SIBLING to
            // `message` on the addedToTranscript entry (never inside
            // the message, never in content — so it doesn't waste LLM
            // tokens on replay). Tools return { content, attributes }
            // and Cloud/StreamAdapter persists attributes here.
            const findToolResultAttributes = id => {
              for (const entry of addedToTranscript) {
                if (!entry || !entry.message) continue
                if (entry.message.tool_call_id === id) {
                  return entry.attributes || null
                }
              }
              return null
            }
            const contents = []
            let start = reply.ts
            const renderTranscriptUserMessage = (entry, index) => {
              const entryMessage = entry && entry.message
              if (!entryMessage) return null
              const sourceMessageId = getTranscriptEntrySourceMessageId(entry)
              const markdown = replaceImgWithMarkdown(entryMessage.content || '')
              return <div key={'steered-user-' + (sourceMessageId || index)}
                          data-message-id={sourceMessageId || entryMessage.id}
                          className='keyboardEditInstruction aiUser aiUser-steered aiUser-transcript'>
                       <div className='keyboardEditIconAndInstruction'>
                         <div className='keyboardEditInstructionLeftIcon'>
                           <SimpleIcon src={UserSaid}/>
                         </div>
                         <div className='keyboardEditInstructionText'>
                           <div className='nonEditing'>
                             <Markdown key={'steered-user-content-' + (sourceMessageId || index)}
                                       components={components}>
                               {markdown}
                             </Markdown>
                           </div>
                         </div>
                       </div>
                     </div>
            }
            const flushToolUse = () => {
              let key = message.id + '-tool-calls'
              if (toolUse.length > 0) {
                key = toolUse[0].id + "-" + key
                const ids = toolUse[0].id
                const autoAdvance = this.props.isBottomLock && isLast
                const defaultOpen = autoAdvance || typeof reply.stream === 'string'
                const isOpen =  (this.props.getToolUseOpen
                  ? this.props.getToolUseOpen(ids, defaultOpen)
                                               : defaultOpen)
                const toggleToolUse = async () => {
                  if (this.props.setToolUseOpen) {
                    this.props.setToolUseOpen(ids, !isOpen)
                  }
                  this.forceUpdate()
                }
                let s = toolUse.length > 1 ? 's' : ''
                //////////debugger
	                let title = this.props.isWide && toolUse.length === 1 ? ('Use the ' + formatName(toolUse[0].name) + ' tool.') : ("Use " + toolUse.length + " tool"+s+".")
	                let div = toolUse.map(x => x.content)
                let messagePrice
                let ts = toolUse[toolUse.length-1].ts
                if (usages) {
                  //debugger
                  let total = {}
                  for (const {id} of toolUse) {
                    const r = usages.byToolCallId[id]
                    total = add(total, r)
                  }
                  //console.log({usages})
                  const { inTokens, outTokens, cachedTokens, cacheWriteTokens, inDollars, outDollars, cacheReadDollars, cacheWriteDollars } = total
                  let ci = 0
                  let co = 0
                  if (cacheReadDollars) {
                    ci = cacheReadDollars[model]
                    co = cacheWriteDollars[model]
                  }
                  let i = 0;
                  let o = 0
                  if (inDollars) {
                    i = inDollars[model]
                    o = outDollars[model]
                  }
                  if (i > 0 || o > 0) {
                    messagePrice = ''
                    if (ci > 0 || co > 0) {
                      messagePrice += formatPrice(ci) + "/" + formatPrice(co) +"|"
                    }
                    messagePrice += +formatPrice(i) + "/" + formatPrice(o)
                  }
                }
	        if (toolUse.length === 1 && isOpen) {
	          div = <VisibleToolUseContent item={toolUse[0]}/>
	        } else if (toolUse.length > 1 && isOpen) {
	          div = <ToolUsePanel
	                  pos={this.getToolUsePos(ids)}
	                  setPos={pos => this.setToolUsePos(ids, pos)}
	                  usages={usages}
	                  ids={ids}
	                  toolUse={toolUse}
	                  autoAdvance={autoAdvance}
	                />
                }
                let icon = ToolServer
                if (isLast) {
                  for (const x of toolUse) {
                    if (!findToolResult(x.id)) {
                      icon = Spin
                      break
                    }
                  }
                }
                let deleteToolUse0
                if (toolUse.length === 1 && this.props.deleteToolUse) {
                  const toDelete = toolUse[0]
                  deleteToolUse0 = async close => {
                    await this.props.deleteToolUse({
                      target: replyTarget(),
                      toolCallId: toDelete.id
                    })
                  }
                }
                let end = ts
                let openStyle = isOpen ? null : { display: 'none' }
                let timestamp
                if (true) {
                  timestamp = <Timestamp ts={ts}/>
                } else {
                  timestamp = <Timestamp start={start} end={end}/>
                }
                const toolUseDiv = <div key={key} className='toolUseDiv'>
                                   <div className='toolUseHeader'>
                                     <div className='toolUseHeaderLeft'>
                                       <div className='toolUserHeaderIcon'><SimpleIcon src={icon}/></div>
                                       <div className='toolUseHeaderTitle'>{title}</div>
                                     </div>
                                     <div className='toolUseHeaderRight'>
                                       {timestamp}
                                       <div className='messagePrice'>{messagePrice}</div>
                                       <div className='toolUseDisclosure'>
                                         {deleteToolUse0 && <DeleteButton icon={Cross} trash={deleteToolUse0}/>}
                                         <SimpleButton icon={isOpen ? Up : Down} action={toggleToolUse}/>
                                       </div>
                                     </div>
                                   </div>
                                     <div key='toolUseContent' className='toolUseContent' style={openStyle}>
                                       {div}
                                     </div>
                                   </div>
                start = end
                contents.push(toolUseDiv)
                toolUse = []
              }
            }
            let lastContent
            let j = 0
            for (; j < transcriptEntries.length; j++) {
              const { compaction, message, usage, ts } = transcriptEntries[j]
              if (!message) continue
              if (compaction) continue
              if (message.role === 'user') {
                flushToolUse()
                contents.push(renderTranscriptUserMessage(transcriptEntries[j], j))
                start = ts || start
                continue
              }
              if (message.role === 'assistant' &&
                  message.content === 'Got it.') {
                continue
              }
              let { tool_calls, tool_call_id, content } = message
              let tool_call
              const streamedToolCall = firstToolCallForRendering(tool_calls)
              if (streamedToolCall) {
                const result = findToolResult(streamedToolCall.id)
                if (!result) {
                  //////////debugger
                  tool_call = streamedToolCall
                }
              }
	      if (content && !tool_call_id) {
	        if (lastContent === content) { // fix me!!!
	          //////////debugger
	          continue
	        }
	        lastContent = content
	        flushToolUse()
	        contents.push(renderStoredTranscriptMarkdown(message, j, 'markdownContent'+j, content))
	      } else {
	        lastContent = ''
	      }
              let callMarkdown
              let resultMarkdown
              if (tool_call_id) {
                tool_call = toolCallForRendering(findToolCall(tool_call_id))
                if (!tool_call) {
                  ////////debugger
                }
              }
              if (tool_call) {
                //////////debugger
                try {
                  const args = JSON.parse(tool_call.function.arguments || "{}")
                  if (name === 'repl') {
                    callMarkdown = "```\n"+ code.replaceAll('\n\n', '\n')+"\n```"
                  } else {
                    callMarkdown = `###${name}\n\n${jsonToMarkdown(args)}`
                  }
                } catch (err) {
                  //console.log({tool_call})
                  //console.log(err)
                  callMarkdown = `${name} ${tool_call.function.arguments}`
                }
              }
	              if (tool_call_id && tool_call) {
	                let parsed
	                try {
	                  parsed = JSON.parse(content)
	                  content = jsonToMarkdown(normalizeToolResultContent(parsed))
	                } catch (ignored) {
	                }
                const { name } = tool_call.function
                if (name == 'repl' && parsed) {
                  const { result, output, errors } = parsed
                  resultMarkdown = ''
                  let sep = ''
                  if (result) {
                    resultMarkdown += "## Result:\n"+"```\n" + result+"\n```"
                    sep = '\n\n'
                  }
                  if (output) {
                    resultMarkdown += sep
                    resultMarkdown += "## Output log:\n"+"```\n" + output+"\n```"
                    sep = '\n\n'
                  }
                  if (errors && errors.length > 0) {
                    resultMarkdown += sep
                    resultMarkdown += "## Error log:\n"+"```\n" + errors.join('\n')+"\n```"
                  }
                } else {
                  resultMarkdown = content ? content.trim() : ''
                }
              }
              if (tool_call) {
                if (tool_call.function.arguments.startsWith("{}{")) {
                  tool_call.function.arguments = tool_call.function.arguments.substring("{}".length)
                }
                let toolCallDiv
                if (tool_call.function.name.startsWith("figma")) {
                  let parsed
                  let markdown
                  try {
                    parsed = JSON.parse(tool_call.function.arguments)
                  } catch( err) {
                    //console.log(tool_call.function.arguments)
                    console.error(err)
                  }
                  // Preferred path: tool returns markdown in
                  // attributes (UI-only, not in LLM-visible content).
                  const attrs = findToolResultAttributes(tool_call.id)
                  if (attrs && attrs.markdown) {
                    markdown = attrs.markdown
                  } else {
                    // Legacy fallback for historical messages where
                    // markdown was smuggled inside content.
                    const toolResult = findToolResult(tool_call.id)
                    if (toolResult) {
                      try {
                        const parsed = parseToolResultContent(toolResult)
                        markdown = parsed.markdown
                      } catch (err) {
                        console.error(err)
                      }
                    }
                  }
                  if (markdown) {
                    toolCallDiv = windowElem(tool_call.id, <Figma><Markdown components={getComponents()}>{markdown}</Markdown></Figma>, true)
                  }
                } else if (tool_call.function.name.startsWith("browser_")) {
                  let parsed
                  let url = this.getLastBrowserLocation()
                  let screenshot
                  let result
                  ////debugger
                  try {
                    parsed = JSON.parse(tool_call.function.arguments)
                    if (parsed.url) {
                      url = parsed.url
                      this.setLastBrowserLocation(url)
                    }
                  } catch( err) {
                    //console.log(tool_call.function.arguments)
                    console.error(err)
                  }
                  const toolResult = findToolResult(tool_call.id)
                  if (toolResult) {
                    try {
                      result = parseToolResultContent(toolResult)
                      screenshot = result.screenshotUrl
                    } catch (err) {
                      console.error(err)
                    }
                  }
                  if (tool_call.function.name === 'browser_launch') {
                    if (result) {
                      if (result.wsUrl) {
                        this.setLastBrowserStreamURL(result.wsUrl)
                      }
                    }
                  }
                  let codeDisplay
                  let browserDisplay
                  if (tool_call.function.name === 'browser_eval') {
                    if (parsed) {
                      const { code } = parsed
                      let output = ''
                      if (result) {
                        output = result.data
                        if (typeof output !== 'string') {
                          output = JSON.stringify(output, null, ' ')
                        }
                      }
                      codeDisplay = <CodeDisplay title="eval" code={code || ''} output={output} language="javascript" follow={followStreaming}/>
                    }
                  }
                  if (url || screenshot) {
                    browserDisplay = <SafariBrowser url={url} screenshot={screenshot}/>
                  }
                  if (codeDisplay || browserDisplay) {
                    let div = <div className='browser-eval'>
                                {codeDisplay}
                                {browserDisplay}
                              </div>
                    toolCallDiv = windowElem(tool_call.id, div)
                  }
                } else {
                  const toolFunctionName = normalizeToolFunctionName(tool_call.function.name)
                  switch (toolFunctionName) {
                    case 'conversation_index_status':
                    case 'conversation_search':
                    case 'conversation_browse':
                    case 'conversation_open_link':
                    case 'tool_result_status':
                    case 'tool_result_search':
                    case 'tool_result_browse':
                    case 'tool_result_open_link':
                      {
                        const toolResult = findToolResult(tool_call.id)
                        if (toolResult) {
                          const result = parseToolResultContent(toolResult)
                          if (result) {
                            toolCallDiv = windowElem(tool_call.id,
                                                     <InteractiveConversationToolResult
                                                       toolName={toolFunctionName}
                                                       args={parseToolCallArguments(tool_call)}
                                                       result={result}
                                                       components={components}
                                                       renderLeaf={this.props.renderConversationLeaf}
                                                       openConversationLink={this.props.openConversationLink}
                                                       me={this.props.me}/>)
                          }
                        }
                      }
                      break
                  case 'ReactDevelopment.captureScreenshot':
                    {
                      let i = 0
                      let content
                      for (const {message} of addedToTranscript) {
                        if (!message) continue
                        const { tool_call_id } = message
                        if (tool_call_id === tool_call.id) {
                          const user = addedToTranscript[i+2]?.message?.content
                          if (user) {
                            const start = user.indexOf('!')
                            content = user.substring(start)
                            ////////debugger
                            toolCallDiv = <Markdown components={components}>{content}</Markdown>
                          }
                          break
                        }
                        i++
                      }
                    }
                    break
                  case 'now':
                    {
                      try {
                        const toolResult = findToolResult(tool_call.id)
                        if (toolResult) {
                          const { timestamp } = parseToolResultContent(toolResult)
                          if (timestamp) {
                            toolCallDiv = windowElem(tool_call.id, <div className='dateTime'>
                                                       <CalendarDate date={new Date(timestamp)}/>
                                                       <AnalogClock time={new Date(timestamp)}/>
                                                     </div>)
                          }
                        }
                      } catch(err) {
                        console.error(err)
                      }
                    }
                    break
                  case 'repl':
                  case 'evaluate':
                    {
                      let parsed
                      //console.log("args", tool_call.function.arguments)
                      try {
                        parsed = JSON.parse(tool_call.function.arguments.replaceAll("\n"), "\\n")
                      } catch( err) {
                        //console.log(tool_call.function.arguments)
                        console.error(err)
                      }
                      let input
                      let output
                      let title
                      let language
                      if (parsed) {
                        let { code, lang, script, target } = parsed
                        lang = lang || "javascript"
                        code = code || script
                        input = code
                        title = target || lang || ''
                        language = lang
                        const toolResult = findToolResult(tool_call.id)
                        let output =''
                        if (toolResult) {
                          output = toolResultText(toolResult)
                          try {
                            const parsed = parseToolResultContent(toolResult)
                            if (parsed.output) {
                              output = parsed.output
                            }
                          } catch (err) {
                            console.error(err)
                          }
                        }
                      }
                      toolCallDiv = <CodeDisplay title={title} code={input || ''} output={output || ''}
                                                 language={language} follow={followStreaming}/>
                    }
                    break
                  case 'search_files':
                    {
                      let parsed
                      try {
                        parsed = JSON.parse(tool_call.function.arguments.replaceAll("\n"), "\\n")
                      } catch( err) {
                        //console.log(tool_call.function.arguments)
                        console.error(err)
                      }
                      const { path } = parsed
                      const toolResult = findDirectToolResult(tool_call.id)
                      if (toolResult) {
                        let { matches, errors } = parseToolResultContent(toolResult)
                        if (matches) {
                          if (matches.length === 0) {
                            matches = [path]
                          }
                          const tree = buildTree(matches)
                          toolCallDiv = windowElem(tool_call.id, <FinderWindow directoryTree={tree}/>)
                        }
                        if (errors) {
                        }
                      }
                      if (!toolCallDiv && path) {
                        const tree = buildTree([path])
                        toolCallDiv = windowElem(tool_call.id, <FinderWindow directoryTree={tree}/>)
                      }
                    }
                    break
                  case 'get_cwd':
                  case 'get_tempdir':
                  case 'get_homedir':
                    {
                      let path = ''
                      let name = ''
                      let children = []
                      const toolResult = findDirectToolResult(tool_call.id)
                      if (toolResult) {
                        path = toolResultText(toolResult)
                        const split = path.split('/')
                        const parent = split[split.length-2]
                        const child = split[split.length-1]
                        name = parent
                        children = [{
                          name: child,
                          type: 'directory'
                        }]
                      }
                      const tree = {
                        name,
                        path,
                        children
                      }
                      toolCallDiv = windowElem(tool_call.id, <FinderWindow directoryTree={tree}/>)
                    }
                    break
                  case 'list_directory':
                  case 'create_directory':
                    {
                      let parsed
                      try {
                        parsed =  JSON.parse(tool_call.function.arguments || '{}')
                      } catch (err) {
                        console.error(err)
                        break
                      }
                      let { path } = parsed
                      {
                        path = path || ''
                        const toolResult = findToolResult(tool_call.id)
                        let children = []
                        const split = path.split('/')
                        const name = split[split.length-1]
                        if (toolResult) {
                          ////////debugger
                          let parsed = parseToolResultContent(toolResult)
                          let { listing } = parsed
                          if (typeof listing === 'string') {
                            listing = listing.split('\n')
                          }
                          if (Array.isArray(listing)) {
                            const lines = listing
                            children = lines.map(line => {
                              if (line.startsWith('[FILE]')) {
                                line = line.substring('[FILE]'.length)
                                return {
                                  name: line,
                                  type: 'file'
                                }
                              } else {
                                line = line.substring('[DIR]'.length)
                                return {
                                  name: line,
                                  type: 'directory'
                                }
                              }
                            })
                          }
                      }
                        const tree = {
                          name,
                          children,
                          path,
                        }
                        toolCallDiv = windowElem(tool_call.id, <FinderWindow directoryTree={tree}/>)
                      }
                    }
                    break
                  case 'directory_tree':
                    {
                      let { path } = JSON.parse(tool_call.function.arguments)
                      const split = path.split('/')
                      const name = split[split.length-1]
                      const toolResult = findToolResult(tool_call.id)
                      let tree = {
                        name,
                        type: "directory",
                        path
                      }
                      if (toolResult) {
                        try {
                          const parsed = parseToolResultContent(toolResult)
                          tree = parsed.tree && { ...parsed.tree }
                        } catch (err) {
                          console.error(err)
                        }
                      }
                      tree = { ...(tree || {}), path }
                      toolCallDiv = <FinderWindow directoryTree={tree}/>
                    }
                    break
                  case 'edit_text_file':
                    ////debugger
                    try {
                      let { old_string, new_string, path } = JSON.parse(tool_call.function.arguments)
                      //<DiffViewer before={old_string} after={new_string}/>
                      const toolResult = findDirectToolResult(tool_call.id)
                      let snippet = ''
                      let diff = ''
                      let success
                      let fullText = ''
                      if (toolResult) {
                        const result = parseToolResultContent(toolResult)
                        success = result.success
                        snippet = result.snippet
                        diff = result.diff
                      }
                      const file = this.props.resolveFile(path)
                      if (file) {
                        fullText = file
                        if (success) {
                          fullText = fullText.replace(new_string, old_string)
                        }
                      } else {
                        //alert("File not found: " + path)
                        fullText = old_string || ''
                      }
                      toolCallDiv = windowElem(tool_call.id, <XcodeDiffViewer
                                                 path={path}
                                                 snippet={snippet}
                                                 diff={diff}
                                                 success={success}
                                                 fullText={fullText}
                                                 oldString={old_string}
                                                 newString={new_string}
                                                 follow={followStreaming}
                                               />)
                    } catch (err) {
                      ////debugger
                      console.error(err)
                    }
                    break
                  case 'subagent':
                      try {
                        let { title, description, messages, tools, result_schema } = JSON.parse(tool_call.function.arguments)
                        const toolResult = findToolResult(tool_call.id)
                        const file = this.props.getSubagentTask((this.props.sourceMessage || this.props.message).id, tool_call.id)
                        let className = 'toolsetPreview'
                        const onClick = () => {
                        }
                        const date = fromNow(file ? file.displayInfo.lastUpdated: Date.now())
                        let dateComp
                        dateComp = <div className='toolsetDate'>{date}</div>
                        const titleDiv = <div className='toolsetTitle'>{title}</div>
                        let open
                        if (file) {
                          open = async () => {
                            this.props.openSubagentChat(message, reply, file)
                          }
                        }
                        toolCallDiv = <div key={tool_call.id} className={className} onClick={onClick}>
                                 <div  className='toolsetLeft'>
                                   <div className='toolsetLeftTopRow'>
                                     <div className='toolsetLeftTopRowLeft'>
	                               <SimpleIcon src={Chat}/>
                                       {titleDiv}
                                     </div>
                                     <div className='toolsetTopRowRight'>{dateComp}</div>
                                   </div>
                                 </div>
                                 <div className='datasetPreviewRow2'>
                                   {description}
                                 </div>
                                 <div className='subagentButtonRow' style={open ? null: {'display': 'none'}}>
                                      <SimpleButton icon={Send} label="Open" action={open}/>
                                 </div>
                               </div>
                        if (toolResult) {
                          //console.log("TOOL_RESULT", toolResult)
                          //debugger
                          toolCallDiv = <div className='subagentReturnDiv'>
                                          {toolCallDiv}
                                          <Markdown components={components}>{JSON.stringify(toolResult, null, ' ')}</Markdown>
                                        </div>
                        }
                      } catch (err) {
                        console.error(err)
                        //debugger
                      }
                    break
                  case 'search_repositories':
                  case 'create_repository':
                  case 'get_file_contents':
                  case 'push_files':
                  case 'create_issue':
                  case 'create_pull_request':
                  case 'fork_repository':
                  case 'create_branch':
                  case 'list_commits':
                  case 'list_issues':
                  case 'update_issue':
                  case 'add_issue_comment':
                  case 'search_code':
                  case 'search_issues':
                  case 'search_users':
                  case 'get_issue':
                  case 'delete_repository':
                    {
                      let input = JSON.parse(tool_call.function.arguments)
                      let output = {}
                      const toolResult = findToolResult(tool_call.id)
                      if (toolResult) {
                        output = parseToolResultContent(toolResult)
                      }
                      toolCallDiv = windowElem(tool_call.id, <XcodeVCS operation={tool_call.function.name} input={input} output={output}/>)
                    }
                  break
                  case 'apply_patch':
                  {
                      try {
                        let { workspace, path, type, diff } = JSON.parse(tool_call.function.arguments)
                        switch (type) {
                          case 'create_file':
                            {
                              const content = applyDiff('', diff, 'create')
                              toolCallDiv = windowElem(tool_call.id, <TextEditViewer filePath={path} content={content} follow={followStreaming}/>)
                            }
                            break
                          case 'update_file':
                            {
                              let old_string
                              let new_string
                            }
                            break
                          case 'delete_file':
                            break
                        }
                        const toolResult = findToolResult(tool_call.id)
                      } catch (err) {
                        console.error(err)
                        return null
                      }
                  }
	                  break
	                  case 'read_file':
	                  case 'write_file':
	                  case 'read_text_file':
	                  case 'write_text_file':
	                    {
	                      try {
	                        let { path, content } = JSON.parse(tool_call.function.arguments)
	                        const isReadFileTool = tool_call.function.name === 'read_file' || tool_call.function.name === 'read_text_file'
	                        const toolResult = findDirectToolResult(tool_call.id)
	                        if (toolResult) {
	                          try {
	                            const result = parseToolResultContent(toolResult)
	                            //console.log("TOOL RESULT", result)
	                            if (result && result.content) {
	                              ////////debugger
	                              if (Array.isArray(result.content)) {
	                                content = result.content.map(x => x.text).join('')
	                              } else {
	                                content = result.content
	                              }
	                            } else if (isReadFileTool) {
	                              content = toolResultFileText(toolResult)
	                            }
	                          } catch (err) {
	                            content = isReadFileTool ? toolResultFileText(toolResult) : toolResultText(toolResult)
	                            console.error(err)
	                          }
	                        }
                        toolCallDiv = windowElem(tool_call.id, <TextEditViewer filePath={path} content={content} follow={followStreaming}/>)
                      } catch (err) {
                        console.error(err)
                      }
                    }
                    break
                  case 'read_multiple_text_files':
                    {
                      let { path, content } = JSON.parse(tool_call.function.arguments)
                      const toolResult = findToolResult(tool_call.id)
                      //////debugger
                      if (toolResult) {
                        let output = []
                        const {results, errors } = parseToolResultContent(toolResult)
                        for (const path in results) {
                          output.push(<TextEditViewer filePath={path} content={results[path]} follow={followStreaming}/>)
                        }
                        toolCallDiv = windowElem(tool_call.id, <div className='multipleTextFiles'>{output}</div>)
                      }
                    }
                    break
                  case 'web_search':
                  case 'builtin-web-search':
                  case 'web_local_search':
                    {
                      const { query } = JSON.parse(tool_call.function.arguments)
                      const toolResult = findToolResult(tool_call.id)
                      let results = []
                      if (toolResult) {
                        try {
                          results = parseToolResultContent(toolResult)
                        } catch (err) {
                          console.error(err)
                        }
                      }
                      const openLink = this.props.me.openWindow
                      const renderMarkdown = content => <Markdown components={components}>{content}</Markdown>
                      toolCallDiv = windowElem(tool_call.id, <GoogleSearchResults
                                      q={query}
                                      openLink={openLink}
                                      renderMarkdown={renderMarkdown}
                                                 results={results}/>)
                    }
                    break
                  case 'webFetch':
                    {
                      const { target } = JSON.parse(tool_call.function.arguments)
                      const toolResult = findToolResult(tool_call.id)
                      let result = ''
                      if (toolResult) {
                        try {
                          const parsed = parseToolResultContent(toolResult)
                          let { content, data } = parsed
                          if (data && data.markdown) {
                            content = data.markdown
                          }
                          if (content) {
                            result = content
                          }
                        } catch (err) {
                          console.error(err)
                          result = toolResultText(toolResult)
                          if (result.startsWith('```')) {
                            result = result.split('\n')
                            result = result.slice(1, result.length-2)
                            result = result.join('\n')
                          }
                        }
                      }
                      const openLink = () => {
                        this.props.me.openWindow(target)
                      }
                      toolCallDiv = windowElem(tool_call.id, <BrowserTab url={target}
                                                           content={<Markdown components={components}>{result}</Markdown>}/>)

                    }
                    break
                  case 'screenshot':
                    const { query } = JSON.parse(tool_call.function.arguments)
                    const toolResult = findToolResult(tool_call.id)
                    if (toolResult) {
                      try {
                        const { content } = parseToolResultContent(toolResult)
                        ////debugger
                        const { source  } = content[0]
                        const { type, media_type, data } = source
                        const dataURL = "data://"+media_type+";"+type+","+data
                        toolCallDiv = windowElem(tool_call.id, <div className='browserScreenshot'><img src={dataURL}/></div>)
                      } catch (err) {
                        console.error(err)
                      }
                    }
                    break
                  case 'queryChatDb':
                    {
                      const { query } = JSON.parse(tool_call.function.arguments)
                      let codeOutput
                      let output
                      const toolResult = findToolResult(tool_call.id)
                      let result = ''
                      if (toolResult) {
                        codeOutput = toolResultText(toolResult)
                        try {
                          const result = parseToolResultContent(toolResult)
                          let messages
                          if (Array.isArray(result)) {
                            messages = result
                          } else {
                            const { rows, fullQuery} = result
                            messages = rows
                          }
                          output = windowElem(tool_call.id, <IMessageDisplay messages={messages}/>)
                        } catch (err) {
                          console.error(err)
                        }
                      }
                      const input = windowElem(tool_call.id, <CodeDisplay title="chat.db" code={query || ''} language={'sql'} output={codeOutput || ''} follow={followStreaming}/>)
                      toolCallDiv = <div className='queryChatDbDiv'>
                                      {input}
                                      {output}
                                    </div>
                  }
                  break
                  case 'poll_tool_output':
                  case 'write_stdin':
                  {
                    let toolResult
                    try {
                      const args = JSON.parse(tool_call.function.arguments)
                      const { session_id, chars } = args
                      toolResult = findToolResult(tool_call.id)
                      if (session_id && findSessionOrigin(session_id)) {
                        continue
                      }
                      if (toolResult) {
                        const parsed = parseToolResultContent(toolResult)
                        const input = toolFunctionName === 'write_stdin'
                          ? (chars || '')
                          : `poll ${session_id || ''}`.trim()
                        const output = toolResultText(toolResult)
                        const entries = []
                        if (input) entries.push({ type: 'input', text: input })
                        addTerminalResultEntries(entries, parsed)
                        toolCallDiv = windowElem(tool_call.id, <TerminalWindow input={input} output={output} entries={entries} follow={followStreaming}/>)
                      }
                    } catch (err) {
                      console.error(err)
                    }
                  }
                  break
                  case 'writeToTerminal':
                  case 'write_to_terminal':
                  case 'exec_command':
                    {
                      let toolResult
                      let input
                      try {
                        const { text, cmd } = JSON.parse(tool_call.function.arguments)
                        input = text || cmd
                        toolResult = findToolResult(tool_call.id)
                      } catch (err) {
                        console.error(err)
                        break
                      }
                      let result = ''
                      let entries = []
                      if (toolResult) {
                        try {
                          const parsed = parseToolResultContent(toolResult)
                          const sessionId = sessionIdFromResult(parsed)
                          const sessionEntries = sessionId && buildTerminalSessionEntries({ sessionId })
                          if (sessionEntries) {
                            entries = sessionEntries
                          } else {
                            entries.push({ type: 'input', text: input })
                            addTerminalResultEntries(entries, parsed)
                          }
                          if (parsed.output) {
                            result = parsed.output
                          }
                        } catch (err) {
                          result = toolResultText(toolResult).trim()
                          entries = [
                            { type: 'input', text: input },
                            { type: 'output', text: result }
                          ]
                        }
                        delete uiState.toolProgress[tool_call_id]
                      } else {
                        const progs = uiState.toolProgress[tool_call_id]
                        entries.push({ type: 'input', text: input })
                        if (progs) {
                          for (const prog of progs) {
                            const { stdout, stderr } = prog
                            if (stdout) {
                              result += stdout
                              entries.push({ type: 'output', text: stdout })
                            }
                            if (stderr) {
                              result += stderr
                              entries.push({ type: 'stderr', text: stderr })
                            }
                          }
                        }
                      }
                      toolCallDiv = windowElem(tool_call.id, <TerminalWindow input={input} output={result} entries={entries} follow={followStreaming}/>)

                    }
                      break
                  }
                }
                if (!toolCallDiv) { // default fallback
                  toolCallDiv = <div className='toolCall'>

                                  <div className='toolCallCall'>
                                    <Markdown components={components}>{callMarkdown}</Markdown>
                                  </div>
                                  {resultMarkdown && <div className='toolCallResult'>
                                                       <Markdown components={components}>{resultMarkdown}</Markdown>
                                                     </div>}

                                </div>
                }
	        const directToolResult = findDirectToolResult(tool_call.id)
	        const latestToolResult = findToolResult(tool_call.id)
	        const hydrateVisible = () => {
	          hydrateStoredToolCallArguments(tool_call, message)
	          hydrateStoredTranscriptEntry(directToolResult)
	          if (latestToolResult && latestToolResult !== directToolResult) {
	            hydrateStoredTranscriptEntry(latestToolResult)
	          }
	        }
	        const cacheVersion = [
	          storedToolCallArgumentsKey(tool_call, message),
	          directToolResult && storedTranscriptEntryKey(directToolResult),
	          latestToolResult && latestToolResult !== directToolResult && storedTranscriptEntryKey(latestToolResult)
	        ].filter(Boolean).join('|')
	        toolUse.push({id: tool_call.id, ts, model, name:tool_call.function.name, content: toolCallDiv, hydrateVisible, cacheVersion})
	      }
            }
            flushToolUse()
            const streamingTail = uncommittedStreamingTail(reply.stream, transcriptEntries)
            if (streamingTail) {
              contents.push(<Markdown key1='stream' key={`${message.id}-stream`} components={components}>{streamingTail}</Markdown>)
            }
            contentDiv = contents
          } else {
            let content = text
            if (reply.storage) {
              const toggleShowAll = () => this.toggleShowAll(reply)
              if (!reply.content) {
                //debugger
              }
              const displayState = getStoredContentDisplayState(reply, content)
              if (displayState.partial || (!uiState.showAll[reply.model] && displayState.truncated)) {
                const label = storedContentMoreLabel(displayState, uiState.downloading[reply.model])
                let button = <div className='contentSmallButton' onClick={toggleShowAll}>{label}<span className='showAll'>(Show All)</span></div>
                contentDiv = <div className='contentSmall'><Markdown key={reply.id} components={components}>{displayState.previewContent}</Markdown>{button}
                             </div>
              } else if (uiState.showAll[reply.model] && displayState.truncated) {
                let button = <div className='contentSmallButton' onClick={toggleShowAll}>(Show Less)</div>
                contentDiv = <div className='contentLarge'><Markdown key={reply.id} components={components}>{displayState.visibleContent}</Markdown>{button}</div>
              } else {
                contentDiv = <Markdown key={reply.id} components={components}>{displayState.visibleContent}</Markdown>
              }
            } else {
              if (content) {
                contentDiv = <div className='editableContent' onDoubleClick={edit}>
                               <Markdown key1={reply.stream ? 'stream': undefined} key={message.id} components={components}>{content}</Markdown>
                             </div>
              }
            }
          }
        }
      } else {
        undo = async () => {
        }
        redo = async () => {
        }
        save = async () => {
        }
        stopEditing = () => {
          if (isMobile()) {
            this.commitEdit()
          } else {
            cancelEditing()
          }
          parent.setEditing(false)
        }
        cancelEditing = () => {
          parent.setEditing(false)
          this.setUiState({
            editing: false
          })
        }
        if (disclaimer) {
          let disclaimerText = disclaimer
          const disclaimerDiv = <div className='editableContentContainer'>
                         <div key='editable' ref={ref => this.setEditable(ref, disclaimerText)} className='editableContent'
                              onPaste={pasteText}
                              contentEditable={true}
                              onBlur={stopEditing}/>
                                </div>
          contentDiv = <div key='disclaimed' className='hallucinatedAnswerContainer'>
                         <div className='answerRed'>
                           <Markdown components={components}>{text}</Markdown>
                         </div>
                         <div className='answerYellow'>
                           {disclaimerDiv}
                         </div>

                       </div>
        } else {
          let cancel = () => cancelEditing()
          let stop = () => stopEditing()
          contentDiv =
            <ClickAwayListener mouseEvent={'mousedown'} onClickAway={cancel}>
              <div key='editable' className='editableContentContainer'>
                <div ref={ref => this.setEditable(ref, reply, text)} className='editableContent'
                     onPaste={pasteText}
                     contentEditable={true}
                     onBlur={stop}>
                  {text}
                  </div>
              </div>
            </ClickAwayListener>
        }
      }
      let correct
      if (typeof reply.content !== 'string') {
        reply.content = ''
        ////////debugger
      }
      if (!isJudge && !isTrain && reply.content.trim()) {
        correct = () => this.props.correct(reply)
      }
      const apply = async () => {
        await this.props.apply({reply, model})
        this.messageBody.swiper.slideTo(0)
      }
      let middleColumn = 'middleColumn1'
      if (defaulted) {
        middleColumn += ' defaultAnswer'
      }
      const actions = []
      let copyThread = () => this.props.copyThread(message, model)
      if (this.props.readOnly) {
        edit = copyThread = replay = deleteContent = null
      }
      if (copyThread) {
        actions.push({
          icon: Chat,
          label: "Copy Thread",
          action: copyThread
        })
      }
      if (!defaulted && deleteContent) {
        actions.push({
          icon: Cross,
          label: "Clear",
          action: deleteContent
        })
      }
      actions.push({
        icon: Copy,
        label: "Copy",
        action: copy
      })
      if (edit) {
        actions.push({
          icon: EditIcon,
          label: "Edit",
          action: edit
        })
      }
      if (replay) {
        if (replayRunning) {
          actions.push({
            icon: Stop,
            label: "Stop",
            action: stopReplay
          })
        } else {
          actions.push({
            icon: Send,
            label: "Replay",
            action: replay
          })
        }
      }
      if (isDataset && !defaulted && correct) {
        actions.push({
          icon: AICheck,
          action: correct,
          label: "Fact Check"
        })
      }
      if (isDataset && !defaulted && !isTrain && apply) {
        actions.push({
          icon: CheckMark,
          label: "Train",
          action: apply
        })
      }
      if (!contentDiv) {
        contentDiv =  <div className='emptyAssistantBody'/>
        ////////////////debugger
      }
      const selectModel = () => {
        this.props.selectModel(this.props.resolveModel(model))
      }
      let replays = 0
      let selectedReplay = -1
      let setReplay
      if (reply.content) {
        replays = 1
        selectedReplay = 0
      }
      if (reply.replays) {
        replays = reply.replays.length
        selectedReplay = reply.replays.findIndex(x => x === null)
        //console.log({selectedReplay})
        setReplay = async (index) => {
          await this.props.saveReplyMessage({
            target: replyTarget(),
            model: reply.model,
            replayIndex: index
          })
        }
      }
      let messagePrice
      if (reply.usage) {
        ////debugger
        const usage = reply.usage[reply.model] || reply.usage
        if (usage && usage.inputTokens) {
          const model = this.props.resolveModel(reply.model)
          //////////console.log({allModels})
          const context = getPricingContext(model, usage.inputTokens, usage.cacheReadTokens)
          if (!context) {
            console.error("no context")
          } else {
            let usages = []
            if (reply.addedToTranscript) {
              usages = usages.concat(reply.addedToTranscript.filter(Boolean).map(x => {
                if (!x.usage) {
                  return null
                }
                try {
                  return x.usage[reply.model]
                } catch (err) {
                  console.error(err)
                  ////debugger
                }
              }).filter(x => x))
            } else {
              usages = [usage]
            }
            ////debugger
            let i = 0
            let o1 = 0
            let ci = 0
            let co = 0
            for (const usage of usages) {
              const cost = usageCostBreakdown(usage, context)
              i += cost.uncachedInputDollars
              ci += cost.cacheReadDollars
              co += cost.cacheWriteDollars
              o1 += cost.outputDollars
            }
            messagePrice = ''
            if (ci > 0 || co > 0) {
              messagePrice += formatPrice(ci) + "/" + formatPrice(co) + "|"
            }
            if (i > 0 || o1 > 0) {
              messagePrice += formatPrice(i) + "/" + formatPrice(o1)
            }
          }
        }
      }
      let priceDiv
      if (messagePrice) {
        priceDiv = <div className='messagePrice'>{messagePrice}</div>
      }
      //const { ts } = this.props.message
      let ts = message.ts
      ////////console.log({contentDiv})
      let clazz = 'horizontalTextLayout'
      if (this.props.isCompacted(message, reply.model)) {
        clazz += " aiSaidCompacted"
      }
      const transcriptPosition = this.props.transcriptPosition
      const splitTranscript = Boolean(transcriptPosition)
      const showHeader = !splitTranscript || transcriptPosition === 'first' || transcriptPosition === 'only'
      const showFooter = !splitTranscript || transcriptPosition === 'last' || transcriptPosition === 'only'
      if (splitTranscript) {
        clazz += ` aiTranscriptUnit aiTranscriptUnit-${transcriptPosition}`
      }
      return <div className='aiSaidMaybeCompacted'>
               <div className={clazz}>
                 <div className='leftColumn1'>
                   {showHeader && <div className='keyboardEditInstructionLeftIcon'>
                     <SimpleButton icon={icon1} action={selectModel}/>
                   </div>}
                 </div>
                 <div className={middleColumn}>
                   {showHeader && <div className='chatGptChatMessageHeaderTopic2' onClick={selectModel}>{modelTitle}<div className='toolUseHeaderRight'><Timestamp ts={ts}/>{priceDiv}</div></div>}
                   {showHeader && judgement}
                   {contentDiv}
                   {showFooter && !this.props.isStreaming(message.id, model) && <AssistantFooter copy={copy}
                                                                                    ts={ts}
                                                                                    replays={replays}
                                                                                    replay={replay}
                                                                                    replaying={replayRunning}
                                                                                    copyThread={copyThread}
                                                                                    stopReplay={stopReplay}
                                                                                    edit={edit}
                                                                                    selectedReplay={selectedReplay}
                                                                                    setReplay={setReplay}/>}
                 </div>
                 <div className='rightColumn1 copyAISaid'>
                   {showHeader && <ActionMenu className='aiSaidMenu' actions={actions}/>}
                 </div>
               </div>
             </div>
    }

    const renderBody1 = () => {
      let autoHeight = replies.length > 1 && replies[selection] && replies[selection].id !== this.activeReplyId
      return <MessageBody
               selected={this.props.selected}
               selectedModelIndex={this.props.selectedModelIndex}
               participants={this.props.participants}
               onCreate={this.setBody}
               selectModel={this.props.selectModel}
               onSlideTransitionStart={this.props.onSlideTransitionStart}
               onSlideTransitionEnd={this.props.onSlideTransitionEnd}
               getModelIcon={this.props.getModelIcon}
               resolveModel={this.props.resolveModel}
	               getModelTitle={this.props.getModelTitle}
	               uiState={this.props.messageBodyState || uiState.messageBodyState}
	               selection={selection}
               onSelectReply={this.onSelectReply}
               message={displayMessage}
               judging={this.props.judging}
               inReplyTo={this.props.inReplyTo}
               autoHeight={true}
               purgeCache={this.props.purgeCache}
               apply={({reply, model}) => this.props.apply({message, reply, model})}
               renderBody={renderBody}/>

    }
    const showCompaction = !this.props.transcriptPosition ||
      this.props.transcriptPosition === 'last' ||
      this.props.transcriptPosition === 'only'
    const compacted = showCompaction && getMessageCompactionEntries(message).find(entry => (
      isCompactionEntryOnMessage(entry, message) &&
      (!this.props.isActiveCompactionEntry || this.props.isActiveCompactionEntry(entry))
    ))
    const compactionReply = compacted && (
      getReplies(message).find(reply => reply && reply.model === compacted.compaction.model) ||
      getReplies(message)[0]
    )
    const compactionComponents = compactionReply
      ? this.getComponents(compactionReply)
      : this.props.getComponents()
    const compactedDiv = compacted && renderConversationCompactionSummary({
      compacted,
      task: this.props.task,
      message,
      reply: compactionReply,
      summaryRecords: this.props.getConversationSummaryRecords
        ? this.props.getConversationSummaryRecords(compacted)
        : this.props.conversationSummaryRecords,
      summaryState: this.props.getConversationSummaryRecordsState
        ? this.props.getConversationSummaryRecordsState(compacted)
        : this.props.conversationSummaryState,
      loadSummaryRecords: this.props.loadConversationSummaryRecords
        ? () => this.props.loadConversationSummaryRecords(compacted)
        : null,
      uiState,
      components: compactionComponents,
      me: this.props.me,
      onOpen: this.props.openConversationLink,
      forceUpdate: () => this.forceUpdate()
    })
    let leftIconClassName = 'chatGPTLeftIcon copyAISaid'
    let className = 'horizontalMessageLayout chatMessageFromGpt'
    if (this.props.transcriptPosition) className += ' chatMessageFromGptTranscriptUnit'
    return <div key={'reply-'+displayMessage.id}
                data-message-id={displayMessage.id}
                className={className}>
             {renderBody1()}
             {compactedDiv}
           </div>
  }

}


export class ExportButton extends Component {

  onCreateFileChooser = fileChooser => {
    this.fileChooser = fileChooser
  }

  handleDataTransfer = (event, transfer) => {
    if (transfer.files.length > 0) {
      event.preventDefault();
      this.props.action(transfer.files)
    }
  }

  render() {
    const action = async () => {
      fileChooser.chooseFile()
    }
    return <div className='exportButton'>
             <SimpleButton icon={Share} label="Export" action={action}/>
             <FileChooser
               handleDataTransfer={this.handleDataTransfer}
               fileType={this.props.fileTypes}
               onCreate={this.onCreateFileChooser}/>
         </div>
  }
}




class MarkdownBody extends Component {
  constructor(props) {
    super(props)
  }

  componentDidMount() {
    this.updateBody()
  }

  updateBody = () => {
    if (true) return
    const ref = this.ref
    // hack for markdown rendering multiple text elements in sequence without line breaks
    if (ref) {
      const element = ref
      const isNested = n => {
        let result = false
        walkDOM(n, x => {
          if (n !== x && x.nodeName === 'LI') {
            result = true
          }
        })
        return result
      }
      if (true) {
        const lis = element.querySelectorAll('li')
        for (const li of lis) {
          const nested = isNested(li)
          //////////console.log("li height", li.offsetHeight, 'nested', nested, li.textContent)
          if (li.offsetHeight > 20 && !nested) {
            if (li.firstChild.nodeName !== 'DIV' && li.firstChild.nodeType !== Node.TEXT_NODE || !li.firstChild.textContent.trim()) {
              const wrapper = document.createElement('div');
              wrapper.className = 'liContainer ' + 'liContainer' + li.parentNode.nodeName
              // Move all children of the li into the new div
              while (li.firstChild) {
                wrapper.appendChild(li.firstChild);
              }
              // Append the new div to the li
              li.appendChild(wrapper);
            }
          }
        }
      }
      element.childNodes.forEach((node, i) => {
        if (i > 0 && node.previousSibling &&
            node.previousSibling.nodeType === Node.TEXT_NODE &&
            node.nodeType === Node.TEXT_NODE) {
            if (node.textContent === '\n') {
              const br1 = document.createElement('br')
              const br2 = document.createElement('br')
              const inserted = node.parentNode.insertBefore(br1, node)
              inserted.parentNode.insertBefore(br2, inserted)
              node.textContent = ""
            }
        }
      })
    }
  }

  setBodyRef = ref => {
    this.ref = ref
  }

  render() {
    return <div className='keyboardEditDocumentTextInline' ref={this.setBodyRef}>
             {this.props.children}
           </div>
  }
}



function escapeUnbalancedDollars(text) {
  let dollarsIndices = [];
  for (let i = 0; i < text.length; i++) {
    if (text[i] === '$') dollarsIndices.push(i);
  }

  // Convert the string to an array to allow modifications
  let escapedTextArray = [...text];
  let skipNext = false;

  for (let i = 0; i < dollarsIndices.length - 1; i++) {
    if (skipNext) {
      skipNext = false;
      continue;
    }

    let currentIdx = dollarsIndices[i];
    let nextIdx = dollarsIndices[i + 1];

    // Simple rule: if there's any character other than space between the `$` pair, consider it math
    if (nextIdx - currentIdx > 1 && !text.substring(currentIdx + 1, nextIdx).trim().length === 0) {
      // This pair is considered a valid math expression, so skip the next `$`
      skipNext = true;
    } else {
      // Escape the current `$` since it doesn't form a valid math expression
      escapedTextArray[currentIdx] = '\\$';
    }
  }

  // If the last `$` wasn't skipped (and exists), it's unpaired and should be escaped
  if (!skipNext && dollarsIndices.length > 0) {
    escapedTextArray[dollarsIndices[dollarsIndices.length - 1]] = '\\$';
  }

  return escapedTextArray.join('');
}




const replaceImgWithMarkdown = (htmlString) => {
  if (htmlString.indexOf('<img') >= 0) {
    ////////////////////////debugger
    const regex = /<img .*\/?>/g
    return htmlString.replace(regex, (match) => {
      ////////////console.log("match", match)
      return turndownService.turndown(match)
    });
  }
  return htmlString
}


export function durationBetween(start, end) {
  const seconds = Math.abs(moment(end).diff(moment(start), 'seconds'))

  if (seconds < 60) return `${seconds}s`

  const minutes = Math.floor(seconds / 60)
  if (minutes < 60) return `${minutes}m`

  const hours = Math.floor(minutes / 60)
  if (hours < 24) return `${hours}h`

  const days = Math.floor(hours / 24)
  if (days < 30) return `${days}d`

  const months = Math.floor(days / 30)
  if (months < 12) return `${months}mo`

  const years = Math.floor(days / 365)
  return `${years}y`
}

export function fromNow(date) {
  const fromNow = moment(date).fromNow().replace(/ ago/, '')
  const fixed = fromNow
        .replace(/.*a few seconds.*/, 'now')
        .replace(/.*a minute.*/, '1m')
        .replace(/.*an hour.*/, '1h')
        .replace(/.*a day.*/, '1d')
        .replace(/.*a month.*/, '1mo')
        .replace(/.*a year.*/, '1y')
        .replace(/ minutes?/, 'm')
        .replace(/ hours?/, 'h')
        .replace(/ days?/, 'd')
        .replace(/ months?/, 'mo')
        .replace(/ years?/, 'y')
  //////////////console.log('fromNow', fromNow, '=>', fixed)
  return fixed
}

export function toThen(date) {
  const fromNow = moment(date).fromNow().replace(/ ago/, '')
  const fixed = fromNow
        .replace(/.*a few seconds.*/, 'now')
        .replace(/.*a minute.*/, '1m')
        .replace(/.*an hour.*/, '1h')
        .replace(/.*a day.*/, '1d')
        .replace(/.*a month.*/, '1mo')
        .replace(/.*a year.*/, '1y')
        .replace(/ minutes?/, 'm')
        .replace(/ hours?/, 'h')
        .replace(/ days?/, 'd')
        .replace(/ months?/, 'mo')
        .replace(/ years?/, 'y')
  if (fixed.startsWith("in ")) {
    return fixed
  }
  return 'in ' + fixed
}

export function toNow(date) {
  return moment(date).toNow()
}


//

const JSON_parse = input => {
  try {
    return JSON.parse(jsonrepair(input))
  } catch (err) {
  }
}

const NBSP = String.fromCharCode(160)

const nbsp = new RegExp(NBSP, "gi");


export class RadioButtonsOld extends Component {
  render() {
    const isSmall = this.props.small
    const buttons = this.props.buttons.map(button => {
      const { selected, label } = button
      if (selected) {
        return <div className='keyboardRadioButtonSelected' onClick={button.select}>
                 <div className='keyboardRadioButtonIcon'><ReactSVG src={button.icon}/></div>
                 {label && <div className='keyboardRadioButtonOn'>{button.label}</div>}
               </div>

      } else {
        return <div className='keyboardRadioButtonUnselected' onClick={button.select}>
                 <div className='keyboardRadioButtonIcon'><ReactSVG src={button.icon}/></div>
                 {label && <div className='keyboardRadioButtonOff'>{button.label}</div>}
               </div>
      }
    });
    return <div className={'keyboardRadioButton' +  (isSmall ? ' keyboardRadioButtonSmall' : '')}>
             {this.props.label &&<div className='keyboardRadioButtonLabel keyboardRadioButton'>
               {this.props.label}
                                 </div>}
             {buttons}
             <div className='keyboardRadioButtonRight'/>
           </div>

  }
}


const encodeURIExt = uri => {
  if (!uri.endsWith("%3f") && !uri.endsWith("%3F")) {
    uri = encodeURI(uri)
  }
  return uri
}

const QUESTIONS = ['Does Australia really have pink lakes?',
                   'When and on what topic  was the NYT\'s first report on "artificial intelligence"?',
                   'Can spiders fly?']
const links = [`Does Australia really have [pink lakes?](ai://?q=${encodeURIComponent(QUESTIONS[0])})`,
               `When and on what topic was the NYT's [first report on "artificial intellgence"](ai://?q=${encodeURIComponent(QUESTIONS[1])})?`,
               `Can [spiders fly?](ai://?q=${encodeURIComponent(QUESTIONS[2])})`]

const generateBlurb = (pre) => {
  pre = pre || `Hello, ask me any questions you'd like. `
  return `${pre}Here are some examples to get you started:\n
${links.map((q, i) => `\n- ${q}`)}\n`.replace(/,\n/g, '\n')
}

const CodeBlock = ({className, node, children}) => {
  let lang
  let text = (typeof children == 'string' && children)  || ''
  text = text.replace(/<signed>.+<[/]signed>/, '')
  text = text.replace(/<think>|<[/]think>/, '')
  const multiline = text.trim().indexOf('\n') > 0
  //////////console.log("CodeBlock", children)
  let clazzName = 'aiCode'
  if (!multiline) {
    clazzName = 'aiCode aiCodeInline'
  } else {
    clazzName = 'aiCode aiCodeMultiline'
  }
  const copy = async () => {
    try {
      navigator.clipboard.writeText(text)
    } catch (ignored) {
      ////////console.log(text)
    }
    await delay(0.5);
  }
  if (className && className.startsWith('lang-')) {
    lang = className.replace('lang-', '');
    return (
      <SyntaxHighlighter language={lang} style={CodeStyle} showLineNumbers={true}>
        {children}
      </SyntaxHighlighter>
    )
  } else {
    if (children && children.indexOf('%') >= 0) {
      try {
        children = decodeURIComponent(children)
      } catch (err) {
        console.error(err)
      }
    }
    return <code className={clazzName}>
             {text}
             {multiline && <div className='codeCopy'><SimpleButton icon={Copy} action={copy}/></div>}
           </code>

  }
}

// markdown-to-jsx uses <pre><code/></pre> for code blocks.
const PreBlock = ({node, children, ...rest}) => {
  if (typeof children == 'object' && ('type' in children) && children ['type'] === 'code') {
    return CodeBlock(children['props']);
  }
  return <div className='aiPre' {...rest}>{children}</div>;
};

const consoleLog = (...args) => {
}

const debugLog = (...args) => {
  args.unshift("debug")
  //////console.log.apply(null, args)
}


class CheckMarkComp extends Component {
  render( ){
    return <div className='aiCheck'><ReactSVG src={AICheck}/></div>
  }
}

const decodeURIComponentExt = c => {
  try{
    let decoded = decodeURIComponent(c)
    return decoded.replace(/[+]/g, ' ')
  } catch (exc) {
    ////////////////////////////debugger
    return c
  }
}


class MessagesViewMessage extends Component {

  setRef = ref => {
    this.ref = ref
  }

  scrollIntoView = (options) => {
    ////console.log("SCROLL INTO VIEW", this.props.message.user.id)
    //setTimeout(() => scrollIntoViewIfNeeded(this.ref, options), 20)
  }

  componentDidUpdate(prevProps) {
    if (this.ref && this.props.isSelected) {
      let options = { block: 'nearest', behavior: 'smooth' }
      if (!prevProps.isSelected) {
        options = { block: 'center', behavior: 'smooth' }
      }
      this.scrollIntoView(options)
    }
  }

  componentDidMount() {
    if (this.props.isSelected) {
      //////////////debugger
      this.scrollIntoView()
    }
  }

  render() {
    const { message } = this.props
    const { user, assistant } = message
    let dateComp
    let dollars
    let onClick = (e) => {
      this.props.select()
    }
    let actions
    let icon = UserSaid
    let legacyIconSize
    let assistantContent
    let assistantIcon
    /*
    const reply = getReplies(assistant).find(x => x.content)
    assistantContent = ''//shorten(reply.content)
    const model = this.props.resolveModel(reply.model)
    if (model) {
      assistantIcon = (model.getModelIcon && model.getModelIcon()) || model.getIcon()
      }
      */
    let className1 = 'toolsetTask toolsetMessageTask'
    if (this.props.isSelected) {
      //////////////debugger
      className1 += ' toolsetMessageTaskSelected'
    }
    return <div
             key={user.id}
             ref={this.setRef}
             data-message-view-id={user.id}
             className={className1} onClick={onClick} >
             <div  className='toolsetLeft'>
               <div className='toolsetLeftTopRow'>
                 <div className='toolsetLeftTopRowLeft'>
	           <SimpleIcon src={icon} legacyIconSize={legacyIconSize}/>
                   <div className='toolsetMiddleDescription'>
                     {shorten(user.content)}
                   </div>
                 </div>
                 <div className='toolsetTopRowRight'>{dateComp}</div>
               </div>
               {false && <div className='toolsetMiddle'>
                 <SimpleIcon src={assistantIcon}/>
                 <div className='toolsetMiddleDescription'>
                   {assistantContent}
                 </div>
                         </div>}
             </div>
             <div className='toolsetRight'>
               {actions && <ActionMenu className='toolsetActions' actions={actions}/>}
               {false && <SimpleButton icon={Right} action={onClick}/>}
             </div>
           </div>
  }
}

class MessagesView extends BnSubpage {

  constructor (props) {
    super(props)
  }

  onSearch = async searchTerm => {
    searchTerm = searchTerm.trim()
    let searchResults
    if (searchTerm) {
      const searchIndex = this.getSearchIndex()
      searchResults = (await searchIndex.search(searchTerm)).map(result => {
        const { user, assistant } = result
        return { user, assistant}
      })
    } else {
      searchResults = null
    }
    if (this.props.onSearchComplete) this.props.onSearchComplete(searchTerm, searchResults)
    this.setState({
      searchTerm,
      searchResults
    })
  }

  componentDidUpdate(prevProps) {
    if (this.props.selectedMessage !== prevProps.selectedMessage) {
      //console.log("SELECTED MESSAGE CHANGED", this.props.selectedMessage)
      if (this.props.selectedMessage && this.messagesScroller) {
        //console.log("SCROLL TO ITEM:", this.props.selectedMessage.id)
        //////debugger
        this.messagesScroller.scrollToItem({user: this.props.selectedMessage}, { block: 'center' })
      }
    }
  }


  getPageTitle() {
    let icon = Left
    let action = async () => {
    }
    return <div className='messagesTitle'>
             <div className='messagesTitleTitle'>Messages</div>
             <SimpleButton icon={icon} action={action}/>
             </div>
  }

  getSearchIndex = () => {
    if (!this.searchIndex) {
      const messages = this.getMessages()
      this.searchIndex = new InMemorySearch({
        id: 'id',
        fields: ['userContent', 'assistantContent'],
        documents: messages.map(({user, assistant}) => {
          return {
            user, assistant,
            id: user.id,
            userContent: user.content,
            assistantContent: !assistant ? '' : getReplies(assistant).map(reply => {
              return reply.content
            }).join('\n')
        }
        })
      })
    }
    return this.searchIndex
  }

  componentDidMount() {
    this.messagesSub = this.props.observeChanges().subscribe(change => {
      this.searchIndex = null
    })
    if (!this.props.selectedMessage) {
      const messages = this.getMessages()
      if (messages.length > 0) {
        const last = messages[messages.length-1]
        this.props.select(last)
      }
    }
  }

  componentWillUnmount() {
    if (this.messagesSub) {
      this.messagesSub.unsubscribe()
    }
  }
  getMessages = () => {
    const messages = []
    let prev
    for (const message of this.props.messages) {
      switch (message.role) {
        case 'system':
          messages.push({
            system: message
          })
          break
        case 'assistant':
          {
            if (prev) prev.assistant = message
          }
          break
        case 'user':
          messages.push(prev = {
            user: message
          })
          break
      }
    }
    return messages
  }

  setMessagesScroller = scroller => {
    this.messagesScroller = scroller
  }


  setContentRef = ref => {
    if (this.props.setContentRef) this.props.setContentRef(ref)
  }

  renderContent() {
    const messages = this.state.searchTerm ? this.state.searchResults: this.getMessages()
    let onKeyDown
    let autoFocus
    let tabIndex
    if (isDesktop()) {
      onKeyDown = scrollOnKeyDown({
        enter: () => {
        },
        getIndex: () => {
          //////////////debugger
          let selected
          if (this.props.selectedMessage) {
            selected = messages.find(x => x.user.id === this.props.selectedMessage.id)
          }
          if (selected) {
            return messages.indexOf(selected)
          }
          return -1
        },
        getLength: () => messages.length,
        setIndex: index => {
          //////////////debugger
          const newSelection = messages[index]
          this.props.select(newSelection)
        }
      })
      tabIndex = 0
      autoFocus = true
    }
    const renderMessages = messages => messages.filter(x => x && x.user).map((message, i) => {
      const select = () => this.props.select(message)
      return <MessagesViewMessage
               key={message.user.id}
               message={message}
               select={select}
               isSelected={(this.props.selectedMessage &&
                            message.user &&
                            message.user.id &&
                            this.props.selectedMessage.id === message.user.id)}
               resolveModel={this.props.resolveModel}
             />
    })

    return <div
             className='chatGptMessagesViewContainer'
           >
             <div className='chatGptMessagesView' ref={this.setContentRef}>
               <InfiniteScroll
                 onCreate={this.setMessagesScroller}
                 onKeyDown={onKeyDown}
                 autoFocus={autoFocus}
                 tabIndex={tabIndex}
                 getId={item => item.user ? item.user.id : ''}
                 getSelector={id => `[data-message-view-id="${id}"]`}
                 items={messages}
                 renderItems={renderMessages}
                 pageSize={16}
               />
               </div>
           </div>
  }
}

export class ChatGPT3 extends BnSubpage {

  constructor(props) {
    super(props)
    let assistantModel = localStorage.getItem("assistantModel")
    let tempStr = localStorage.getItem('temp')
    let temp = 1.0
    if (tempStr) {
      temp = parseFloat(tempStr)
      if (isNaN(temp)) {
        temp = 1.0
      }
    }
    let selectedModel  = assistantModel
    this.state = {
      recentLimit: 15,
      uploadError: '',
      sendError: '',
      active: true,
      uploads: [],
      slide: 0,
      edits: new Document(),
      completions: [],
      lang: {
        name: "English",
        dialect: "United States",
        iso: "en-US",
        hasVoice: true
      },
      mobileChatView: 'chat',
      role: 'user',
      threadBusy: false,
      swipeIndex: 0,
      assistantModel,
      selectedThreads: [],
      selectedModelIds: [],
      selectedModelIndex: localStorage.getItem('selectedModelIndex') || '',
      selectedTask: this.props.task || null,
      rawMessages: [],
      uiElements: { modelInfo: { price: 0, judgePrice: 0 }, participants: [] },
      searchResults: [],
      calendarView: this.props.calendarViewSelection ? this.props.calendarViewSelection[0] : 'recent',
      selectedDay: new Date(),
      topP: 1,
      topK: 50,
      temp: 1,
      isBottomLock: true,
      taskOpacity: 0
    }
  }

  getComponents = () => {
    if (!this.components) {
      this.components = getComponents({openLink: url => this.props.me.openWindow(url)})
    }
    return this.components
  }

  getModelRouteIndicator = (model, providerId) => {
    return getSubscriptionRouteIndicator(model, providerId, {
      openAICodexOAuth: this.props.openAICodexOAuth,
      hosts: this.props.hosts,
      me: this.props.me
    })
  }

  getRouteClassNameForModels = models => {
    const indicators = (models || [])
      .map(model => this.getModelRouteIndicator(model))
      .filter(x => x && x.className)
    if (!indicators.length) {
      return ''
    }
    const ids = new Set(indicators.map(indicator => indicator.id))
    if (ids.size > 1) {
      return 'modelSubscriptionRoute modelSubscriptionRouteMixed'
    }
    return indicators[0].className
  }

  getRouteDisplayLabelForModels = models => {
    models = (models || []).filter(x => x)
    if (!models.length) {
      return ''
    }
    const labels = []
    for (const model of models) {
      const indicator = this.getModelRouteIndicator(model)
      const label = model.displayPriceLabel || model.hostLabel
      if (!indicator || !label) {
        return ''
      }
      labels.push(label)
    }
    const uniqueLabels = new Set(labels)
    return uniqueLabels.size === 1 ? labels[0] : ''
  }

  getContextUsageLabel = entry => {
    const model = this.resolveModel(entry && entry.model)
    return (model && (model.title || model.name || model.id)) ||
      entry && (entry.model || entry.billingModel) ||
      'model'
  }

  renderContextUsageTelemetry = (currentUsage, participants = []) => {
    const usageByModel = currentUsage || {}
    const orderedModelIds = (participants || []).map(model => model && model.id).filter(Boolean)
    const seen = new Set()
    const entries = orderedModelIds.map(modelId => {
      seen.add(modelId)
      return { model: modelId, usage: usageByModel[modelId] }
    }).filter(entry => entry.usage)
    for (const [modelId, usage] of Object.entries(usageByModel)) {
      if (!seen.has(modelId) && usage) {
        entries.push({ model: modelId, usage })
      }
    }
    if (!entries.length) {
      return orderedModelIds.length > 0
        ? <div className='contextUsageTelemetry'>
            <div className='contextUsageTelemetryItem contextUsageTelemetryItemMuted'>usage unavailable</div>
          </div>
        : null
    }
    const shown = entries.slice(0, 3)
    const hidden = entries.length - shown.length
    return <div className='contextUsageTelemetry'>
	             {shown.map((entry, index) => {
	               const { usage } = entry
	               const input = formatContextUsageTokens(usage && usage.inputTokens)
	               const output = formatContextUsageTokens(usage && usage.outputTokens)
	               const cacheRead = formatContextUsageTokens(usage && usage.cacheReadTokens)
	               const cacheWrite = formatContextUsageTokens(usage && usage.cacheWriteTokens)
	               const reasoning = formatContextUsageTokens(usage && usage.reasoningTokens)
	               const visibleOutputTokens = Math.max(0, Number(usage && usage.outputTokens || 0) - Number(usage && usage.reasoningTokens || 0))
	               const nextInput = formatContextUsageTokens(Number(usage && usage.inputTokens || 0) + visibleOutputTokens)
	               return <div className='contextUsageTelemetryItem' key={`${entry.model || 'model'}-${index}`}>
	                        <span className='contextUsageTelemetryModel'>{this.getContextUsageLabel(entry)}</span>
	                        {input && <span>in {input}</span>}
	                        {nextInput && <span>next {nextInput}</span>}
	                        {output && <span>out {output}</span>}
	                        {cacheRead && <span className='contextUsageTelemetryCache'>cache {cacheRead}</span>}
	                        {cacheWrite && <span>write {cacheWrite}</span>}
	                        {reasoning && <span>reason {reasoning}</span>}
	                      </div>
	             })}
             {hidden > 0 && <div className='contextUsageTelemetryMore'>+{hidden}</div>}
           </div>
  }

  getRouteClassNameForModelIds = modelIds => {
    return this.getRouteClassNameForModels((modelIds || []).map(id => this.resolveModel(id)).filter(x => x))
  }

  isStreaming = (id, model) => {
    return this.activeReply &&
      this.activeReply.id === id &&
      this.activeReply.model === model
  }


  hallucinationQuestions = {}

  hasTasks() {
    for (const id in this.tasks) {
      return true
    }
    return false
  }

  resolveModel = value => {
    const id = resolveModelId(value)
    if (!id) return
    if (id === 'train') {
      return TRAIN
    }
    if (id === 'reject') {
      return REJECT
    }
    if (id.startsWith('epoch-')) {
      if (!EPOCHS[id]) {
        const [_, n] = id.split('-')
        epochs[id] = EPOCH(parseInt(n))
      }
      return EPOCHS[id]
    }
    this.getModels()
    return this.modelsById[id]
  }

  onDayChange = day => {
    ////////console.log("day change", day)
    this.setState({
      selectedDay: day
    }, () => this.updateTaskObserver())
  }


  tools = {}
  getTools = () => {
    return Object.values(this.tools)
  }


  currentTaskHasMessages = () => {
    const taskId = this.state.selectedTask.id
    for (const id in this.received) {
      if (this.received[id].task === taskId) {
        return true
      }
    }
    return false
  }

  subagentTasks = {}
  subagentTasksResolving = {}
  getSubagentTask = (messageId, toolCallId) => {
    const id = messageId + '-' + toolCallId
    return this.subagentTasks[id]
  }

  resolveSubagentTask = async (messageId, toolCallId) => {
    //debugger
    const id = messageId + '-' + toolCallId
    if (!this.subagentTasks[id] && !this.subagentTasksResolving[id]) {
      this.subagentTasksResolving[id] = true
      for (let tries = 0; tries < 3; tries++) {
        const task = await this.props.me.resolveSubagentTask(this.state.selectedTask.id,
                                                             messageId,
                                                             toolCallId)
        //debugger
        if (task) {
          this.subagentTasks[id] = task
          this.updateUIElementsLater()
          break
        } else {
          await delay(1.5)
        }
      }
    }
  }

  openThreadChat = (message) => {
    const messages = this.getMessages().filter(x => x.ts <= message.ts || x.inReplyTo === message.id)
    const back = () => {
      this.setState({
        subpage: null
      })
    }
    const title = "Thread"
    const breadcrumbs = this.props.breadcrumbs.concat([{
      title,
      back
    }])
    this.setState({
      subpage: () => this.props.openTask({
        task: this.state.selectedTask,
        back,
        thread: message,
        messages,
        breadcrumbs,
      })
    })
  }

  openSubagentChat = (message, reply, task) => {
    //debugger
    const back = () => {
      this.setState({
        subpage: null
      })
    }
    const breadcrumbs = this.props.breadcrumbs.concat([])
    this.setState({
      subpage: () => this.props.openTask({
        task,
        back,
        breadcrumbs
      })
    })
  }

  deinitSelectedTask = () => {
    //////////////////////debugger
    this.state.taskOpacity = 0
    this.firstTime = false
    this.state.selectedMessage = null
    this.state.selectedModelIndex = ''
    this.state.recentLimit = 15
    this.state.selectedTask = null
    this.state.showSettings = false
    this.state.sendError = null
    this.state.systemPrompt = ''
    this.invalid = {}
    this.received = {}
    this.messageSnapshotSequence = {}
    this.state.rawMessages = []
    this.pendingInitialMessageId = null
    this.restoringInitialView = false
    this.activeReply = {}
    this.state.uiElements = { modelInfo: { price: 0, judgePrice: 0 }, participants: [] }
    if (this.taskSub) {
      this.taskSub.unsubscribe()
    }
    if (this.systemPromptSubs) {
      Object.values(this.systemPromptSubs).forEach(x => x.unsubscribe())
      this.systemPromptSubs = null
    }
    if (this.messagesSub) {
      this.messagesSub.unsubscribe()
      this.messageSub = null
    }
    if (this.threadsSub) {
      this.threadsSub.unsubscribe()
      this.threadsSub = null
    }
    this.received = {}
    this.chatThreads = {}
    this.models = null
    this.modelsById = {}
    this.forceUpdate()
  }

  systemPrompts = {}
  observeSystemPrompt = () => {
    if (this.systemPromptSubs) {
      Object.values(this.systemPromptSubs).forEach(x => x.unsubscribe())
      this.systemPromptSubs = null
    }
    //this.systemPrompts = {}
    const task = this.state.selectedTask
    let systemPromptArray = task.systemPrompts && Object.values(task.systemPrompts) || (task.systemPrompt && [task.systemPrompt]) || []
    const subs = systemPromptArray.map(x => {
      const sub = this.props.me.observeSystemPrompt(x.id).subscribe(change => {
        const { type, systemPrompt } = change
        if (type !== 'removed') {
          this.systemPrompts[systemPrompt.id] = systemPrompt
        } else {
          delete this.systemPrompts[systemPrompt.id]
        }
        this.updateLater('systemPrompts', this.updateSystemPrompts)
      })
      return {
        id: x.id,
        sub
      }
    })
    ////debugger
    this.systemPromptSubs = {}
    for (const { sub, id } of subs) {
      this.systemPromptSubs[id] = sub
    }
  }

  getFileContents = async path => {
    const hostId = this.desktopFilesHost
    const conversationId = this.props.task.id
    const result = await this.props.me.getFileContent({hostId, path})
    this.desktopFiles[path] = result
    //alert("got file contents")
    //////debugger
    return result
  }


  desktopFiles = {}

  observeDesktopFileSystem = async systemPrompt => {
    const { hostId, toolset } = systemPrompt
    const { id } = toolset
    this.desktopFilesHost = hostId
    const conversationId = this.props.task.id
    if (this.desktopFileSystemSub) {
      this.desktopFileSystemSub.unsubscribe()
      this.desktopFileSystemSub = null
      this.desktopFiles = {}
    }
    let files = {}
    visitToolCalls(this.getMessages(), tool_call => {
      const { name } = tool_call.function
      if (!name) return
      if (name.indexOf("_file") > 0) {
        try {
          let { path, destinationPath } = JSON.parse(tool_call.function.arguments)
          path = path || destinationPath
          if (path) {
            files[path] = true
          } else {
            //console.log("no path", tool_call.function)
          }
        } catch (ignored) {
        }
      }
    })
    if (files.length > 0) {
      this.props.me.watchConversationFiles({hostId, conversationId, files: Object.keys(files)})
      this.desktopFileSystemSub = this.props.me.observeDesktopFileSystem({hostId, conversationId}).subscribe(change => {
        const { type, file } = change
        ////debugger
        if (type === 'removed') {
          delete this.desktopFiles[file.id]
        } else {
          this.desktopFiles[file.id] = file
        }
        this.forceUpdate()
      })
    }
  }

  updateSystemPrompts = () => {
    const systemPrompts = Object.values(this.systemPrompts).filter(x=>x)
    this.invalidateCache()
    //console.log({systemPrompts})
    for (const systemPrompt of systemPrompts) {
      if (systemPrompt.name === "FileSystem") {
        this.observeDesktopFileSystem(systemPrompt)
      }
    }
    this.setState({
      systemPrompts
    })
  }

  messagesSubject = new Subject()

  initSelectedTask = (messages) => {
    clearTimeout(this.listenerTimeout)
    this.taskInit = Date.now()
    this.pendingInitialMessageId = null
    this.restoringInitialView = false
    this.transcriptTimestamp = 0
    let now = Date.now()
    const checkStreaming = message => {
    }
    let p
    if (messages) {
      p = Promise.resolve(messages)
    } else {
      p = this.props.getChatMessages({task: this.state.selectedTask, before: now})
    }
    p.then(async messages => {
      let last
      let lastUser
      messages.forEach(message => {
        this.parseMessage(message)
        this.received[message.id] = message
        if (message.role === 'user') {
          if (!lastUser || message.ts > lastUser.ts) {
            lastUser = message
          }
        }
        if (!last || message.ts > last.ts) {
          last = message
        }
      })
      if (last && last.models) {
        for (const model of last.models) {
          await this.resolveStorage(last, model)
        }
      }
      if (lastUser) {
        checkStreaming(lastUser)
        this.pendingInitialMessageId = lastUser.id
      }
      if (last) {
        this.state.timelineFilter = last.ts
      }
      this.updateUIElements()
      this.listenerTimeout = setTimeout(() => {
        this.messagesSub = this.props.observeTaskMessages({ task: this.state.selectedTask, after: now } ).subscribe(change => {
          consoleLog(change)
          //debugger
          const { message } = change
          if (this.props.thread) {
            if (message.ts > this.props.thread.ts) {
              return
            }
          }
          const notify = () => {
            this.messagesSubject.next(change)
            this.invalidateCache(message)
            this.updateMessagesLater()
          }
          const sequence = (this.messageSnapshotSequence[message.id] || 0) + 1
          this.messageSnapshotSequence[message.id] = sequence
          if (change.type !== 'removed') {
            const existing = this.received[message.id]
            /*
             * While this client is streaming the reply, the live stream owns
             * the message. The server's periodic sync always lags the stream,
             * so replacing the in-memory message here would drop entries and
             * in-flight text; later streamed tool calls then merge against a
             * stale tail and render out of order. The snapshot that follows
             * stream completion reconciles with the canonical doc.
             */
            const ownedByActiveStream = existing && !message.deleted && this.xhr &&
              (this.activeStreamReplyId === message.id ||
               (this.activeReply && this.activeReply.id === message.id))
            if (ownedByActiveStream) {
              return
            }
            if (message.deleted) {
              delete this.received[message.id]
              notify()
            } else {
              this.parseMessage(message, existing).then(() => {
                if (this.messageSnapshotSequence[message.id] !== sequence) return
                this.received[message.id] = message
                checkStreaming(message)
                notify()
              }).catch(err => {
                console.error(err)
                if (this.messageSnapshotSequence[message.id] !== sequence) return
                this.received[message.id] = message
                checkStreaming(message)
                notify()
              })
            }
          } else {
            delete this.received[message.id]
            notify()
          }
        })
      }, 5000)
    })
    this.observeSystemPrompt()
    this.updateUIElementsLater()
    this.taskSub = this.observeSelectedTask().subscribe(data => {
      if (data) {
        const current = this.state.selectedTask
        let taskChanged = false
        if (JSON.stringify(current.systemPrompts) != JSON.stringify(data.systemPrompts)) {
          current.systemPrompts = data.systemPrompts
          this.observeSystemPrompt()
          taskChanged = true
        }
        if (JSON.stringify(current.conversationIndex) !== JSON.stringify(data.conversationIndex)) {
          current.conversationIndex = data.conversationIndex
          taskChanged = true
        }
        if (JSON.stringify(current.lastCompaction) !== JSON.stringify(data.lastCompaction)) {
          current.lastCompaction = data.lastCompaction
          taskChanged = true
        }
        if (JSON.stringify(current.conversationIndexProgress) !== JSON.stringify(data.conversationIndexProgress)) {
          current.conversationIndexProgress = data.conversationIndexProgress
          taskChanged = true
        }
        if (current.credits !== data.credits) {
          current.credits = data.credits
          taskChanged = true
        }
        if (current.usageLastUpdated !== data.usageLastUpdated) {
          current.usageLastUpdated = data.usageLastUpdated
          taskChanged = true
        }
        if (JSON.stringify(current.usage) !== JSON.stringify(data.usage)) {
          current.usage = data.usage
          taskChanged = true
        }
        if (taskChanged && current.id && this.tasks[current.id]) {
          this.tasks[current.id] = {
            ...this.tasks[current.id],
            systemPrompts: current.systemPrompts,
            conversationIndex: current.conversationIndex,
            conversationIndexProgress: current.conversationIndexProgress,
            lastCompaction: current.lastCompaction,
            credits: current.credits,
            usage: current.usage,
            usageLastUpdated: current.usageLastUpdated
          }
        }
        this.updateSystemPrompts()
        if (taskChanged) {
          this.invalidateCache()
          this.updateUIElementsLater()
          this.forceUpdate()
        }
      }
    })
  }

  observeSelectedTask = () => {
    const task = this.state.selectedTask
    if (this.props.observeSelectedTask) {
      return this.props.observeSelectedTask(task, this)
    }
    return this.props.me.observeTaskData(task.id)
  }

  checkSelectedModelLater = () => {
    clearTimeout(this.selectedModelTimeout)
    this.selectedModelTimeout = setTimeout(this.checkSelectedModel, 200)
  }

  hasMessages = () => {
    for (const id in this.received) {
      return true
    }
  }

  decomposeAddedTranscript = message => {
    const { id, role, ts  } = message
    const replies = getReplies(message)
    const decomposed = []
    for (const reply of replies) {
      const { addedToTranscript, model } = reply
      if (addedToTranscript) {
        for (const {message} of addedToTranscript) {
          if (!message) continue
          if (addedToTranscript.ts) {
            message.ts = addedToTranscript.ts
          }
          decomposed.push(message)
        }
      }
    }
    //////debugger
    return decomposed
  }

  checkMessageForFiles = (messages) => {
    let containsFiles = false
    let containsBrowser = false
    for (const message of messages) {
      if (message.role === 'assistant') {
        for (const reply of getReplies(message)) {
          const { model, tool_calls, addedToTranscript } = reply
          const checkForFiles = tool_calls => {
            for (const x of tool_calls) {
              if (x.function && x.function.name) {
                if (x.function.name.includes('file')) {
                  containsFiles = true
                }
                if (x.function.name.startsWith("browser_")) {
                  //containsBrowser = true
                }
              }
            }
          }
          if (addedToTranscript) {
            for (const { message } of addedToTranscript) {
              if (!message) continue
              const { tool_calls } = message
              if (tool_calls) {
                checkForFiles(tool_calls)
                if (containsFiles && containsBrowser) {
                  break
                }
              }
            }
          } else if (tool_calls) {
            checkForFiles(tool_calls)
            if (containsFiles && containsBrowser) {
              break
            }
          }
        }
      }
    }
    return { containsFiles, containsBrowser }
  }

  sendToTranscript = (message, isStreaming) => {
    let ts = message.ts
    if (isStreaming) ts++
    if (true || message.stream || ts > this.transcriptTimestamp) {
      this.transcriptSubject.next(message)
      this.transcriptTimestamp = message.ts
    }
  }

  updateMessagesLater = () => {
    this.updateUIElementsLater()
    const individualized = this.getMessages().flatMap(this.decomposeAddedTranscript)
    //////debugger
    for (const message of individualized) {
      this.sendToTranscript(message)
    }
    this.doInitialSearchLater()
  }

  initialSearchPending = true
  doInitialSearchLater = () => {
    if (!this.initialSearchPending) {
      return
    }
    if (this.props.initialSearchTerm) {
      const { id, content, highlight } = this.props.initialSearchTerm
      if (!this.received[id]) {
        return
      }
      const { role, models } = this.received[id]
      let uid  = id
      let searchTerm = ''
      if (role === 'assistant') {
        uid = uid.split('.')[0] // id.reply -> id
        searchTerm = highlight.models[0].content.matched_tokens[0]
      } else {
        searchTerm = highlight.content.matched_tokens[0]
      }
      this.initialSearchPending = false
      const result = {
        role,
        uid,
        id,
        index: 0,
        q: searchTerm
      }
      this.scrollToSearchResult(result)
    }
  }

  checkSelectedModel = () => {
    this.forceUpdate(() => {
      if (this.hasMessages()) {
        this.updateSelectedChatModel(this.getMessages())
      }
    })
  }

  init = () => {
    this.ticker = setInterval(() => {
      this.forceUpdate()
    }, 1000*60)
    this.initTimeout = null
    this.deinit()
    if (this.props.onCreate) {
      this.props.onCreate(this)
    }
  }

  deinit = () => {
    clearInterval(this.ticker)
    this.endStream()
    if (this.messagesSub) this.messagesSub.unsubscribe()
    if (this.taskSub) this.taskSub.unsubscribe()
    this.purgeCache()
    this.received = {}
    this.chatThreads = {}
    this.models = null
    this.modelsById = {}
  }

  chatThreads = {}
  received = {}
  messageSnapshotSequence = {}
  tasks = {}

  restartDelayApologyTimer() {
    clearTimeout(this.delayApologyTimeout)
    this.delayApologyTimeout = setTimeout(() => {
      this.forceUpdate()
    }, 15000)
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.resource !== prevProps.resource) {
      this.init()
    }
    if (this.props.task !== prevProps.task) {
      this.init()
      this.state.selectedTask = this.props.task
      this.deinitSelectedTask()
      this.state.selectedTask = this.props.task
      if (this.state.selectedTask) {
        this.initSelectedTask()
      }
    }
    if (this.state.searchTerm !== prevState.searchTerm ||
        this.state.selectedMessage !== prevState.selectedMessage) {
      //this.applyHighlight()
    }
    if (this.state.timelineFilter !== prevState.timelineFilter) {
      this.resetTranscriptLater()
    }
  }

  componentDidMount() {
    //////console.log("CHATGPT", this.props)
    this.startTime = Date.now()
    this.init()
    this.state.selectedTask = this.props.task
    if (this.state.selectedTask) {
      this.initSelectedTask(this.props.messages)
    }
    if (isMobile()) {
      document.addEventListener('selectionchange', this.onSelectionChange)
    }
  }

  onSelectionChange = e => {
    const selection = document.getSelection();
    if (selection.toString().length > 0) {
      if (this.swiper) {
        this.swiper.disable()
      }
      if (this.judgeSwiper) {
        this.judgeSwiper.disable()
      }
    } else {
      if (this.swiper) {
        try {
          this.swiper.enable()
        } catch (err) {
          console.error(err)
        }
      }
      if (this.judgeSwiper && this.judgeSwiper.params) {
        this.judgeSwiper.enable()
      }
    }
  }

  componentWillUnmount() {
    this.deinit()
    if (isMobile()) {
      document.removeEventListener('selectionchange', this.onSelectionChange)
    }
    if (this.threadsSub) this.threadsSub.unsubscribe()
    if (this.messagesSub) this.messagesSub.unsubscribe()
    clearInterval(this.interval)
    if (this.optionsSub) this.optionsSub.unsubscribe()
    if (this.props.onDelete) {
      this.props.onDelete(this)
    }
    if (this.desktopFileSystemSub) {
      const hostId = this.desktopHostId
      const conversationId = this.props.task.id
      this.props.me.unwatchConversationFiles({hostId, conversationId})
      this.desktopFileSystemSub.unsubscribe()
      this.desktopFileSystemSub = null
      this.desktopFiles = {}
    }
  }

  getActiveModels = (rawMessages) => {
    const active = {}
    let isStreaming = !!this.state.sendChatId
    if (!isStreaming) for (let j = rawMessages.length-1; j >= 0; j--) {
      const message = rawMessages[j]
      let any = false
      if (message.role === 'assistant') {
        getReplies(message).forEach(reply => {
          const modelId = resolveModelId(reply && reply.model)
          if (!modelId) return
          if (reply.stream !== undefined) {
            isStreaming = this.resolveModel(modelId)
          }
          if (reply.content || reply.stream || reply.addedToTranscript) {
            active[modelId] = true
            any = true
          }
        })
      }
      if (any) {
        break
      }
    }
    return { isStreaming, activeModels: Object.keys(active).map(id => this.resolveModel(id)) }
  }

  getActiveUserMessage = (messages = this.getMessages()) => {
    if (this.state.sendChatId) {
      const localActive = this.received[this.state.sendChatId]
      if (localActive && localActive.role === 'user' && localActive.status === 'inferencing' && !localActive.canceledByUser) {
        return localActive
      }
    }
    for (let j = messages.length - 1; j >= 0; j--) {
      const message = messages[j]
      if (message &&
          message.role === 'user' &&
          message.status === 'inferencing' &&
          !message.canceledByUser) {
        return message
      }
    }
    return null
  }

  isReplyForActiveUserMessage = message => {
    const active = this.getActiveUserMessage()
    return !!(active && message && message.inReplyTo === active.id)
  }

  canSteerQueuedMessage = message => {
    if (!message || message.status !== 'queued') {
      return false
    }
    const active = this.getActiveUserMessage()
    if (!active) {
      const task = this.state.selectedTask
      return !task || !message.task || message.task === task.id
    }
    return !message.queuedDuring || message.queuedDuring === active.id || message.task === active.task
  }

  isActiveRunNotFoundError = err => {
    const responseError = err && err.response && err.response.data && err.response.data.error
    return responseError === 'active-run-not-found' ||
      err && (err.code === 'active-run-not-found' || err.message === 'active-run-not-found')
  }

  clearStaleActiveRun = activeUserMessage => {
    const xhr = this.xhr
    this.xhr = null
    if (xhr && typeof xhr.abort === 'function') {
      try {
        xhr.abort()
      } catch (err) {
        console.error(err)
      }
    }
    this.activeStreamReplyId = null
    this.activeReply = {}
    this.state.isStreaming = false
    this.state.sending = false
    this.state.replay = false
    this.state.sendChatId = null
  }

  sendQueuedMessageAsNewTurn = async (message, activeUserMessage) => {
    this.clearStaleActiveRun(activeUserMessage)
    message.retryErrored = message.status === 'error'
    message.status = 'queued'
    message.canceledByUser = false
    this.invalidateCache(message)
    this.setState({
      sendError: null
    })
    await this.sendChat(message, {
      models: normalizeModelIds(message.models),
      config: message.modelRequestConfigVersion === MODEL_REQUEST_CONFIG_VERSION ? message.config : undefined
    })
  }

  isEmbeddedTranscriptUserMessage = message => {
    return !!(message &&
              message.role === 'user' &&
              (message.embeddedInTranscript || message.steeredInto))
  }

  getActiveReplyForSteer = activeUserMessage => {
    if (!activeUserMessage) return null
    const activeReplyId = this.activeStreamReplyId || (this.activeReply && this.activeReply.id)
    return (activeReplyId && this.received[activeReplyId]) ||
      Object.values(this.received).find(message => {
        return message && message.role === 'assistant' && message.inReplyTo === activeUserMessage.id
      })
  }

  getActiveReplyModelForSteer = replyMessage => {
    if (!replyMessage) return null
    const activeModel = this.activeReply && this.activeReply.model
    const replies = getReplies(replyMessage)
    return replies.find(reply => activeModel && reply.model === activeModel) ||
      replies.find(reply => reply.stream !== undefined || reply.addedToTranscript || reply.content !== undefined) ||
      replies[0] ||
      null
  }

  appendSteerToActiveTranscript = (message, activeUserMessage, now) => {
    const replyMessage = this.getActiveReplyForSteer(activeUserMessage)
    const reply = this.getActiveReplyModelForSteer(replyMessage)
    const entry = makeSteeredTranscriptEntry(message, now)
    const appended = appendTranscriptEntriesToReply(reply, [entry])
    if (replyMessage) {
      this.invalidateCache(replyMessage)
    }
    if (appended) {
      this.sendToTranscript(entry.message, true)
    }
    return { replyMessage, reply, entry, appended }
  }

  removeSteerFromTranscript = ({ replyMessage, reply, entry }) => {
    if (!reply || !reply.addedToTranscript || !entry) return
    const next = reply.addedToTranscript.filter(existing => !isSameTranscriptEntry(existing, entry))
    if (next.length !== reply.addedToTranscript.length) {
      reply.addedToTranscript = next
      if (replyMessage) {
        this.invalidateCache(replyMessage)
      }
    }
  }

  persistReplyTranscript = async ({ replyMessage, reply, entry }) => {
    if (!replyMessage || !reply || !entry || !this.props.me) return
    await this.props.me.appendAssistantTranscriptEntries({
      message: replyMessage,
      target: assistantReplyTargetFor(replyMessage, reply),
      entries: [entry]
    })
  }

  getMessages = () => {
    let messages
    messages = Object.values(this.received).filter(message => !this.isEmbeddedTranscriptUserMessage(message))
    const getTs = msg => {
      const inReplyTo = msg.inReplyTo && this.received[msg.inReplyTo]
      return inReplyTo ? inReplyTo.ts : msg.ts
    }
    const getPosition = msg => {
      return msg.inReplyTo ? 1 : 0
    }
    messages.sort((x, y) => {
      const t1 = getTs(x)
      const t2 = getTs(y)
      const cmp = t1 - t2
      if (cmp === 0) {
        const p = getPosition(x) - getPosition(y)
        if (p !== 0) {
          return p
        }
        return (x.ts || 0) - (y.ts || 0)
      }
      return cmp
    })
    if (this.props.messageFilter) {
      messages = messages.filter(message => this.props.messageFilter(message, this))
    }
    return messages
  }

  getThreadMessages = () => {
    if (!this.state.selectedThread) {
      return null
    }
    const messages = this.state.searchResults
    if (!messages) {
      return null
    }
    messages.sort((x, y) => {
      return x.ts - y.ts
    })
    return messages
  }

  getInReplyTo = message => {
    const { inReplyTo } = message
    return this.received[inReplyTo]
  }

  scrollPos = {}

  onScrollThreads = ({
    view,
    baseOffset,
    offset,
    scrollTop
  }) => {
    this.scrollPos[view] = {
      baseOffset,
      offset,
      scrollTop
    }
  }

  setChatContentRef = ref => {
    this.chatContentRef = ref
  }

  setMessages1 = ref => {
    //////////////////debugger
    this.messages1 = ref
    this.restoreInitialConversationView()
  }

  restoreInitialConversationView = () => {
    if (!this.pendingInitialMessageId || !this.messages1 || this.restoringInitialView) return
    const selectedTask = this.state.selectedTask
    const message = this.received[this.pendingInitialMessageId]
    if (!selectedTask || !message) return
    this.restoringInitialView = true
    this.setState({ selectedMessage: message }, async () => {
      try {
        const restored = await this.messages1.scrollToBottom()
        if (restored) this.pendingInitialMessageId = null
      } finally {
        this.restoringInitialView = false
      }
    })
  }

  onBottomLockChanged = isBottomLock => {
    if (this.state.isBottomLock === isBottomLock) {
      return
    }

    this.setState({ isBottomLock })
  }

  setMessages2 = ref => {
    this.messages2 = ref
  }

  gotoTop = async () => {
    console.log("goto top")
    ////////debugger
    this.invalidateCache()
    const messages = this.getMessages();
    if (messages[0] !== this.state.selectedMessage) {
      await this.selectMessageAsync(messages[0])
    }
    await this.messages1.scrollToTop()
  }

  gotoBottomLater = () => {
    clearTimeout(this.bottomTimeout)
    this.bottomTimeout = setTimeout(async () => {
      await this.gotoBottom()
      this.updateUIElementsLater()
    }, 200)
  }

  pageUp = async () => {
    console.log("page up")
    let messages = this.getCurrentTranscript()
    let i = messages.findIndex(x => x.id == this.state.selectedMessage.id)
    if (i > 0) {
      i -= 2
      if (i <= 1) {
        return await this.gotoTop()
      }
    } else {
      return//i = messages.length-2;
    }
    await this.selectMessageAsync(messages[i])
  }

  pageDown = async () => {
    console.log("page down")
    let messages = this.getCurrentTranscript()
    let i = 0
    if (this.state.selectedMessage) {
      i = messages.findIndex(x => x.id == this.state.selectedMessage.id)
      if (i === 0) {
        i = 1
      }
      i += 2
      if (i >= messages.length) {
        return //await this.gotoTop()
      }
    }
    if (i < messages.length) {
      await this.selectMessageAsync(messages[i])
    }
  }

  gotoBottom = async () => {
    console.log("goto bottom")
    this.invalidateCache()
    ////////debugger
    let messages = this.getCurrentTranscript()
    let n = messages.length-1
    if (n > 0) {
      let lastUserMessage = messages[n]
      while (lastUserMessage.role !== 'user' && n > 0) {
        n--
        lastUserMessage = messages[n]
      }
      if (this.state.selectedMessage === lastUserMessage) {
        await this.messages1.scrollToBottom()
      } else {
        await this.selectMessageAsync(lastUserMessage)
        await this.messages1.scrollToBottom()
      }
    }
  }

  ask = async (topic, q, autoSend) => {
    if (this.received['pending']) {
      return
    }
    if (this.animating) {
      return
    }
    if (topic) {
      let currentTopic = this.getCurrentTopic()
      if (topic != currentTopic) {
        autoSend = false
        const thread = this.chatThreads[topic]
        this.selectThread(thread)
      }
    } else {
      autoSend = false
    }
    const result = this.editor.setText(q)
    if (isDesktop()) {
      this.setState({
        tooltip: ''
      })
    }
    if (autoSend) {
      this.sendChat()
    }
  }

  renderAISaid = (inReplyTo, message, onClick, opts) => {
    return this.renderAISaidHoriz(inReplyTo, message, null, opts)
  }

  onSlideTransitionStart = message => {
  }

  onSlideTransitionEnd = message => {
  }

  userSaidComps = {}
  onCreateUserSaid = (comp, id) => {
    this.userSaidComps[id] = comp
  }

  onDeleteUserSaid = id => {
    delete this.userSaidComps[id]
  }


  aiSaidComps = {}

  onCreateAISaid = (comp, id) => {
    this.aiSaidComps[id] = comp
  }

  onDeleteAISaid = id => {
    delete this.aiSaidComps[id]
  }


  selectModelIndex = (index, speed) => {
    if (!index || !index.id) return
    this.state.selectedModelIndex = index.id
    localStorage.setItem('selectedModelIndex', index.id)
    for (const id in this.aiSaidComps) {
      const x = this.aiSaidComps[id]
      x.selectModel(index, speed)
    }
    this.forceUpdate()
  }

  selectJudgeIndex = index => {
    for (const id in this.aiSaidComps) {
      const x = this.aiSaidComps[id]
      x.selectJudgeIndex(index)
    }
    this.forceUpdate()
  }

  resolveStorage = async (message, reply) => {
    if (message.role === 'user') {
      if (message.storage && message.content.length !== message.contentLength) {
        await (this.props.me.downloadMessageContent(message.id, message.storage).then(content => {
          message.content = content
        }))
      }
    } else {
      if (reply.storage && reply.content.length !== reply.contentLength) {
        await (this.props.me.downloadAssistantContent(message.id, reply.model, reply.storage).then(content => {
          reply.content = content
        }))
        }
    }
  }


  renderAISaidHoriz = (inReplyTo, message, onClick, opts) => {
    opts = opts || {}
    const sourceMessage = opts.sourceMessage || message
    const stateMessageId = sourceMessage.id
    const { isLast, isCompacted } = opts
    const pause = async () => {
      return await this.pauseChat()
      this.forceUpdate()
    }
    let del
    let copy = async (msg, reply) => {
      await this.resolveStorage(msg, reply)
      const text = reply.content
      const toCopy = removeSignatures(text)
      return this.copyToClipboard(toCopy)
    }
    const getModelIcon = model => {
      const m = this.modelsById[model]
      if (!m) {
        ////////////////debugger
        return null
      }
      return m.getModelIcon && m.getModelIcon() || m.getIcon()
    }
    const getModelTitle = model => {
      const m = this.resolveModel(model)
      if (m.isFinetune) {
        return <ModelLabel model={m}/>
      }
    }
    const { participants } = opts
    const {containsFiles, containsBrowser } = this.shouldShowCanvas()
    const containsConversation = this.shouldShowConversationBrowser()
    let isWide = !isMobile() && this.state.mobileChatView === 'chat'
    return <AISaidComp
             deleteToolUse={this.props.saveReplyEdit
               ? undefined
               : update => this.deleteToolUse(sourceMessage, update)}
	     getToolUsePos={(ids) => this.getToolUsePos(stateMessageId, ids)}
	     setToolUsePos={(ids, pos) => this.setToolUsePos(stateMessageId, ids, pos)}
	     getToolUseOpen={(ids, defaultOpen) => this.getToolUseOpen(stateMessageId, ids, defaultOpen)}
	     setToolUseOpen={(ids, isOpen) => this.setToolUseOpen(stateMessageId, ids, isOpen)}
	     uiState={this.getAiSaidCompState(stateMessageId)}
	     messageBodyState={this.getAiSaidCompState(message.id).messageBodyState}
	     onTranscriptChanged={() => {
	       this.updateUIElementsLater()
	       this.forceUpdate()
	     }}
	     onSelectReply={opts.onSelectReply}
	     sourceMessage={sourceMessage}
	     transcriptPosition={opts.transcriptPosition}
	     getTranscriptEntriesForReply={opts.getTranscriptEntriesForReply}
	     registerComponent={opts.registerComponent}
	     hydrateTranscriptArchives={opts.hydrateTranscriptArchives}
	     hydrateTranscriptArchiveEntries={this.hydrateTranscriptArchiveEntries}
             isCompacted={isCompacted}
             getLastBrowserLocation={this.getLastBrowserLocation}
             setLastBrowserLocation={this.setLastBrowserLocation}
	     setLastBrowserStreamURL={this.setLastBrowserStreamURL}
	     openConversationLink={this.openConversationLink}
	     renderConversationLeaf={this.renderConversationLeafWithChat}
             isWide={isWide}
             readOnly={this.isReadOnly()}
             isReplyRunning={this.isReplyForActiveUserMessage}
             getSubagentTask={this.getSubagentTask}
             resolveSubagentTask={this.resolveSubagentTask}
             openSubagentChat={this.openSubagentChat}
             copyThread={this.copyThread}
             enableChat={this.enableChat}
             isStreaming={this.isStreaming}
             resolveStorage={this.resolveStorage}
             isLast={isLast}
             isBottomLock={this.state.isBottomLock}
             selectedModelIndex={this.state.selectedModelIndex}
             participants={participants}
             saveEdit={({target, model, content}) => this.saveReplyEdit({message: sourceMessage, target, model, content})}
	     deleteReply={update => this.deleteAssistantReply(sourceMessage, update)}
	             saveReplyMessage={update => this.saveReplyMessage(sourceMessage, update)}
             inReplyTo={inReplyTo}
             onCreate={this.onCreateAISaid}
             onDelete={this.onDeleteAISaid}
             selectModel={this.selectModelIndex}
             onSlideTransitionStart={()=>this.onSlideTransitionStart(sourceMessage)}
             onSlideTransitionEnd={()=>this.onSlideTransitionEnd(sourceMessage)}
             getModelIcon={getModelIcon}
             resolveModel={this.resolveModel}
             getModelTitle={getModelTitle}
             opts={opts}
             key={message.id}
             resolveFile={this.resolveFile}
             getComponents={this.getComponents}
             selected={this.state.selectedMessage && sourceMessage.id === this.state.selectedMessage.id}
             message={message}
             task={this.state.selectedTask}
             isActiveCompactionEntry={opts.isActiveCompactionEntry}
             getConversationSummaryRecords={compacted => this.getConversationSummaryRecords(compacted, this.state.selectedTask)}
             getConversationSummaryRecordsState={compacted => this.getConversationSummaryRecordsState(compacted, this.state.selectedTask)}
             loadConversationSummaryRecords={compacted => this.loadConversationSummaryRecords(compacted, this.state.selectedTask)}
             received={this.received}
             opts={opts}
             saveMessageContent={this.saveMessageContent}
             me={this.props.me}
             pause={pause}
             del={del}
             copy={copy}
             judging={opts.isJudge}
             stop={this.stopChat}
             replay={(reply) => this.replay(sourceMessage, reply)}
             correct={(reply) => this.correct(sourceMessage, reply)}
             purgeCache={() => this.purgeCache(sourceMessage)}
             apply={this.props.applyReply && (({reply, body}) => this.applyReply({message: sourceMessage, reply, body}))}
             getModelLabel={message => <ModelLabel model={this.resolveModel(message.model)}/>}
           />
  }

  aiSaidCompState = {}
  userSaidCompState = {}
  systemMessageState = {}
  conversationSummaryRecordsByStoragePath = {}
  conversationSummaryRecordsLoading = {}

  conversationIndexStoragePath = index => {
    if (!index || !index.summaryStoragePrefix || !Array.isArray(index.summaryLevelCounts)) return ''
    const version = index.updatedAt || index.conversationIndexUpdatedAt || ''
    return `${index.summaryStoragePrefix}#${index.summaryLevelCounts.join('-')}#${version}`
  }

  conversationIndexForCompaction = (compacted, task) => {
    const compaction = compacted && compacted.compaction || {}
    const index = { ...(compaction.index || {}) }
    if (this.conversationIndexStoragePath(index)) return index
    return task && task.conversationIndex || {}
  }

  getConversationSummaryRecords = (compacted, task) => {
    const index = this.conversationIndexForCompaction(compacted, task)
    const storagePath = this.conversationIndexStoragePath(index)
    if (!storagePath) return []
    const cached = this.conversationSummaryRecordsByStoragePath[storagePath]
    if (cached) {
      return cached.records || []
    }
    return []
  }

  getConversationSummaryRecordsState = (compacted, task) => {
    const index = this.conversationIndexForCompaction(compacted, task)
    const storagePath = this.conversationIndexStoragePath(index)
    if (!storagePath) return { loaded: false, loading: false, error: null }
    const cached = this.conversationSummaryRecordsByStoragePath[storagePath]
    return {
      loaded: Boolean(cached),
      loading: Boolean(this.conversationSummaryRecordsLoading[storagePath]),
      error: cached && cached.error || null
    }
  }

  loadConversationSummaryRecords = async (compacted, task) => {
    const index = this.conversationIndexForCompaction(compacted, task)
    const storagePath = this.conversationIndexStoragePath(index)
    if (!storagePath) return
    const cached = this.conversationSummaryRecordsByStoragePath[storagePath]
    if (cached && !cached.error) return
    if (this.conversationSummaryRecordsLoading[storagePath]) return
    this.conversationSummaryRecordsLoading[storagePath] = true
    try {
      const records = await this.props.me.downloadConversationIndexSummaryRecords(index)
      this.conversationSummaryRecordsByStoragePath[storagePath] = {
        records
      }
      this.invalidateCache()
      this.forceUpdate()
    } catch (err) {
      console.error(err)
      this.conversationSummaryRecordsByStoragePath[storagePath] = {
        records: [],
        error: err && err.message || String(err)
      }
      this.invalidateCache()
      this.forceUpdate()
    } finally {
      delete this.conversationSummaryRecordsLoading[storagePath]
    }
  }

  getUserSaidCompState = messageId => {
    if (!this.userSaidCompState[messageId]) {
      this.userSaidCompState[messageId] = {}
    }
    return this.userSaidCompState[messageId]
  }

  getSystemMessageState = taskId => {
    const key = taskId || 'system'
    if (!this.systemMessageState[key]) {
      this.systemMessageState[key] = {}
    }
    return this.systemMessageState[key]
  }

  getAiSaidCompState = messageId => {
    if (!this.aiSaidCompState[messageId]) {
      this.aiSaidCompState[messageId] = {
        compactionOpen: {},
        downloading: {},
        messageBodyState: {},
        showAll: {},
        toolProgress: {},
        toolUseState: {}
      }
    }
    return this.aiSaidCompState[messageId]
  }

  setToolUseState =  (messageId, ids, state) => {
    const theState = this.getToolUseState(messageId, ids)
    for (const id in state) {
      theState[id] = state[id]
    }
  }

  getToolUseState = (messageId, ids) => {
    const theState = this.getAiSaidCompState(messageId)
    if (!theState.toolUseState) {
      theState.toolUseState = {}
    }
    const { toolUseState } = theState
    if (!toolUseState[ids]) {
      toolUseState[ids] = {
        pos: 0,
        isOpen: undefined
      }
    }
    return toolUseState[ids]
  }

  deleteToolUse = async (message, {target, toolCallId}) => {
    await this.props.me.deleteAssistantToolCall({ message, target, toolCallId })
    this.purgeCache(message)
    this.updateUIElementsLater()
  }

  getToolUsePos = (messageId, ids) => {
    const state = this.getToolUseState(messageId, ids)
    return state.pos
  }

  setToolUsePos=(messageId, ids, pos) => {
    const state = this.getToolUseState(messageId, ids)
    return state.pos = pos
  }

  getToolUseOpen=(messageId, ids, defaultOpen = false) => {
    const state = this.getToolUseState(messageId, ids)
    if (state.isOpen && typeof state.isOpen === 'object') {
      state.isOpen = state.isOpen[ids]
    }
    if (state.isOpen === undefined) {
      state.isOpen = defaultOpen
    }
    return state.isOpen
  }

  setToolUseOpen=(messageId, ids, isOpen) => {
    const state = this.getToolUseState(messageId, ids)
    state.isOpen = isOpen
    return state.isOpen
  }

  lastBrowserStreamURL = ''
  setLastBrowserStreamURL = (url) => {
    if (this.lastBrowserStreamURL !== url) {
      debugger
      this.lastBrowserStreamURL = url
      this.forceUpdate()
    }
  }

  lastBrowserLocation = ''
  getLastBrowserLocation = () => {
    return this.lastBrowserLocation
  }

  setLastBrowserLocation = (url) => {
    this.lastBrowserLocation = url
  }

  resolveFile = path => {
    if (this.canvasEditor) {
      return this.canvasEditor.resolveFile(path)
    }
  }

  enableChat = enabled => {
    this.state.chatDisabled = !enabled
    this.forceUpdate()
  }

  saveUserEdit = async (message, {content, json}) => {
    let changed = (content !== undefined && content !==  message.content) ||
        (json !== undefined && json !== message.json)
    if (!changed) {
      return
    }
    const task = this.state.selectedTask
    const status = message.status === 'queued' ? 'steered' : undefined
    try {
      this.enableChat(false)
      if (this.props.saveUserEdit) {
        await this.props.saveUserEdit(this, {task, message, content, json, status})
      } else {
        await this.props.me.saveUserEdit({task, message, content, json, status})
      }
    } finally {
      this.enableChat(true)
    }
  }

  saveReplyMessage = async (message, update) => {
    await this.props.me.saveReplyMessage(message, update)
    this.purgeCache(message)
    this.updateUIElementsLater()
  }

  saveReplyEdit = async ({message, target, model, content}) => {
    const task = this.state.selectedTask
    try {
      this.enableChat(false)
      if (this.props.saveReplyEdit) {
        await this.props.saveReplyEdit(this, {task, target, model, message, content})
      } else {
        await this.props.me.saveReplyEdit({task, target, model, message, content})
      }
    } finally {
      this.enableChat(true)
    }
  }

  deleteAssistantReply = async (message, {target, model}) => {
    const task = this.state.selectedTask
    try {
      this.enableChat(false)
      if (this.props.saveReplyEdit) {
        await this.props.saveReplyEdit(this, {task, target, model, message, content: ''})
      } else {
        await this.props.me.deleteAssistantReply({message, target})
      }
    } finally {
      this.enableChat(true)
    }
  }

  applyReply = async ({message, reply, model}) => {
    ////////////////debugger
    if (this.props.applyReply) {
      await this.props.applyReply(this, {message, reply, model})
    }
  }

  endStream = () => {
    const xhr = this.xhr
    this.xhr = null
    this.activeReply = {}
    //debugger
    if (xhr) {
      try {
        xhr.abort()
        consoleLog("aborted xhr")
      } catch (err) {
        console.error(err)
      }
    }
  }

  stopChat = async () => {
    const activeUserMessage = this.getActiveUserMessage()
    const activeMessageId = (activeUserMessage && activeUserMessage.id) || this.state.sendChatId
    if (activeUserMessage) {
      activeUserMessage.canceledByUser = true
    }
    this.clearStaleActiveRun(activeUserMessage)
    this.updateUIElementsLater()
    if (activeMessageId) {
      try {
        await this.props.me.cancelStreamChat(activeMessageId)
      } catch (err) {
        console.error(err)
      }
    }
  }

  getMessageById = id => {
    if (!id) return null
    return this.received[id] ||
      (this.state.rawMessages || []).find(message => message && message.id === id) ||
      null
  }

  getReplaySourceModels = (request, responseMessage, reply) => {
    let models = normalizeModelIds(request && request.models)
    if (models.length === 0) {
      models = normalizeModelIds(getReplies(responseMessage).map(reply => reply && reply.model))
    }
    const replayModelId = resolveModelId(reply && reply.model)
    if (replayModelId && !models.includes(replayModelId)) {
      models = [replayModelId].concat(models)
    }
    return models
  }

  replay = async (message, reply) => {
    if (!reply || !reply.model) {
      this.setState({
        sendError: 'Cannot replay this response because it has no model id.'
      })
      return
    }
    const model = this.resolveModel(reply.model)
    const req = this.getMessageById(message.inReplyTo)
    if (!req) {
      this.setState({
        sendError: 'Cannot replay this response because the original user message is not loaded.'
      })
      return
    }
    if (!model || !model.prefill) {
      reply.content = ''
      reply.stream = ''
      reply.addedToTranscript = null
    }
    this.forceUpdate()
    const models = this.getReplaySourceModels(req, message, reply)
    await new Promise((resolve, reject) => {
      this.sendChat(req, {
        replay: reply.model,
        models,
        onDone: resolve,
        reject
      }).then(xhr => {
        if (!xhr) resolve()
      }).catch(reject)
    }).catch(err => {
      console.error(err)
      this.setState({
        sendError: err && err.message || 'Replay failed.'
      })
    })
  }

  correct = async (message, reply) => {
    if (reply.corrected) {
      reply.corrected = null
    } else {
      const req = this.received[message.inReplyTo]
      const judges = this.judgeView.getSelectedModelIds()
      const task = this.state.selectedTask
      if (this.props.correct) {
        await this.props.correct(this, {task, message: req, reply: message, model: reply.model, judges})
      }
      this.purgeCache(req)
    }
    this.purgeCache(message)
  }

  getJudgeConversation = () => {
    let judgeConversation = []
    const rawMessages = this.getMessages()
    for (const message of rawMessages) {
      judgeConversation.push(message)
      if (this.state.swipeMessage) {
        if (message.inReplyTo === this.state.swipeMessage.id) {
          break
        }
      }
    }
    return judgeConversation;
  }

  judge = async req => {
    this.setState({
      judging: true
    })
    //const conversation = this.getJudgeConversation()
    const userMsg = this.editor.getText()
    this.editor.clear()
    let reply = this.resolveReply(req)
    const judges = this.judgeView.getSelectedModelIds()
    let judgeFunc
    if (this.props.judge) {
      judgeFunc = (judges, req, reply, userMsg) => this.props.judge(this, judges, req, reply, userMsg)
    } else {
      judgeFunc = this.props.me.judge
    }
    await judgeFunc(judges, req, reply, userMsg)
    this.state.judging = false
    this.forceUpdateLater()
  }

  invalid = {}

  invalidateCache = msg => {
    if (!msg) {
      this.invalid = {}
      return
    }
    const invalidate = id => {
      this.invalid[id] = true
    }
    invalidate(msg.id)
    if (msg.inReplyTo) {
      invalidate(msg.inReplyTo)
    }
  }

  resolveReply = message => {
    for (const id in this.received) {
      const x = this.received[id]
      if (x.inReplyTo === message.id) {
        return x
      }
    }
  }

  resolveTopic = message => {
    const task = this.tasks[message.task]
    return null
  }

  saveSystemPromptContent = async (task, content) => {
    task.systemPromptContent = content
    this.forceUpdate()
    await this.props.me.updateTask(task.id, {systemPromptContent: content})
  }

  maskSystemPrompt = async (task, id) => {
    if (!task.systemPromptMask) {
      task.systemPromptMask = {}
    }
    const masked = task.systemPromptMask[id] !== false
    ////////debugger
    task.systemPromptMask[id] = !masked
    this.forceUpdate()
    await this.props.me.updateTask(task.id, {systemPromptMask: task.systemPromptMask})
  }

  saveTaskLater = (task) => {
    clearTimeout(this.saveTaskTimeout)
    this.saveTaskTimeout = setTimeout(() => {
      if (this.state.selectedTask &&
          this.state.selectedTask.id == task.id) {
      }
    }, 500)
  }

  renderSystemMessage = message => {
    const task = this.state.selectedTask
    const delSysPrompt = this.deleteSystemPrompt
    const systemPrompt = {
      title: task.systemPrompt ? task.systemPrompt.title : 'System',
      content: this.state.systemPrompt || ''
    }
    const { title, content } = systemPrompt
    const components = this.getComponents()
    const openSystemPrompts = async (onSelect) => {
      this.openSystemPrompt(onSelect)
    }
    const editSystemPrompt = async () => {
      if (task.systemPrompt) {
      }
    }
    const maskSystemPrompt = async (id) => {
      return this.maskSystemPrompt(task, id)
    }
    const saveContent = async content => {
      this.saveSystemPromptContent(task, content)
    }
	    return <SystemMessage
	             key='systemMessage'
	             ref={this.setSystemMessage}
	             uiState={this.getSystemMessageState(task.id)}
	             readOnly={this.isReadOnly()}
             content={task.systemPromptContent}
             components={this.getComponents()}
             saveContent={saveContent}
             maskSystemPrompt={maskSystemPrompt}
             systemPromptMask={task.systemPromptMask || {}}
             systemPrompt={task.systemPrompt}
             systemPrompts={Object.values(task.systemPrompts || {})}
             systemPromptsExpanded={this.state.systemPrompts}
             deleteSystemPrompt={delSysPrompt}
             editSystemPrompt={editSystemPrompt}
             openSystemPrompts={openSystemPrompts}
           />
  }

  setSystemMessage = ref => {
    //debugger
    this.systemMessageRef = ref
  }

  getSystemPromptText = () => {
    const task = this.state.selectedTask
    const systemPromptMask= task.systemPromptMask || {}
    const systemPromptsExpanded = this.state.systemPrompts
    return systemPromptsExpanded.filter(x => !x.isFolder && systemPromptMask[x.id]).map(systemPrompt => {
      let { id, content, heading, title, name, isFolder } = systemPrompt
      return content
    }).join('\n\n')
  }

  renderN = 0
  renderChatMessage = (message, prev, next, mergedBody, opts) => {
    if (message.role === 'system') {
      return this.renderSystemMessage(message)
    }
    this.renderN++
    if (message.role === 'assistant') {
      if (prev && prev.role !== 'user') {
        //debugger
      }
    }
    ////////console.log("renderChatMessage not cached", message.content)
    let className = 'chatGptChatMessageHeader'
    const msgBody = this.renderChatMessageBody(message, prev, next, mergedBody, opts)
    let style
    let bodyClassName = 'chatGptChatMessageBody'
    if (opts && opts.transcriptPosition) {
      bodyClassName += ` chatGptChatMessageBodyTranscriptUnit chatGptChatMessageBodyTranscriptUnit-${opts.transcriptPosition}`
    }
    const result = <div key={message.id} className={bodyClassName} style={style}>{msgBody}</div>
    delete this.invalid[message.id]
    return result
  }

  isRecent = message => {
    const now = Date.now()
    return now - message.ts < 60000;
  }

  isToolCallComplete = (tool_call_id) => {
    const reply = Object.values(this.received).find(x => x.tool_call_id === tool_call_id)
    return reply
  }

  wasAnswered = (message) => {
    const reply = Object.values(this.received).find(x => x.inReplyTo === message.id)
    if (reply && reply.id == message.id + ".reply" && reply.text) {
      if (message.stream) {
        message.stream = null
      }
    }
    ////////////console.log("was answered", message.id, reply)
    return reply
  }

  onClickMessage = message => {
    const f = this.props.onClickMessage
    if (f) {
      f(message, this)
    }
  }

  purgeCache = message => {
    this.invalidateCache(message)
    this.forceUpdate(this.updateUIElementsLater)
  }


  isFromMe = message => message.role === 'user'

  toggleJson = message => {
    this.saveUserEdit(message, { json: !message.json })
  }

  copyAction = async (modelFilter) => {
    if (true) {
      return this.copyThread(null, modelFilter)
    }
  }

  copyThread = async (message, model) => {
    let messages = this.getMessages()
    if (message) {
      const index = messages.findIndex(x => x.id === message.id)
      messages = messages.slice(0, index+1)
    }
    const resolvePrice = (model, usage) => {
      const resolved = this.resolveModel(model)
      const contextTokens = usageBilling.usageTokenBreakdown(usage).contextInputTokens
      const context = getPricingContext(resolved, contextTokens)
      if (!context) { // model not loaded yet
        return {
          input: 0, output: 0, cached: 0, cacheWrite: 0
        }
      }
      const { input, output, cached, cacheWrite } = context.price
      //console.log(model, context)
      return {
        input: input / (1000*1000),
        output: output / (1000*1000),
        cached: (cached || 0) / (1000*1000),
        cacheWrite: (cacheWrite || 0) / (1000*1000),
      }
    }
    const usage = tallyTranscriptUsage({messages, model, resolvePrice})
    messages = messages.flatMap(x => {
      let { role, models, content } = x
      if (role === 'assistant') {
        let found
        if (models) {
          found = models.find(x => x.model === model)
          if (!found) {
            found = models.find(x => x.content || x.addedToTranscript)
          }
        }
        if (found) {
          let { content, addedToTranscript } = found
          if (addedToTranscript) {
            return found.addedToTranscript.flatMap(x => {
              if (!x || !x.message) return []
              let { content, tool_calls, tool_call_id, role } = x.message
              if (role === 'assistant') {
                content = removeSignatures(content)
              }
              return [{ role, content, tool_calls, tool_call_id }]
            })
          } else  {
            content = removeSignatures(found.content)
          }
        } else {
          content = removeSignatures(content)
        }
      }
      return [{ role, content }]
    })
    const json = JSON.stringify({
      messages,
      usage
    })
    return await this.copyPlainTextToClipboard(json)
  }

  cutConversation = async (message, direction, text) => {
    const { messages, task }  = await this.props.cutConversation(this, this.state.selectedTask, message, direction)
    if (direction === 'thread') {
      this.deinitSelectedTask()
      this.state.selectedTask = task
      this.initSelectedTask(messages)
    } else {
      this.received = {}
    }
    messages.forEach(message => {
      this.received[message.id] = message
    })
    this.invalidateCache()
    ////////debugger
    this.updateUIElements()
  }

  getActiveTranscriptReplyIndex = (message, replies) => {
    if (!Array.isArray(replies) || replies.length === 0) return -1
    const selectedModelId = this.state.selectedModelIndex
    if (selectedModelId) {
      const selectedModel = this.resolveModel(selectedModelId)
      const selectedIndex = replies.findIndex(reply => reply && (
        reply.model === selectedModelId ||
        selectedModel && selectedModel.isModel && selectedModel.isModel(reply.model)
      ))
      if (selectedIndex >= 0) return selectedIndex
    }
    const activeIndex = this.getAiSaidCompState(message.id).activeIndex
    if (Number.isInteger(activeIndex)) {
      return Math.max(0, Math.min(activeIndex, replies.length - 1))
    }
    return 0
  }

  makeTranscriptDisplayMessage = (sourceMessage, id, replies) => ({
    id,
    role: 'assistant',
    ts: sourceMessage.ts,
    inReplyTo: sourceMessage.inReplyTo,
    judgement: sourceMessage.judgement,
    isStreaming: sourceMessage.isStreaming,
    models: replies.filter(Boolean)
  })

  virtualizeAssistantTranscript = message => {
    const replies = getReplies(message)
    const activeIndex = this.getActiveTranscriptReplyIndex(message, replies)
    const activeReply = activeIndex >= 0 ? replies[activeIndex] : null
    const unitsByReply = new Map(replies.map(reply => [reply, assistantTranscriptRenderUnits(reply)]))
    const activeUnits = unitsByReply.get(activeReply) || []
    if (activeUnits.length === 0) return [message]

    const items = []
    const firstPosition = activeUnits.length === 1 ? 'only' : 'first'
    items.push({
      id: message.id,
      virtualTranscriptItem: true,
      sourceMessage: message,
      displayMessage: this.makeTranscriptDisplayMessage(message, message.id, replies),
      transcriptPosition: firstPosition,
      getTranscriptEntriesForReply: reply => {
        const units = unitsByReply.get(reply) || []
        return units[0] || null
      },
      registerComponent: true,
      hydrateTranscriptArchives: true,
      onSelectReply: () => this.forceUpdate()
    })

    for (let index = 1; index < activeUnits.length; index += 1) {
      const modelKey = encodeURIComponent(String(activeReply && activeReply.model || activeIndex))
      const id = `${message.id}::transcript::${modelKey}::${index}`
      items.push({
        id,
        virtualTranscriptItem: true,
        sourceMessage: message,
        displayMessage: this.makeTranscriptDisplayMessage(message, id, [activeReply]),
        transcriptPosition: index === activeUnits.length - 1 ? 'last' : 'middle',
        getTranscriptEntriesForReply: () => activeUnits[index],
        registerComponent: false,
        hydrateTranscriptArchives: false,
        onSelectReply: null
      })
    }
    return items
  }

  virtualizeTranscriptMessages = messages => {
    return (messages || []).flatMap(message => {
      if (!message || message.role !== 'assistant') return [message]
      return this.virtualizeAssistantTranscript(message)
    }).filter(Boolean)
  }

  getUserMessageQueueState = message => {
    if (!message || message.role !== 'user') {
      return null
    }
    if (this.isEmbeddedTranscriptUserMessage(message)) {
      return null
    }
    if (message.status === 'inferencing') {
      return 'inferencing'
    }
    for (const id in this.received) {
      if (this.received[id].inReplyTo === message.id) {
        return null
      }
    }
    if (message.status === 'steered') {
      return 'steered'
    }
    if (message.status === 'queued') {
      return 'queued'
    }
    return null
  }


  renderChatMessageBody = (message, prev, next, mergedBody, opts) => {
    const { isJudge, participants, isCompacted } = opts
    const components = this.getComponents(message)
    ////////console.log("renderChatMessageBody", message, opts)
    if (message.role === 'user') {
      if (true) {
        const uploadFile = async file => {
          const ref = await this.props.uploadFile(file)
          return await ref.getDownloadURL()
        }
        const copy = async () => {
          await this.resolveStorage(message)
          return this.copyMarkdownToClipboard(message.content)
        }
	        return <UserSaidComp
	                 readOnly={this.isReadOnly()}
	                 uiState={this.getUserSaidCompState(message.id)}
	                 selected={this.state.selectedMessage && message.id === this.state.selectedMessage.id}
                 selectedMessage={this.state.selectedMessage}
                 onCreate={this.onCreateUserSaid}
                 onDelete={this.onDeleteUserSaid}
	                 compacted={isCompacted(message)}
                 uploadFile={uploadFile}
                 openThread={this.openThreadChat}
                 cutConversation={this.cutConversation}
                 deleteChatMessage={this.deleteChatMessage}
                 message={message}
                 task={this.state.selectedTask}
                 isActiveCompactionEntry={opts.isActiveCompactionEntry}
                 getConversationSummaryRecords={compacted => this.getConversationSummaryRecords(compacted, this.state.selectedTask)}
                 getConversationSummaryRecordsState={compacted => this.getConversationSummaryRecordsState(compacted, this.state.selectedTask)}
                 loadConversationSummaryRecords={compacted => this.loadConversationSummaryRecords(compacted, this.state.selectedTask)}
                 openConversationLink={this.openConversationLink}
                 toggleJson={() => this.toggleJson(message)}
                 queueState={this.getUserMessageQueueState(message)}
                 steerQueuedMessage={this.canSteerQueuedMessage(message) ? this.steerQueuedMessage : null}
                 components={components}
                 me={this.props.me}
                 isJudge={isJudge}
                 judging={this.props.judging}
                 purgeCache={(x) => {
                   this.purgeCache(x)
                   this.forceUpdate()
                 }}
                 copy={copy}
                 saveEdit={(content)=>this.saveUserEdit(message, {content})}
                 judge={async () => {
                   this.state.swipeMessage = message
                   this.judgeSwiper.slideTo(1)
                   this.forceUpdate()
                 }}/>

      }
      const trash = async () => {
        ////////////////debugger
        if (this.state.confirmDelete !== message.id) {
          this.purgeCache(message)
          this.setState({confirmDelete: message.id})
          return
        }
        try {
          message.busy = true
          this.forceUpdate()
          await this.props.me.deleteChatMessage(message.id)
          this.purgeCache(message)
        } finally {
          message.busy = false
          this.setState({confirmDelete: null})
        }
      }
      const now = Date.now()
      if (message.reaction && !message.reaction.split) {
        ////////////////////////////debugger
      }
      let action1
      let icon1
      let clazz1 = ''
      if (message.id !== 'pending') {
        action1 = trash
        icon1 = Trash
        clazz1 = 'userSaidDel'
      }
      let deleteButton
      let deleteIcon = message.busy ? Spin : Trash
      if (!isJudge) {
        deleteButton = trash && <DeleteButton trash={trash}/>
      }

      let markdown = replaceImgWithMarkdown(message.content|| '')
      ////////////console.log("markdown", markdown)
      let content = markdown
      if (message.storage) {
        const len = message.contentLength
        content = message.content.substring(0, 8192)
        content += '\n... ' + (len - content.length).toLocaleString() + " more characters ..."
      } else {
        content = <Markdown components={components}>{markdown.replaceAll('\n', '\n\n')}</Markdown>
      }
      let judgeIcon = this.props.judging ? Spin : Right
      let judge
      const hasReplies = message => {
        for (const id in this.received) {
          if (this.received[id].inReplyTo === message.id) return true
        }
      }
      if (!isJudge) {
        judge = async () => {
          this.state.swipeMessage = message
          this.judgeSwiper.slideTo(1)
          this.forceUpdate()
        }
      }
      const onSwipe = e => {
        this.setState({
          swipeMessage: message
        })
      }
      let edit
      let trashMessage
      if (!isJudge) {
        edit = async () => {
        }
        trashMessage = async () => {
          if (this.props.deleteChatMessage) {
            await this.props.deleteChatMessage(this, message.id)
          } else {
            await this.props.me.deleteChatMessage(message.id)
          }
          this.purgeCache(message)
        }
      }
      let user = <div
                   key='usermsg'
                   className='chatMessageFromUser keyboardEditInstruction aiUser'
                 >
                   <div className='keyboardEditIconAndInstruction'>
                     <div className='keyboardEditInstructionLeftIcon'>
                       <ReactSVG src={UserSaid}/>
                     </div>
                     <div className='keyboardEditInstructionText' key={'user-'+message.id}>
                       {content}
                     </div>
                     <div className='rightColumn1 copyAISaid'>
                       {edit && <div key='edit' className='judgeButtonHolder'><KeyboardButton1 keepFocus icon={EditIcon} action={edit}/></div>}
                       {trashMessage && <DeleteButton trash={trashMessage}/>}
                       {judge && <div key='judge'  className='judgeButtonHolder'><KeyboardButton1 icon={judgeIcon} action={judge}/></div>}
                     </div>
                   </div>
                 </div>
      return user
    }
    const output = []
    let { content, role, task, ts, isStreaming } = message
    let text = content
    let outputTs = ts
    if (isStreaming && !text ) {
      text = 'Working.'
    }
    let images
    let noSpin = text
    const isLast = !next
    const inReplyTo = this.received[message.inReplyTo]
    const isTrain = inReplyTo && inReplyTo.model ===  'train'
    if (isJudge && message.judgement) {
      //////console.log({judgement: message.judgement})
      let { judgements } = message.judgement
      if (judgements) {
        //////console.log({judgements})
        const sortedJudgements = [].concat(judgements)
        sortedJudgements.sort((x, y) => {
          const a = this.resolveModel(x.judge)
          const b = this.resolveModel(y.judge)
          return a.name.localeCompare(b.name)
        })
        judgements = sortedJudgements
        //////console.log(judgements)
        const Avg = {
        }
        const trashJudge = async (judge) => {
          if (this.props.deleteJudge) {
            await this.props.deleteJudge(this, {task: this.state.selectedTask, model: judge, messageId: message.id})
          } else {
            await this.props.me.deleteJudgeFromTask({task: this.state.selectedTask.id, model: judge, messageId: message.id})
          }
        }
        for (const j of judgements) {
          const { judge, ratings } = j
          let seen = {}
          for (const r of ratings) {
            let { rating, model } = r
            if (!model && isTrain) { // hack
              model = 'train'
            }
            if (model && !seen[model]) {
              seen[model] = true
              if (!Avg[model]) {
                Avg[model] = 0
              }
              Avg[model] += (rating / judgements.length)
            }
          }
        }
        ////////console.log({Avg})
        let winner
        let winners = []
        let rating = 0
        for (const model in Avg) {
          if (winner == undefined || Avg[model] >= rating) {
            winner = model
            if (Avg[model] === rating) {
              winners.push(model)
            } else {
              winners = [model]
            }
            rating = Avg[model]
          }
        }
        const selectModel = async (modelId) => {
          const resolved = this.resolveModel(modelId)
          this.selectModelIndex(resolved)
        }
        const selectJudge = async (judge) => {
          const resolved = this.resolveModel(judge)
          this.selectJudgeIndex(resolved)
        }
        const toButton = (modelId, noIcon, action) => {
          const m = this.resolveModel(modelId)
          if (!m) {
            ////////////////debugger
            return null
          }
          const icon = (m.getModelIcon && m.getModelIcon()) || m.getIcon()
          if (!action) {
            action = async () => {
              selectModel(modelId)
            }
          }
          let label = <ModelLabel model={m}/>
          if (noIcon) {
            return <div className='modelSelection2'>{label}</div>
          } else {
            return <div className='modelSelection1'><SimpleButton icon={icon} label={label}/></div>
          }
        }
        const ws = winners.map(x => toButton(x, true)).flatMap((x, i) => i === 0 ? x : [', ', x])
        for (const w of winners) {
          delete Avg[w]
        }
        const losers = Object.keys(Avg)
        losers.sort((x, y) => {
          return Avg[y] - Avg[x]
        })
        const ls = losers.map(loser => {
          let button = toButton(loser, true)
          if (!button) {
            return null
          }
          return <div className='judgeLoser'>{button}{` ${Math.round(Avg[loser] * 10)/10}/10`}</div>
        })
        let avgRating = 'rating'
        if (judgements.length > 1) {
          if (ws.length > 1) {
            avgRating = "average ratings of"
          } else {
            avgRating = "an average rating of"
          }
        }
        let answerIs = "answer is from"
        if (ws.length > 1) {
          answerIs = "answers are from"
        }
        output.push(<div className='judgementSummaries'>
                      {sortedJudgements.map(x => <div className='judgeSummary'>{toButton(x.judge, false)}<div className='judgeSummaryContent'>{x.summary}</div><div className='judgeDeleteButton'><DeleteButton icon={Cross} trash={() => trashJudge(x.judge)}/></div></div>)}
                    </div>)
        const textContent = [`The best ${answerIs} `,ws, ` with ${avgRating} ${Math.round(rating * 10)/10}/10.`]
        const text = <div className='judgeWinnerMsgText'>{textContent}</div>
        const div = <div className='judgeWinnerMsg'>
                      <div className='judgesLine'>
                        {sortedJudgements.map(x => toButton(x.judge, true,  async () => selectJudge(x.judge)))}
                      </div>
                       {text}
                      <div className='judgeLosers'>
                        {ls}
                      </div>
                    </div>
        output.push(div)
      }
    }
    const aiSaid = this.renderAISaid(inReplyTo, message, null, {
      ...opts,
      isLast,
      isJudge,
      participants,
      isCompacted
    })
    output.push(aiSaid)
    return output
  }

  progressMessage = {}


  isTextMessage = (message, withReactions) => {
    return true
  }

  deleteChatMessage = messageId => {
    ////////////////debugger
    if (this.props.deleteChatMessage) {
      this.props.deleteChatMessage(this, messageId)
    } else {
      this.props.me.deleteChatMessage(messageId)
    }
    delete this.received[messageId] // hack, because we aren't listening to old messages
    for (const id in this.received) {
      const reply = this.received[id]
      if (reply.inReplyTo === messageId) {
        delete this.received[id]
      }
    }
    this.forceUpdate()
  }

  deleteSystemPrompt = async (systemPrompt) => {
    await this.props.deleteSystemPrompt(this, this.state.selectedTask, systemPrompt)
  }

  renderSystemPromptView = (onSelect) => {
    const back = () => {
      this.setState({
        subpage: null
      }, () => {
        this.messages1.scrollToTop()
      })
    }
    const select = async systemPrompt => {
      await this.props.selectSystemPrompt(this, this.state.selectedTask, systemPrompt)
      back()
      onSelect(systemPrompt)
    }
    const onCreate = comp => {
      if (this.state.selectedTask.systemPrompt) {
        comp.openToolset(this.state.selectedTask.systemPrompt)
      }
    }
    const title = "System Prompts"
    const breadcrumbs = this.props.breadcrumbs.concat([{
      title, back
    }])
    return <div className='chatGptSystemPromptView'>
             {this.props.openFileSystem({
               onCreate,
               copy: this.props.copySystemPrompt,
               cut: this.props.cutSystemPrompt,
               title,
               choose: select,
               files: this.props.systemPrompts,
               fileSystem: this.props.systemPromptFileSystem,
               renderFile: this.props.renderSystemPrompt,
               breadcrumbs,
               back,
             })
             }
           </div>
  }

  openSystemPrompt = (onSelect) => {
    this.setState({
      subpage: () => this.renderSystemPromptView(onSelect)
    })
  }

  selectMessageAsync = async message => {
    return new Promise(resolve => this.selectMessage(message, resolve))
  }

  selectMessage = (selectedMessage, then, noScroll) => {
    if (this.selectMessageBusy) return
    const previousMessage = this.state.selectedMessage
    if (previousMessage) {
      this.invalidateCache(previousMessage)
    }
    if (selectedMessage) {
      this.invalidateCache(selectedMessage)
    }
    if (true || this.state.selectedMessage !== selectedMessage) {
      this.setState({
        selectedMessage
      }, () => {
        if (!noScroll && selectedMessage && selectedMessage.id === this.state.selectedMessage.id && this.messages1) {
          this.messages1.scrollToItem(selectedMessage, { block: 'center'}, then)
        } else if (then) {
          then()
        }
      })
    } else {
      if (then) then()
    }
  }

  renderMessages = (rawMessages, opts) => {
    if (rawMessages.length === 0) return []
    this.renderN = 0
    const result = this.renderMessagesImpl(rawMessages, opts)
    const { renderN } = this
    ////console.log("renderMessages", this.invalid, { renderN })
    const edits = Object.values(this.userFileEdits)
    if (false && edits.length) {
      ////debugger
      const message = {
        role: 'user',
        content: "FYI, the user just edited the following files: " + edits.map(x => {
          const comps = x.edit.path.split("/")
          return comps[comps.length-1]
        }).join(', ')
      }
      const rendered = <div className='userFileEditsNotification'>
                         {message.content}
                       </div>
      result.push(rendered)
    }
    return result
  }

  renderMessagesImpl = (rawMessages, {isJudge, participants, compactionState}) => {
    if (!this.state.selectedTask) {
      return []
    }
    //console.log("render messages", rawMessages, { isJudge })
    const mergedBody = {}
    const items = rawMessages
    const stableCompactionState = compactionState || conversationCompactionRenderState(items)
    const { lastCompactionIndex, activeCompactionId, messageIndexById } = stableCompactionState
	    let seenSys = false
    let rendered = items.map((item, i) => {
      const msg = item && item.virtualTranscriptItem ? item.displayMessage : item
      const sourceMessage = item && item.virtualTranscriptItem ? item.sourceMessage : msg
      if (msg.role === 'system') {
        seenSys = true
      }
      const opts = {
        isJudge,
        participants: item && item.virtualTranscriptItem && item.transcriptPosition !== 'first' && item.transcriptPosition !== 'only'
          ? []
          : participants,
        sourceMessage,
        transcriptPosition: item && item.transcriptPosition,
        getTranscriptEntriesForReply: item && item.getTranscriptEntriesForReply,
        registerComponent: item && item.registerComponent,
        hydrateTranscriptArchives: item && item.hydrateTranscriptArchives,
        onSelectReply: item && item.onSelectReply,
        isCompacted: candidate => {
        const compactedMessage = sourceMessage || candidate
        const globalIndex = compactedMessage && messageIndexById && messageIndexById.has(compactedMessage.id)
          ? messageIndexById.get(compactedMessage.id)
          : i
        return Boolean(compactedMessage && lastCompactionIndex >= 0 && globalIndex <= lastCompactionIndex)
      }, isActiveCompactionEntry: entry => {
        return Boolean(activeCompactionId && getCompactionEntryId(entry) === activeCompactionId)
      }}
      const prevItem = i > 0 ? items[i-1] : null
      const nextItem = i + 1 < items.length ? items[i+1] : null
      const prev = prevItem && prevItem.virtualTranscriptItem ? prevItem.sourceMessage : prevItem
      const next = nextItem && nextItem.virtualTranscriptItem ? nextItem.sourceMessage : nextItem
      return this.renderChatMessage(msg, prev, next, mergedBody, opts)
    })
    return rendered.filter(x=>x)
  }

  setSliderContainer = ref => {
    this.sliderContainer = ref
  }

  back = () => {
    this.setState({
      subpage: null,
      popup: null
    })
  }

  shareThread = async (thread, messages) => {
    await this.props.me.shareThread(thread, messages)
  }

  setFileChooser = ref => {
    this.fileChooser = ref
  }

  setCal = cal => {
    this.cal = cal
  }

  render() {
    if (this.props.fullScreen) {
      return this.renderDetail()
    } else {
      return super.render()
    }
  }

  setMessagesView = ref => {
    this.messagesView = ref
  }

  setMessagesViewContentRef = ref => {
    this.messagesViewContentRef = ref
  }

  getSearchIndex = () => {
    if (!this.searchIndex) {
      const messages = this.getMessages()
      this.searchIndex = new InMemorySearch({
        id: 'id',
        fields: ['content', 'models'],
        documents: messages.map(message => {
          return {
            message,
            id: message.id,
            content: message.content,
            models: message.role !== 'assistant' ? '' : getReplies(message).map(reply => {
              return reply.content
            }).join('\n')
          }
        })
      })
    }
    return this.searchIndex
  }

  searchImpl = async q => {
    q = q.trim()
    let searchResults
    if (q && q.length > 1) {
      searchResults = []
      q = q.toLowerCase()
      let lastUser
      const addSearchResult = (role, id, content, model) => {
        if (!content) return
        let index = 0
        const text = content.toLowerCase()
        let i = text.indexOf(q)
        while (i !== -1) {
          const start = i
          const end = i + q.length
          searchResults.push({
            q,
            role,
            id,
            start,
            end,
            uid: lastUser.id,
            index
          })
          index++
          i = text.indexOf(q, end)
        }
      }
      for (const message of this.getMessages()) {
        const { id, role, models, content } = message
        if (role === 'user') {
          lastUser = message
        }
        if (role === 'user' || !models) {
          addSearchResult(role, id, content)
        } else if (models) {
          for (const x of models) {
            const { content, addedToTranscript, model } = x
            addSearchResult(role, id, content, model)
          }
        }
      }
    }
    this.setState({
      searchTerm: q,
      searchResults,
    }, this.scrollToFirstSearchResult)
  }

  searchImplOld = async q => {
    if (this.messagesView) {
      this.messagesView.onSearch(q)
    } else {
      const searchResults = []
      if (!this.initialSearchPending) {
        this.filtered = {}
      } else {
        this.filtered = null
      }
      if (q) {
        const searchIndex = this.getSearchIndex()
        const searchResults = (await searchIndex.search(q)).map(result => {
          const { message } = result
          return message
        })
        this.onSearchComplete(q, searchResults.map(x => {
          return { user: x }
        }))
      } else {
        this.onSearchComplete('', [])
        this.selectMessage(this.state.selectedMessage)
      }
    }
  }

  renderHeader() {
    if (!this.props.messagesView) {
      const onSearch = this.searchImpl
      const onSearchUp = this.onSearchUp
      const onSearchDown = this.onSearchDown
      let n = undefined
      let of = undefined
      if (this.state.searchTerm && this.state.searchResults) {
        of = this.state.searchResults.length
        n = this.searchResultIndex + 1
      }
      return <SearchField onCreate={this.setSearchField}
                          up={onSearchUp}
                          down={onSearchDown}
                          of={of}
                          n={n}
                          onSearch={onSearch}
                          placeholder="Search"/>
    }
  }


  transcriptSubject = new Subject()
  transcriptTimestamp = 0
  transcriptEntryHydrations = new Map()
  transcriptArchiveEntries = new Map()

  hydrateTranscriptArchiveEntries = async message => {
    if (!message || !this.props.me.downloadAddedToTranscriptArchive) return false
    return await hydrateTranscriptArchives(message, {
      cache: this.transcriptArchiveEntries,
      load: (messageId, archive) => this.props.me.downloadAddedToTranscriptArchive(messageId, archive),
      loadCollection: (messageId, pointer) => this.props.me.downloadReplyTranscriptCollection(messageId, pointer)
    })
  }

  hydrateConversationCompactionRecords = async () => {
    if (this.hydratingConversationCompactionRecords) {
      return await this.hydratingConversationCompactionRecords
    }
    this.hydratingConversationCompactionRecords = (async () => {
      let changed = false
      for (const message of this.getMessages()) {
        if (hasTranscriptArchives(message)) {
          changed = await this.hydrateTranscriptArchiveEntries(message) || changed
        }
        for (const entry of getMessageCompactionEntries(message)) {
          const storedMessage = entry && entry.message
          if (!storedMessage || !storedMessage.storage || !storedMessage.contentLength) continue
          if (String(storedMessage.content || '').length === Number(storedMessage.contentLength)) continue
          try {
            await this.hydrateCanvasToolResult(storedMessage)
            delete storedMessage.storageHydrationError
          } catch (err) {
            storedMessage.storageHydrationError = err && err.message || 'Stored compaction content could not be loaded'
          }
          changed = true
        }
      }
      if (changed) {
        this.invalidateCache()
        this.forceUpdate()
      }
      return changed
    })()
    try {
      return await this.hydratingConversationCompactionRecords
    } finally {
      this.hydratingConversationCompactionRecords = null
    }
  }

  hydrateCanvasToolResult = async message => {
    if (!message || !message.storage || !message.contentLength) return message
    if (String(message.content || '').length >= Number(message.contentLength)) return message
    const key = [
      message.storage,
      message.contentLength,
      message.lastUpdated || message.updatedAt || message.ts || ''
    ].join(':')
    let loading = this.transcriptEntryHydrations.get(key)
    if (!loading) {
      loading = this.props.me.downloadAssistantContent('', 'transcript', message.storage).then(content => {
        if (typeof content !== 'string') throw new Error('Stored tool result did not contain text')
        return content
      })
      this.transcriptEntryHydrations.set(key, loading)
      loading.catch(() => this.transcriptEntryHydrations.delete(key))
    }
    message.content = await loading
    return message
  }

  getCurrentTranscript = (rawMessages) => {
    if (rawMessages === undefined) {
      rawMessages = this.getMessages()
    }
    if (false && this.state.timelineFilter !== undefined) {
      let index = rawMessages.findIndex(x => x.ts > this.state.timelineFilter)
      if (index > 0) {
        index = Math.max(index - 1, Math.min(rawMessages.length, 1))
        let message = rawMessages[index]
        if (message.role === 'user') {
          index++
        }
        rawMessages = rawMessages.slice(0, index+1)
      }
    }
    return rawMessages
  }

  buildRawMessagesState = (messages = this.getCurrentTranscript(this.getMessages())) => {
    return [{ id: 'system', role: 'system', content: 'placeholder' }, ...messages]
  }

  observeTranscript = () => {
    const rawMessages = this.getCurrentTranscript()
    return concat(from(rawMessages.flatMap(this.decomposeAddedTranscript)), this.transcriptSubject)
  }

  resetTranscriptLater = () => {
    clearTimeout(this.resetTranscriptTimeout)
    setTimeout(this.resetTranscript, 200)
  }

  resetTranscript = () => {
    if (this.canvasEditor) {
      this.transcriptTimestamp = 0
      this.canvasEditor.reset()
      const rawMessages = this.getCurrentTranscript()
      for (const message of rawMessages) {
        const { id, role, ts  } = message
        const replies = getReplies(message)
        for (const reply of replies) {
          const { addedToTranscript, model } = reply
          if (addedToTranscript) {
            for (const entry of addedToTranscript) {
              if (entry && entry.message) this.sendToTranscript(entry.message)
            }
          }
        }
      }
    }
  }

  showCanvas = { containsFiles: false, containsBrowser: false }
  shouldShowCanvas = () => {
    const showCanvas = this.showCanvas
    return showCanvas
  }

  getConversationBrowserTask = () => {
    return this.state.selectedTask || this.props.task
  }

  shouldShowConversationBrowser = () => {
    //if (!this.props.showConversationBrowser) return false
    const task = this.getConversationBrowserTask()
    return !!(task && task.id && this.props.me)
  }

  setConversationIndexBrowser = browser => {
    this.conversationIndexBrowser = browser
  }

  openConversationLink = (link, node = {}) => {
    if (!link) return
    this.setState({ mobileChatView: 'conversation' }, () => {
      if (this.conversationIndexBrowser) {
        this.conversationIndexBrowser.openExternalLink(link, node)
      }
      this.updateUIElementsLater()
    })
  }

  renderConversationLeafWithChat = node => {
    const indexedContent = String(node && node.content || '')
    const indexedMessage = JSON_parse(indexedContent)
    const toolCallId = node && node.tool_call_id || indexedMessage && indexedMessage.tool_call_id
    const role = node && node.role || indexedMessage && indexedMessage.role
    const indexedFragments = []
    const collectStrings = value => {
      if (typeof value === 'string') {
        if (value.length >= 8) indexedFragments.push(value)
        return
      }
      if (Array.isArray(value)) {
        value.forEach(collectStrings)
        return
      }
      if (value && typeof value === 'object') {
        Object.values(value).forEach(collectStrings)
      }
    }
    collectStrings(indexedMessage)
    if (indexedContent.length >= 8) indexedFragments.push(indexedContent)
    const holders = []
    const directHolder = node && node.message_id && this.received[node.message_id]
    if (directHolder) holders.push(directHolder)
    for (const holder of this.getMessages()) {
      if (holder && holder !== directHolder && holder.role === 'assistant') holders.push(holder)
    }

    for (const holder of holders) {
      if (!holder || holder.role !== 'assistant') continue
      for (const reply of getReplies(holder)) {
        const units = assistantTranscriptRenderUnits(reply)
        const matchedToolResultUnit = toolCallId && toolResultRenderUnit(reply, toolCallId, indexedContent)
        const unit = matchedToolResultUnit || units.find(entries => (entries || []).some(entry => {
          const message = entry && entry.message
          if (!message) return false
          if (toolCallId && message.tool_call_id === toolCallId) return true
          if (role && message.role !== role) return false
          if (typeof message.content !== 'string') return false
          return indexedFragments.some(fragment =>
            message.content.startsWith(fragment) ||
            fragment.startsWith(message.content) ||
            (fragment.length >= 24 && message.content.includes(fragment))
          )
        }))
        if (!unit) continue
        const id = `${holder.id}::conversation-leaf::${node.handle ?? node.start_event_cursor ?? toolCallId ?? 'source'}`
        const displayMessage = this.makeTranscriptDisplayMessage(holder, id, [reply])
        return this.renderChatMessage(displayMessage, null, null, {}, {
          isJudge: false,
          participants: [],
          sourceMessage: holder,
          transcriptPosition: 'only',
          getTranscriptEntriesForReply: () => unit,
          registerComponent: false,
          hydrateTranscriptArchives: false,
          onSelectReply: null,
          isCompacted: () => false,
          isActiveCompactionEntry: () => false
        })
      }
    }
    return null
  }

  renderConversationBrowser = () => {
    const task = this.getConversationBrowserTask()
    if (!task) return null
    return <ConversationIndexBrowser
             key={task.id}
             ref={this.setConversationIndexBrowser}
             me={this.props.me}
             task={task}
             components={this.components}
             renderLeaf={this.renderConversationLeafWithChat}
             getMessages={this.getMessages}
             getMessageById={id => this.received[id]}
             getSummaryRecords={compacted => this.getConversationSummaryRecords(compacted, task)}
             getSummaryRecordsState={compacted => this.getConversationSummaryRecordsState(compacted, task)}
             loadSummaryRecords={compacted => this.loadConversationSummaryRecords(compacted, task)}
             invalidateSummaryRecords={() => {
               this.conversationSummaryRecordsByStoragePath = {}
               this.conversationSummaryRecordsLoading = {}
               this.invalidateCache()
               this.forceUpdate()
             }}
             hydrateCompactionRecords={this.hydrateConversationCompactionRecords}/>
  }

  getCanvasActiveView = ({containsFiles, containsBrowser, containsConversation, includeChat}) => {
    const hasBrowser = containsBrowser || !!this.lastBrowserStreamURL
    const requested = this.state.mobileChatView
    const requestedValid =
      (includeChat && requested === 'chat') ||
      (requested === 'files' && containsFiles) ||
      (requested === 'conversation' && containsConversation) ||
      (requested === 'browser' && hasBrowser)
    if (requestedValid) return requested
    if (includeChat) return 'chat'
    if (containsFiles) return 'files'
    if (containsConversation) return 'conversation'
    if (hasBrowser) return 'browser'
    return 'chat'
  }

  userFileEdits = {}
  onUserEdit = edit => {
    const { type, path, oldContent, content } = edit
    if (!path) {
      ////debugger
      return
    }
    if (type === 'user-change') {
      const existing = this.userFileEdits[path]
      if (!existing) {
        this.userFileEdits[path] = {
          edit,
          orig: edit.oldContent
        }
      } else {
        if (edit.content === existing.orig) {
          delete this.userFileEdits[path]
          this.forceUpdateLater()
          return
        } else
          existing.edit = edit
      }
      this.saveUserFileEditLater(edit)
    }
    this.forceUpdateLater()
  }

  debounceTimers = {}
  saveUserFileEditLater = edit => {
    clearTimeout(this.debounceTimers[edit.path])
    this.debounceTimers[edit.path] = setTimeout(() => this.saveUserFileEditNow(edit), 1000)
  }

  saveUserFileEditNow = async edit => {
    clearTimeout(this.debounceTimers[edit.path])
    const {path, content} = edit
    const hostId = this.desktopFilesHost
    const conversationId = this.props.task.id
    const result = await this.props.me.setFileContent({hostId, conversationId, path, content})
    this.userFileEdits[edit.path].saved = true
  }

  setDesktopMainChatSlot = ref => {
    if (this.desktopMainChatSlot !== ref) {
      this.desktopMainChatSlot = ref
      this.forceUpdateLater()
    }
  }

  setDesktopSidebarChatSlot = ref => {
    if (this.desktopSidebarChatSlot !== ref) {
      this.desktopSidebarChatSlot = ref
      this.forceUpdateLater()
    }
  }

  getChatScrollContentRef = () => {
    return this.messages1 && this.messages1.getContentRef
      ? this.messages1.getContentRef()
      : null
  }

  captureDesktopChatScroll = () => {
    const ref = this.getChatScrollContentRef()
    if (!ref) return null
    const maxScrollTop = Math.max(0, ref.scrollHeight - ref.clientHeight)
    const scrollTop = ref.scrollTop
    const scrollBottom = Math.max(0, maxScrollTop - scrollTop)
    const isBottomLocked = this.messages1 && this.messages1.isBottomLocked
      ? this.messages1.isBottomLocked()
      : this.state.isBottomLock
    return {
      scrollTop,
      scrollBottom,
      wasAtBottom: scrollBottom <= 2,
      isBottomLocked
    }
  }

  restoreDesktopChatScroll = snapshot => {
    if (!snapshot) return
    const ref = this.getChatScrollContentRef()
    if (!ref) return
    const maxScrollTop = Math.max(0, ref.scrollHeight - ref.clientHeight)
    const nextScrollTop = Math.max(0, Math.min(maxScrollTop, snapshot.scrollTop))
    if (this.messages1 && this.messages1.setScrollTop) {
      this.messages1.setScrollTop(nextScrollTop)
    } else {
      ref.scrollTop = nextScrollTop
    }
  }

  renderDesktopChatPortal = activeView => {
    if (!isDesktop()) return null
    const target = activeView === 'chat' ? this.desktopMainChatSlot : this.desktopSidebarChatSlot
    return <MovablePortal key='desktop-chat-portal'
                          target={target}
                          beforeMove={this.captureDesktopChatScroll}
                          afterMove={this.restoreDesktopChatScroll}>
             {this.renderChat()}
           </MovablePortal>
  }

  renderDetail() {
    if (isDesktop()) {
      const {containsFiles, containsBrowser } = this.shouldShowCanvas()
      const containsConversation = this.shouldShowConversationBrowser()
      const hasBrowser = containsBrowser || !!this.lastBrowserStreamURL
      const chatMount = this.props.fullScreen
        ? this.renderChat()
        : <div className='chatPortalSlot' ref={this.setDesktopMainChatSlot}/>
      if (containsFiles || hasBrowser || containsConversation) {
        let className = 'desktopChatCanvas'
        const chat = async () => {
          this.setState({
            mobileChatView: 'chat'
          }, this.updateUIElementsLater)
        }
        const files = async () => {
          this.setState({
            mobileChatView: 'files'
          }, this.updateUIElementsLater)
        }
        const conversation = async () => {
          this.setState({
            mobileChatView: 'conversation'
          }, this.updateUIElementsLater)
        }
        const browser = async () => {
          this.setState({
            mobileChatView: 'browser'
          }, this.updateUIElementsLater)
        }
        const none = {display: 'none'}
        const activeView = this.getCanvasActiveView({containsFiles, containsBrowser: hasBrowser, containsConversation, includeChat: true})
        const chatStyle = activeView === 'chat' ? null : none
        const filesStyle = activeView === 'files' && containsFiles ? null : none
        const conversationStyle = activeView === 'conversation' && containsConversation ? null : none
        const browserStyle = activeView === 'browser' && hasBrowser ? null : none
        return <div className={className}>
                 <div className='mobileChatCanvasButtons'>
                   <SimpleButton icon={Chat} action={chat} label="Chat"/>
                   {containsFiles && <SimpleButton icon={File} action={files} label="Files"/>}
                   {containsConversation && <SimpleButton icon={Chat} action={conversation} label="Conversation"/>}
                   {hasBrowser && <SimpleButton icon={File} action={browser} label="Browser"/>}
                 </div>
	                 <div className='chatView' style={chatStyle}>
	                   {chatMount}
	                 </div>
                 <div className='filesView' style={filesStyle}>
                   {containsFiles && <CanvasComponent key='canvas'
                                                       onCreate={this.setCanvasEditor}
                                                       onFileAvailable={this.onFileAvailable}
                                                       onUserEdit={this.onUserEdit}
                                                       desktopFiles={this.desktopFiles}
                                                       transcript={this.observeTranscript()}
                                                       hydrateToolResult={this.hydrateCanvasToolResult}
                                                       getFileContents={this.getFileContents}/>}
                   </div>
                   <div className='conversationView' style={conversationStyle}>
                     {this.renderConversationBrowser()}
                   </div>
                   <div className='browserView' style={browserStyle}>
                     {this.lastBrowserStreamURL && <AgentBrowserScreencast wsUrl={this.lastBrowserStreamURL}/>}
                   </div>
                 </div>
      }
      let header
      if (this.props.renderDetailHeader) {
        header = this.props.renderDetailHeader()
      }
      let className = 'chatGPTDetail'
      if (this.isReadOnly()) {
        className += ' chatGPTReadOnly'
      }
	      return <div className={className}>
	               <div className='chatGPTDetailHeader'>
	                 {header}
	               </div>
	               <div className='chatGPTDetailBody'>
	                 {chatMount}
	               </div>
	             </div>
    }
  }

  setCanvasEditor = e => {
    this.canvasEditor = e
  }

  onFileAvailable = file => {
  }

  onSearchComplete = (query, searchResults) => {
    this.searchTerm = query
    clearTimeout(this.searchCompleteTimeout)
    setTimeout(() => this.onSearchCompleteImpl(query, searchResults), 100)
  }

  searchChat = searchTerm => {
    const searchResults = []
    const t = searchTerm.toLowerCase()
    for (const message of this.getMessages()) {
      const { content, models } = message
      if (content) {
        if (content.toLowerCase().includes(t)) {
          searchResults.push({message})
        } else {
          if (models) {
            for (const model of models) {
              const { addedToTranscript, content } = model
              if (content) {
                if (content.toLowerCase().includes(t)) {
                  searchResults.push({
                    message, model
                  })
                }
              }
              if (addedToTranscript) {
                const { content, args } = addedToTranscript
                if (content && content.toLowerCase().includes(t)) {
                  searchResults.push({
                    message, model
                  })
                }
              }
            }
          }
        }
      }
    }
  }

  applyHighlight = () => {
    if (true) return
    clearTimeout(this.highlightTimer)
    this.highlightTimer = setTimeout(() => {
      if (this.clearHighlight) this.clearHighlight()
      if (this.state.searchTerm && this.state.searchTerm.length > 1) {
        this.clearHighlight = clearHighlight
        const roots = [{target: this, root: this.chatContentRef, attribute: 'data-message-id'}]
        if (this.messagesViewContentRef) {
          //roots.push({target: this.messageView, root: this.messagesViewContentRef, attribute: 'data-message-view-id'})
        }
        highlightIn(roots, this.state.searchTerm, false)
      } else {
        this.clearHighlight = null
      }
    })
  }

  searchResultIndex = -1

  onSearchUp = () => {
    if (!this.state.searchResults) return
    if (this.state.searchResults.length > 0) {
      this.searchResultIndex--
      if (this.searchResultIndex < 0) {
        this.searchResultIndex = this.state.searchResults.length - 1
      }
    }
    this.scrollToSearchResult(this.state.searchResults[this.searchResultIndex])
  }

  onSearchDown = () => {
    if (!this.state.searchResults) return
    ////debugger
    if (this.state.searchResults.length > 0) {
      this.searchResultIndex++
      if (this.searchResultIndex >= this.state.searchResults.length) {
        this.searchResultIndex = 0
      }
    }
    this.scrollToSearchResult(this.state.searchResults[this.searchResultIndex])
  }


  scrollToFirstSearchResult = async () => {
    clearHighlight()
    if (this.state.searchResults &&
        this.state.searchResults.length > 0) {
      this.searchResultIndex = 0
      this.scrollToSearchResult(this.state.searchResults[0])
    }
  }

  scrollToSearchResult = async (result) => {
    if (!result) return
    const { role, start, end, id, q, uid, index } = result
    const getSelector = (attribute='data-message-id') => {
      return '['+attribute+'="'+id+'"]'
    }
    const selector = getSelector()
    const ref = this.messages1.getContentRef()
    let n = ref.querySelector(selector)
    if (!n) {
      await this.selectMessageAsync({id: uid})
      n = ref.querySelector(selector)
    }
    highlightIn([{container: ref, root: n, attribute: 'data-message-id'}], q, id, index)
    this.forceUpdate()
  }

  onSearchCompleteImpl = (query, searchResults) => {
    if (true) return
    let first
    if (searchResults) {
      if (query) {
        this.filtered = {}
        for (const {message, user, assistant} of searchResults) {
          if (!first) {
            first = user
          }
          this.filtered[user.id] = true
          if (assistant) {
            this.filtered[assistant.id] = true
          }
        }
      } else {
        this.filtered = null
      }
    } else {
      this.filtered = query ? {} : null
    }
    this.filtered = null // no filtering for now
    this.searchResultIndex = searchResults && searchResults.length > 0 ? 0 : -1
    this.setState({
      searchTerm: query,
    }, () => {
      if (first) {
        this.applyHighlight()
      } else {
        this.state.selectedMessage = null
        scrollToFirstHighlight()
        this.forceUpdate()
      }
    })
  }

  onTimelineChanged = () => {
    clearTimeout(this.timelineChangedTimeout)
    this.timelineChangedTimeout = setTimeout(() => {
      this.updateUIElements(this.gotoBottom)
    }, 200)
  }

  key = chatGptId++

  renderContent() {
    const { containsFiles, containsBrowser } = this.shouldShowCanvas()
    const containsConversation = this.shouldShowConversationBrowser()
    const hasBrowser = containsBrowser || !!this.lastBrowserStreamURL
    const messages = this.getMessages()
    const timeline = <Timeline messages={messages.filter(x => x.role !== 'system')} onChange={(ts, msg) => {
                                 this.setState({timelineFilter: ts}, this.onTimelineChanged)
                               }}/>
    const hasDesktopCanvas = containsFiles || hasBrowser || containsConversation
    const desktopActiveView = isDesktop()
      ? (hasDesktopCanvas
          ? this.getCanvasActiveView({containsFiles, containsBrowser: hasBrowser, containsConversation, includeChat: true})
          : 'chat')
      : null
    const desktopChatPortal = isDesktop() ? this.renderDesktopChatPortal(desktopActiveView) : null
    const renderDesktopMessagesView = () => {
      if (this.props.messagesView) return <>
        {desktopChatPortal}
        {this.props.messagesView}
      </>
      const select = async x => {
        await this.selectMessageAsync(x.user)
      }
      const messagesView = <MessagesView
                             ref={this.setMessagesView}
                             setContentRef={this.setMessagesViewContentRef}
                             onSearchComplete={this.onSearchComplete}
                             observeChanges={() => this.messagesSubject}
                             selectedMessage={this.state.selectedMessage}
                             select={select}
                             resolveModel={this.resolveModel}
                             messages={this.getCurrentTranscript()}
                             me={this.props.me}
	                             />
      return <>
        {desktopChatPortal}
        <div className='desktopContentView'>
          {timeline}
          {messagesView}
        </div>
      </>
    }
    const renderDesktopSidebarChat = () => {
      return <>
        {desktopChatPortal}
        <div className='chatWithTimeline'>
          {timeline}
          <div className='chatPortalSlot' ref={this.setDesktopSidebarChatSlot}/>
        </div>
      </>
    }
    if (isDesktop() && !hasDesktopCanvas) {
      return renderDesktopMessagesView()
    }
    if (isDesktop() && hasDesktopCanvas) {
      if (desktopActiveView === 'chat') {
        return renderDesktopMessagesView()
      }
      return renderDesktopSidebarChat()
    }
    if (!isDesktop()) {
      if (containsFiles || hasBrowser || containsConversation) {
        const chat = async () => {
          this.setState({
            mobileChatView: 'chat'
          })
        }
        const files = async () => {
          this.setState({
            mobileChatView: 'files'
          })
        }
        const conversation = async () => {
          this.setState({
            mobileChatView: 'conversation'
          })
        }
        const browser = async () => {
          this.setState({
            mobileChatView: 'browser'
          })
        }
        const none = {display: 'none'}
        const activeView = this.getCanvasActiveView({containsFiles, containsBrowser: hasBrowser, containsConversation, includeChat: true})
        const chatStyle = activeView === 'chat' ? null : none
        const filesStyle = activeView === 'files' && containsFiles ? null : none
        const conversationStyle = activeView === 'conversation' && containsConversation ? null : none
        const browserStyle = activeView === 'browser' && hasBrowser ? null : none
        let className = 'mobileChatCanvas'
        if (this.isReadOnly()) {
          className += ' chatGPTReadOnly'
        }
        return <div className={className}>
            <div className='mobileChatCanvasButtons'>
              <SimpleButton icon={Chat} action={chat} label="Chat"/>
              {containsFiles && <SimpleButton icon={File} action={files} label="Files"/>}
              {containsConversation && <SimpleButton icon={Chat} action={conversation} label="Conversation"/>}
              {hasBrowser && <SimpleButton icon={File} action={browser} label="Browser"/>}
            </div>
                 <div className='chatWithTimeline'>
                   {timeline}
                   <div className='chatView' style={chatStyle}>
                     {this.renderChat()}
                   </div>
                 </div>
            <div className='filesView' style={filesStyle}>
              {containsFiles && <CanvasComponent key='canvas'
                                                  onUserEdit={this.onUserEdit}
                                                  files={this.desktopFiles}
                                                  transcript={this.observeTranscript()}
                                                  hydrateToolResult={this.hydrateCanvasToolResult}
                                                  getFileContents={this.getFileContents}/>}
                 </div>
                 <div className='conversationView' style={conversationStyle}>
                   {this.renderConversationBrowser()}
                 </div>
                 <div className='browserView' style={browserStyle}>
                   {this.lastBrowserStreamURL && <AgentBrowserScreencast wsUrl={this.lastBrowserStreamURL}/>}
                 </div>
               </div>
      }
    }
    return <div className='chatWithTimeline'>
             {timeline}
             {this.renderChat()}
           </div>
  }


  onJudgeSwiper = swiper => {
    this.judgeSwiper = swiper
  }

  onJudgeSwipeTransitionStart = event => {
    ////////////////debugger
    if (this.judgeSwiper.activeIndex === 1) {
      this.setState({
        judgeSelected: true
      })
    }
  }

  onJudgeSwipeTransitionEnd = event => {
    if (this.judgeSwiper.activeIndex === 0) {
      this.setState({
        swipeMessage: null,
        judgeSelected: false
      })
    }
  }

   onSelectJudge = event => {
     this.setState({
       judgeChat: this.judgeSwiper.activeIndex === 1
     }, () => {
       ////////console.log("judgeChat", this.state.judgeChat)
     })

  }

  setJudgeView = (view)  => {
    if (view !== this.judgeView) {
      this.judgeView = view
      this.updateUIElementsLater()
    }
  }

  setModelsView = (view)  => {
    if (view !== this.modelsView) {
      this.modelsView = view
      if (view && view.state) this.setModelSelectionOptions(view.state.options)
      this.updateUIElementsLater()
    }
  }

  setModelSelectionOptions = options => {
    if (!options) return
    const currentTs = Number(this.modelSelectionOptions && this.modelSelectionOptions.ts || 0)
    const nextTs = Number(options.ts || 0)
    if (!this.modelSelectionOptions || nextTs >= currentTs) {
      this.modelSelectionOptions = options
    }
  }

  modelAdd = async () => {
    const onOptionsChanged = options => {
      this.setModelSelectionOptions(options)
    }
    let savedOptions
    const saveOptions = options => {
      savedOptions = options
      this.setModelSelectionOptions(options)
      this.forceUpdate()
    }
    const back = () => {
      this.back()
      const onBack = () => {
        this.setState({
          modelSelectionInProgress: false
        })
        this.updateUIElementsLater()
      }
      if (savedOptions) {
        this.props.me.saveModelOptions(savedOptions).then(onBack)
      } else {
        onBack()
      }
    }

    const getOpenSubpage = (f) => {
      if (this.props.getOpenSubpage) {
        return this.props.getOpenSubpage(f)
      }
      this.setState({
        subpage: () => {
          const { breadcrumbs} = this.props
          return f({back, breadcrumbs})
        }
      })
    }

    getOpenSubpage(({back, breadcrumbs}) => {
      let title="Model Selection"
      return <ModelsView
               back={back}
               title={title}
               done={back}
               breadcrumbs={
                 breadcrumbs.concat({
                   title,
                   back
                 })
               }
               topLevel={true}
               menuActive={true}
               key={'models-subpage'}
               fineTunedModel={(this.props.fineTunedModel || {}).id}
               onOptionsChanged={onOptionsChanged}
               me={this.props.me}
               category={'models'}
               prices={this.props.price}
               models={(isSelected, select) => this.props.models(this, isSelected, select)}
               vendors={this.props.vendors}
               openAICodexOAuth={this.props.openAICodexOAuth}
               hosts={this.props.hosts}
               getModelRouteIndicator={this.getModelRouteIndicator}
               observeOptions={this.props.me.observeModelOptions}
               configure={this.props.configure}
               saveOptions={saveOptions}/>
    })
  }

  updateSelectedChatModel = (rawMessages) => {
    if (rawMessages.length === 0) return
    if (this.state.replay) return
    const { activeModels, isStreaming }  = this.getActiveModels(rawMessages)
    if (isStreaming) {
      //return
    }
    let newSelection
    const selectedModels = this.getSelectedModelIds()
    const Selected = {}
    selectedModels.forEach(x => Selected[x] = true)
    activeModels.sort(sortModels)
    //////debugger
    if (this.props.fineTunedModel) {
      newSelection = this.props.fineTunedModel
    } else {
      const currentSelection = this.state.selectedModelIndex
      newSelection = activeModels.find(active => active && Selected[active.id] && (
        active.id === currentSelection ||
        active.isModel && active.isModel(currentSelection)
      ))
      for (const active of activeModels) {
        if (newSelection) break
        if (active && Selected[active.id])  {
          newSelection = active
          break
        }
      }
    }
    if (!newSelection && activeModels.length > 0) {
      newSelection = activeModels[0]
    }
    if (!newSelection) {
      const models = selectedModels.map(x => this.resolveModel(x))
      models.sort(sortModels)
      newSelection = models[0]
    }
    if (newSelection) {
      this.updateSelectedModelIndexLater(newSelection, false)
      return true
    }
    return false
  }

  updateSelectedModelIndexLater = (newSelection, animate) => {
    clearTimeout(this.modelIndexUpdater)
    this.modelIndexUpdater = setTimeout(() => {
      this.selectModelIndex(newSelection, 0)
      //setTimeout(this.messages1.scrollToBottomMessage, 400);
    }, 0)
  }

  updateUIElements = (then) => {
    clearTimeout(this.uiElementTimeout)
    if (!this.modelsView) {
      return
    }
    let input = 0
    let output = 0
    const all = {}
    let participants = []
    const selectedModelIds = this.getSelectedModelIds()
    const selectedModelCount = selectedModelIds.length
    const selectedIconByVendor = {}
    const vendorActive = {}
    const seen = {}
    let rawMessages = this.getMessages()
    this.showCanvas = this.checkMessageForFiles(rawMessages)
    rawMessages = this.getCurrentTranscript(rawMessages)
    const getAllModels = () => {
      const allModels = this.getModels()
      //////////console.log({allModels})
      for (const model of allModels) {
        if(model.id) {
          all[model.id] = model
        } else {
          //////////////////debugger
        }
      }
      const result = []
      const add = model => {
        if (model) {
          if (!seen[model]) {
            result.push(all[model])
            seen[model] = true
          }
        } else {
        }
      }
      for (const message of rawMessages) {
        if (message.role === 'assistant') {
          if (message.content) {
            add('attunewise')
          }
          if (true) {
            for (const reply of getReplies(message)) {
              add(reply.model)
            }
            if (message.judgement) {
              const { judge, judgements } = message.judgement
              if (judge) {
                add(judge)
              } else if (judgements) {
                for (const j of judgements) {
                  const { judge, ratings } = j
                  add(judge)
                }
              }
            }
          }
        }
      }
      return result
    }
    const models = getAllModels()
    ////////console.log({allModels: models})
    const modelsById = {}
    const vendorByName = {}
    for (const vendor of this.props.vendors) {
      vendorByName[vendor.name] = vendor
    }
    for (const model of models) {
      if (!model) {
        //////////////////debugger
        continue
      }
      modelsById[model.id]  = model
    }
    const calcPrices = (modelSrc, judgeSrc, rawMessages) => {
      //////console.log('calcPrices', rawMessages.length)
      const selectedIcons = []
      const selectedJudgeIcons = []
      const usage = {}
      const inTokens = {attunewise: 0}
      const outTokens = {attunewise: 0}
      const cachedTokens = {attunewise: 0}
      const cacheWriteTokens = {attunewise: 0}
      const inDollars = {}
      const outDollars = {}
      let i = 0
      let i$ = 0
      let o$ = 0
      let ji$ = 0
      let jo$ = 0
      let seenModel = {}
      let seenJudge = {}
      for (const model of modelSrc.getSelectedModelsListFiltered()) {
        let m = seenModel[model.id]
        if (!m) {
          let menu
          if (this.props.fineTunedModel) {
            if (model.id === this.props.fineTunedModel.id) {
              const actions = []
              const models = this.getModels()
              let className = 'baseModelMenu'
              const active = modelsById[model.id]
              if (active) className += ' baseModelMenuActive'
              let x = models.find(y => y.id === model.baseModelId)
              ////////////////debugger
              while (x) {
                const apply = (x) => {
                  const icon = (x.getModelIcon && x.getModelIcon()) || x.getIcon()
                  const action = async (close) => {
                    ////////////////debugger
                    modelSrc.selectModel(x.id)
                    close()
                  }
                  actions.push({ button: close => <SimpleButton key={x.id} icon={icon} label={<ModelLabel model={x}/>} action={() => action(close)} />})
                }
                apply(x)
                if (!x.baseModelId) {
                  break
                }
                x = models.find(y => y.id === x.baseModelId)
              }
              if (actions.length > 0) {
                menu = <ActionMenu className={className} actions={actions} position = 'bottom right'/>
              }
            }
          }
          seenModel[model.id] = m = { model, selected: true, active: false, menu}
          selectedIcons.push(m)
        } else {
          m.selected = true
        }
      }
      if (this.state.judgeSelected && judgeSrc) for (const model of judgeSrc.getSelectedModelsListFiltered()) {
        let m = seenJudge[model.id]
        if (!m) {
          seenJudge[model.id] = m = { model, selected: true, active: false }
          selectedJudgeIcons.push(m)
        } else {
          m.selected = true
        }
      }
      for (const message of rawMessages) {
        let { role, content, usage, judgement } = message
        const models = getReplies(message)
        content = content || ''
        if (judgement) {
          const { judgements } = judgement
          for (const j of judgements) {
            const { judge } = j
            if (j.usage) for (const model in j.usage) {
              const usage = j.usage[model]
              if (usage && usage.inputTokens) {
                if (!inTokens[model]) {
                  inTokens[model] = 0
                }
                if (!outTokens[model]) {
                  outTokens[model] = 0
                }
                if (!cachedTokens[model]) {
                  cachedTokens[model] = 0
                }
                if (!cacheWriteTokens[model]) {
                  cacheWriteTokens[model] = 0
                }
                inTokens[model] += usage.inputTokens
                outTokens[model] += usage.outputTokens
                let i
                let o
                let inputTokens = usage.inputTokens
                if (usage.cacheReadTokens) {
                  inputTokens -= usage.cacheReadTokens
                  const context = getPricingContext(model, usage.inputTokens, usage.cacheReadTokens)
                  if (!context.price.cached) {
                    ////debugger
                  }
                  i =  (usage.cacheReadTokens / 1000000) * context.price.cached
                  if (usage.cacheWriteTokens) {
                    inputTokens -= usage.cacheWriteTokens
                    if (!context.price.cacheWrite) {
                      ////debugger
                    }
                    i +=  (usage.cacheWriteTokens / 1000000) * context.price.cacheWrite
                  }
                }
                i = (inputTokens / 1000000) * context.input
                o = (usage.outputTokens /1000000) * context.output
                ji$ += i
                jo$ += o
                i$ += i
                o$ += o
              }
            }
            if (!seenJudge[judge]) {
              const m = modelsById[judge]
              if(m) {
                const icon = (m.getModelIcon && m.getModelIcon()) || m.getIcon()
                let m1 = { model: m, active: true }
                seenJudge[m.id] = m1
                selectedJudgeIcons.push(m1)
                } else {
                  console.error("model not found", judge)
                }
            } else {
              seenJudge[judge].active = true
            }
          }
        }
        if (role === 'user') {
        } else {
          if (message.usage) {
            for (const model in message.usage) {
              const usage = message.usage[model]
              let o = 0
              let i = 0
              if (usage) {
                o = usage.outputTokens || 0
                i = usage.inputTokens || 0
              }
              inTokens[model] += i
              outTokens[model] += o
            }
          }
          if (!content) content = ''
          if (!content.trim) {
            //////debugger
          }
          if (content && message.model === 'attunewise') {
            const m = modelsById['attunewise']
            vendorActive[m.vendor] = true
            const icon = (m.getModelIcon && m.getModelIcon()) || m.getIcon()
            selectedIconByVendor[m.vendor] = true
            let m1 = seenModel[m.id]
            if (!m1) {
              seenModel[m.id] = m1 = { model: m, active: true }
              selectedIcons.push(m1)
            } else {
              seenModel[m.id].active = true
            }
          }
          if (models) {
            for (let x of models) {
              const {content, addedToTranscript } = x
              const applyUsage = x => {
                for (const model in x.usage) {
                  const usage = x.usage[model]
                  let o = 0
                  let i1 = 0
                  if (usage && usage.inputTokens) {
                    const pricingModel = resolveUsagePricingModel(model, modelsById)
                    const contextTokens = usageBilling.usageTokenBreakdown(usage).contextInputTokens
                    const context = getPricingContext(pricingModel, contextTokens)
                    if (!context) {
                      console.error("no context")
                      //////debugger
                      continue
                    }
                    const cost = usageCostBreakdown(usage, context)
                    o = cost.outputTokens
                    i1 = cost.inputTokens
                    if (!inTokens[model]) {
                      inTokens[model] = 0
                    }
                    if (!cachedTokens[model]) {
                      cachedTokens[model] = 0
                    }
                    if (!cacheWriteTokens[model]) {
                      cacheWriteTokens[model] = 0
                    }
                    cachedTokens[model] += cost.cacheReadTokens
                    cacheWriteTokens[model] += cost.cacheWriteTokens
                    if (!inDollars[model]) {
                      inDollars[model] = 0
                    }
                    if (!outDollars[model]) {
                      outDollars[model] = 0
                    }
                    inDollars[model] += cost.uncachedInputDollars + cost.cacheReadDollars + cost.cacheWriteDollars
                    outDollars[model] += cost.outputDollars
                  } else {
                    o = 0//countTokens(content)
                    i1 = i
                  }
                  inTokens[model] += i1
                  if (!outTokens[model]) {
                    outTokens[model] = 0
                  }
                  outTokens[model] += o
                }
              }
              const transcriptUsage = (addedToTranscript || []).filter(entry => entry && entry.usage)
              if (transcriptUsage.length > 0) {
                // Per-request usage is the conversation-level source of truth.
                // Archive pointers carry the subtotal for their stored entries.
                for (const entry of transcriptUsage) applyUsage(entry)
              } else if (x.usage && Object.keys(x.usage).length > 0) {
                // Historical replies without per-request records retain an
                // aggregate usage map on the reply itself.
                applyUsage(x)
              }
              const {model} = x
              const modelId = resolveModelId(model)
              const m = modelsById[modelId]
              if (!m) {
                //////////debugger
                console.error("model not found", model)
                continue
              }
              vendorActive[m.vendor] = true
              const icon = (m.getModelIcon && m.getModelIcon()) || m.getIcon()
              selectedIconByVendor[m.vendor] = true
              let m1 = seenModel[m.id]
              if (!m1) {
                seenModel[m.id] = m1 = { model: m, active: true }
                selectedIcons.push(m1)
              } else {
                m1.active = true
              }
            }
          }
        }
      }
      selectedIcons.sort((a, b) => {
        const x = a.model
        const y = b.model
        if (x.id !== y.id) {
          if (x.id === 'train') return -1
          if (y.id === 'train') return 1
          if (x.id === 'reject') {
            return y.id === 'train' ? 1 : -1
          }
          if (y.id === 'reject') {
            return x.id === 'train' ? -1 : 1
          }
        }
        const cmp = x.title.localeCompare(y.title)
        if (cmp) return cmp
        if (x.isFinetune && !y.isFinetune) {
          return 1
        }
        if (y.isFinetune && !x.isFinetune) {
          return -1
        }
        return y.ts - x.ts
      })
      selectedJudgeIcons.sort((a, b) => {
        const x = a.model
        const y = b.model
        return x.title.localeCompare(y.title)
      })
      for (let id in inDollars) {
        i$ += inDollars[id]
      }
      for (let id in outDollars) {
        o$ += outDollars[id]
      }
      let inTokens1 = 0
      let outTokens1 = 0
      let cacheTokens1 = 0
      let cacheWriteTokens1 = 0
      for (let id in inTokens) {
        inTokens1 += inTokens[id]
      }
      for (let id in outTokens) {
        outTokens1 += outTokens[id]
      }
      for (let id in cachedTokens) {
        cacheTokens1 += cachedTokens[id]
      }
      for (let id in cacheWriteTokens) {
        cacheWriteTokens1 += cacheWriteTokens[id]
      }
      const format = this.props.formatPrice || formatPrice
      const calculatedPrice = "$" + format(i$, 3) + "/" + format(o$, 3)
      const price = calculatedPrice
            //+ "|" +formatInt(cacheTokens1) +NBSP+formatInt(cacheWriteTokens1) + NBSP + formatInt(outTokens1)
      const judgePrice = "$" + format(ji$, 3) + "/" + format(jo$, 3)
      return { inTokens, outTokens, usage, selectedIcons, price, calculatedPrice, judgePrice, selectedJudgeIcons}
    }
    const trashModel = async info => {
      const { model } = info
      if (this.props.deleteModel) {
        await this.props.deleteModel(this, {task: this.state.selectedTask, model: model.id})
      } else {
        await this.props.me.deleteModelFromTask({task: this.state.selectedTask.id, model: model.id})
      }
      if (info.selected) {
        this.modelsView.selectModel(info.model.id)
      }
      this.purgeCache()
    }
    const trashJudge = async info => {
      const { model } = info
      if (this.props.deleteJudge) {
        await this.props.deleteJudge(this, {task: this.state.selectedTask, model: model.id})
      } else {
        await this.props.me.deleteJudgeFromTask({task: this.state.selectedTask.id, model: model.id})
      }
      if (info.selected) {
        this.modelsView.selectModel(info.model.id)
      }
      this.purgeCache()
    }
    const toggleModelSelection = info => {
      this.modelsView.selectModel(info.model.id)
      this.forceUpdate()
    }
    const toggleJudgeSelection = info => {
      this.judgeView.selectModel(info.model.id)
    }
    let messageSelectionClassName = 'messageSelection'
    let judgeMessageSelectionClassName = 'messageSelection'
    const modelInfo = calcPrices(this.modelsView, this.judgeView, rawMessages)
    //////console.log({modelInfo})
    participants = modelInfo.selectedIcons.map(x => x.model)
    const modelAdd = async () => this.modelAdd()
    const judgeAdd = async () => this.judgeView.togglePopup()
    const currentUsage = {}
    /*
     * Context usage must be relative to the latest exact request record. A
     * compaction or a newer reply with only an archive subtotal makes older
     * request usage stale; such models show no usage until an exact request
     * measurement is available.
     */
    const contextUsageBlocked = new Set()
    if (rawMessages.length > 0) {
      let i = rawMessages.length-1
      while (true) {
        const last = rawMessages[i]
        if (last) {
          let foundAny = false
          for (const reply of getReplies(last)) {
            const { model } = reply
            if (currentUsage[model] || contextUsageBlocked.has(model)) continue
            const selectedUsage = selectReplyContextUsage(reply, model)
            if (selectedUsage.usage) {
              currentUsage[model] = selectedUsage.usage
              foundAny = true
            } else if (selectedUsage.blocked) {
              contextUsageBlocked.add(model)
              foundAny = true
            }
          }
          const foundAll = participants.every(p => currentUsage[p.id] || contextUsageBlocked.has(p.id))
          if (foundAny && foundAll) {
            break
          }
          i -= 2
        } else {
          ////debugger
          break
        }
      }
    }
    const modelOnCreate = ref => {
      this.modelSelection = ref
    }
    const judgeOnCreate = ref => {
      this.judgeSelection = ref
    }
    let actions = []
    if (true || modelInfo.selectedIcons.length > 1) {
      const modelCopy = async model => {
        await delay(0.3)
        return await this.copyAction(model)
      }
      actions.push({
        icon: Copy,
        label: "Copy",
        action: modelCopy
      })
    }
    const modelSelection = <ModelSelection currentUsage={currentUsage} models={modelInfo.selectedIcons} trash={trashModel} action={this.selectModelIndex} toggleSelection={toggleModelSelection}  add={modelAdd} onCreate={modelOnCreate} actions={actions} getModelRouteIndicator={this.getModelRouteIndicator}/>
    messageSelectionClassName += ' messageSelectionModels'
    const judgeSelection = () => <ModelSelection models={modelInfo.selectedJudgeIcons} trash={trashJudge} action={this.selectJudgeIndex} toggleSelection={toggleJudgeSelection} add={judgeAdd} onCreate={judgeOnCreate} getModelRouteIndicator={this.getModelRouteIndicator}/>
    //////console.log({rawMessages})
    this.invalidateCache()
    const displayMessages = this.buildRawMessagesState(rawMessages)
    this.setState({
      uiElements: { modelSelection, judgeSelection, messageSelectionClassName, judgeMessageSelectionClassName, selectedModelCount, participants, selectedIconByVendor, modelInfo, currentUsage},
      rawMessages: displayMessages, selectedModelIds,
    }, () => {
      this.restoreInitialConversationView()
      this.updateAutoHeights()
      this.checkSelectedModelLater()
      if (then) then()
    })
  }

  updateAutoHeights = () => {
  }

  updateUIElementsLater = () => {
    clearTimeout(this.uiElementTimeout)
    this.uiElementTimeout = setTimeout(this.updateUIElements, 16)
  }


  copyActionOld = async (modelFilter) => {
    const messages = this.getMessages()
    let text = ''
    for (const message of messages) {
      let { role, model, models, content } = message
      if (role === 'user') {
        text += role + ":\n"
        text += content
        text += '\n\n'
      }
      else {
        if (modelFilter) {
          const replies = getReplies(message)
          let found = replies.find(x => x.model === modelFilter)
          if (!found) {
            found = replies.find(x => x.content || x.addedToTranscript)
          }
          if (!found) {
            found = {
              model: modelFilter,
              content: ''
            }
          }
          model = this.resolveModel(found.model)
          if (found.addedToTranscript) {
            const findResult = id => found.addedToTranscript.find(y => y && y.message && y.message.tool_call_id === id)
            for (const entry of found.addedToTranscript) {
              const message = entry && entry.message
              if (!message) continue
              let { content, tool_calls, tool_call_id, role, contentLength } = message
              if (role === 'tool') {
                continue
              } else {
                role = model.vendor + " " + model.name
              }
              text += role +":\n"
              if (content) {
                text += content
                text += '\n\n'
              }
              if (tool_calls) {
                for (const tool_call of tool_calls) {
                  const { id } = tool_call
                  const name = tool_call.function.name
                  const args = tool_call.function.arguments
                  const result = findResult(id)
                  try {
                    parsed = JSON.parse(args)
                    const params = Object.keys(parsed)
                    text += name
                    text += '(\n'
                    let sep = ''
                    params.forEach(param => {
                      text += sep
                      text += param
                      text += ' = '
                      text += parsed[param]
                      sep = ', '
                    })
                    text += "\n)\n"
                  } catch(err) {
                    console.error(err)
                    text += args
                  }
                  if (result.content) {
                    text += " = \n"
                    text += result.content
                    text += '\n\n'
                  }
                }
              }
            }
          } else {
            text += model.vendor + " " + model.name + ":\n"
            text = removeSignatures(text)
            text += '\n\n'
          }
        } else {
          [{model, content}].concat(models || []).forEach((x, i) => {
            let { model, content, addedToTranscript } = x
            if (model) {
              model = this.resolveModel(model)
              text += '#' + (i+1) + ' ' + model.vendor + " " + model.name
            }
            else {
              text += "assistant"
            }
            text += ":\n"
            text = removeSignatures(text)
            text += '\n\n'
          })
        }
        text += '\n\n'
      }
    }
    //////////console.log(text)
    await this.copyPlainTextToClipboard(text)
  }

  renderChat = () => {
    if (!this.state.selectedTask) return null
    let blurb = ''
    let followUpQuestions
    let title
    let { selectedModelIds, rawMessages, uiElements } = this.state
    const { modelSelection, judgeSelection, messageSelectionClassName, judgeMessageSelectionClassName, selectedModelCount, participants = [], selectedIconByVendor, modelInfo, currentUsage = {} } = uiElements
    const modelPriceRouteClassName = this.getRouteClassNameForModels(modelInfo && modelInfo.selectedIcons && modelInfo.selectedIcons.map(item => item.model))
    const judgePriceRouteClassName = this.getRouteClassNameForModels(modelInfo && modelInfo.selectedJudgeIcons && modelInfo.selectedJudgeIcons.map(item => item.model))
    const modelPriceClassName = 'modelPrice' + (modelPriceRouteClassName ? ' ' + modelPriceRouteClassName : '')
    const judgePriceClassName = 'modelPrice' + (judgePriceRouteClassName ? ' ' + judgePriceRouteClassName : '')
    const modelPriceLabel = this.getRouteDisplayLabelForModels(modelInfo && modelInfo.selectedIcons && modelInfo.selectedIcons.map(item => item.model)) || modelInfo.price
    const judgePriceLabel = this.getRouteDisplayLabelForModels(modelInfo && modelInfo.selectedJudgeIcons && modelInfo.selectedJudgeIcons.map(item => item.model)) || modelInfo.judgePrice
    const vendorSelected = {}
    let buttonIcon = Send
    let buttonAction = async () => {
      return await this.sendChat()
    }
    const copyAction = this.copyAction
    const shareAction = null
    let busy = false
    let questions = []
    let placeholder = this.props.getPlaceholder ? this.props.getPlaceholder(this) : (this.state.judgeChat ? 'Talk to judge' : 'How can I assist?')
    let currentTask
    if (this.state.slide > 0.5) {
      currentTask = this.state.selectedTask && this.state.selectedTask.id
    }
    let newTopicButton
    busy = this.state.threadBusy
    let buttonLabel = 'Send'
    if (this.state.selectedTask.autoplay) {
      buttonLabel = "Play"
    }
    if (!currentTask) {
      const newTopic = async () => {
        //////////////////debugger
        if (this.props.newTopic) {
          return this.props.newTopic(this)
        }
        if (!this.props.onNewFile) {
          this.props.createNewTask()
        }
      }
      newTopicButton = <KeyboardButton className='newTopicButton' label={'Ask'} keepFocus action={newTopic} icon={Hashtag}/>
    }
    const openImage = async (event) => {
      this.fileChooser.click()
    }
    const handleImage = async (event) => {
      this.handleDataTransfer(event, event.target)
    }
    const userSelected = () => this.state.role === 'user'
    const selectUser = () => {
      this.setState({
        role: 'user'
      })
    }
    const systemSelected = () => this.state.role === 'system'
    const selectSystem = () => {
     this.setState({
        role: 'system'
      })
    }
    const showSettings = async () => {
      this.setState({
        showSettings: !this.state.showSettings
      })
    }
    const toggleJson = () => {
      this.state.selectedTask.jsonOutput = !this.state.selectedTask.jsonOutput
      this.forceUpdate()
    }
    const toggleAutoplay = async () => {
      if (this.state.selectedTask.autoplay) {
        this.state.selectedTask.autoplay = null
      } else {
        this.state.selectedTask.autoplay = this.editor.getText()
      }
      this.forceUpdate()
    }
    const text = this.editor && this.editor.getText()
    let showAutoplay = false //(this.state.selectedTask && this.state.selectedTask.autoplay) || text
    let hideIfEditing = isMobile() && this.editor && this.editor.isFocused() ? { display: 'none' } : null
    const json = <Checkbox label="JSON" toggle={toggleJson} selected={this.state.selectedTask.jsonOutput}/>

	    let bottomRow = [<div className='imageChooser' onClick={openImage} style={hideIfEditing}>
	                      <input
	                        ref={this.setFileChooser}
                        type="file"
                        accept={"image/*,application/pdf"}
                        style={{ display: 'none' }} // Hides the file input
                        onChange={handleImage}
                      />
                       <ReactSVG src={Image}/>
                     </div>,
                     showAutoplay && <Checkbox key={'autoplay'} label="Autoplay" toggle={toggleAutoplay} selected={this.state.selectedTask.autoplay}/>
                     /*<RadioButtons buttons={[
                       {
                                       icon: UserSaid,
                                       select: selectUser,
                                       selected: userSelected()
                                     },
                                     {
                                       icon: AISaid,
                                       select: selectSystem,
                                       selected: systemSelected()
	                                     },
	                                     ]}/>*/].filter(x => x)
	    const messages = rawMessages
	    const compactionRenderState = conversationCompactionRenderState(messages)
	    const virtualMessages = this.virtualizeTranscriptMessages(messages)
	    const contextUsageTelemetry = this.renderContextUsageTelemetry(currentUsage, participants)
	    const activeUserMessage = this.getActiveUserMessage(messages)
    const edits = Object.values(this.userFileEdits)
    if (this.editor && edits.length === 0 && !this.editor.getText() && rawMessages.length > 0) {
      const message = messages[messages.length-1]
      if (!this.xhr || message.inReplyTo) {
        const resend = async () => {
          const { inReplyTo } = message
          let request
          if (inReplyTo) {
            request = this.received[inReplyTo]
          } else {
            request = message
          }
          //debugger
          await this.sendChat(request)
          this.forceUpdate()
        }
        if (message.inReplyTo) {
          buttonLabel = this.props.getButtonLabel(this, message)
        }
        buttonAction = resend
      } else {
        buttonAction = async () => {
        }
      }
    }
    if (!this.state.magpie) {
      if (this.state.sending) {
        buttonIcon = Spin
        buttonAction = async () => {}
      }
      if (this.state.autoplayInProgress || activeUserMessage) {
        buttonAction = () => {
          this.stopChat()
          this.state.waitingForModels = {}
          this.state.isStreaming = false
          this.state.sending = false
          this.state.replay = false
          this.forceUpdate()
          this.state.autoplayInProgress = false
        }
        buttonLabel = "Stop"
        buttonIcon = Stop
      }
    }
    let showSearchField = this.props.isSearchFieldVisible(this, messages)
    const x = (1.0-this.state.slide) * -(Math.min(window.innerWidth, 600) - 10)
    const sliderStyle = {
      //transform: `translate(${x}px, 0)`
    }
    let index = this.state.swipeIndex
    let sliderClassName = 'chatMessagesSlider'
    if (this.state.selectedThread) {
      //sliderClassName += ' chatMessagesSliderEnabled'
    }
    let showKeyboard = this.state.showKeyboard
    let menu
    const sfcStyle = {
      height: this.state.selectedThread ? 40 : 80
    }
    let style = !isDesktop() &&this.state.orient === 'landscape' ? { display: 'none' } : null
    let style2
    if (!this.props.goBack) {
      style2 = { visibility: 'hidden'}
    }
    let style3
    title = null
    let inputControlStyle
    inputControlStyle = {
      //opacity: this.hasTasks() ? this.state.slide : 1
    }
    let mainClassName ='chatGPT'
    if (this.isReadOnly()) {
      mainClassName += ' chatGPTReadOnly'
    }
    let noInput
    let multiJudge
    if (this.state.judgeSelected && (this.state.judgeChat && (true || this.judgeView.getSelectedModelIds().length > 1))) {
      noInput = true
      multiJudge = true
   }
    if (noInput) {
      inputControlStyle = { display: 'none' }
      mainClassName += ' chatGPTNoInput'
    }

    const goBack = async () => {
      this.goBack()
    }
    const toggleSize = (size) => {
      if (this.state.sizes[size]) {
        delete this.state.sizes[size]
      } else {
        this.state.sizes[size] = true
      }
      this.forceUpdate(this.saveOptionsLater)
    }
    const toggleSmall = () => toggleSize('small')
    const toggleMedium = () => toggleSize('medium')
    const toggleLarge = () => toggleSize('large')
    let filler = ''
    const openSettings = async () => {
      this.setState({showSettings: !this.state.showSettings})
    }
    for (const id of selectedModelIds) {
      const model = this.resolveModel(id)
      if (model) {
        const icon = (model.getModelIcon && model.getModelIcon()) || model.getIcon()
        if (icon) {
          vendorSelected[model.vendor] = true
          const selectModel = async () => this.selectModel(model)
        }
      }
    }
    let deleteButton
    let shareButton
    let share = async () => {
      const { taskId } = await this.props.me.shareTask(this.state.selectedTask.id)
      if (taskId) {
        this.props.me.openLink(window.location.origin + "/?discussion="+taskId)
      }
    }
    const thread = this.state.selectedTask
    if (thread) {
      const trash = async () => {
        if (this.state.confirmDelete !== thread.id) {
          this.state.confirmDelete = thread.id
          ////////////console.log("confirmDelete", thread)
        } else {
          thread.busy = true
          this.forceUpdate()
          await this.deleteTask(thread)
          this.state.confirmDelete = null
          delete thread.busy
          this.selectThread(null)
        }
        this.forceUpdate()
      }
      deleteButton = trash && <DeleteButton trash={trash}/>
      shareButton = share && <DeleteButton icon={Share} trash={share} confirm={"Share"}/>
    }
    const closeMenu = () => {
      setTimeout(() => {
        this.setState({
          showModelMenu: false
        })
      }, 50)
    }
    const toggleMenu = async () => {
      this.setState({
        showModelMenu: !this.state.showModelMenu
      })
    }
    const menuActive1 = thread  && selectedModelCount === 0
    ////////console.log("swipeMessage", this.state.swipeMessage)
    let judgeConversation = this.getJudgeConversation()
    const judgeCompactionRenderState = conversationCompactionRenderState(judgeConversation)
    let selectedJudgeCount = 0
    let menuActive2 = this.state.judgeChat && selectedJudgeCount === 0
    const judgeSelected = this.state.judgeSelected
    //////console.log({judgeSelected})
    let sliderContainerStyle = noInput ? null: {
     // height: `calc(100% - ${this.state.editorHeight}px - 5px)`
    }


    const onOptionsChanged = options => {
      this.setModelSelectionOptions(options)
      if (!this.state.modelSelectionInProgress) {
        this.updateUIElementsLater()
      }
    }

    const editSystemPrompt = async () => {
    }
    const openSystemPrompts = async () => {
    }
    let settingsPopup
    if (this.state.judgeChat) {
      mainClassName += ' chatGPTJudge'
    }

    if (isDesktop() && !this.state.judgeChat) {
      style2 = {
        visibility: 'hidden'
      }
    }
    const renderJudgeView = () => {
      return <div className={sliderClassName} style={sliderStyle}>
               <div className='forModelsMenu modelsMenuPopupHidden'>
                 <ModelsView
                   key={'judges'}
                   onOptionsChanged={onOptionsChanged}
                   onCreate={this.setJudgeView}
                   me={this.props.me}
                   category={'judges'}
                   prices={this.props.price}
                   models={(isSelected, select) => this.props.models(this, isSelected, select)}
                   vendors={this.props.vendors}
                   openAICodexOAuth={this.props.openAICodexOAuth}
                   hosts={this.props.hosts}
                   getModelRouteIndicator={this.getModelRouteIndicator}
                   observeOptions={this.props.me.observeModelOptions}
                   saveOptions={this.props.me.saveModelOptions}
                 />
                 <div className='chatHeaderFiller'>{filler}</div>
                 <div className={judgePriceClassName}>{judgePriceLabel}</div>
                 <DeleteButton trash={deleteThisChat}/>
               </div>
               <div className={messageSelectionClassName || 'messageSelection'}>
                 {judgeSelected && judgeSelection()}
                 {judgeSelected && <InfiniteScroll
                                     items={judgeConversation}
                                     count={judgeConversation.length}
                                     onCreate={this.setMessages2}
                                     getSelector={
                                       id => `[data-message-id="${id}"]`
                                     }
                                     getId={
                                       item => item.id
                                     }
                                     renderItems={
                                       messages => this.renderMessages(messages, {participants, compactionState: judgeCompactionRenderState})
                                     }
                                   />}
               </div>
             </div>
    }
    const renderSlide2 = () => {
      if (this.state.systemPromptSelected) {
        return this.renderSystemPromptView()
      }
      if (this.state.judgeSelected) {
        return renderJudgeView()
      }
    }
    if (true) {
      const createNewTurn = async () => {
        const models = this.getSelectedModelIds()
        if (models.length > 0) {
          const task = this.state.selectedTask.id
          const models = this.getSelectedModelIds()
          const { user, assistant } = await this.props.me.createNewTurn({task, models})
          if (!this.received[user.id]) {
            this.received[user.id] = user
          }
          if (!this.received[assistant.id]) {
            this.received[assistant.id] = assistant
          }
          this.updateUIElements(() => {
            const userSaid = this.userSaidComps[user.id]
            userSaid.startEdit()
          })
        }
      }
      const magpie = async () => {
        await new Promise((resolve, reject) => {
          this.state.magpie = {resolve, reject}
          this.sendChat()
        })
        this.forceUpdate()
      }
      const actions = []
      if (this.modelsView && this.modelsView.getSelectedModelIds().length > 0) {
        actions.push({
          icon: UserSaid,
          label: "Generate",
          action: magpie
        })
      }
      actions.push({
            icon: Plus,
            label: "New Turn",
            action: createNewTurn
      })
      if (this.isChatInProgress()) {
        const text = this.editor.getText()
        if (text.trim()) {
          actions.push({
            icon: Send,
            label: "Send",
            action: this.sendChat
          })
        }
      }
      if (false) actions.push({
        icon:this.state.selectedTask.jsonOutput ?
          CheckMark : "empty",
        label:'JSON',
        action: toggleJson
      })
      menu = <ActionMenu actions={actions}/>
    }
    if (false && this.filtered) {
      messages = messages.filter(message => {
        return this.filtered[message.id]
      })
    }
    const selectedTranscriptModelId = this.state.selectedModelIndex || selectedModelIds && selectedModelIds[0]
    const messageCounts = conversationHeaderMessageCounts({
      messages,
      task: this.state.selectedTask,
      selectedModelId: selectedTranscriptModelId,
      resolveModel: this.resolveModel
    })
    let uiChatMarginBottom = 'uiChatMarginBottom'
    uiChatMarginBottom += ' uiChatMarginBottomSmall'

    const deleteThisChat = async () => {
      await this.props.deleteChat()
    }

    return <div id={this.key} key='chatGpt2' className={mainClassName}>
             <div className='forModelsMenu modelsMenuPopupHidden'>
               <ModelsView
                 key={'models'}
                 fineTunedModel={(this.props.fineTunedModel || {}).id}
                 onOptionsChanged={onOptionsChanged}
                 onCreate={this.setModelsView}
                 me={this.props.me}
                 category={'models'}
                 prices={this.props.price}
                 models={(isSelected, select) => this.props.models(this, isSelected, select)}
                 vendors={this.props.vendors}
                 openAICodexOAuth={this.props.openAICodexOAuth}
                 hosts={this.props.hosts}
                 getModelRouteIndicator={this.getModelRouteIndicator}
                 observeOptions={this.props.me.observeModelOptions}
                 configure={this.props.configure}
                 saveOptions={this.props.me.saveModelOptions}/>
               <SimpleButton icon={Down} action={this.pageDown} doubleClickAction={this.gotoBottom}/>
               <SimpleButton icon={Up} action={this.pageUp} doubleClickAction={this.gotoTop}/>
               <div className='chatHeaderFiller'>{filler}</div>
               {messageCounts.total > 0 &&
                 <div
                   key='messageCount'
                   className='messageCount'
                   title='Messages visible to the selected model / total transcript messages'>
                   {messageCounts.visible}/{messageCounts.total} messages
                 </div>}
               <div key='modelPrice' className={modelPriceClassName}>{modelPriceLabel}</div>
               <div className='chatHeaderSelectedModels'>{selectedModelCount}</div>
               <DeleteButton trash={deleteThisChat}/>
               {shareButton}
             </div>
             <div className={messageSelectionClassName || 'messageSelection'}>
               {modelSelection}
             </div>
             <div className={'chatMessagesSlider'}>
               <div className={uiChatMarginBottom} ref={this.setChatContentRef}>
                 <InfiniteScroll
                   debug={true}
                   isBottomAligned={true}
                   items={virtualMessages}
                   count={virtualMessages.length}
                   onCreate={this.setMessages1}
                   onBottomLockChanged={this.onBottomLockChanged}
                   windowSize={7}
                   getSelector={
                     id => `[data-message-id="${id}"]`
                   }
                   getId={
                     item => item.id
                   }
                   renderItems={
                     messages => this.renderMessages(messages, {participants, compactionState: compactionRenderState})
                   }
                 />
               </div>

             {renderConversationIndexProgress(this.state.selectedTask && this.state.selectedTask.conversationIndexProgress)}

             {this.state.sendError &&
                <div className='keyboardEditIconAndInstruction sendError'>
                  <div className='keyboardEditInstructionLeftIcon'>
                    <ReactSVG src={Alert}/>
                    </div>
                  <div className='keyboardEditInstructionText'>
                    {this.state.sendError}
                  </div>
                </div>}
             </div>
             <div className={'chatGPTInput' + (menu ? ' chatGPTInputWithMenu' : '')} style={inputControlStyle}>
               <InputControl key='chat'
                             editorIcon={UserSaid}
                             onCreate={this.setInputRef}
                             busy={busy}
                             onDrop={this.onDrop}
                             onPaste={this.onPaste}
                             onKeyDown={this.onKeyDown}
                             placeholder={placeholder} me={this.props.me}
                             onSetEditor={this.setEditor}
                             onClear={this.onClear}
                             speechInputNoFocus={true}
                             speechInputActive={this.state.textFieldSpeechInputActive}
                             speechInputAction={this.toggleTextFieldSpeechInput}
                             selectSpeechInputLang={this.selectTextInputLang}
                             selectedLang={this.state.lang}
                             autodetect={this.autodetectLang} label={buttonLabel}
                             icon={buttonIcon} action={buttonAction}
                             copy={copyAction}
                             cancel={undefined}
                             undo={undefined}
                             redo={undefined}
                             onBlur={
                               () => {
                                 this.setTextInputFocus(false)
                               }
                             }
                             onFocus={
                               () => {
                                 this.setTextInputFocus(true)
                               }
                             }
                             onInput={true ? null: this.onInput}
                             applyCompletion={this.applyCompletion}
                             completions={this.state.completions}
	                             bottomRow={bottomRow}
	                             menu={menu}
	                          />
	                 {contextUsageTelemetry}
	                 {settingsPopup &&
	                  <div className='settingsPopup'>
                    <Popup1 popup={settingsPopup}>
                      <GearButton action={showSettings}/>
                    </Popup1>
                  </div>}
             </div>
             {multiJudge &&
              <div className='judgeButton'>
                <KeyboardButton icon={Send} label="Judge" action={buttonAction}/>
              </div>}
           </div>
  }

  isReadOnly = () => {
    if (this.props.readOnly) {
      return true
    }
    const ts = this.state.timelineFilter
    if (ts !== undefined) {
      for (const id in this.received) {
        if (this.received[id].ts > ts) {
          //console.log("filtered out", ts, this.received[id])
          return true
        }
      }
    }
    return false
  }

  editorSub1
  setInputRef = ref => {
    if (ref != this.inputRef) {
      if (ref) {
        if (this.editorSub1) {
          this.editorSub1.unsubscribe()
        }
        this.editorSub1 = ref.observeEditorHeight().subscribe(height => {
          ////////////////debugger
          height = Math.round(height)
          if (height != this.state.editorHeight) {
            this.state.editorHeight = height
            this.forceUpdate()
          }
        })
      }
      this.inputRef = ref
    }
  }

  checkScrollBack2 = async () => {
    if (false) {
      return await this.checkScrollBack()
    }
  }


  checkScrollBack = async () => {
    if (this.scrollBusy) {
      return
    }
    this.scrollBusy = true

    let earliestTs = Date.now()
    let earliest = { ts: earliestTs }
    for (const k in this.received) {
      const msg = this.received[k]
      const { ts } = msg
      if (ts < earliestTs) {
        earliestTs = ts
        earliest = msg
      }
    }
    //////////////////debugger
    const prev = await this.props.getHistory(this, this.state.selectedTask, earliest, this.props.pageSize || 10)
    if (prev.length > 0) {
      for (const msg of prev) {
        this.parseMessage(msg)
        this.received[msg.id] = msg
      }
      this.forceUpdate(() => {
        this.scrollBusy = false
      })
    } else {
      this.scrollBusy = false
    }
  }

  setSearchEditor = editor => {
    if (this.searchEditorSub) {
      this.searchEditorSub.unsubscribe()
      this.searchEditorSub = null
    }
    this.searchEditor = editor
    if (editor) {
      this.searchEditorSub = editor.observeIsEmpty().subscribe(isEmpty => {
        this.setState({
          searchCanApply: !isEmpty
        })
      })
    }
    this.forceUpdate()
  }

  setEditor = ref => {
    //////////////debugger
    if (this.editorSub) {
      this.editorSub.unsubscribe()
    }
    if (ref) {
      this.state.editorCanApply = true
      this.editor = ref
      this.editorSub = this.editor.observeIsEmpty().subscribe(isEmpty => {
        if (this.state.editorCanApply !== !isEmpty) {
          this.state.editorCanApply = !isEmpty
          this.forceUpdate()
        }
      })
      if (this.state.selectedTask && this.state.selectedTask.autoplay) {
        this.editor.setText(this.state.selectedTask.autoplay)
      }

    }
    this.forceUpdate()
  }

  onClear = () => {
    let { magpie } = this.state
    this.state.magpie = null
    this.clearEditor()
    if (magpie) {
      magpie.resolve()
    }
  }

  clearEditor = () => {
    this.state.completions = []
    this.renderCurrentDocument()
 }

  isKeyboardShowing = () => !isDesktop() && this.state.textInputFocus

  undoEdit = async () => {
    //////////////////////////////debugger
    if (this.canUndoCurrentDocument()) {
      const doc = this.getCurrentDocument()
      doc.undo()
    } else {
      let i = this.getCurrentInstruction()
      this.state.variableToComplete = null
      if (i) {
        if (i.output) {
          this.state.edits.undo()
          i.undoOutput = i.output
          i.output = null
        } else if (i.inputText) {
          i.inputTemplate = null
          i.variableToComplete = null
          i.instruction = new Document(i.inputText)
          i.inputText = null
        } else {
          this.state.instructions.undo()
          i = this.getCurrentInstruction()
        }
        this.buildNextInstruction(i)
        this.renderCurrentDocument()
        return
      }
      if (this.state.instructions.canUndo()) {
        this.state.instructions.undo()
        const i = this.getCurrentInstruction()
        this.buildNextInstruction(i)
      } else {
        this.buildNextInstruction()
      }
    }
    this.renderCurrentDocument()
  }

  redoEdit = async () => {
    //////////////////////////////debugger
    const doc = this.getCurrentDocument()
    if (doc && doc.canRedo()) {
      doc.redo()
    } else {
      let i = this.getCurrentInstruction()
      if (i) {
        if (i.undoOutput) {
          i.output = i.undoOutput
          i.undoOutput = null
          this.state.edits.redo()
          this.buildNextInstruction()
        } else {
          this.state.instructions.redo()
          i = this.getCurrentInstruction()
          this.buildNextInstruction(i)
        }
      } else if (this.state.instructions.canRedo()) {
        this.state.instructions.redo()
        i = this.getCurrentInstruction()
        this.buildNextInstruction(i)
      }
    }
    this.renderCurrentDocument()
  }

  showKeyboard = () => {
    if (true) return
    if (false) {
      const back = () => {
        this.setState({
          subpage: null,
          popup: null
        })
      }
      this.setState({
        popup: () => <div className='chatGPTKeyboard'><InputField me={this.props.me} sendKeyboardOutput={this.sendKeyboardOutput} cancelKeyboardOutput={back} isWritingAssistant={true}/></div>
      })
    } else {
      this.setState({
        showKeyboard: true
      })
    }
  }

  setTextInputFocus = textInputFocus => {
    this.showKeyboard()
    let instructionFocus = this.state.instructionFocus
    if (textInputFocus) {
      instructionFocus = false
    } else {
      this.onBlur()
    }
    this.setState({
      textInputFocus,
      instructionFocus
    },() => {
      this.updateLang()
      if (this.editor && this.editor.focused) {
        //this.onInput()
      }
    })
    if (!instructionFocus && !textInputFocus) {
      //this.stopVoiceInput()
    }
  }

  renderCurrentDocument = () => {
    const text = this.renderText(this.getCurrentDocument())
    if (this.editor.setText(text)) {
      this.focusedText = undefined
    }
    this.forceUpdate(this.showLastInstruction)
    return text
  }

  copyMarkdownToClipboard = async (text) => {
    try {
      //console.log(text)
      const html = await mdToHtml(text.replace(/<think>([\s\S]*?)<\/think>/gi, ''))
      ////debugger
      document.body.focus()
      const item = new ClipboardItem({
        'text/plain': text,
        'text/html': html
      })
      navigator.clipboard.write([item])
    } catch (err) {
      console.error(err)
      ////////console.log(text)
    } finally {
      await delay(0.5)
    }
  }


  copyToClipboard = async (text) => {
    return await this.copyMarkdownToClipboard(text)
  }

  copyPlainTextToClipboard = async (text) => {
    try {
      const item = new ClipboardItem({
        'text/plain': text,
      })
      navigator.clipboard.write([item])
    } catch (err) {
      console.error(err)
    }
    await delay(0.5)
  }

  copy = async () => {
    const text = this.editor.getText()
    return this.copyToClipboard(text)
  }

  renderText = (edit) => {
    return (edit && edit.getCurrent()) || ''
  }

  getCurrentDocument = () => {
    return this.state.edits.getCurrent()
  }

  cancel = () => {
    this.props.back()
  }

  goBack = async () => {
    //////debugger
    this.props.goBack()
  }

  canUndo = () => {
  }

  canRedo = () => {
  }


  updateLang = () => {
  }

  inputSeq = 0


  clearError = () => {
  }

  onBlur = e => {
    this.state.editing = false
    this.state.completions = []
    const text = this.editor.getText()
    if (this.getCurrentText() == text) {
      //debugLog("onBlur no change")
      this.forceUpdate()
      return
    }
    //debugLog("onBlur text changed")
    this.clearError()
    const doc = this.getCurrentDocument()
    ////////////////////////////////debugger
    this.forceUpdate()
  }

  getCurrentText = () => {
    const doc = this.getCurrentDocument()
    return doc ? doc.getCurrent() || "" : ""
  }

  getCurrentTopic = () => {
    let topic
    if (this.state.selectedThread) {
      topic = this.state.selectedThread.id
    } else {
      let ts = 0
      let lastMessage
      for (const id in this.received) {
        const message = this.received[id]
        if (message.ts > ts) {
          ts = message.ts
          lastMessage = message
        }
      }
      if (lastMessage) {
        topic = lastMessage.topic
      }
    }
    if (!topic) {
      if (this.state.selectedTask && this.state.selectedTask.lastTopic) {
        topic = this.state.selectedTask.lastTopic.id
      }
    }
    return topic
  }

  waitForUploads = () => {
    return new Promise((resolve, reject) => {
      const checkForUploadsDone = () => {
        if (this.state.uploads.length === 0) {
          resolve()
        } else {
          setTimeout(checkForUploadsDone, 500)
        }
      }
      checkForUploadsDone()
    })
  }

  getContent = () => {
    let content  = []
    let result = ''
    const flush = () => {
      if (result) {
        result = result.replace(/\n•[ ]+/g, "\n•  ");
        content.push({
          type: "text",
          text: result
        })
        result = ''
      }
    }
    const apply = node => {
      walkDOM(node, n => {
        if (n instanceof HTMLVideoElement) {
        }
        else if (n instanceof HTMLImageElement) {
          const url = n.src
          flush()
          content.push({
            type: "image_url",
            image_url: {
              url
            }
          })
        } else if (n.nodeName == "WBR") {
        } else if (n.nodeName == "BR") {
          result += "\n";
        } else if (n.nodeType == 3 && !(n.parentElement instanceof HTMLSpanElement)) {
          let textContent = n.textContent.replace(nbsp, " ");
          result += textContent;
          if (n.parentElement !== node && n.parentElement instanceof HTMLDivElement) {
            result += '\n'
          }
        }
      })
    }
    apply(this.editor.getNode())
    return content
  }

  getSelectedModelIds = () => {
    return (this.modelsView && this.modelsView.getSelectedModelIds()) || []
  }

  getModelRequestConfig = (modelIds, storedConfig = {}) => {
    const ids = normalizeModelIds(modelIds)
    const generationConfigs = this.modelSelection ? this.modelSelection.getConfig(ids) : {}
    const viewRouteConfigs = this.modelsView ? this.modelsView.getSelectedModelRequestConfigs(ids) : {}
    const optionRouteConfigs = selectedModelRouteConfigsFromOptions(ids, this.modelSelectionOptions)
    const selectedRouteConfigs = mergeSelectedModelRouteConfigs(
      ids,
      optionRouteConfigs,
      viewRouteConfigs
    )
    const missingSelections = new Set(this.modelsView ? this.modelsView.getMissingInferenceProviderSelections(ids) : [])
    const routeConfigs = {}
    const missing = []
    for (const id of ids) {
      const route = pickModelRouteConfig(storedConfig && storedConfig[id]) || selectedRouteConfigs[id]
      if (route) {
        routeConfigs[id] = route
      } else if (missingSelections.has(id)) {
        missing.push(id)
      }
    }
    if (missing.length > 0) {
      throw new Error(`Select an inference provider for ${missing.join(', ')}`)
    }
    const baseConfigs = {}
    for (const id of ids) {
      baseConfigs[id] = {
        ...(generationConfigs[id] || {}),
        ...(storedConfig && storedConfig[id] || {})
      }
    }
    return mergeModelRequestConfigs(ids, baseConfigs, routeConfigs)
  }

  modelsById = {}

  getModels = () => {
    if (!this.models) {
      this.models = this.props.models(() => true, () => {}).concat([TRAIN, REJECT])
      this.modelsById = {}
      this.models.forEach(model => {
        this.modelsById[model.id] = model
      })
    }
    return this.models
  }

  isChatInProgress = () => {
    return !!(this.xhr || this.state.isStreaming || this.state.sending || this.getActiveUserMessage())
  }

  shouldQueueChat = (previous, opts = {}) => {
    return !previous &&
      !opts.replay &&
      !this.state.magpie &&
      !this.state.judgeChat &&
      !this.props.thread &&
      this.isChatInProgress()
  }

  queueChatMessage = async () => {
    await this.clearSearchField()
    if (this.state.chatDisabled) return
    if (this.state.uploadingFile) return
    await this.waitForUploads()
    const html = this.editor.getHTML()
    const text = turndownService.turndown('<pre>' + html + '</pre>')
    const contents = this.getContent()
    const hasAttachment = contents && contents.find && contents.find(x => x.type === 'image_url')
    if (!text && !hasAttachment) {
      return
    }
    const models = normalizeModelIds(this.getSelectedModelIds())
    if (models.length === 0) {
      await delay(0.5)
      this.modelsView.showPopup()
      return
    }
    const task = this.state.selectedTask
    if (!task) {
      this.setState({
        sendError: 'Please start a chat before queueing follow-up messages.'
      })
      return
    }
    let config
    try {
      config = this.getModelRequestConfig(models)
    } catch (err) {
      this.setState({ sendError: err.message })
      return
    }
    let msg
    if (this.props.createNewMessage) {
      msg = this.props.createNewMessage(this, { text, contents, models, task: task.id })
    } else {
      msg = this.props.me.createNewMessage({ text, contents, models, task: task.id })
    }
    const now = Date.now()
    msg.uid = this.props.me.self.uid
    msg.models = models
    msg.config = config
    msg.modelRequestConfigVersion = MODEL_REQUEST_CONFIG_VERSION
    msg.status = 'queued'
    msg.queuedAt = now
    msg.queuedDuring = this.state.sendChatId
    msg.lastUpdated = now
    const MAX_INLINE_LENGTH = 8192
    if (msg.content.length > MAX_INLINE_LENGTH) {
      const ref = await this.props.me.uploadMessageContent(msg.id, msg.content)
      msg.storage = ref.fullPath
      msg.contentLength = msg.content.length
      msg.content = msg.content.substring(0, MAX_INLINE_LENGTH)
      const newLine = msg.content.lastIndexOf('\n')
      if (newLine > msg.content.length / 2) {
        msg.content = msg.content.substring(0, newLine)
      }
    }
    this.received[msg.id] = msg
    this.invalidateCache(msg)
    delete this.state.timelineFilter
    this.clearEditor()
    this.setState({
      sendError: null,
      rawMessages: this.buildRawMessagesState()
    }, () => {
      this.gotoBottom()
    })
    try {
      if (this.props.queueChatMessage) {
        await this.props.queueChatMessage(this, msg)
      } else {
        await this.props.me.getMessagesRef().doc(msg.id).set(msg, { merge: true })
      }
      this.forceUpdate()
    } catch (err) {
      console.error(err)
      delete this.received[msg.id]
      this.setState({
        sendError: 'Could not queue that message. Please try again.',
        rawMessages: this.buildRawMessagesState()
      })
    }
  }

  steerQueuedMessage = async message => {
    if (!message || message.status !== 'queued') {
      return
    }
    const activeUserMessage = this.getActiveUserMessage()
    if (!activeUserMessage) {
      await this.sendQueuedMessageAsNewTurn(message, null)
      return
    }
    const previousStatus = message.status
    const previousQueuedDuring = message.queuedDuring
    const previousSteeredDuring = message.steeredDuring
    const previousSteerSubmittedAt = message.steerSubmittedAt
    const previousLastUpdated = message.lastUpdated
    const previousEmbeddedInTranscript = message.embeddedInTranscript
    const previousSteeredInto = message.steeredInto
    const now = Date.now()
    const queuedDuring = message.queuedDuring || activeUserMessage.id
    const steerTranscript = this.appendSteerToActiveTranscript(message, activeUserMessage, now)
    Object.assign(message, {
      status: 'steered',
      queuedDuring,
      steeredDuring: activeUserMessage.id,
      steeredInto: steerTranscript.replyMessage && steerTranscript.replyMessage.id,
      embeddedInTranscript: !!steerTranscript.replyMessage,
      steerSubmittedAt: now,
      lastUpdated: now
    })
    this.invalidateCache(message)
    this.forceUpdate()
    try {
      const payload = {
        ...message,
        task: message.task || activeUserMessage.task,
        queuedDuring
      }
      let result
      if (this.props.steerChat) {
        result = await this.props.steerChat(this, payload, activeUserMessage)
      } else {
        result = await this.props.me.steerChat(payload)
      }
      if (!result || result.steered === false) {
        const err = new Error((result && result.error) || 'active-run-not-found')
        err.code = result && result.error
        throw err
      }
      await this.props.me.getMessagesRef().doc(message.id).set({
        status: 'steered',
        queuedDuring,
        steeredDuring: activeUserMessage.id,
        steeredInto: steerTranscript.replyMessage && steerTranscript.replyMessage.id,
        embeddedInTranscript: !!steerTranscript.replyMessage,
        steerSubmittedAt: now,
        lastUpdated: now
      }, { merge: true })
      try {
        await this.persistReplyTranscript(steerTranscript)
      } catch (persistErr) {
        console.error(persistErr)
      }
    } catch (err) {
      console.error(err)
      this.removeSteerFromTranscript(steerTranscript)
      Object.assign(message, {
        status: previousStatus,
        queuedDuring: previousQueuedDuring,
        steeredDuring: previousSteeredDuring,
        embeddedInTranscript: previousEmbeddedInTranscript,
        steeredInto: previousSteeredInto,
        steerSubmittedAt: previousSteerSubmittedAt,
        lastUpdated: previousLastUpdated
      })
      this.invalidateCache(message)
      if (this.isActiveRunNotFoundError(err)) {
        try {
          await this.sendQueuedMessageAsNewTurn(message, activeUserMessage)
        } catch (fallbackErr) {
          console.error(fallbackErr)
          this.setState({
            sendError: 'Could not send that queued message.'
          })
        }
        return
      }
      this.setState({
        sendError: 'Could not steer the active response.'
      })
    }
  }

  onQueueStreamEvent = queue => {
    if (!queue) {
      return
    }
    const user = this.received[queue.messageId]
    if (queue.event === 'start') {
      this.activeStreamReplyId = queue.replyId || (queue.messageId + '.reply')
      if (user) {
        user.status = queue.status || 'inferencing'
        if (!this.received[this.activeStreamReplyId]) {
          const reply = this.props.me.createNewReply(user)
          reply.id = this.activeStreamReplyId
          reply.inReplyTo = user.id
          reply.ts = Math.max(Date.now(), user.ts + 1)
          reply.lastUpdated = Date.now()
          this.received[reply.id] = reply
        }
        this.activeReply = {
          id: this.activeStreamReplyId,
          model: resolveModelId((user.models && user.models[0]) || user.model)
        }
      }
      this.setState({ rawMessages: this.buildRawMessagesState() }, () => {
        this.gotoBottom()
      })
    } else if (queue.event === 'done') {
      if (user) {
        user.status = queue.status || 'answered'
      }
      this.forceUpdate()
    }
  }

  getOrCreateAssistantReply = (message, model) => {
    if (!message) return null
    if (message.model === model) return message
    if (!Array.isArray(message.models)) message.models = []
    let reply = message.models.find(candidate => candidate && candidate.model === model)
    if (!reply) {
      reply = { model, content: '' }
      message.models.push(reply)
    }
    return reply
  }

  appendStreamingModelText = (message, model, text) => {
    const reply = this.getOrCreateAssistantReply(message, model)
    if (!reply) return
    reply.stream = appendStreamingDelta(reply.stream, text)
    this.invalidateCache(message)
    this.forceUpdateLater()
  }

  updateStreamingToolCalls = (message, model, toolCalls) => {
    const reply = this.getOrCreateAssistantReply(message, model)
    if (!reply || !Array.isArray(toolCalls) || toolCalls.length === 0) return
    let transcriptEntry
    for (const toolCall of toolCalls) {
      if (toolCall && toolCall.function && toolCall.function.name === 'subagent') {
        this.resolveSubagentTask(message.id, toolCall.id)
      }
    }
    if (Array.isArray(reply.addedToTranscript)) {
      /*
       * Text streamed since the last entry means a new assistant segment
       * began: these tool calls belong to it, never to the previous entry —
       * merging there would render them ahead of the text and results that
       * actually preceded them.
       */
      const previous = reply.addedToTranscript[reply.addedToTranscript.length - 1]
      if (!reply.stream && previous && previous.message && previous.message.role === 'assistant') {
        transcriptEntry = previous
      } else {
        transcriptEntry = reply.addedToTranscript.find(entry => {
          const existingCalls = entry && entry.message && entry.message.tool_calls
          return Array.isArray(existingCalls) && existingCalls.some(existing => (
            toolCalls.some(incoming => incoming && existing && incoming.id === existing.id)
          ))
        })
      }
    }
    if (!transcriptEntry) {
      if (!Array.isArray(reply.addedToTranscript)) reply.addedToTranscript = []
      if (reply.stream) {
        reply.addedToTranscript.push({
          message: { role: 'assistant', content: reply.stream }
        })
        reply.stream = ''
      }
      transcriptEntry = {
        message: { role: 'assistant', tool_calls: toolCalls }
      }
      reply.addedToTranscript.push(transcriptEntry)
    } else {
      const existingCalls = transcriptEntry.message.tool_calls || []
      for (const incoming of toolCalls) {
        if (!incoming) continue
        const existing = existingCalls.find(candidate => candidate && candidate.id === incoming.id)
        if (existing) {
          existing.function = incoming.function
        } else {
          existingCalls.push(incoming)
        }
      }
      transcriptEntry.message.tool_calls = existingCalls
    }
    this.invalidateCache(message)
    this.forceUpdateLater()
  }

  appendStreamingTranscript = (message, model, entries) => {
    const reply = this.getOrCreateAssistantReply(message, model)
    if (!reply || !appendTranscriptEntriesToReply(reply, entries)) return false
    this.invalidateCache(message)
    this.forceUpdateLater()
    return true
  }

  updateStreamingToolProgress = (message, model, toolProgress, then) => {
    if (!toolProgress) return
    const { tool_call_id, progress } = toolProgress
    if (!tool_call_id) return
    const uiState = this.getAiSaidCompState(message.id)
    if (!uiState.toolProgress) uiState.toolProgress = {}
    const updates = uiState.toolProgress[tool_call_id] || (uiState.toolProgress[tool_call_id] = [])
    if (progress !== undefined) updates.push(progress)
    const reply = this.getOrCreateAssistantReply(message, model)
    const transcript = reply && reply.addedToTranscript
    const current = Array.isArray(transcript) ? transcript[transcript.length - 1] : null
    if (current) current.tool_calls = uiState.toolProgress
    if (then) then(current)
    this.forceUpdateLater()
  }

  finalizeStreamingModelText = (message, model) => {
    const reply = this.getOrCreateAssistantReply(message, model)
    if (!reply || !reply.stream) return
    if (Array.isArray(reply.addedToTranscript)) {
      reply.addedToTranscript.push({
        message: { role: 'assistant', content: reply.stream }
      })
    } else {
      reply.content = reply.stream
    }
    delete reply.stream
    this.invalidateCache(message)
  }


  sendChat = async (previous, opts = {}) => {
    if (this.shouldQueueChat(previous, opts)) {
      return await this.queueChatMessage()
    }
    if (opts.replay) {
      if (this.xhr) return
    } else {
      const activeUserMessage = this.getActiveUserMessage()
      const activeMessageId = (activeUserMessage && activeUserMessage.id) || this.state.sendChatId
      const targetMessageId = previous && previous.id
      if (shouldCancelActiveRun(activeMessageId, targetMessageId)) {
        await this.stopChat()
      } else {
        this.clearStaleActiveRun(activeUserMessage)
      }
    }
    return await this.sendChatImpl(previous, opts)
  }

  sendChatImpl = async (previous, opts = {}) => {
    await this.clearSearchField()
    if (this.state.chatDisabled) return
    if (this.state.uploadingFile) return
    if (this.xhr) {
      //return
    }
    let {replay, resolve, reject, onFirstToken, onDone} = opts
    this.sendInfo = opts
    if (!replay && this.state.judgeChat) {
      let message
      if (this.state.swipeMessage) {
        message = this.state.swipeMessage
      } else {
        message = previous
      }
      return await this.judge(message)
    }
    await this.waitForUploads()
    ////////////////////////////debugger
    let text = ''
    //////////////debugger
    if (!replay)  {
      let html = this.editor.getHTML()
      text = turndownService.turndown('<pre>' + html + '</pre>')
    }
    if (this.props.thread) {
      // we need to make a real thread here
      this.cutConversation(message, "thread", text)
      return
    }
    const edits = Object.values(this.userFileEdits)
    if (false && edits.length > 0) {
      text = "FYI, the user just edited the following files: " + edits.map(x => {
          const comps = x.edit.path.split("/")
          return comps[comps.length-1]
        }).join(', ') + "\n" + text
    }
    ////////////console.log('text', text)
    const selectedModelIds = normalizeModelIds(this.getSelectedModelIds())
    if (!replay && !this.state.magpie && selectedModelIds.length === 0) {
      ////////debugger
      await delay(0.5)
      this.modelsView.showPopup()
      return
    }
    if (this.state.magpie || previous || text) {
      let contents = ''
      if (!replay) {
        contents = this.getContent()
      }
      const task = this.state.selectedTask
      if (!task) {
        // this is the user's first task
        if (this.props.createNewTask) {
          ////////////////debugger
        } else {
          task = this.props.me.createNewTask()
          if (task) {
            this.selectThread(task)
            isNewTopic = true
          }
        }
      }
      const sent = Date.now()
      const models = selectedModelIds
      let selectedModels = normalizeModelIds(opts.models)
      if (selectedModels.length === 0 && previous) selectedModels = normalizeModelIds(previous.models)
      if (selectedModels.length === 0 && previous) selectedModels = normalizeModelIds([previous.model])
      if (selectedModels.length === 0) selectedModels = models
      const configModelIds = replay ? normalizeModelIds([replay]) : selectedModels
      let config
      try {
        const persistedConfig = previous && previous.modelRequestConfigVersion === MODEL_REQUEST_CONFIG_VERSION
          ? previous.config
          : undefined
        config = this.getModelRequestConfig(configModelIds, opts.config || persistedConfig || {})
      } catch (err) {
        this.setState({ sendError: err.message })
        return
      }
      //console.log("MODELS", models)
      let msg
      if (previous) {
        const retryErrored = previous.status === 'error'
        const retryCanceled = previous.canceledByUser === true
        msg = previous
        msg.retryErrored = retryErrored
        msg.retryCanceled = retryCanceled
        msg.status = 'inferencing'
        msg.canceledByUser = false
        msg.lastUpdated = Date.now()
      } else {
        if (this.props.createNewMessage) {
          msg = this.props.createNewMessage(this, { text, contents, models: selectedModels, task: task.id })
        } else {
          msg = this.props.me.createNewMessage({ text, contents, models: selectedModels, task: task.id })
        }
        msg.status = 'inferencing'
        this.received[msg.id] = msg
      }
      msg.models = selectedModels
      msg.config = config
      msg.modelRequestConfigVersion = MODEL_REQUEST_CONFIG_VERSION
      delete this.state.timelineFilter
      let spoken = 0
      let completeText = ''
      const defaultGetMessage = () => { // fix me: refactor
        return this.received[this.activeStreamReplyId || msg.id + ".reply"]
      }
      let getMessage
      if (this.props.getMessage){
        getMessage = () => this.props.getMessage(this)
      } else {
        //debugger
        if (!this.received[msg.id + ".reply"]) {
          if (!msg.models) {
            msg.models = models
          }
          const reply = this.props.me.createNewReply(msg)
          this.received[reply.id] = reply
          this.activeStreamReplyId = reply.id
          this.activeReply = {
            id: reply.id,
            model: resolveModelId(reply.model || reply.models && reply.models[0])
          }
        } else {
          const reply = this.received[msg.id + '.reply']
          this.activeStreamReplyId = reply.id
          this.activeReply = {
            id: reply.id,
            model: reply.model
          }
        }
        getMessage = defaultGetMessage
      }
      const getReplyMessage = () => {
        const reply = this.wasAnswered(msg)
        return reply
      }
      this.setState({
        sendError: null,
        isStreaming: !(this.state.magpie || replay),
        sending: !(this.state.magpie || replay),
        sendChatId: msg.id,
        replay,
        rawMessages: this.buildRawMessagesState()
      }, () => {
        if (!replay) {
          this.gotoBottom()
        }
      })
      this.clearEditor()
      try {
        if (!previous) {
          const MAX_INLINE_LENGTH = 8192
          if (msg.content.length > MAX_INLINE_LENGTH) {
            const ref = await this.props.me.uploadMessageContent(msg.id, msg.content)
            msg.storage = ref.fullPath
            msg.contentLength = msg.content.length
            msg.content = msg.content.substring(0, MAX_INLINE_LENGTH)
            const newLine = msg.content.lastIndexOf('\n')
            if (newLine > msg.content.length / 2) {
              msg.content = msg.content.substring(0, newLine)
            }
          }
        }
        const found = getMessage()
        if (found) {
          //////debugger
          getReplies(found).forEach(x => {
            if (!replay || replay === x.model) {
              x.content = ''
              x.stream = ''
              delete x.corrected
              x.addedToTranscript = null
            }
          })
          this.invalidateCache(found)
        } else {
          //alert("not found")
        }
        if (this.state.selectedTask.autoplay) {
          this.state.autoplayInProgress = true
        }
        //////console.log("REPLAY", replay)
        let cleared = {}
        let sawReasoning = false
        let streamFailed = false
        let magpieContent = ''
        this.firstTime = !replay
        //this.updateMessagesLater() // this.state.rawMessages must be rebuilt: hack
        this.xhr = await this.props.streamChat(this, msg, {
          autoplay: this.state.selectedTask.autoplay,
          models: selectedModels,
          replay,
          magpie: !!this.state.magpie,
          config,
          assistantModel: this.state.assistantModel,
          onContent: snip => {
            //console.log('onContent', JSON.stringify(snip, null, ' '))
            const found = getMessage()
            this.activeReply.message = found
            const { choices, model, progress, toolProgress, error, queue } = snip
            if (this.state.sending) {
              this.state.sending = false
            }
            if (error) {
              ////debugger
              streamFailed = true
              this.xhr = null
              this.activeStreamReplyId = null
              msg.status = 'error'
              this.activeReply = {}
              this.state.waitingForModels = {}
              this.state.isStreaming = false
              this.state.sending = false
              this.state.replay = false
              this.setState({
                sendError: error
              })
              this.forceUpdate()
              return
            }
            if (queue) {
              this.onQueueStreamEvent(queue)
              return
            }
            if (choices) {
              const choice = choices[0]
              if (this.state.magpie) {
                if (choice) {
                  const text = choice.delta.content || ''
                  if (text) {
                    magpieContent += text
                    this.editor.setText(magpieContent)
                    this.forceUpdate()
                  }
                }
                return
              }
              if (!cleared[model]) {
                if (found) {
                  cleared[model] = true
                  this.activeReply = {
                    id: found.id,
                    model
                  }
                }
              }
              if (choice) {
                if (choice.delta.tool_calls) {
                  if (found) {
                    this.updateStreamingToolCalls(found, model, choice.delta.tool_calls)
                    for (const message of this.decomposeAddedTranscript(found)) {
                      this.sendToTranscript(message)
                    }
                  }
                }
                //////////////debugger
                let text = choice.delta.text || choice.delta.content || choice.delta.reasoning_content || ''
                if (sawReasoning && !choice.delta.reasoning_content) {
                  text = '\n</think>\n\n' + text
                  sawReasoning = false
                }
                if (choice.delta.reasoning_content) {
                  if (!sawReasoning) {
                    text = '<think>\n' + text
                  }
                  sawReasoning = true
                }
                if (!found) {
                  this.state.sending = false
                  ////////////////debugger
                } else {
                }
                //////console.log({found, text})
                if (found && text) {
                  if (!this.state.isStreaming) {
                    this.state.isStreaming = true
                    if (onFirstToken) {
                      onFirstToken()
                      onFirstToken = null
                    }
                  }
                  this.appendStreamingModelText(found, model, text)
                } else {
                  ////////////////////////////debugger
                }
              }
              this.forceUpdate()
            } else if (progress) {
              //////debugger
              if (found) {
                const { model, addedToTranscript, subagentReturn } = progress
                if (addedToTranscript) {
                  this.appendStreamingTranscript(found, model, addedToTranscript)
                  for (const entry of addedToTranscript) {
                    const message = entry && entry.message
                    if (!message) continue
                    this.sendToTranscript(message, true)
                  }
                } else if (subagentReturn) {
                  const { toolMessage, taskId, title, description,
                          toolCallId, messageId } = subagentReturn

                } else {
                  const then = message => {
                    if (message) this.sendToTranscript(message, true)
                  }
                  this.updateStreamingToolProgress(found, model, progress.toolProgress || toolProgress, then)
                }
                this.forceUpdate()
              }
            } else if (toolProgress) {
              if (found) {
                this.updateStreamingToolProgress(found, model, toolProgress)
                this.forceUpdate()
              }
            } else {
              //////debugger
            }

          },
          onDone: () => {
            this.xhr = null
            this.activeStreamReplyId = null
            if (streamFailed) {
              this.activeReply = {}
              this.state.waitingForModels = {}
              this.state.isStreaming = false
              this.state.sending = false
              this.state.replay = false
              this.forceUpdate()
              return
            }
            if (msg.status !== 'error') {
              msg.status = 'answered'
            }
            this.activeReply = {}
            if (onDone) {
              onDone()
            }
            if (this.state.magpie) {
              const { resolve, reject } = this.state.magpie
              this.state.magpie = null
              resolve()
              return
            }
            const found = getMessage()
            if (found) {
              const streamedModelIds = Object.keys(cleared)
              const completedModelIds = streamedModelIds.length > 0
                ? streamedModelIds
                : configModelIds
              for (const completedModelId of completedModelIds) {
                this.finalizeStreamingModelText(found, completedModelId)
              }
            }
            if (resolve) return resolve()
            this.activeReply = {}
            this.state.waitingForModels = {}
            this.state.isStreaming = false
            this.state.sending = false
            this.state.replay = false
            this.updateUIElementsLater()
            this.forceUpdate(async () => {
              this.messages1.autoScroll = true
              if (this.state.selectedTask &&
                  this.state.selectedTask.autoplay &&
                  this.state.autoplayInProgress) {
                if (this.editor) {
                  this.editor.setText(this.state.selectedTask.autoplay, false)
                  await delay(0.5)
                  this.sendChat()
                }
              }
            })
          },
          onError: (err, status) => {
            const transportDetached = isDetachedStreamStatus(status)
            this.activeStreamReplyId = null
            if (onDone) {
              onDone()
            }
            console.error(err)
            this.xhr = null
            if (!transportDetached) msg.status = 'error'
            this.state.isStreaming = false
            this.state.waitingForModels = {}
            this.activeReply = {}
            if (this.state.magpie) {
              const { resolve, reject } = this.state.magpie
              this.state.magpie = null
              reject(err)
              return
            }
            if (reject) return reject()
            const found = getMessage()
            if (transportDetached) {
              console.warn('Live response stream detached; continuing from Firestore.', {
                messageId: msg.id
              })
            } else if (status === 400) {
              ////////////////debugger
              this.setState({
                sendError: "Oof, sorry that didn't work."
              })
            } else {
              if (!found || found.status !== 'inferencing') {
                this.setState({
                  sendError: 'Server unreachable. Please try again later.'
                })
              }
            }
            this.state.replay = false
            this.state.sending = false
            this.state.isStreaming = false
            this.state.sending = false
            this.forceUpdate(() => {
              this.messages1.autoScroll = true
            })
          }
        })
      } catch (err) {
        console.error(err)
        ////////////////debugger
        this.setState({
          sendError: "Oof, sorry that didn't work."
        })
        this.state.isStreaming = false
        this.forceUpdate()
      }
    }
    if (isMobile()) {
      this.editor.blur()
    }
  }

  forceUpdateLater = (k) => {
    clearTimeout(this.forceUpdateTimeout)
    this.forceUpdateTimeout = setTimeout(() => {
      this.forceUpdate(k)
    }, 33)
  }

  notEnoughTokens = instruction => {
  }

  getThreads = () => {
    let threads
    if (this.state.searchTerm) {
      threads = this.state.searchResults
    } else {
      threads = Object.values(this.tasks)
      if (this.props.sortTasks) {
        threads = this.props.sortTasks(this, threads, this.state.calendarView)
      } else {
        if (this.state.calendarView !== 'all') {
          threads.sort((x, y) => {
            return y.lastUpdated - x.lastUpdated
          })
        } else {
          threads.sort((x, y) => x.title.localeCompare(y.title))
        }
      }
      let filt
      switch(this.state.calendarView) {
        case 'all':
          {
            //threads = threads.slice(0, this.state.recentLimit)
            break
          }
        case 'recent':
          {
            //threads = threads.slice(0, this.state.recentLimit)
            break
          }
        case 'week':
          {
            const t = startOfWeek(this.state.selectedDay).getTime()
            filt = x => {
              const { lastUpdated } = x
              return startOfWeek(lastUpdated).getTime() === t
            }
          }
          break
        case 'day':
          {
            const t = startOfDay(this.state.selectedDay).getTime()
            filt = x => {
              const { lastUpdated } = x
              return startOfDay(lastUpdated).getTime() === t
            }
          }
          break
        default:
          ////////////////debugger
      }
      ////////console.log("FILT", this.state.calendarView, filt, threads)
      if (filt) {
        const selectedId = this.state.selectedThread && this.state.selectedThread.id
        threads = threads.filter(x => x.id === selectedId || filt(x))
      }
    }
    //////console.log({tasks: threads})
    return threads
  }

  setAutocomplete = ref => {
    this.autocomplete = ref
    if (this.inputRef && ref) {
      ref.setInput(this.inputRef)
    }
  }

  selectThread = (task) => {
    if (task && this.state.selectedTask &&
        this.state.selectedTask.id === task.id) {
      return
    }
    if (this.initTimeout) {
      clearTimeout(this.initTimeout)
      this.init()
    }
    let lastTask = this.state.selectedTask
    if (lastTask) {
      this.deinitSelectedTask()
    }
    const back = () => {
      if (lastTask) {
        if (this.tasks[lastTask.id]) {
          if (!this.props.onCloseTask) {
            this.props.me.updateTaskSummary(lastTask)
          } else {
            this.props.onCloseTask(this, lastTask)
          }
        }
      }
    }
    let subpage
    if (task) {
      const render = () => <ChatPage me={this.props.me} chatGPT={this}/>
      if (isMobile()) {
        this.threads.openSubpage(render)
      } else {
      }
    }
    this.setState({
//      subpage,
      selectedTask: task,
    }, () => {
        if (task) {
          this.initSelectedTask()
        } else {
          back()
        }
    })
  }

  openSubpage = (fun) => {
    this.setState({
      subpage: () => fun(this.back)
    })
  }

  onCreateThreads = threads => {
    this.threads = threads
  }

  seqNum = 0
  search = async (searchTerm, then) => {
    this.state.searchTerm = searchTerm.trim()
    this.forceUpdate()
    this.performSearch(then)
  }


  setSearchField = field => {
    this.searchField = field
  }

  clearSearchField = () => {
    this.searchField.clear()
    this.searchField.onSearch('')
  }

  parseMessage = async (message, prev) => {
    if (!message) return
    replaceCachedArchiveEntries(message, this.transcriptArchiveEntries)
    if (prev && hasTranscriptArchives(message)) {
      await this.hydrateTranscriptArchiveEntries(message)
    }
    let text = message.content
    const replies = getReplies(message)
    for (const reply of replies) {
      if (reply.storage) {
        let download = this.state.selectedMessage && this.state.selectedMessage.id === message.id
        if (!download) {
          let thoughtOnly = String(reply.content || '').indexOf("<think>") >= 0 &&
                            String(reply.content || '').indexOf("</think>") < 0
          const detachedProgressPartial = reply.inferenceProgress && reply.contentLength &&
            String(reply.content || '').length < Number(reply.contentLength)
          download = thoughtOnly || detachedProgressPartial
        }
        if (download) await this.props.me.downloadAssistantContent(message.id, reply.model, reply.storage).then(content => {
          reply.content = content
          this.updateMessagesLater()
        })
      }
    }
    if (message.role === 'user' && message.storage) {
      if (false) this.props.me.downloadMessageContent(message.id, message.storage).then(content => {
        message.content = content
        this.updateMessagesLater()
      })
    }
    if (message.models) {
	      message.models = message.models.filter(x => {
	        if (!x) {
	          console.warn("null model in message", message)
	          return false
	        }
	        return true
	      })
      for (const x of message.models) {
        const {model, addedToTranscript} = x
        if (addedToTranscript) {
          for (const entry of addedToTranscript) {
            const toolCalls = entry && entry.message && entry.message.tool_calls
            if (Array.isArray(toolCalls)) {
              for (const tool_call of toolCalls) {
                if (tool_call && tool_call.function && tool_call.function.name === 'subagent') {
                  this.resolveSubagentTask(message.id, tool_call.id)
                }
              }
            }
          }
        }
      }
    }
    this.invalidateCache(message)
  }

  performSearch = async (then) => {
    const seq = ++this.seqNum
    const searchTerm = this.state.searchTerm
    let topic = this.state.selectedThread ? this.state.selectedThread.id : ''
    ////debugger
    if (searchTerm || topic) {
      this.state.searching = true
      if (!this.state.searchTerm) {
        this.state.threadBusy = true
      }
      this.forceUpdate()
      let searchResults
      if (this.state.slide > 0.5) {
        let { results, page, out_of }  = await this.props.searchChatMessages(searchTerm)
        results.forEach(message => {
          this.parseMessage(message)
        })
        searchResults = results
      } else {
        let { results, page, out_of }  = await this.props.searchTasks(searchTerm)
        ////////////console.log("SEARCH", seq, this.seqNum, results)
        searchResults = results
      }
      if (seq === this.seqNum) {
        this.setState({
          searching: false,
          threadBusy: false,
          searchResults
        },then)
      }
    } else {
      ////debugger
      this.setState({
        searching: false,
        searchResults: [],
        threadBusy: false
      }, then)
    }
  }

  onKeyDown = e => {
    const RETURN = "Enter";
    if (isDesktop()) {
      if (e.key === RETURN && !e.shiftKey) {
        e.preventDefault()
        const text = this.editor.getText()
        if (text.trim()) {
          this.sendChat()
        }
      }
    }
  }

  selectModel = (model) => {
    ////////////console.log('selectModel', model)
    if (this.state.selectedModels[model]) {
      delete this.state.selectedModels[model]
    } else {
      this.state.selectedModels[model] = true
    }
    ////////////console.log(this.state.selectedModels)
    //localStorage.setItem('selectedModels', JSON.stringify(this.state.selectedModels))
    this.forceUpdate(this.saveOptionsLater)
  }

  isModelSelected = (model) => {
    return this.state.selectedModels[model]
  }

  renderDiscussionSearchField = () => {
    let menu
    let busy = this.state.searching && this.state.searchTerm
    let searchTerm = ''
    const clear = () => {
      // fixme!!
      this.searchEditor.clear()
      this.search('')
    }
    const onFocus = () => {
    }
    const onBlur = () => {
    }
    const onInput = () => {
      this.search(this.searchEditor.getText())
    }
    const selectThread = thread => {
      this.selectThread(thread)
    }
    let icon
    let label
    let action
    action = async () => {
      //////////////debugger
      const defaultAction = () => {
        if (this.state.selectedTask && isMobile()) {
          const task = this.state.selectedTask
          this.selectThread(null)
        } else {
          if (this.props.newTopic) {
            this.props.newTopic(this)
            return
          }
          if (this.props.onNewFile) return
          const task = this.props.createNewTask()
          if (task) {
            if (this.props.onOpenTask) {
              this.props.onOpenTask(this, task)
            }
            this.selectThread(task)
          }
        }
      }
      if (this.props.onBack) {
        this.props.onBack(this, defaultAction)
      } else {
        defaultAction()
      }
    }
    if (this.state.slide < 0.5) {
      label = 'New'
      icon = Hashtag
    } else {
      label = 'Back'
      icon = Left
    }
    const newTopicButton = () => <KeyboardButton className={'newTopicButton'} icon={icon} action={action} label={label}/>
    const selectedThread = this.state.selectedThread
    ////////////console.log("slide", this.state.slide)
    let threads = this.getThreads()
    const style = {
      //transform: `translate(calc(${1.0-this.state.slide} * -100%), 0)`,
      //display: this.state.slide === 0 ? 'none': undefined
    }
    let style2
    const selectedModelIds = this.getSelectedModelIds()
    const selectedModelCount = selectedModelIds.length

    let middleLeft
    if (this.props.getNewButton) {
      const button = this.props.getNewButton(this, action)
      if (button)
        middleLeft = <div className='customNewTopicButton'>
                       {button}
                     </div>
    } else {
      middleLeft = newTopicButton()
    }
    if (this.props.onNewFile && !this.state.selectedTask) {
      const openImage = async (event) => {
        this.newFileChooser.click()
      }
      const handleImage = async (event) => {
        this.handleDataTransfer(event, event.target)
        this.newFileChooser.reset()
      }
      const fileChooser =
        <div className='fileChooser' onClick={openImage}>
          <input
            ref={this.setNewFileChooser}
            type={"file"}
            accept={this.props.newFiletypes}
            style={{ display: 'none' }} // Hides the file input
            onChange={handleImage}
          />
          {newTopicButton}
        </div>
      middleLeft = fileChooser
    }

    let inputEnabled = true
    if (this.props.enableInput) {
      inputEnabled = this.props.enableInput(this)
    }
    let filler = ''

    const openSettings = async () => {
      this.setState({showSettings: !this.state.showSettings})
    }

    const setTemp = ({value}) => {
      //////console.log("setTemp", value)
      this.setState({temperature:value})
    }
    const getTemp = () => this.state.temperature

    const toggleSize = (size) => {
      if (this.state.sizes[size]) {
        delete this.state.sizes[size]
      } else {
        this.state.sizes[size] = true
      }
      this.forceUpdate()
    }
    let magpie
    if (this.props.magpieEnabled) {
      magpie = async () => {
        await new Promise((resolve, reject) => {
          this.state.magpie = {resolve, reject}
          this.sendChat()
        })
        this.forceUpdate()
      }
    }
    if (this.props.onFile) {
      const openFile = async (event) => {
        this.setState({fileChooserActive: true})
        this.newFileChooser2.click()
      }
      const handleFile = async (event) => {
        this.setState({fileChooserActive: false})
        const { files } = event.target
        const MAX_SIZE = 4 * 1000 * 1000
        for (const file of files) {
          if (true || file.size > MAX_SIZE) {
              this.setState({
                uploadError: 'Your file is too large, it must be <= 4MB'
              })
            return
          }
        }
        this.handleDataTransfer(event, event.target)
      }
      let fileMenuButton = 'fileMenuButton'
      let icon = OpenFile
      if (false && this.state.fileChooserActive) {
        fileMenuButton += ' fileMenuButtonActive'
        icon = Spin
      }
      menu = <div className='fileMenu' onClick={openFile}>
               <input
                 ref={this.setNewFileChooser2}
                 type={"file"}
                 accept={this.props.fileTypes}
                 style={{ display: 'none' }} // Hides the file input
                 onChange={handleFile}
               />
               <div className={fileMenuButton}>
                 <ReactSVG src={icon}/>
               </div>
        </div>
    }
    let uploadError = this.state.uploadError
    const toggleSmall = () => toggleSize('small')
    const toggleMedium = () => toggleSize('medium')
    const toggleLarge = () => toggleSize('large')
    //<div className='chatBack'><KeyboardButton icon={Left} label={'Back'} action={action}/></div>
    const clearErr = () => {
      this.setState({
        uploadError: ''
      })
    }
    return <div key='discussionSearch' className='discussionSearch'>
             <div className='chatHeader'>
               <div className='chatHeaderFiller'>{filler}</div>
               <div className='inputControlContainer'>
                 <InputControl
                   key={'discussionSearch'}
                   busy={busy}
                   middleLeft={middleLeft}
                   me={this.props.me}
                   placeholder={'Search'}
                   onSetEditor={this.setSearchEditor}
                   downward={true}
                   onClear={clear}
                   onFocus={onFocus}
                   onBlur={onBlur}
                   onInput={onInput}
                   menu={menu}
                 />
               </div>
             </div>
             {uploadError && <ClickAwayListener onClickAway={clearErr}>
                               <div key='uploadErr' className='uploadErrorDialog' onClick={clearErr}>
                                 <SimpleIcon src={Alert}/>{uploadError}
                               </div>
                             </ClickAwayListener>}
           </div>
  }



  setNewFileChooser = ref => { this.newFileChooser = ref }
  setNewFileChooser2 = ref => { this.newFileChooser2 = ref }


  deleteTask = async task => {
    await this.props.deleteTask(this, task)
    delete this.tasks[task.id]
    if (this.state.searchTerm) {
      this.state.searchResults = this.state.searchResults.filter(x => {
        return x.id !== task.id
      })
    }
    this.forceUpdate()
  }

  pullHistoryBefore = async (limit) => {
    return await this.pullHistory(limit, '>')
  }

  pullHistoryAfter = async (limit) => {
    return await this.pullHistory(limit, '<')
  }

  pullHistory = async (limit, op) => {
    //////debugger
    if (!this.tasks || this.state.searchTerm) return { count: 0, update: (then) => {then} }
    let latest = 0
    let earliest = Date.now()
    const tasks = this.getThreads()
    if (tasks.length > 0) {
      latest = tasks[0].lastUpdated
      earliest = tasks[tasks.length-1].lastUpdated
    }
    let lastUpdated = op === '<' ? earliest : latest
    const getThreadsHistory = (this.props.getThreadsHistory &&
                               ((lastUpdated, limit) => this.props.getThreadsHistory(this, lastUpdated, op, limit))
                              ) ||
          this.props.me.getThreadsHistory
    const results = await getThreadsHistory(lastUpdated, op, limit)
    for (const task of results) {
      this.tasks[task.id] = task
    }
    const count = results.length
    //console.log("PULL HISTORY", op, count)
    ////////debugger
    return {
      count,
      update: (then) => this.forceUpdate2(then)
    }
  }

  forceUpdate2 = then => {
    this.forceUpdate(() => {
      this.forceUpdate(then)
    })
  }

  threadsHistBusy = false
  getThreadsHistory = async () => {
    ////////console.log("get threads history")
    if (!this.tasks) return
    if (this.threadsHistBusy) return
    this.threadsHistBusy = true
    let lastUpdated = Date.now()
    for (const id in this.tasks) {
      const task = this.tasks[id]
      lastUpdated = Math.min(task.lastUpdated, lastUpdated)
    }
    const getThreadsHistory = (this.props.getThreadsHistory &&
                               ((lastUpdated, limit) => this.props.getThreadsHistory(this, lastUpdated, limit))
                              ) ||
          this.props.me.getThreadsHistory
    const results = await getThreadsHistory(lastUpdated, 15)
    for (const task of results) {
      this.tasks[task.id] = task
    }
    this.threadsHistBusy = false
    this.forceUpdate()
  }

  toggleTextFieldSpeechInput = async () => {
    const textFieldSpeechInputActive = !this.state.textFieldSpeechInputActive
    if (this.state.voiceRecognitionActive) {
      this.toggleVoiceRecognition()
    }
    this.setState({
      textFieldSpeechInputActive,
      instructionSpeechInputActive: false
    }, () => {
      if (textFieldSpeechInputActive) {
        this.toggleVoiceRecognition()
      }
    })
  }

  toggleVoiceRecognition = async e => {
    if (e) e.preventDefault()
    ////////////////////////////////debugger
    this.state.voiceRecognitionActive = !this.state.voiceRecognitionActive
    if (this.recognition) {
      this.recognition.stop()
      this.recognition = null
    }
    if (!this.state.voiceRecognitionActive) {
      this.setState({
        instruction: null
      })
      if (this.sub3) {
        this.sub3.unsubscribe()
        this.sub3 = null
      }
      if (this.sub4) {
        this.sub4.unsubscribe()
        this.sub4 = null
      }
    } else {
      this.recognition = this.props.me.getVoiceRecognizer()
      this.sub3 = this.recognition.observeIsActive().subscribe(isActive => {
        if (this.state.voiceRecognitionActive !== isActive) {
          ////////////console.log("isActive", isActive)
          this.state.voiceRecognitionActive = isActive
          this.forceUpdate()
        }
      })
      this.sub4 = this.recognition.observeInstruction().subscribe(instruction => {
        ////////////console.log("instruction", instruction)
        this.receiveVoiceInput(instruction)
      })
      this.updateLang()
      this.recognition.start()
    }
    this.forceUpdate(this.updateLang)
  }

  selectTextInputLang = lang => {
    localStorage.setItem('keyboard.text.lang', JSON.stringify(lang))
    this.setState({
      lang
    }, this.updateLang)
  }

  updateLang = () => {
    if (this.state.instructionSpeechInputActive) {
      if (this.recognition) {
        this.recognition.setLang(this.state.instructionLang.iso)
      }
    }
    else if (this.state.textFieldSpeechInputActive) {
      if (this.recognition) {
        this.recognition.setLang(this.state.lang.iso)
      }
    } else {

    }
  }

  speakText = async (cancel) => {
    if (cancel) {
      this.props.me.cancelSpeak()
    } else {
      const text = this.editor.getText()
      this.props.me.resetAudioSource()
      await this.props.me.speak(text, this.state.lang.iso)
    }
  }

  receiveVoiceInput = async input => {
    consoleLog("voice input", input)
    if (this.state.instructionSpeechInputActive) {
      const { instruction } = this.state.nextInstruction
      const editor = this.instructionEditor
      editor.insertTextAtCaret(input)
      const text = editor.getText()
      instruction.advance(text)
      const { isComplete, corrected } = await this.props.me.autocorrect({input: text, lang: this.state.instructionLang.iso})
      if (corrected && text != corrected) {
        instruction.undo()
        instruction.advance(corrected)
        editor.setText(corrected)
      }
    } else if (this.state.textFieldSpeechInputActive) {
      this.editor.insertTextAtCaret(input)
      const text = this.editor.getText()
      const data  = await this.props.me.autocorrect({input: text, lang: this.state.lang.iso})
      const { isComplete, corrected } = data
      if (corrected && text != corrected) {
        this.editor.setText(corrected)
      }
      if (isComplete && !this.state.isStreaming) {
        this.sendChat()
      }
    } else {
      console.error("voice input fail")
    }
    this.forceUpdate()
  }

  factCheck = async (id) => {
    return await this.props.me.factCheck(id)
  }

  uploadFile = async file => {
    this.state.uploadingFile = true
    const upload = {
      file: file,
      progress: 0,
      blobUrl: URL.createObjectURL(file)
    }
    const progress = percent => {
      upload.progress = percent;
      this.forceUpdate();
    }
    this.state.uploads.push(upload)
    this.forceUpdate()
    let setImage
    if (file.type) {
      if (file.type.startsWith("image/")) {
        const url = URL.createObjectURL(file);
        setImage = this.editor.insertImage(url)
      } else {
        setImage = url => this.editor.insertTextAtCaret(`[${file.name}](${url})`)
      }
      if (isDesktop()) {
        this.editor.focus()
      }
    }
    const name = file.name.toLowerCase();
    //////////////////////debugger
    if (name.endsWith(".mov")) {
      try {
        file = new File(file, name.replace(".mov", ".mp4"));
      } catch (err) {
        this.props.me.nativeLog(err)
      }
    }
    try {
      const ref = await this.props.uploadFile(file, progress, false)
      ////////debugger
      if (setImage) {
        setImage(await ref.getDownloadURL())
        this.state.uploadingFile = false
        this.forceUpdate()
      }
    } catch (err) {
      console.error(err)
    } finally {
      this.setState({
        uploadingFile: false,
        uploads: this.state.uploads.filter(x => x.file != file),
      })
    }
  }

  handleDataTransfer = (event, transfer)=> {
    if (transfer.files.length > 0) {
      event.preventDefault();
      for (const file of transfer.files) {
        this.uploadFile(file);
      }
      return true;
    }
    if (false) {
      let plainText = e.clipboardData.getData('text/plain')
      if (!plainText) {
        const text = e.clipboardData.getData('text/html')
        plainText = makeTextPlain(text)
      }
      if (plainText.length > 100 * 1000) {
        event.preventDefault()
        this.props.me.uploadMessageContent(plainText)
        return true
      }
    }
    return false;
  }

  onPaste = e => {
    if (this.handleDataTransfer(e, e.clipboardData)) {
      return
    }
  }

  onUpdate = e => {
  }

  onDrop = e => {
    const transfer = e.dataTransfer;
    this.handleDataTransfer(e, transfer);
  }

}


export const ChatGPT = ChatGPT3
